import { useEffect } from 'react'
import './style.css'

const circleCount = 12
const barsPerCircle = 7
const circleAbortArray = Array(circleCount).fill(false)
const circleClickedArray = Array(circleCount).fill(false)
const circleIndexArray = Array(circleCount)
  .fill()
  .map((e, i) => i * barsPerCircle + 1)
const circleStartIndex = Array(circleCount + 1)
  .fill()
  .map((e, i) => i * barsPerCircle + 1)

const sectionArray = [
  'zinsanleihen-section',
  'strukturierte-anleihen-section',
  'kapitalschutz-section',
  'schuldverschreibung-section',
  'express-section',
  'aktienanleihen-section',
  'discount-section',
  'bonus-section',
  'index-section',
  'option-section',
  'faktor-section',
  'knock-out-section'
]

export const ProduktKlassifizierung = (props) => {
  useEffect(() => {
    let selectedIndex = -1

    for (let i = 0; i < circleCount; i++) {
      const circleElem = document.getElementById(`circle-${i + 1}-path`)
      circleElem?.classList.remove('circle-color-fix')
      circleClickedArray[i] = false

      if (props.selectedCategory === sectionArray[i]) {
        circleElem?.classList.add('circle-color-fix')
        circleClickedArray[i] = true
        selectedIndex = i
      }
    }

    const selectedStart =
      selectedIndex !== -1 ? circleStartIndex[selectedIndex] : -1
    const selectedEnd =
      selectedIndex !== -1 ? circleStartIndex[selectedIndex + 1] : -1

    for (let i = 0; i <= circleCount * barsPerCircle; i++) {
      const topElem = document.getElementById(`bar-top-${i}`)
      const bottomElem = document.getElementById(`bar-bottom-${i}`)

      const isSelectedBar = i >= selectedStart && i < selectedEnd

      topElem?.classList.toggle('bar-top-fix', isSelectedBar)
      bottomElem?.classList.toggle('bar-bottom-fix', isSelectedBar)
    }
  }, [props.selectedCategory])

  const handleCircleMouseEnter = async (e) => {
    const circleIndex = parseInt(e.target.id.split('-')[1]) - 1
    circleAbortArray[circleIndex] = false

    for (
      let i = circleStartIndex[circleIndex];
      i < circleIndexArray[circleIndex];
      i++
    ) {
      let elem = document.getElementById('bar-top-' + i.toString())
      elem.classList.add('bar-top-fix')

      elem = document.getElementById('bar-bottom-' + i.toString())
      elem.classList.add('bar-bottom-fix')
    }

    for (
      let i = circleIndexArray[circleIndex];
      i < circleStartIndex[circleIndex + 1];
      i++
    ) {
      if (circleAbortArray[circleIndex]) break
      circleIndexArray[circleIndex] = i

      let elem = document.getElementById('bar-top-' + i.toString())
      elem.classList.add('bar-top-fix')

      elem = document.getElementById('bar-bottom-' + i.toString())
      elem.classList.add('bar-bottom-fix')

      await new Promise((resolve) => setTimeout(resolve, 100))
    }
  }

  const handleCircleMouseLeave = async (e) => {
    const circleIndex = parseInt(e.target.id.split('-')[1]) - 1

    if (circleClickedArray[circleIndex]) return

    circleAbortArray[circleIndex] = true
    for (
      let i = circleStartIndex[circleIndex + 1] - 1;
      i > circleIndexArray[circleIndex];
      i--
    ) {
      let elem = document.getElementById('bar-top-' + i.toString())
      elem.classList.remove('bar-top-fix')

      elem = document.getElementById('bar-bottom-' + i.toString())
      elem.classList.remove('bar-bottom-fix')
    }

    for (
      let i = circleIndexArray[circleIndex];
      i > circleStartIndex[circleIndex] - 1;
      i--
    ) {
      await new Promise((resolve) => setTimeout(resolve, 100))
      if (!circleAbortArray[circleIndex]) break

      let elem = document.getElementById('bar-top-' + i.toString())
      elem.classList.remove('bar-top-fix')

      elem = document.getElementById('bar-bottom-' + i.toString())
      elem.classList.remove('bar-bottom-fix')

      circleIndexArray[circleIndex] = i
    }
  }

  const handleCircleMouseDown = (e) => {
    if (e.button !== 0) return

    const circleIndex = parseInt(e.target.id.split('-')[1]) - 1
    const oldCircleIndex = circleClickedArray.indexOf(true) + 1

    for (let i = 0; i < circleCount; i++) {
      circleClickedArray[i] = i === circleIndex
    }
    oldCircleIndex !== 0 &&
      handleCircleMouseLeave({
        target: { id: 'circle-' + oldCircleIndex.toString() }
      })

    for (let i = 0; i < circleCount; i++) {
      const elem = document.getElementById(
        'circle-' + (i + 1).toString() + '-path'
      )
      elem.classList.remove('circle-color-fix')
      if (i === circleIndex) {
        elem.classList.add('circle-color-fix')
      }
    }

    props.onSetSection(sectionArray[circleIndex])
    props.onSetCategory(sectionArray[circleIndex])
    // props.onClickScrollIntoView()
  }

  return (
    <svg
      style={{ maxWidth: '841.89pt', maxHeight: '595.276pt' }}
      viewBox="30 60 781.89 520.276"
      version="1.2"
      id="svg8309"
    >
      <defs id="defs5032">
        <g id="g2990">
          <symbol overflow="visible" id="glyph0-0">
            <path
              style={{ stroke: 'none' }}
              d="M 2.921875 0 L 2.921875 -13.125 L 13.421875 -13.125 L 13.421875 0 Z M 4.109375 -1.21875 L 12.203125 -1.21875 L 12.203125 -11.90625 L 4.109375 -11.90625 Z M 4.109375 -1.21875 "
              id="path2666"
            />
          </symbol>
          <symbol overflow="visible" id="glyph0-1">
            <path
              style={{ stroke: 'none' }}
              d="M 0.796875 0 L 0.796875 -0.6875 C 1.253906 -0.6875 1.585938 -0.71875 1.796875 -0.78125 C 2.015625 -0.84375 2.15625 -0.957031 2.21875 -1.125 C 2.28125 -1.300781 2.3125 -1.550781 2.3125 -1.875 L 2.3125 -11.96875 C 2.3125 -12.320312 2.28125 -12.582031 2.21875 -12.75 C 2.15625 -12.925781 2.015625 -13.039062 1.796875 -13.09375 C 1.578125 -13.15625 1.242188 -13.1875 0.796875 -13.1875 L 0.796875 -13.859375 L 7.3125 -13.859375 C 8.375 -13.859375 9.285156 -13.75 10.046875 -13.53125 C 10.804688 -13.3125 11.390625 -12.972656 11.796875 -12.515625 C 12.203125 -12.054688 12.40625 -11.441406 12.40625 -10.671875 C 12.40625 -9.816406 12.144531 -9.125 11.625 -8.59375 C 11.101562 -8.070312 10.34375 -7.707031 9.34375 -7.5 L 9.34375 -7.46875 C 10.144531 -7.332031 10.816406 -7.101562 11.359375 -6.78125 C 11.910156 -6.457031 12.320312 -6.039062 12.59375 -5.53125 C 12.875 -5.03125 13.015625 -4.425781 13.015625 -3.71875 C 13.015625 -2.851562 12.800781 -2.140625 12.375 -1.578125 C 11.945312 -1.023438 11.328125 -0.625 10.515625 -0.375 C 9.703125 -0.125 8.707031 0 7.53125 0 Z M 7 -0.796875 C 7.582031 -0.796875 8.070312 -0.90625 8.46875 -1.125 C 8.875 -1.34375 9.171875 -1.664062 9.359375 -2.09375 C 9.554688 -2.519531 9.65625 -3.054688 9.65625 -3.703125 C 9.65625 -4.734375 9.390625 -5.535156 8.859375 -6.109375 C 8.328125 -6.679688 7.578125 -6.96875 6.609375 -6.96875 L 5.5 -6.96875 L 5.5 -2.15625 C 5.5 -1.65625 5.601562 -1.300781 5.8125 -1.09375 C 6.019531 -0.894531 6.414062 -0.796875 7 -0.796875 Z M 5.5 -7.796875 L 6.546875 -7.796875 C 7.460938 -7.796875 8.148438 -8.023438 8.609375 -8.484375 C 9.066406 -8.941406 9.296875 -9.609375 9.296875 -10.484375 C 9.296875 -11.035156 9.195312 -11.503906 9 -11.890625 C 8.8125 -12.273438 8.515625 -12.566406 8.109375 -12.765625 C 7.703125 -12.960938 7.191406 -13.0625 6.578125 -13.0625 C 6.273438 -13.0625 6.046875 -13.035156 5.890625 -12.984375 C 5.742188 -12.941406 5.640625 -12.859375 5.578125 -12.734375 C 5.523438 -12.617188 5.5 -12.441406 5.5 -12.203125 Z M 5.5 -7.796875 "
              id="path2669"
            />
          </symbol>
          <symbol overflow="visible" id="glyph0-2">
            <path
              style={{ stroke: 'none' }}
              d="M 5.4375 0.25 C 4.851562 0.25 4.359375 0.195312 3.953125 0.09375 C 3.554688 -0.0078125 3.222656 -0.113281 2.953125 -0.21875 C 2.679688 -0.320312 2.4375 -0.375 2.21875 -0.375 C 2.070312 -0.375 1.945312 -0.335938 1.84375 -0.265625 C 1.75 -0.203125 1.679688 -0.113281 1.640625 0 L 1.03125 0 L 0.78125 -4.015625 L 1.484375 -4.015625 C 1.566406 -3.628906 1.710938 -3.226562 1.921875 -2.8125 C 2.140625 -2.40625 2.410156 -2.019531 2.734375 -1.65625 C 3.054688 -1.289062 3.4375 -0.992188 3.875 -0.765625 C 4.3125 -0.546875 4.8125 -0.4375 5.375 -0.4375 C 5.820312 -0.4375 6.25 -0.515625 6.65625 -0.671875 C 7.0625 -0.835938 7.382812 -1.097656 7.625 -1.453125 C 7.863281 -1.816406 7.984375 -2.265625 7.984375 -2.796875 C 7.984375 -3.421875 7.785156 -3.925781 7.390625 -4.3125 C 6.992188 -4.707031 6.421875 -5.046875 5.671875 -5.328125 L 4.578125 -5.71875 C 3.847656 -5.976562 3.207031 -6.289062 2.65625 -6.65625 C 2.113281 -7.019531 1.6875 -7.46875 1.375 -8 C 1.0625 -8.53125 0.90625 -9.179688 0.90625 -9.953125 C 0.90625 -10.796875 1.097656 -11.523438 1.484375 -12.140625 C 1.878906 -12.765625 2.421875 -13.25 3.109375 -13.59375 C 3.796875 -13.9375 4.609375 -14.109375 5.546875 -14.109375 C 6.046875 -14.109375 6.460938 -14.0625 6.796875 -13.96875 C 7.140625 -13.882812 7.429688 -13.789062 7.671875 -13.6875 C 7.921875 -13.59375 8.15625 -13.546875 8.375 -13.546875 C 8.539062 -13.546875 8.65625 -13.582031 8.71875 -13.65625 C 8.78125 -13.738281 8.835938 -13.832031 8.890625 -13.9375 L 9.453125 -13.9375 L 9.65625 -10.265625 L 8.953125 -10.265625 C 8.816406 -10.941406 8.585938 -11.515625 8.265625 -11.984375 C 7.953125 -12.453125 7.570312 -12.8125 7.125 -13.0625 C 6.675781 -13.3125 6.171875 -13.4375 5.609375 -13.4375 C 4.878906 -13.4375 4.28125 -13.238281 3.8125 -12.84375 C 3.351562 -12.445312 3.125 -11.9375 3.125 -11.3125 C 3.125 -10.8125 3.269531 -10.40625 3.5625 -10.09375 C 3.863281 -9.789062 4.21875 -9.539062 4.625 -9.34375 C 5.039062 -9.144531 5.410156 -8.984375 5.734375 -8.859375 L 7.125 -8.359375 C 7.75 -8.117188 8.304688 -7.816406 8.796875 -7.453125 C 9.285156 -7.085938 9.671875 -6.644531 9.953125 -6.125 C 10.234375 -5.613281 10.375 -4.984375 10.375 -4.234375 C 10.375 -3.554688 10.253906 -2.9375 10.015625 -2.375 C 9.773438 -1.8125 9.4375 -1.332031 9 -0.9375 C 8.5625 -0.550781 8.039062 -0.253906 7.4375 -0.046875 C 6.832031 0.148438 6.164062 0.25 5.4375 0.25 Z M 5.4375 0.25 "
              id="path2672"
            />
          </symbol>
          <symbol overflow="visible" id="glyph0-3">
            <path
              style={{ stroke: 'none' }}
              d="M 5.078125 0 L 1.703125 -12.109375 C 1.628906 -12.367188 1.539062 -12.570312 1.4375 -12.71875 C 1.332031 -12.875 1.1875 -12.988281 1 -13.0625 C 0.8125 -13.132812 0.546875 -13.171875 0.203125 -13.171875 L 0.203125 -13.859375 L 6.296875 -13.859375 L 6.296875 -13.171875 L 5.453125 -13.171875 C 5.179688 -13.171875 5 -13.101562 4.90625 -12.96875 C 4.820312 -12.84375 4.820312 -12.628906 4.90625 -12.328125 L 7.140625 -4.046875 L 7.1875 -4.046875 L 9.953125 -13.5625 L 12.046875 -13.5625 L 14.828125 -4.15625 L 14.875 -4.15625 L 16.921875 -12.1875 C 17.003906 -12.53125 17.015625 -12.78125 16.953125 -12.9375 C 16.890625 -13.09375 16.675781 -13.171875 16.3125 -13.171875 L 15.375 -13.171875 L 15.375 -13.859375 L 19.46875 -13.859375 L 19.46875 -13.171875 C 19.144531 -13.171875 18.878906 -13.125 18.671875 -13.03125 C 18.472656 -12.9375 18.300781 -12.765625 18.15625 -12.515625 C 18.019531 -12.265625 17.890625 -11.898438 17.765625 -11.421875 L 14.640625 0 L 12.890625 0 L 9.84375 -10.140625 L 9.78125 -10.140625 L 6.78125 0 Z M 5.078125 0 "
              id="path2675"
            />
          </symbol>
          <symbol overflow="visible" id="glyph0-4">
            <path
              style={{ stroke: 'none' }}
              d="M 1.265625 -4.3125 L 1.265625 -6.265625 L 6.953125 -6.265625 L 6.953125 -4.3125 Z M 1.265625 -4.3125 "
              id="path2678"
            />
          </symbol>
          <symbol overflow="visible" id="glyph0-5">
            <path
              style={{ stroke: 'none' }}
              d="M 0.796875 0 L 0.796875 -0.6875 C 1.273438 -0.6875 1.617188 -0.71875 1.828125 -0.78125 C 2.035156 -0.84375 2.164062 -0.957031 2.21875 -1.125 C 2.28125 -1.300781 2.3125 -1.550781 2.3125 -1.875 L 2.3125 -11.96875 C 2.3125 -12.300781 2.28125 -12.554688 2.21875 -12.734375 C 2.15625 -12.910156 2.015625 -13.023438 1.796875 -13.078125 C 1.578125 -13.140625 1.242188 -13.171875 0.796875 -13.171875 L 0.796875 -13.859375 L 7.0625 -13.859375 C 8.0625 -13.859375 8.90625 -13.75 9.59375 -13.53125 C 10.289062 -13.3125 10.847656 -13.015625 11.265625 -12.640625 C 11.691406 -12.273438 12 -11.851562 12.1875 -11.375 C 12.375 -10.90625 12.46875 -10.40625 12.46875 -9.875 C 12.46875 -9.21875 12.351562 -8.625 12.125 -8.09375 C 11.894531 -7.570312 11.535156 -7.113281 11.046875 -6.71875 C 10.566406 -6.320312 9.9375 -6.019531 9.15625 -5.8125 C 8.375 -5.601562 7.429688 -5.5 6.328125 -5.5 L 5.5 -5.5 L 5.5 -1.875 C 5.5 -1.53125 5.535156 -1.273438 5.609375 -1.109375 C 5.679688 -0.941406 5.832031 -0.828125 6.0625 -0.765625 C 6.289062 -0.710938 6.644531 -0.6875 7.125 -0.6875 L 7.125 0 Z M 5.5 -6.34375 L 6.390625 -6.34375 C 7.210938 -6.34375 7.890625 -6.625 8.421875 -7.1875 C 8.953125 -7.757812 9.21875 -8.632812 9.21875 -9.8125 C 9.21875 -10.875 8.984375 -11.679688 8.515625 -12.234375 C 8.054688 -12.785156 7.367188 -13.0625 6.453125 -13.0625 C 6.046875 -13.0625 5.785156 -13.007812 5.671875 -12.90625 C 5.554688 -12.8125 5.5 -12.617188 5.5 -12.328125 Z M 5.5 -6.34375 "
              id="path2681"
            />
          </symbol>
          <symbol overflow="visible" id="glyph0-6">
            <path
              style={{ stroke: 'none' }}
              d="M 0.53125 0 L 0.53125 -0.6875 C 0.9375 -0.6875 1.234375 -0.710938 1.421875 -0.765625 C 1.609375 -0.828125 1.726562 -0.9375 1.78125 -1.09375 C 1.84375 -1.25 1.875 -1.46875 1.875 -1.75 L 1.875 -7.9375 C 1.875 -8.269531 1.832031 -8.488281 1.75 -8.59375 C 1.675781 -8.695312 1.515625 -8.75 1.265625 -8.75 L 0.59375 -8.75 L 0.59375 -9.453125 L 3.859375 -9.96875 L 4.765625 -9.96875 L 4.765625 -8.046875 L 4.84375 -8.046875 L 4.84375 -1.75 C 4.84375 -1.445312 4.878906 -1.222656 4.953125 -1.078125 C 5.035156 -0.929688 5.1875 -0.828125 5.40625 -0.765625 C 5.632812 -0.710938 5.984375 -0.6875 6.453125 -0.6875 L 6.453125 0 Z M 4.4375 -5.671875 L 4.4375 -7.015625 C 4.488281 -7.179688 4.582031 -7.429688 4.71875 -7.765625 C 4.863281 -8.109375 5.050781 -8.453125 5.28125 -8.796875 C 5.507812 -9.148438 5.800781 -9.445312 6.15625 -9.6875 C 6.519531 -9.9375 6.953125 -10.0625 7.453125 -10.0625 C 8.046875 -10.0625 8.5 -9.890625 8.8125 -9.546875 C 9.132812 -9.203125 9.296875 -8.769531 9.296875 -8.25 C 9.296875 -7.832031 9.179688 -7.457031 8.953125 -7.125 C 8.722656 -6.800781 8.34375 -6.640625 7.8125 -6.640625 C 7.394531 -6.640625 7.054688 -6.742188 6.796875 -6.953125 C 6.535156 -7.171875 6.40625 -7.476562 6.40625 -7.875 C 6.40625 -8.113281 6.4375 -8.285156 6.5 -8.390625 C 6.5625 -8.492188 6.617188 -8.578125 6.671875 -8.640625 C 6.734375 -8.703125 6.765625 -8.757812 6.765625 -8.8125 C 6.765625 -8.863281 6.742188 -8.898438 6.703125 -8.921875 C 6.671875 -8.953125 6.613281 -8.96875 6.53125 -8.96875 C 6.363281 -8.96875 6.179688 -8.867188 5.984375 -8.671875 C 5.785156 -8.472656 5.597656 -8.210938 5.421875 -7.890625 C 5.253906 -7.566406 5.113281 -7.210938 5 -6.828125 C 4.894531 -6.453125 4.84375 -6.070312 4.84375 -5.6875 Z M 4.4375 -5.671875 "
              id="path2684"
            />
          </symbol>
          <symbol overflow="visible" id="glyph0-7">
            <path
              style={{ stroke: 'none' }}
              d="M 5.96875 0.25 C 4.1875 0.25 2.867188 -0.175781 2.015625 -1.03125 C 1.171875 -1.882812 0.75 -3.175781 0.75 -4.90625 C 0.75 -6.675781 1.179688 -7.984375 2.046875 -8.828125 C 2.910156 -9.671875 4.226562 -10.09375 6 -10.09375 C 7.75 -10.09375 9.046875 -9.675781 9.890625 -8.84375 C 10.734375 -8.019531 11.15625 -6.722656 11.15625 -4.953125 C 11.15625 -3.191406 10.726562 -1.882812 9.875 -1.03125 C 9.03125 -0.175781 7.726562 0.25 5.96875 0.25 Z M 5.96875 -0.5 C 6.71875 -0.5 7.25 -0.859375 7.5625 -1.578125 C 7.882812 -2.304688 8.03125 -3.429688 8 -4.953125 C 8 -6.484375 7.835938 -7.597656 7.515625 -8.296875 C 7.191406 -9.003906 6.664062 -9.359375 5.9375 -9.359375 C 5.1875 -9.359375 4.648438 -8.976562 4.328125 -8.21875 C 4.015625 -7.46875 3.859375 -6.351562 3.859375 -4.875 C 3.859375 -3.34375 4.015625 -2.226562 4.328125 -1.53125 C 4.648438 -0.84375 5.195312 -0.5 5.96875 -0.5 Z M 5.96875 -0.5 "
              id="path2687"
            />
          </symbol>
          <symbol overflow="visible" id="glyph0-8">
            <path
              style={{ stroke: 'none' }}
              d="M 4.71875 0.234375 C 3.476562 0.234375 2.503906 -0.195312 1.796875 -1.0625 C 1.097656 -1.9375 0.75 -3.15625 0.75 -4.71875 C 0.75 -5.914062 0.945312 -6.910156 1.34375 -7.703125 C 1.75 -8.503906 2.328125 -9.101562 3.078125 -9.5 C 3.835938 -9.894531 4.742188 -10.09375 5.796875 -10.09375 C 6.203125 -10.09375 6.546875 -10.066406 6.828125 -10.015625 C 7.109375 -9.972656 7.363281 -9.910156 7.59375 -9.828125 C 7.820312 -9.742188 8.0625 -9.65625 8.3125 -9.5625 L 8.3125 -8.1875 C 8.15625 -8.34375 7.960938 -8.507812 7.734375 -8.6875 C 7.515625 -8.875 7.265625 -9.03125 6.984375 -9.15625 C 6.710938 -9.289062 6.40625 -9.359375 6.0625 -9.359375 C 5.28125 -9.359375 4.710938 -9.015625 4.359375 -8.328125 C 4.003906 -7.648438 3.828125 -6.640625 3.828125 -5.296875 C 3.828125 -3.828125 4.015625 -2.738281 4.390625 -2.03125 C 4.765625 -1.320312 5.296875 -0.96875 5.984375 -0.96875 C 6.304688 -0.96875 6.585938 -1.035156 6.828125 -1.171875 C 7.066406 -1.316406 7.289062 -1.5 7.5 -1.71875 C 7.707031 -1.945312 7.910156 -2.148438 8.109375 -2.328125 L 8.21875 -1.296875 C 7.894531 -0.960938 7.550781 -0.679688 7.1875 -0.453125 C 6.820312 -0.234375 6.4375 -0.0664062 6.03125 0.046875 C 5.632812 0.171875 5.195312 0.234375 4.71875 0.234375 Z M 7.953125 0 L 7.703125 -1.546875 L 7.703125 -12.5 C 7.703125 -12.800781 7.65625 -13.003906 7.5625 -13.109375 C 7.476562 -13.210938 7.320312 -13.265625 7.09375 -13.265625 L 6.390625 -13.265625 L 6.390625 -13.96875 L 9.765625 -14.484375 L 10.640625 -14.484375 L 10.640625 -1.75 C 10.640625 -1.28125 10.703125 -0.984375 10.828125 -0.859375 C 10.960938 -0.742188 11.195312 -0.6875 11.53125 -0.6875 L 12.015625 -0.6875 L 12.015625 0 Z M 7.5625 -9.515625 L 7.5625 -9.828125 L 8.296875 -9.828125 L 8.296875 -9.515625 Z M 7.5625 -9.515625 "
              id="path2690"
            />
          </symbol>
          <symbol overflow="visible" id="glyph0-9">
            <path
              style={{ stroke: 'none' }}
              d="M 4.765625 0.25 C 3.828125 0.25 3.085938 -0.00390625 2.546875 -0.515625 C 2.015625 -1.035156 1.75 -1.875 1.75 -3.03125 L 1.75 -8 C 1.75 -8.320312 1.707031 -8.535156 1.625 -8.640625 C 1.550781 -8.742188 1.390625 -8.796875 1.140625 -8.796875 L 0.4375 -8.796875 L 0.4375 -9.484375 L 3.796875 -9.96875 L 4.71875 -9.96875 L 4.71875 -3.25 C 4.71875 -2.71875 4.773438 -2.289062 4.890625 -1.96875 C 5.015625 -1.644531 5.191406 -1.410156 5.421875 -1.265625 C 5.660156 -1.117188 5.945312 -1.046875 6.28125 -1.046875 C 6.539062 -1.046875 6.78125 -1.097656 7 -1.203125 C 7.226562 -1.304688 7.453125 -1.445312 7.671875 -1.625 C 7.898438 -1.8125 8.128906 -2.03125 8.359375 -2.28125 L 8.421875 -1.578125 C 8.265625 -1.367188 8.019531 -1.117188 7.6875 -0.828125 C 7.363281 -0.546875 6.957031 -0.296875 6.46875 -0.078125 C 5.988281 0.140625 5.421875 0.25 4.765625 0.25 Z M 8.25 0 L 8.25 -1.359375 L 8.1875 -1.359375 L 8.1875 -8 C 8.1875 -8.320312 8.144531 -8.535156 8.0625 -8.640625 C 7.988281 -8.742188 7.828125 -8.796875 7.578125 -8.796875 L 6.890625 -8.796875 L 6.890625 -9.484375 L 10.234375 -9.96875 L 11.15625 -9.96875 L 11.15625 -1.515625 C 11.15625 -1.273438 11.1875 -1.09375 11.25 -0.96875 C 11.3125 -0.851562 11.429688 -0.773438 11.609375 -0.734375 C 11.796875 -0.703125 12.0625 -0.6875 12.40625 -0.6875 L 12.40625 0 Z M 8.25 0 "
              id="path2693"
            />
          </symbol>
          <symbol overflow="visible" id="glyph0-10">
            <path
              style={{ stroke: 'none' }}
              d="M 0.46875 0 L 0.46875 -0.6875 C 0.875 -0.6875 1.171875 -0.710938 1.359375 -0.765625 C 1.554688 -0.828125 1.679688 -0.9375 1.734375 -1.09375 C 1.796875 -1.25 1.828125 -1.46875 1.828125 -1.75 L 1.828125 -12.453125 C 1.828125 -12.785156 1.785156 -13 1.703125 -13.09375 C 1.628906 -13.195312 1.46875 -13.25 1.21875 -13.25 L 0.53125 -13.25 L 0.53125 -13.96875 L 3.90625 -14.484375 L 4.8125 -14.484375 L 4.8125 -1.75 C 4.8125 -1.445312 4.832031 -1.222656 4.875 -1.078125 C 4.914062 -0.929688 5.015625 -0.828125 5.171875 -0.765625 C 5.335938 -0.710938 5.59375 -0.6875 5.9375 -0.6875 L 5.9375 0 Z M 6.9375 0 L 6.9375 -0.6875 L 7.21875 -0.6875 C 7.34375 -0.6875 7.4375 -0.707031 7.5 -0.75 C 7.570312 -0.789062 7.609375 -0.847656 7.609375 -0.921875 C 7.609375 -0.992188 7.5625 -1.097656 7.46875 -1.234375 C 7.375 -1.378906 7.269531 -1.535156 7.15625 -1.703125 L 4.984375 -5 L 6.890625 -7 L 10.03125 -2.5625 C 10.34375 -2.125 10.613281 -1.765625 10.84375 -1.484375 C 11.070312 -1.210938 11.28125 -1.007812 11.46875 -0.875 C 11.664062 -0.75 11.835938 -0.6875 11.984375 -0.6875 L 12.203125 -0.6875 L 12.203125 0 Z M 2.9375 -2.375 L 2.9375 -3.296875 L 7.28125 -7.734375 C 7.75 -8.222656 7.984375 -8.582031 7.984375 -8.8125 C 7.984375 -9.050781 7.847656 -9.171875 7.578125 -9.171875 L 7.0625 -9.171875 L 7.0625 -9.890625 L 11.375 -9.875 L 11.375 -9.171875 L 11.1875 -9.171875 C 10.59375 -9.171875 10.046875 -9 9.546875 -8.65625 C 9.054688 -8.3125 8.515625 -7.851562 7.921875 -7.28125 Z M 2.9375 -2.375 "
              id="path2696"
            />
          </symbol>
          <symbol overflow="visible" id="glyph0-11">
            <path
              style={{ stroke: 'none' }}
              d="M 4.265625 0.25 C 3.671875 0.25 3.164062 0.148438 2.75 -0.046875 C 2.34375 -0.253906 2.023438 -0.582031 1.796875 -1.03125 C 1.578125 -1.488281 1.46875 -2.085938 1.46875 -2.828125 L 1.46875 -9.140625 L 0.203125 -9.140625 L 0.203125 -9.8125 C 0.765625 -9.914062 1.285156 -10.144531 1.765625 -10.5 C 2.242188 -10.863281 2.648438 -11.3125 2.984375 -11.84375 C 3.328125 -12.382812 3.578125 -12.96875 3.734375 -13.59375 L 4.453125 -13.59375 L 4.453125 -9.875 L 6.515625 -9.875 L 6.515625 -9.140625 L 4.453125 -9.140625 L 4.453125 -2.96875 C 4.453125 -2.320312 4.539062 -1.835938 4.71875 -1.515625 C 4.894531 -1.191406 5.195312 -1.03125 5.625 -1.03125 C 5.875 -1.03125 6.109375 -1.078125 6.328125 -1.171875 C 6.554688 -1.273438 6.710938 -1.351562 6.796875 -1.40625 L 7.15625 -0.8125 C 6.988281 -0.6875 6.773438 -0.539062 6.515625 -0.375 C 6.253906 -0.207031 5.941406 -0.0625 5.578125 0.0625 C 5.222656 0.1875 4.785156 0.25 4.265625 0.25 Z M 4.265625 0.25 "
              id="path2699"
            />
          </symbol>
          <symbol overflow="visible" id="glyph0-12">
            <path
              style={{ stroke: 'none' }}
              d="M 0.484375 0 L 0.484375 -0.6875 C 0.890625 -0.6875 1.179688 -0.710938 1.359375 -0.765625 C 1.546875 -0.828125 1.671875 -0.9375 1.734375 -1.09375 C 1.796875 -1.25 1.828125 -1.46875 1.828125 -1.75 L 1.828125 -12.453125 C 1.828125 -12.773438 1.785156 -12.988281 1.703125 -13.09375 C 1.617188 -13.195312 1.457031 -13.25 1.21875 -13.25 L 0.53125 -13.25 L 0.53125 -13.96875 L 3.90625 -14.484375 L 4.8125 -14.484375 L 4.8125 -1.75 C 4.8125 -1.445312 4.835938 -1.222656 4.890625 -1.078125 C 4.953125 -0.929688 5.066406 -0.828125 5.234375 -0.765625 C 5.398438 -0.710938 5.664062 -0.6875 6.03125 -0.6875 L 6.03125 0 Z M 0.484375 0 "
              id="path2702"
            />
          </symbol>
          <symbol overflow="visible" id="glyph0-13">
            <path
              style={{ stroke: 'none' }}
              d="M 8.546875 0.234375 C 8.085938 0.234375 7.707031 0.164062 7.40625 0.03125 C 7.113281 -0.101562 6.898438 -0.28125 6.765625 -0.5 C 6.640625 -0.726562 6.578125 -0.972656 6.578125 -1.234375 L 6.578125 -7.4375 C 6.578125 -8.039062 6.460938 -8.488281 6.234375 -8.78125 C 6.015625 -9.070312 5.601562 -9.21875 5 -9.21875 C 4.789062 -9.21875 4.585938 -9.195312 4.390625 -9.15625 C 4.203125 -9.113281 4.050781 -9.050781 3.9375 -8.96875 C 3.832031 -8.894531 3.78125 -8.800781 3.78125 -8.6875 C 3.78125 -8.5625 3.820312 -8.453125 3.90625 -8.359375 C 4 -8.273438 4.085938 -8.171875 4.171875 -8.046875 C 4.265625 -7.921875 4.3125 -7.738281 4.3125 -7.5 C 4.3125 -7.132812 4.179688 -6.820312 3.921875 -6.5625 C 3.671875 -6.300781 3.316406 -6.171875 2.859375 -6.171875 C 2.390625 -6.171875 2.03125 -6.300781 1.78125 -6.5625 C 1.53125 -6.832031 1.40625 -7.144531 1.40625 -7.5 C 1.40625 -7.882812 1.5625 -8.273438 1.875 -8.671875 C 2.195312 -9.066406 2.695312 -9.398438 3.375 -9.671875 C 4.0625 -9.941406 4.957031 -10.078125 6.0625 -10.078125 C 7.269531 -10.078125 8.15625 -9.8125 8.71875 -9.28125 C 9.28125 -8.75 9.5625 -7.894531 9.5625 -6.71875 L 9.5625 -2.09375 C 9.5625 -1.582031 9.601562 -1.242188 9.6875 -1.078125 C 9.78125 -0.921875 9.925781 -0.84375 10.125 -0.84375 C 10.289062 -0.84375 10.425781 -0.863281 10.53125 -0.90625 C 10.632812 -0.957031 10.738281 -1.015625 10.84375 -1.078125 L 11.0625 -0.4375 C 10.71875 -0.21875 10.34375 -0.0507812 9.9375 0.0625 C 9.53125 0.175781 9.066406 0.234375 8.546875 0.234375 Z M 3.671875 0.25 C 2.742188 0.25 2.03125 0.0546875 1.53125 -0.328125 C 1.03125 -0.710938 0.78125 -1.269531 0.78125 -2 C 0.78125 -2.695312 1.054688 -3.3125 1.609375 -3.84375 C 2.160156 -4.375 2.941406 -4.820312 3.953125 -5.1875 C 4.972656 -5.550781 6.15625 -5.832031 7.5 -6.03125 L 7.5 -5.234375 C 6.175781 -4.972656 5.21875 -4.625 4.625 -4.1875 C 4.03125 -3.757812 3.734375 -3.195312 3.734375 -2.5 C 3.734375 -1.96875 3.84375 -1.59375 4.0625 -1.375 C 4.28125 -1.15625 4.617188 -1.046875 5.078125 -1.046875 C 5.390625 -1.046875 5.679688 -1.113281 5.953125 -1.25 C 6.222656 -1.394531 6.46875 -1.5625 6.6875 -1.75 C 6.914062 -1.9375 7.09375 -2.101562 7.21875 -2.25 L 7.46875 -1.546875 C 7.207031 -1.273438 6.898438 -1 6.546875 -0.71875 C 6.203125 -0.445312 5.796875 -0.21875 5.328125 -0.03125 C 4.859375 0.15625 4.304688 0.25 3.671875 0.25 Z M 3.671875 0.25 "
              id="path2705"
            />
          </symbol>
          <symbol overflow="visible" id="glyph0-14">
            <path
              style={{ stroke: 'none' }}
              d="M 4.703125 0.25 C 4.203125 0.238281 3.796875 0.191406 3.484375 0.109375 C 3.179688 0.0234375 2.921875 -0.0546875 2.703125 -0.140625 C 2.492188 -0.222656 2.285156 -0.265625 2.078125 -0.265625 C 1.941406 -0.265625 1.828125 -0.238281 1.734375 -0.1875 C 1.640625 -0.132812 1.566406 -0.0664062 1.515625 0.015625 L 1.015625 0.015625 L 0.8125 -3.40625 L 1.484375 -3.40625 C 1.660156 -2.507812 2.023438 -1.800781 2.578125 -1.28125 C 3.140625 -0.757812 3.804688 -0.5 4.578125 -0.5 C 5.097656 -0.5 5.546875 -0.625 5.921875 -0.875 C 6.296875 -1.132812 6.484375 -1.519531 6.484375 -2.03125 C 6.484375 -2.300781 6.421875 -2.53125 6.296875 -2.71875 C 6.179688 -2.90625 6 -3.066406 5.75 -3.203125 C 5.5 -3.347656 5.171875 -3.5 4.765625 -3.65625 L 3.640625 -3.96875 C 2.640625 -4.300781 1.929688 -4.703125 1.515625 -5.171875 C 1.109375 -5.640625 0.90625 -6.234375 0.90625 -6.953125 C 0.90625 -7.898438 1.238281 -8.660156 1.90625 -9.234375 C 2.582031 -9.804688 3.507812 -10.09375 4.6875 -10.09375 C 5.144531 -10.09375 5.507812 -10.054688 5.78125 -9.984375 C 6.050781 -9.921875 6.273438 -9.851562 6.453125 -9.78125 C 6.640625 -9.71875 6.828125 -9.6875 7.015625 -9.6875 C 7.179688 -9.6875 7.289062 -9.726562 7.34375 -9.8125 C 7.40625 -9.894531 7.445312 -9.976562 7.46875 -10.0625 L 8 -10.0625 L 8.171875 -7 L 7.53125 -7 C 7.394531 -7.5 7.203125 -7.921875 6.953125 -8.265625 C 6.703125 -8.617188 6.398438 -8.890625 6.046875 -9.078125 C 5.691406 -9.265625 5.300781 -9.359375 4.875 -9.359375 C 4.351562 -9.359375 3.9375 -9.234375 3.625 -8.984375 C 3.320312 -8.742188 3.171875 -8.441406 3.171875 -8.078125 C 3.171875 -7.804688 3.253906 -7.570312 3.421875 -7.375 C 3.585938 -7.175781 3.800781 -7.019531 4.0625 -6.90625 C 4.332031 -6.789062 4.59375 -6.6875 4.84375 -6.59375 L 5.84375 -6.28125 C 6.5 -6.082031 7.039062 -5.835938 7.46875 -5.546875 C 7.894531 -5.265625 8.210938 -4.929688 8.421875 -4.546875 C 8.628906 -4.171875 8.734375 -3.710938 8.734375 -3.171875 C 8.734375 -2.515625 8.578125 -1.925781 8.265625 -1.40625 C 7.960938 -0.882812 7.507812 -0.476562 6.90625 -0.1875 C 6.300781 0.101562 5.566406 0.25 4.703125 0.25 Z M 4.703125 0.25 "
              id="path2708"
            />
          </symbol>
          <symbol overflow="visible" id="glyph0-15">
            <path
              style={{ stroke: 'none' }}
              d="M 0.53125 0 L 0.53125 -0.6875 C 0.914062 -0.6875 1.203125 -0.710938 1.390625 -0.765625 C 1.585938 -0.828125 1.710938 -0.9375 1.765625 -1.09375 C 1.816406 -1.25 1.84375 -1.46875 1.84375 -1.75 L 1.84375 -7.9375 C 1.84375 -8.269531 1.800781 -8.488281 1.71875 -8.59375 C 1.644531 -8.695312 1.484375 -8.75 1.234375 -8.75 L 0.546875 -8.75 L 0.546875 -9.453125 L 3.90625 -9.96875 L 4.84375 -9.96875 L 4.84375 -1.75 C 4.84375 -1.445312 4.867188 -1.222656 4.921875 -1.078125 C 4.984375 -0.929688 5.097656 -0.828125 5.265625 -0.765625 C 5.429688 -0.710938 5.695312 -0.6875 6.0625 -0.6875 L 6.0625 0 Z M 3.25 -11.15625 C 2.789062 -11.15625 2.390625 -11.3125 2.046875 -11.625 C 1.703125 -11.945312 1.53125 -12.34375 1.53125 -12.8125 C 1.53125 -13.269531 1.703125 -13.660156 2.046875 -13.984375 C 2.390625 -14.304688 2.789062 -14.46875 3.25 -14.46875 C 3.5625 -14.46875 3.847656 -14.394531 4.109375 -14.25 C 4.378906 -14.101562 4.59375 -13.898438 4.75 -13.640625 C 4.90625 -13.390625 4.984375 -13.113281 4.984375 -12.8125 C 4.984375 -12.34375 4.8125 -11.945312 4.46875 -11.625 C 4.125 -11.3125 3.71875 -11.15625 3.25 -11.15625 Z M 3.25 -11.15625 "
              id="path2711"
            />
          </symbol>
          <symbol overflow="visible" id="glyph0-16">
            <path
              style={{ stroke: 'none' }}
              d="M 0.359375 0 L 0.359375 -0.6875 C 0.742188 -0.6875 1.035156 -0.710938 1.234375 -0.765625 C 1.429688 -0.828125 1.554688 -0.929688 1.609375 -1.078125 C 1.671875 -1.222656 1.703125 -1.445312 1.703125 -1.75 L 1.703125 -9.109375 L 0.359375 -9.109375 L 0.359375 -9.875 L 1.703125 -9.875 L 1.703125 -10.734375 C 1.703125 -11.546875 1.90625 -12.253906 2.3125 -12.859375 C 2.71875 -13.472656 3.304688 -13.953125 4.078125 -14.296875 C 4.847656 -14.640625 5.800781 -14.8125 6.9375 -14.8125 C 7.675781 -14.8125 8.351562 -14.722656 8.96875 -14.546875 C 9.582031 -14.367188 10.070312 -14.109375 10.4375 -13.765625 C 10.8125 -13.429688 11 -13 11 -12.46875 C 11 -12.082031 10.875 -11.75 10.625 -11.46875 C 10.375 -11.1875 10.023438 -11.046875 9.578125 -11.046875 C 9.160156 -11.046875 8.832031 -11.160156 8.59375 -11.390625 C 8.363281 -11.617188 8.25 -11.914062 8.25 -12.28125 C 8.25 -12.53125 8.296875 -12.722656 8.390625 -12.859375 C 8.484375 -12.992188 8.578125 -13.101562 8.671875 -13.1875 C 8.765625 -13.28125 8.8125 -13.378906 8.8125 -13.484375 C 8.8125 -13.648438 8.660156 -13.804688 8.359375 -13.953125 C 8.066406 -14.097656 7.679688 -14.171875 7.203125 -14.171875 C 6.796875 -14.171875 6.4375 -14.109375 6.125 -13.984375 C 5.8125 -13.859375 5.546875 -13.679688 5.328125 -13.453125 C 5.117188 -13.234375 4.957031 -12.953125 4.84375 -12.609375 C 4.738281 -12.265625 4.6875 -11.863281 4.6875 -11.40625 L 4.6875 -9.875 L 9.328125 -9.875 L 9.328125 -9.109375 L 4.6875 -9.109375 L 4.6875 -1.75 C 4.6875 -1.445312 4.71875 -1.21875 4.78125 -1.0625 C 4.851562 -0.914062 5.007812 -0.816406 5.25 -0.765625 C 5.488281 -0.710938 5.847656 -0.6875 6.328125 -0.6875 L 6.328125 0 Z M 7.03125 0 L 7.03125 -0.6875 C 7.425781 -0.6875 7.722656 -0.710938 7.921875 -0.765625 C 8.117188 -0.828125 8.242188 -0.9375 8.296875 -1.09375 C 8.347656 -1.25 8.375 -1.46875 8.375 -1.75 L 8.375 -8.3125 C 8.375 -8.632812 8.332031 -8.847656 8.25 -8.953125 C 8.175781 -9.054688 8.023438 -9.109375 7.796875 -9.109375 L 7.078125 -9.109375 L 7.078125 -9.8125 L 10.421875 -10.15625 L 11.34375 -10.15625 L 11.34375 -1.75 C 11.34375 -1.445312 11.367188 -1.222656 11.421875 -1.078125 C 11.484375 -0.929688 11.601562 -0.828125 11.78125 -0.765625 C 11.957031 -0.710938 12.222656 -0.6875 12.578125 -0.6875 L 12.578125 0 Z M 7.03125 0 "
              id="path2714"
            />
          </symbol>
          <symbol overflow="visible" id="glyph0-17">
            <path
              style={{ stroke: 'none' }}
              d="M 0.46875 0 L 0.46875 -1.171875 L 6.03125 -9.21875 L 4.328125 -9.21875 C 3.816406 -9.21875 3.363281 -9.148438 2.96875 -9.015625 C 2.582031 -8.878906 2.265625 -8.640625 2.015625 -8.296875 C 1.773438 -7.960938 1.59375 -7.472656 1.46875 -6.828125 L 0.84375 -6.828125 L 1.078125 -9.875 L 9.140625 -9.875 L 9.140625 -8.96875 L 3.5625 -0.671875 L 5.4375 -0.671875 C 6.195312 -0.671875 6.785156 -0.75 7.203125 -0.90625 C 7.617188 -1.0625 7.945312 -1.34375 8.1875 -1.75 C 8.425781 -2.15625 8.632812 -2.734375 8.8125 -3.484375 L 9.453125 -3.484375 L 9.21875 0 Z M 0.46875 0 "
              id="path2717"
            />
          </symbol>
          <symbol overflow="visible" id="glyph0-18">
            <path
              style={{ stroke: 'none' }}
              d="M 5.484375 0.25 C 3.941406 0.25 2.765625 -0.179688 1.953125 -1.046875 C 1.148438 -1.921875 0.75 -3.207031 0.75 -4.90625 C 0.75 -6.070312 0.929688 -7.039062 1.296875 -7.8125 C 1.660156 -8.582031 2.195312 -9.15625 2.90625 -9.53125 C 3.625 -9.90625 4.503906 -10.09375 5.546875 -10.09375 C 6.359375 -10.09375 7.054688 -9.976562 7.640625 -9.75 C 8.234375 -9.519531 8.710938 -9.179688 9.078125 -8.734375 C 9.453125 -8.296875 9.722656 -7.769531 9.890625 -7.15625 C 10.066406 -6.539062 10.15625 -5.835938 10.15625 -5.046875 L 10.15625 -4.875 L 2.546875 -4.875 L 2.546875 -5.609375 L 7.03125 -5.609375 C 7.03125 -6.460938 6.988281 -7.160156 6.90625 -7.703125 C 6.832031 -8.253906 6.6875 -8.664062 6.46875 -8.9375 C 6.257812 -9.21875 5.941406 -9.359375 5.515625 -9.359375 C 5.171875 -9.359375 4.867188 -9.242188 4.609375 -9.015625 C 4.359375 -8.785156 4.175781 -8.390625 4.0625 -7.828125 C 3.945312 -7.273438 3.890625 -6.5 3.890625 -5.5 C 3.890625 -4.726562 3.929688 -4.066406 4.015625 -3.515625 C 4.097656 -2.960938 4.234375 -2.503906 4.421875 -2.140625 C 4.609375 -1.773438 4.863281 -1.507812 5.1875 -1.34375 C 5.519531 -1.175781 5.925781 -1.09375 6.40625 -1.09375 C 6.894531 -1.09375 7.316406 -1.164062 7.671875 -1.3125 C 8.035156 -1.46875 8.347656 -1.691406 8.609375 -1.984375 C 8.878906 -2.285156 9.085938 -2.632812 9.234375 -3.03125 L 9.953125 -2.640625 C 9.773438 -2.210938 9.523438 -1.773438 9.203125 -1.328125 C 8.878906 -0.878906 8.425781 -0.503906 7.84375 -0.203125 C 7.257812 0.0976562 6.472656 0.25 5.484375 0.25 Z M 5.484375 0.25 "
              id="path2720"
            />
          </symbol>
          <symbol overflow="visible" id="glyph0-19">
            <path
              style={{ stroke: 'none' }}
              d="M 7.21875 0 L 7.21875 -0.6875 C 7.539062 -0.6875 7.78125 -0.707031 7.9375 -0.75 C 8.09375 -0.789062 8.191406 -0.878906 8.234375 -1.015625 C 8.285156 -1.160156 8.3125 -1.367188 8.3125 -1.640625 L 8.3125 -6.671875 C 8.3125 -7.179688 8.25 -7.59375 8.125 -7.90625 C 8.007812 -8.21875 7.835938 -8.445312 7.609375 -8.59375 C 7.378906 -8.738281 7.097656 -8.8125 6.765625 -8.8125 C 6.359375 -8.8125 5.992188 -8.707031 5.671875 -8.5 C 5.359375 -8.289062 5.019531 -8.003906 4.65625 -7.640625 L 4.59375 -8.359375 C 4.875 -8.640625 5.1875 -8.914062 5.53125 -9.1875 C 5.882812 -9.457031 6.28125 -9.675781 6.71875 -9.84375 C 7.164062 -10.007812 7.675781 -10.09375 8.25 -10.09375 C 9.175781 -10.09375 9.910156 -9.832031 10.453125 -9.3125 C 11.003906 -8.789062 11.28125 -7.953125 11.28125 -6.796875 L 11.28125 -1.75 C 11.28125 -1.445312 11.304688 -1.222656 11.359375 -1.078125 C 11.410156 -0.929688 11.53125 -0.828125 11.71875 -0.765625 C 11.914062 -0.710938 12.203125 -0.6875 12.578125 -0.6875 L 12.578125 0 Z M 0.53125 0 L 0.53125 -0.6875 C 0.9375 -0.6875 1.234375 -0.710938 1.421875 -0.765625 C 1.609375 -0.828125 1.726562 -0.929688 1.78125 -1.078125 C 1.84375 -1.222656 1.875 -1.445312 1.875 -1.75 L 1.875 -7.9375 C 1.875 -8.269531 1.832031 -8.488281 1.75 -8.59375 C 1.675781 -8.695312 1.515625 -8.75 1.265625 -8.75 L 0.59375 -8.75 L 0.59375 -9.453125 L 3.859375 -9.96875 L 4.765625 -9.96875 L 4.765625 -8.59375 L 4.84375 -8.59375 L 4.84375 -1.703125 C 4.84375 -1.410156 4.875 -1.191406 4.9375 -1.046875 C 5.007812 -0.910156 5.125 -0.816406 5.28125 -0.765625 C 5.4375 -0.710938 5.675781 -0.6875 6 -0.6875 L 6 0 Z M 0.53125 0 "
              id="path2723"
            />
          </symbol>
          <symbol overflow="visible" id="glyph0-20">
            <path
              style={{ stroke: 'none' }}
              d="M 4.984375 4.453125 C 4.097656 4.453125 3.3125 4.363281 2.625 4.1875 C 1.9375 4.007812 1.398438 3.734375 1.015625 3.359375 C 0.628906 2.992188 0.4375 2.53125 0.4375 1.96875 C 0.4375 1.382812 0.660156 0.882812 1.109375 0.46875 C 1.554688 0.0625 2.269531 -0.253906 3.25 -0.484375 L 5 -0.34375 C 4.394531 -0.28125 3.921875 -0.140625 3.578125 0.078125 C 3.234375 0.296875 2.984375 0.550781 2.828125 0.84375 C 2.679688 1.144531 2.609375 1.457031 2.609375 1.78125 C 2.609375 2.375 2.84375 2.851562 3.3125 3.21875 C 3.78125 3.59375 4.492188 3.78125 5.453125 3.78125 C 6.046875 3.78125 6.578125 3.707031 7.046875 3.5625 C 7.515625 3.414062 7.878906 3.191406 8.140625 2.890625 C 8.410156 2.597656 8.546875 2.226562 8.546875 1.78125 C 8.546875 1.195312 8.300781 0.78125 7.8125 0.53125 C 7.320312 0.289062 6.570312 0.171875 5.5625 0.171875 L 3.4375 0.171875 C 3.09375 0.171875 2.753906 0.0859375 2.421875 -0.078125 C 2.097656 -0.253906 1.832031 -0.488281 1.625 -0.78125 C 1.425781 -1.070312 1.328125 -1.398438 1.328125 -1.765625 C 1.328125 -2.378906 1.601562 -2.898438 2.15625 -3.328125 C 2.707031 -3.765625 3.410156 -4.097656 4.265625 -4.328125 L 4.703125 -3.984375 C 4.566406 -3.960938 4.410156 -3.910156 4.234375 -3.828125 C 4.054688 -3.753906 3.878906 -3.671875 3.703125 -3.578125 C 3.523438 -3.484375 3.378906 -3.378906 3.265625 -3.265625 C 3.160156 -3.160156 3.109375 -3.035156 3.109375 -2.890625 C 3.109375 -2.753906 3.203125 -2.613281 3.390625 -2.46875 C 3.578125 -2.332031 3.9375 -2.265625 4.46875 -2.265625 L 6.65625 -2.265625 C 7.925781 -2.265625 8.875 -2.003906 9.5 -1.484375 C 10.132812 -0.972656 10.453125 -0.226562 10.453125 0.75 C 10.453125 1.582031 10.226562 2.269531 9.78125 2.8125 C 9.332031 3.363281 8.703125 3.773438 7.890625 4.046875 C 7.078125 4.316406 6.109375 4.453125 4.984375 4.453125 Z M 5.125 -3.484375 C 4.3125 -3.484375 3.570312 -3.59375 2.90625 -3.8125 C 2.238281 -4.039062 1.71875 -4.398438 1.34375 -4.890625 C 0.96875 -5.378906 0.78125 -5.988281 0.78125 -6.71875 C 0.78125 -7.3125 0.894531 -7.816406 1.125 -8.234375 C 1.351562 -8.648438 1.671875 -8.992188 2.078125 -9.265625 C 2.492188 -9.546875 2.96875 -9.753906 3.5 -9.890625 C 4.039062 -10.023438 4.601562 -10.09375 5.1875 -10.09375 C 6.007812 -10.09375 6.753906 -9.96875 7.421875 -9.71875 C 8.085938 -9.46875 8.613281 -9.097656 9 -8.609375 C 9.394531 -8.117188 9.59375 -7.492188 9.59375 -6.734375 C 9.59375 -5.984375 9.394531 -5.367188 9 -4.890625 C 8.601562 -4.410156 8.0625 -4.054688 7.375 -3.828125 C 6.695312 -3.597656 5.945312 -3.484375 5.125 -3.484375 Z M 5.1875 -4.15625 C 5.664062 -4.15625 6.03125 -4.359375 6.28125 -4.765625 C 6.53125 -5.179688 6.65625 -5.878906 6.65625 -6.859375 C 6.65625 -7.484375 6.609375 -7.976562 6.515625 -8.34375 C 6.429688 -8.71875 6.289062 -8.984375 6.09375 -9.140625 C 5.894531 -9.304688 5.613281 -9.390625 5.25 -9.390625 C 4.707031 -9.390625 4.328125 -9.1875 4.109375 -8.78125 C 3.898438 -8.382812 3.796875 -7.703125 3.796875 -6.734375 C 3.796875 -5.796875 3.894531 -5.128906 4.09375 -4.734375 C 4.300781 -4.347656 4.664062 -4.15625 5.1875 -4.15625 Z M 10.796875 -7.921875 C 10.523438 -7.921875 10.316406 -7.976562 10.171875 -8.09375 C 10.035156 -8.21875 9.96875 -8.367188 9.96875 -8.546875 C 9.96875 -8.660156 9.976562 -8.75 10 -8.8125 C 10.019531 -8.882812 10.03125 -8.953125 10.03125 -9.015625 C 10.03125 -9.078125 10.003906 -9.128906 9.953125 -9.171875 C 9.910156 -9.210938 9.828125 -9.234375 9.703125 -9.234375 C 9.578125 -9.234375 9.421875 -9.175781 9.234375 -9.0625 C 9.046875 -8.957031 8.859375 -8.738281 8.671875 -8.40625 L 8.25 -8.96875 C 8.488281 -9.375 8.78125 -9.660156 9.125 -9.828125 C 9.46875 -10.003906 9.828125 -10.09375 10.203125 -10.09375 C 10.679688 -10.09375 11.050781 -9.988281 11.3125 -9.78125 C 11.582031 -9.570312 11.71875 -9.265625 11.71875 -8.859375 C 11.71875 -8.597656 11.644531 -8.375 11.5 -8.1875 C 11.351562 -8.007812 11.117188 -7.921875 10.796875 -7.921875 Z M 10.796875 -7.921875 "
              id="path2726"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-0">
            <path style={{ stroke: 'none' }} d="" id="path2729" />
          </symbol>
          <symbol overflow="visible" id="glyph1-1">
            <path
              style={{ stroke: 'none' }}
              d="M 4.34375 -4.234375 C 4.3125 -4.703125 4.234375 -4.96875 4.03125 -5.25 C 3.703125 -5.703125 3.125 -5.96875 2.453125 -5.96875 C 1.34375 -5.96875 0.546875 -5.296875 0.546875 -4.34375 C 0.546875 -3.921875 0.71875 -3.546875 1.015625 -3.265625 C 1.234375 -3.0625 1.609375 -2.859375 2.21875 -2.59375 C 2.90625 -2.3125 3.015625 -2.25 3.1875 -2.125 C 3.453125 -1.953125 3.578125 -1.75 3.578125 -1.484375 C 3.578125 -1.015625 3.125 -0.6875 2.5 -0.6875 C 1.734375 -0.6875 1.3125 -1.09375 1.234375 -1.90625 L 0.359375 -1.90625 C 0.421875 -0.59375 1.15625 0.109375 2.484375 0.109375 C 3.71875 0.109375 4.5 -0.578125 4.5 -1.640625 C 4.5 -2.0625 4.375 -2.421875 4.125 -2.6875 C 3.90625 -2.9375 3.640625 -3.09375 2.78125 -3.4375 C 2.0625 -3.75 1.96875 -3.796875 1.78125 -3.90625 C 1.578125 -4.03125 1.453125 -4.21875 1.453125 -4.421875 C 1.453125 -4.859375 1.875 -5.1875 2.421875 -5.1875 C 3.03125 -5.1875 3.40625 -4.84375 3.46875 -4.234375 Z M 4.34375 -4.234375 "
              id="path2732"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-2">
            <path
              style={{ stroke: 'none' }}
              d="M 1.734375 -4.171875 L 1.75 -5.375 L 0.921875 -5.375 L 0.890625 -4.171875 L 0.234375 -4.171875 L 0.21875 -3.5 L 0.859375 -3.5 L 0.8125 -1.640625 C 0.796875 -1.21875 0.796875 -1.21875 0.796875 -1.125 C 0.796875 -0.71875 0.828125 -0.53125 0.9375 -0.359375 C 1.125 -0.078125 1.453125 0.09375 1.890625 0.09375 C 2.1875 0.09375 2.4375 0.03125 2.734375 -0.078125 L 2.75 -0.8125 C 2.53125 -0.71875 2.328125 -0.671875 2.125 -0.671875 C 1.78125 -0.671875 1.6875 -0.8125 1.6875 -1.296875 C 1.6875 -1.359375 1.6875 -1.359375 1.6875 -1.640625 L 1.71875 -3.5 L 2.640625 -3.5 L 2.640625 -4.171875 Z M 1.734375 -4.171875 "
              id="path2735"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-3">
            <path
              style={{ stroke: 'none' }}
              d="M 0.5625 -4.171875 C 0.609375 -3.8125 0.609375 -3.734375 0.609375 -2.828125 L 0.609375 0 L 1.484375 0 L 1.484375 -1.90625 C 1.484375 -2.375 1.53125 -2.6875 1.640625 -2.921875 C 1.796875 -3.296875 2.0625 -3.5 2.390625 -3.5 C 2.59375 -3.5 2.765625 -3.453125 3 -3.3125 L 3 -4.1875 C 2.828125 -4.25 2.703125 -4.28125 2.59375 -4.28125 C 2.109375 -4.28125 1.75 -3.96875 1.4375 -3.296875 C 1.453125 -3.40625 1.453125 -3.46875 1.453125 -3.53125 C 1.453125 -3.75 1.421875 -3.96875 1.390625 -4.171875 Z M 0.5625 -4.171875 "
              id="path2738"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-4">
            <path
              style={{ stroke: 'none' }}
              d="M 0.59375 -4.171875 L 0.59375 -1.6875 C 0.59375 -1.125 0.65625 -0.78125 0.8125 -0.53125 C 1.0625 -0.140625 1.515625 0.09375 2.0625 0.09375 C 2.59375 0.09375 2.921875 -0.09375 3.203125 -0.515625 C 3.21875 -0.3125 3.25 -0.125 3.296875 0 L 4.125 0 C 4.015625 -0.34375 4.015625 -0.34375 4.015625 -1.28125 L 4.015625 -4.171875 L 3.15625 -4.171875 L 3.15625 -1.875 C 3.15625 -1.515625 3.109375 -1.28125 3.015625 -1.09375 C 2.84375 -0.8125 2.578125 -0.671875 2.25 -0.671875 C 1.96875 -0.671875 1.734375 -0.78125 1.59375 -0.953125 C 1.5 -1.09375 1.453125 -1.34375 1.453125 -1.71875 L 1.453125 -4.171875 Z M 0.59375 -4.171875 "
              id="path2741"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-5">
            <path
              style={{ stroke: 'none' }}
              d="M 3.140625 -4.171875 L 1.5 -2.25 L 3.15625 0 L 4.3125 0 L 2.53125 -2.265625 L 4.1875 -4.171875 Z M 0.625 -5.90625 L 0.625 0 L 1.484375 0 L 1.484375 -5.90625 Z M 0.625 -5.90625 "
              id="path2744"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-6">
            <path
              style={{ stroke: 'none' }}
              d="M 0.625 -4.171875 L 0.625 0 L 1.5 0 L 1.5 -4.171875 Z M 1.078125 -5.96875 C 0.75 -5.96875 0.515625 -5.734375 0.515625 -5.40625 C 0.515625 -5.09375 0.734375 -4.875 1.0625 -4.875 C 1.390625 -4.875 1.609375 -5.09375 1.609375 -5.40625 C 1.609375 -5.734375 1.390625 -5.96875 1.078125 -5.96875 Z M 1.078125 -5.96875 "
              id="path2747"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-7">
            <path
              style={{ stroke: 'none' }}
              d="M 4.0625 -1.90625 C 4.078125 -1.984375 4.078125 -2.0625 4.078125 -2.078125 C 4.078125 -3.4375 3.375 -4.296875 2.265625 -4.296875 C 1.109375 -4.296875 0.34375 -3.390625 0.34375 -2.046875 C 0.34375 -0.734375 1.125 0.109375 2.296875 0.109375 C 3.15625 0.109375 3.75 -0.3125 3.96875 -1.09375 L 3.203125 -1.140625 C 3.015625 -0.765625 2.75 -0.59375 2.328125 -0.59375 C 1.640625 -0.59375 1.25 -1.0625 1.21875 -1.90625 Z M 1.234375 -2.546875 C 1.375 -3.25 1.703125 -3.59375 2.25 -3.59375 C 2.78125 -3.59375 3.109375 -3.25 3.1875 -2.546875 Z M 1.234375 -2.546875 "
              id="path2750"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-8">
            <path style={{ stroke: 'none' }} d="" id="path2753" />
          </symbol>
          <symbol overflow="visible" id="glyph1-9">
            <path
              style={{ stroke: 'none' }}
              d="M 2.125 -5.890625 L 0.125 0 L 1.0625 0 L 1.5 -1.375 L 3.640625 -1.375 L 4.078125 0 L 5.015625 0 L 3.015625 -5.890625 Z M 3.40625 -2.15625 L 1.734375 -2.15625 L 2.5625 -4.796875 Z M 3.40625 -2.15625 "
              id="path2756"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-10">
            <path
              style={{ stroke: 'none' }}
              d="M 0.515625 -4.171875 C 0.625 -3.78125 0.625 -3.734375 0.625 -2.71875 L 0.625 0 L 1.484375 0 L 1.484375 -2.21875 C 1.484375 -2.625 1.53125 -2.875 1.640625 -3.046875 C 1.796875 -3.34375 2.09375 -3.515625 2.421875 -3.515625 C 2.734375 -3.515625 2.96875 -3.375 3.078125 -3.125 C 3.15625 -2.953125 3.1875 -2.765625 3.1875 -2.265625 L 3.1875 0 L 4.046875 0 L 4.046875 -2.40625 C 4.046875 -3.171875 4.015625 -3.359375 3.875 -3.640625 C 3.671875 -4.03125 3.234375 -4.28125 2.6875 -4.28125 C 2.140625 -4.28125 1.71875 -4.0625 1.4375 -3.609375 C 1.421875 -3.875 1.40625 -4.015625 1.34375 -4.171875 Z M 0.515625 -4.171875 "
              id="path2759"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-11">
            <path
              style={{ stroke: 'none' }}
              d="M 0.625 -5.90625 L 0.625 0 L 1.5 0 L 1.5 -5.90625 Z M 0.625 -5.90625 "
              id="path2762"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-12">
            <path
              style={{ stroke: 'none' }}
              d="M 0.625 -5.90625 L 0.625 0 L 1.484375 0 L 1.484375 -2.21875 C 1.484375 -2.59375 1.53125 -2.84375 1.640625 -3.046875 C 1.796875 -3.328125 2.09375 -3.515625 2.421875 -3.515625 C 2.734375 -3.515625 2.96875 -3.375 3.09375 -3.125 C 3.1875 -2.953125 3.203125 -2.71875 3.203125 -2.265625 L 3.203125 0 L 4.078125 0 L 4.078125 -2.40625 C 4.078125 -3.171875 4.03125 -3.453125 3.859375 -3.71875 C 3.640625 -4.0625 3.1875 -4.28125 2.6875 -4.28125 C 2.1875 -4.28125 1.796875 -4.09375 1.484375 -3.703125 L 1.484375 -5.90625 Z M 0.625 -5.90625 "
              id="path2765"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-13">
            <path
              style={{ stroke: 'none' }}
              d="M 1.640625 -3.4375 L 1.640625 -5.078125 L 4.203125 -5.078125 L 4.203125 -5.875 L 0.734375 -5.875 L 0.734375 0 L 1.640625 0 L 1.640625 -2.640625 L 4 -2.640625 L 4 -3.4375 Z M 1.640625 -3.4375 "
              id="path2768"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-14">
            <path
              style={{ stroke: 'none' }}
              d="M 3.65625 -2.953125 C 3.59375 -3.8125 3.03125 -4.296875 2.078125 -4.296875 C 1.140625 -4.296875 0.515625 -3.78125 0.515625 -3.015625 C 0.515625 -2.734375 0.609375 -2.46875 0.78125 -2.28125 C 0.953125 -2.109375 1.1875 -1.984375 1.640625 -1.859375 C 2.3125 -1.65625 2.40625 -1.625 2.546875 -1.546875 C 2.75 -1.4375 2.828125 -1.328125 2.828125 -1.140625 C 2.828125 -0.796875 2.53125 -0.5625 2.0625 -0.5625 C 1.5 -0.5625 1.21875 -0.8125 1.171875 -1.34375 L 0.359375 -1.34375 C 0.359375 -0.390625 0.96875 0.109375 2.078125 0.109375 C 3.09375 0.109375 3.6875 -0.390625 3.6875 -1.203125 C 3.6875 -1.5 3.609375 -1.734375 3.453125 -1.9375 C 3.265625 -2.125 3 -2.265625 2.359375 -2.453125 C 1.515625 -2.6875 1.375 -2.78125 1.375 -3.09375 C 1.375 -3.390625 1.65625 -3.609375 2.0625 -3.609375 C 2.515625 -3.609375 2.75 -3.40625 2.8125 -2.953125 Z M 3.65625 -2.953125 "
              id="path2771"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-15">
            <path
              style={{ stroke: 'none' }}
              d="M 0.390625 -4.171875 L 0.390625 -3.46875 L 2.34375 -3.46875 L 0.1875 -0.671875 L 0.1875 0 L 3.390625 0 L 3.390625 -0.71875 L 1.21875 -0.71875 L 3.40625 -3.53125 L 3.40625 -4.171875 Z M 0.390625 -4.171875 "
              id="path2774"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-16">
            <path
              style={{ stroke: 'none' }}
              d="M 0 -2.53125 L 0 -1.890625 L 2.34375 -1.890625 L 2.34375 -2.53125 Z M 0 -2.53125 "
              id="path2777"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-17">
            <path
              style={{ stroke: 'none' }}
              d="M 4.03125 -5.90625 L 3.171875 -5.90625 L 3.171875 -3.65625 C 2.859375 -4.109375 2.5625 -4.28125 2.046875 -4.28125 C 1.0625 -4.28125 0.359375 -3.359375 0.359375 -2.046875 C 0.359375 -0.75 1.03125 0.09375 2.078125 0.09375 C 2.625 0.09375 2.96875 -0.109375 3.25 -0.59375 C 3.25 -0.5 3.25 -0.453125 3.25 -0.40625 C 3.25 -0.265625 3.25 -0.171875 3.296875 0 L 4.109375 0 C 4.0625 -0.28125 4.03125 -0.546875 4.03125 -1.28125 Z M 2.234375 -3.546875 C 2.828125 -3.546875 3.1875 -2.984375 3.1875 -2.09375 C 3.1875 -1.203125 2.8125 -0.640625 2.203125 -0.640625 C 1.609375 -0.640625 1.234375 -1.171875 1.234375 -2.0625 C 1.234375 -2.984375 1.625 -3.546875 2.234375 -3.546875 Z M 2.234375 -3.546875 "
              id="path2780"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-18">
            <path
              style={{ stroke: 'none' }}
              d="M 1.578125 -4.171875 L 1.578125 -4.359375 C 1.578125 -4.6875 1.59375 -4.859375 1.625 -4.96875 C 1.703125 -5.15625 1.859375 -5.265625 2.078125 -5.265625 C 2.265625 -5.265625 2.453125 -5.234375 2.734375 -5.125 L 2.734375 -5.859375 C 2.453125 -5.96875 2.1875 -6.015625 1.921875 -6.015625 C 1.484375 -6.015625 1.125 -5.84375 0.921875 -5.53125 C 0.765625 -5.296875 0.71875 -5.015625 0.71875 -4.4375 L 0.71875 -4.171875 L 0.140625 -4.171875 L 0.140625 -3.5 L 0.71875 -3.5 L 0.71875 0 L 1.59375 0 L 1.59375 -3.5 L 2.59375 -3.5 L 2.59375 -4.171875 Z M 1.578125 -4.171875 "
              id="path2783"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-19">
            <path
              style={{ stroke: 'none' }}
              d="M 1.359375 -3 C 1.4375 -3.390625 1.703125 -3.578125 2.1875 -3.578125 C 2.703125 -3.578125 2.90625 -3.375 2.90625 -2.828125 L 2.90625 -2.71875 C 1.984375 -2.546875 1.734375 -2.5 1.34375 -2.34375 C 0.71875 -2.109375 0.390625 -1.6875 0.390625 -1.09375 C 0.390625 -0.359375 0.9375 0.09375 1.8125 0.09375 C 2.390625 0.09375 2.78125 -0.109375 3.015625 -0.515625 C 3.015625 -0.296875 3.03125 -0.1875 3.078125 0 L 3.875 0 C 3.78125 -0.25 3.75 -0.453125 3.75 -1.015625 L 3.75 -2.640625 C 3.75 -3.171875 3.71875 -3.390625 3.609375 -3.625 C 3.4375 -4.03125 2.9375 -4.28125 2.234375 -4.28125 C 1.703125 -4.28125 1.25 -4.140625 0.953125 -3.890625 C 0.703125 -3.671875 0.578125 -3.421875 0.53125 -3 Z M 2.90625 -1.796875 C 2.90625 -1.421875 2.875 -1.1875 2.78125 -1.03125 C 2.640625 -0.75 2.34375 -0.59375 1.984375 -0.59375 C 1.5625 -0.59375 1.28125 -0.828125 1.28125 -1.203125 C 1.28125 -1.703125 1.703125 -1.9375 2.90625 -2.125 Z M 2.90625 -1.796875 "
              id="path2786"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-20">
            <path
              style={{ stroke: 'none' }}
              d="M 3.90625 -5.875 L 1.65625 -3.09375 L 3.96875 0 L 5.15625 0 L 2.6875 -3.125 L 4.96875 -5.875 Z M 0.734375 -5.875 L 0.734375 0 L 1.640625 0 L 1.640625 -5.875 Z M 0.734375 -5.875 "
              id="path2789"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-21">
            <path
              style={{ stroke: 'none' }}
              d="M 0.625 1.734375 L 1.484375 1.734375 L 1.484375 -0.515625 C 1.8125 -0.078125 2.140625 0.09375 2.640625 0.09375 C 3.625 0.09375 4.3125 -0.8125 4.3125 -2.109375 C 4.3125 -3.40625 3.625 -4.28125 2.609375 -4.28125 C 2.078125 -4.28125 1.71875 -4.078125 1.4375 -3.640625 C 1.4375 -3.828125 1.40625 -4.046875 1.359375 -4.171875 L 0.546875 -4.171875 C 0.609375 -3.890625 0.625 -3.625 0.625 -2.890625 Z M 2.46875 -3.546875 C 3.0625 -3.546875 3.421875 -2.984375 3.421875 -2.09375 C 3.421875 -1.171875 3.0625 -0.640625 2.46875 -0.640625 C 1.859375 -0.640625 1.46875 -1.21875 1.46875 -2.078125 C 1.46875 -2.96875 1.859375 -3.546875 2.46875 -3.546875 Z M 2.46875 -3.546875 "
              id="path2792"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-22">
            <path
              style={{ stroke: 'none' }}
              d="M 3.875 -2.796875 C 3.75 -3.765625 3.1875 -4.296875 2.25 -4.296875 C 1.09375 -4.296875 0.34375 -3.421875 0.34375 -2.078125 C 0.34375 -0.765625 1.09375 0.109375 2.25 0.109375 C 3.203125 0.109375 3.828125 -0.484375 3.890625 -1.453125 L 3.046875 -1.453125 C 2.984375 -0.859375 2.734375 -0.59375 2.25 -0.59375 C 1.609375 -0.59375 1.234375 -1.140625 1.234375 -2.078125 C 1.234375 -3 1.625 -3.59375 2.234375 -3.59375 C 2.6875 -3.59375 2.921875 -3.359375 3.015625 -2.796875 Z M 3.875 -2.796875 "
              id="path2795"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-23">
            <path
              style={{ stroke: 'none' }}
              d="M 0.453125 -5.875 L 0.453125 -5.109375 L 3.046875 -5.109375 L 0.234375 -0.71875 L 0.234375 0 L 4.078125 0 L 4.078125 -0.78125 L 1.296875 -0.78125 L 4.15625 -5.234375 L 4.15625 -5.875 Z M 0.453125 -5.875 "
              id="path2798"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-24">
            <path
              style={{ stroke: 'none' }}
              d="M 1.578125 -4.171875 L 1.578125 -4.359375 C 1.578125 -4.6875 1.59375 -4.859375 1.625 -4.96875 C 1.703125 -5.15625 1.859375 -5.265625 2.078125 -5.265625 C 2.265625 -5.265625 2.453125 -5.234375 2.734375 -5.125 L 2.734375 -5.859375 C 2.453125 -5.96875 2.1875 -6.015625 1.921875 -6.015625 C 1.484375 -6.015625 1.125 -5.84375 0.921875 -5.53125 C 0.765625 -5.296875 0.71875 -5.015625 0.71875 -4.4375 L 0.71875 -4.171875 L 0.140625 -4.171875 L 0.140625 -3.5 L 0.71875 -3.5 L 0.71875 0 L 1.59375 0 L 1.59375 -3.5 L 2.59375 -3.5 L 2.59375 -4.171875 Z M 3.296875 -4.171875 L 3.296875 0 L 4.171875 0 L 4.171875 -4.171875 Z M 3.75 -5.96875 C 3.40625 -5.96875 3.1875 -5.734375 3.1875 -5.40625 C 3.1875 -5.09375 3.40625 -4.875 3.734375 -4.875 C 4.0625 -4.875 4.28125 -5.09375 4.28125 -5.40625 C 4.28125 -5.734375 4.0625 -5.96875 3.75 -5.96875 Z M 3.75 -5.96875 "
              id="path2801"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-25">
            <path
              style={{ stroke: 'none' }}
              d="M 0.734375 -5.875 L 0.734375 0 L 1.9375 0 C 2.96875 0 3.25 -0.03125 3.65625 -0.15625 C 4.28125 -0.359375 4.6875 -0.953125 4.6875 -1.65625 C 4.6875 -2.453125 4.28125 -2.921875 3.40625 -3.125 C 4.078125 -3.34375 4.375 -3.734375 4.375 -4.40625 C 4.375 -5.03125 4.03125 -5.53125 3.46875 -5.734375 C 3.140625 -5.828125 2.8125 -5.875 2.0625 -5.875 Z M 1.625 -3.421875 L 1.625 -5.125 L 2.078125 -5.125 C 2.625 -5.125 2.84375 -5.09375 3.046875 -5.015625 C 3.3125 -4.90625 3.46875 -4.625 3.46875 -4.296875 C 3.46875 -3.953125 3.328125 -3.6875 3.078125 -3.5625 C 2.875 -3.453125 2.609375 -3.421875 2.140625 -3.421875 Z M 1.625 -0.75 L 1.625 -2.6875 L 2.1875 -2.6875 C 2.75 -2.6875 2.96875 -2.671875 3.203125 -2.59375 C 3.546875 -2.453125 3.75 -2.140625 3.75 -1.71875 C 3.75 -1.3125 3.578125 -1 3.296875 -0.875 C 3.0625 -0.78125 2.828125 -0.75 2.15625 -0.75 Z M 1.625 -0.75 "
              id="path2804"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-26">
            <path
              style={{ stroke: 'none' }}
              d="M 2.296875 -4.296875 C 1.171875 -4.296875 0.34375 -3.375 0.34375 -2.125 C 0.34375 -0.796875 1.140625 0.109375 2.296875 0.109375 C 3.4375 0.109375 4.234375 -0.796875 4.234375 -2.078125 C 4.234375 -3.375 3.4375 -4.296875 2.296875 -4.296875 Z M 2.296875 -3.59375 C 2.921875 -3.59375 3.359375 -2.96875 3.359375 -2.078125 C 3.359375 -1.203125 2.921875 -0.59375 2.296875 -0.59375 C 1.65625 -0.59375 1.234375 -1.1875 1.234375 -2.109375 C 1.234375 -2.984375 1.671875 -3.59375 2.296875 -3.59375 Z M 2.296875 -3.59375 "
              id="path2807"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-27">
            <path
              style={{ stroke: 'none' }}
              d="M 1.359375 -3 C 1.4375 -3.390625 1.703125 -3.578125 2.1875 -3.578125 C 2.703125 -3.578125 2.90625 -3.375 2.90625 -2.828125 L 2.90625 -2.71875 C 1.984375 -2.546875 1.734375 -2.5 1.34375 -2.34375 C 0.71875 -2.109375 0.390625 -1.6875 0.390625 -1.09375 C 0.390625 -0.359375 0.9375 0.09375 1.8125 0.09375 C 2.390625 0.09375 2.78125 -0.109375 3.015625 -0.515625 C 3.015625 -0.296875 3.03125 -0.1875 3.078125 0 L 3.875 0 C 3.78125 -0.25 3.75 -0.453125 3.75 -1.015625 L 3.75 -2.640625 C 3.75 -3.171875 3.71875 -3.390625 3.609375 -3.625 C 3.4375 -4.03125 2.9375 -4.28125 2.234375 -4.28125 C 1.703125 -4.28125 1.25 -4.140625 0.953125 -3.890625 C 0.703125 -3.671875 0.578125 -3.421875 0.53125 -3 Z M 2.90625 -1.796875 C 2.90625 -1.421875 2.875 -1.1875 2.78125 -1.03125 C 2.640625 -0.75 2.34375 -0.59375 1.984375 -0.59375 C 1.5625 -0.59375 1.28125 -0.828125 1.28125 -1.203125 C 1.28125 -1.703125 1.703125 -1.9375 2.90625 -2.125 Z M 1.40625 -5.96875 C 1.109375 -5.96875 0.875 -5.734375 0.875 -5.4375 C 0.875 -5.140625 1.109375 -4.90625 1.40625 -4.90625 C 1.703125 -4.90625 1.9375 -5.140625 1.9375 -5.4375 C 1.9375 -5.734375 1.703125 -5.96875 1.40625 -5.96875 Z M 2.921875 -5.984375 C 2.625 -5.984375 2.390625 -5.75 2.390625 -5.4375 C 2.390625 -5.140625 2.625 -4.90625 2.921875 -4.90625 C 3.21875 -4.90625 3.453125 -5.140625 3.453125 -5.4375 C 3.453125 -5.734375 3.21875 -5.984375 2.921875 -5.984375 Z M 2.921875 -5.984375 "
              id="path2810"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-28">
            <path
              style={{ stroke: 'none' }}
              d="M 0.609375 -5.90625 L 0.609375 -1.140625 C 0.609375 -0.40625 0.609375 -0.3125 0.578125 0 L 1.34375 0 C 1.390625 -0.171875 1.40625 -0.328125 1.421875 -0.578125 C 1.671875 -0.109375 2.03125 0.09375 2.546875 0.09375 C 3.59375 0.09375 4.3125 -0.796875 4.3125 -2.09375 C 4.3125 -3.375 3.625 -4.28125 2.640625 -4.28125 C 2.140625 -4.28125 1.8125 -4.078125 1.484375 -3.609375 L 1.484375 -5.90625 Z M 2.484375 -3.53125 C 3.0625 -3.53125 3.421875 -2.984375 3.421875 -2.109375 C 3.421875 -1.203125 3.046875 -0.640625 2.4375 -0.640625 C 1.84375 -0.640625 1.46875 -1.203125 1.46875 -2.0625 C 1.46875 -2.96875 1.859375 -3.53125 2.484375 -3.53125 Z M 2.484375 -3.53125 "
              id="path2813"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-29">
            <path
              style={{ stroke: 'none' }}
              d="M 4.296875 -4.171875 L 2.96875 -4.140625 C 2.671875 -4.234375 2.484375 -4.25 2.234375 -4.25 C 1.234375 -4.25 0.59375 -3.6875 0.59375 -2.796875 C 0.59375 -2.21875 0.828125 -1.84375 1.359375 -1.59375 C 0.8125 -1.40625 0.609375 -1.21875 0.609375 -0.9375 C 0.609375 -0.71875 0.75 -0.5625 1.078125 -0.4375 C 0.46875 -0.234375 0.21875 0.078125 0.21875 0.5625 C 0.21875 1.296875 0.984375 1.78125 2.203125 1.78125 C 3.453125 1.78125 4.1875 1.28125 4.1875 0.4375 C 4.1875 0 3.984375 -0.359375 3.640625 -0.546875 C 3.375 -0.6875 3.125 -0.734375 2.34375 -0.8125 C 1.6875 -0.890625 1.671875 -0.890625 1.578125 -0.921875 C 1.5 -0.953125 1.453125 -1.015625 1.453125 -1.09375 C 1.453125 -1.21875 1.640625 -1.359375 1.90625 -1.390625 C 2.734375 -1.515625 2.828125 -1.53125 3.125 -1.671875 C 3.5 -1.84375 3.71875 -2.234375 3.71875 -2.703125 C 3.71875 -3.03125 3.609375 -3.375 3.4375 -3.546875 L 4.296875 -3.546875 Z M 2.1875 -3.59375 C 2.640625 -3.59375 2.96875 -3.265625 2.96875 -2.8125 C 2.96875 -2.359375 2.640625 -2.078125 2.15625 -2.078125 C 1.6875 -2.078125 1.359375 -2.359375 1.359375 -2.8125 C 1.359375 -3.265625 1.6875 -3.59375 2.1875 -3.59375 Z M 2.109375 -0.109375 C 2.90625 -0.109375 3.359375 0.109375 3.359375 0.5 C 3.359375 0.875 2.921875 1.125 2.21875 1.125 C 1.453125 1.125 0.96875 0.875 0.96875 0.5 C 0.96875 0.109375 1.390625 -0.109375 2.109375 -0.109375 Z M 2.109375 -0.109375 "
              id="path2816"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-30">
            <path
              style={{ stroke: 'none' }}
              d="M 0.09375 -4.171875 L 1.578125 0.03125 L 2.53125 0.03125 L 4.015625 -4.171875 L 3.109375 -4.171875 L 2.0625 -0.9375 L 1 -4.171875 Z M 0.09375 -4.171875 "
              id="path2819"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-31">
            <path
              style={{ stroke: 'none' }}
              d="M 1.640625 -3.4375 L 1.640625 -5.078125 L 4.203125 -5.078125 L 4.203125 -5.875 L 0.734375 -5.875 L 0.734375 0 L 4.28125 0 L 4.28125 -0.78125 L 1.640625 -0.78125 L 1.640625 -2.640625 L 4 -2.640625 L 4 -3.4375 Z M 1.640625 -3.4375 "
              id="path2822"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-32">
            <path
              style={{ stroke: 'none' }}
              d="M 0.234375 -4.171875 L 1.5625 -2.21875 L 0.03125 0 L 1.078125 0 L 2.078125 -1.546875 L 3.078125 0 L 4.125 0 L 2.609375 -2.21875 L 3.9375 -4.171875 L 2.90625 -4.171875 L 2.078125 -2.859375 L 1.265625 -4.171875 Z M 0.234375 -4.171875 "
              id="path2825"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-33">
            <path
              style={{ stroke: 'none' }}
              d="M 0.734375 -5.875 L 0.734375 0 L 1.796875 0 C 3.015625 0 3.421875 -0.0625 3.921875 -0.34375 C 4.734375 -0.796875 5.21875 -1.78125 5.21875 -2.9375 C 5.21875 -4.09375 4.703125 -5.109375 3.859375 -5.546875 C 3.40625 -5.78125 2.90625 -5.875 1.921875 -5.875 Z M 1.640625 -0.78125 L 1.640625 -5.078125 L 1.890625 -5.078125 C 2.84375 -5.078125 3.09375 -5.046875 3.453125 -4.828125 C 3.984375 -4.5 4.28125 -3.8125 4.28125 -2.9375 C 4.28125 -2.078125 4 -1.390625 3.515625 -1.0625 C 3.171875 -0.84375 2.875 -0.78125 2.109375 -0.78125 Z M 1.640625 -0.78125 "
              id="path2828"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-34">
            <path
              style={{ stroke: 'none' }}
              d="M 1.640625 0 L 1.640625 -5.875 L 0.71875 -5.875 L 0.71875 0 Z M 1.640625 0 "
              id="path2831"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-35">
            <path
              style={{ stroke: 'none' }}
              d="M 0.734375 -5.875 L 0.734375 0 L 1.640625 0 L 1.640625 -2.28125 L 2.015625 -2.28125 C 2.859375 -2.28125 3.234375 -2.3125 3.578125 -2.4375 C 4.21875 -2.65625 4.625 -3.265625 4.625 -4.046875 C 4.625 -4.84375 4.21875 -5.484375 3.546875 -5.703125 C 3.171875 -5.828125 2.78125 -5.875 1.90625 -5.875 Z M 1.640625 -3.0625 L 1.640625 -5.078125 L 2.015625 -5.078125 C 2.671875 -5.078125 2.9375 -5.046875 3.1875 -4.9375 C 3.5 -4.796875 3.671875 -4.484375 3.671875 -4.0625 C 3.671875 -3.59375 3.453125 -3.25 3.0625 -3.15625 C 2.828125 -3.078125 2.640625 -3.0625 2.015625 -3.0625 Z M 1.640625 -3.0625 "
              id="path2834"
            />
          </symbol>
          <symbol overflow="visible" id="glyph1-36">
            <path
              style={{ stroke: 'none' }}
              d="M 2.90625 -5.96875 C 1.421875 -5.96875 0.375 -4.75 0.375 -2.96875 C 0.375 -1.109375 1.375 0.109375 2.90625 0.109375 C 4.421875 0.109375 5.4375 -1.125 5.4375 -2.9375 C 5.4375 -4.75 4.421875 -5.96875 2.90625 -5.96875 Z M 2.90625 -5.1875 C 3.875 -5.1875 4.484375 -4.3125 4.484375 -2.9375 C 4.484375 -1.546875 3.875 -0.671875 2.90625 -0.671875 C 1.921875 -0.671875 1.328125 -1.546875 1.328125 -2.96875 C 1.328125 -4.3125 1.9375 -5.1875 2.90625 -5.1875 Z M 2.90625 -5.1875 "
              id="path2837"
            />
          </symbol>
          <symbol overflow="visible" id="glyph2-0">
            <path style={{ stroke: 'none' }} d="" id="path2840" />
          </symbol>
          <symbol overflow="visible" id="glyph2-1">
            <path
              style={{ stroke: 'none' }}
              d="M 2.5 -4.8125 L 2.5 -8 L 0.953125 -8 L 0.953125 0 L 2.5 0 L 2.5 -3.546875 L 5.671875 -3.546875 L 5.671875 0 L 7.21875 0 L 7.21875 -8 L 5.671875 -8 L 5.671875 -4.8125 Z M 2.5 -4.8125 "
              id="path2843"
            />
          </symbol>
          <symbol overflow="visible" id="glyph2-2">
            <path
              style={{ stroke: 'none' }}
              d="M 3.21875 -5.859375 C 1.59375 -5.859375 0.390625 -4.59375 0.390625 -2.890625 C 0.390625 -1.09375 1.546875 0.15625 3.21875 0.15625 C 4.84375 0.15625 6.03125 -1.109375 6.03125 -2.84375 C 6.03125 -4.59375 4.84375 -5.859375 3.21875 -5.859375 Z M 3.21875 -4.671875 C 3.984375 -4.671875 4.515625 -3.921875 4.515625 -2.859375 C 4.515625 -1.78125 3.984375 -1.03125 3.21875 -1.03125 C 2.421875 -1.03125 1.90625 -1.765625 1.90625 -2.875 C 1.90625 -3.921875 2.453125 -4.671875 3.21875 -4.671875 Z M 3.21875 -4.671875 "
              id="path2846"
            />
          </symbol>
          <symbol overflow="visible" id="glyph2-3">
            <path
              style={{ stroke: 'none' }}
              d="M 0.828125 -8.046875 L 0.828125 0 L 2.296875 0 L 2.296875 -2.921875 C 2.296875 -3.40625 2.359375 -3.703125 2.453125 -3.921875 C 2.65625 -4.296875 3.03125 -4.53125 3.4375 -4.53125 C 3.796875 -4.53125 4.109375 -4.34375 4.265625 -4.015625 C 4.375 -3.796875 4.40625 -3.53125 4.40625 -2.96875 L 4.40625 0 L 5.875 0 L 5.875 -3.28125 C 5.875 -4.3125 5.8125 -4.65625 5.59375 -5.03125 C 5.28125 -5.515625 4.640625 -5.8125 3.953125 -5.8125 C 3.28125 -5.8125 2.75 -5.5625 2.296875 -5.078125 L 2.296875 -8.046875 Z M 0.828125 -8.046875 "
              id="path2849"
            />
          </symbol>
          <symbol overflow="visible" id="glyph2-4">
            <path
              style={{ stroke: 'none' }}
              d="M 5.765625 -2.5 L 5.765625 -2.78125 C 5.765625 -4.6875 4.78125 -5.859375 3.171875 -5.859375 C 1.5 -5.859375 0.390625 -4.625 0.390625 -2.78125 C 0.390625 -0.984375 1.484375 0.15625 3.21875 0.15625 C 4.46875 0.15625 5.40625 -0.515625 5.65625 -1.609375 L 4.359375 -1.671875 C 4.15625 -1.234375 3.796875 -1.03125 3.25 -1.03125 C 2.421875 -1.03125 1.921875 -1.5625 1.875 -2.5 Z M 1.90625 -3.578125 C 2.09375 -4.34375 2.515625 -4.71875 3.15625 -4.71875 C 3.796875 -4.71875 4.15625 -4.34375 4.28125 -3.578125 Z M 1.90625 -3.578125 "
              id="path2852"
            />
          </symbol>
          <symbol overflow="visible" id="glyph2-5">
            <path style={{ stroke: 'none' }} d="" id="path2855" />
          </symbol>
          <symbol overflow="visible" id="glyph2-6">
            <path
              style={{ stroke: 'none' }}
              d="M 6.125 -5.65625 C 6.09375 -6.3125 5.96875 -6.703125 5.703125 -7.09375 C 5.21875 -7.78125 4.375 -8.15625 3.390625 -8.15625 C 1.78125 -8.15625 0.640625 -7.1875 0.640625 -5.8125 C 0.640625 -5.25 0.84375 -4.734375 1.21875 -4.359375 C 1.5 -4.046875 1.953125 -3.78125 2.859375 -3.390625 C 4.015625 -2.921875 4.015625 -2.921875 4.234375 -2.796875 C 4.609375 -2.59375 4.78125 -2.34375 4.78125 -2.03125 C 4.78125 -1.53125 4.265625 -1.171875 3.515625 -1.171875 C 2.515625 -1.171875 1.96875 -1.6875 1.875 -2.71875 L 0.390625 -2.71875 C 0.453125 -0.84375 1.53125 0.15625 3.5 0.15625 C 5.25 0.15625 6.359375 -0.796875 6.359375 -2.3125 C 6.359375 -2.921875 6.171875 -3.4375 5.8125 -3.796875 C 5.46875 -4.140625 5.296875 -4.234375 3.90625 -4.796875 C 2.8125 -5.234375 2.8125 -5.234375 2.59375 -5.359375 C 2.328125 -5.5 2.1875 -5.71875 2.1875 -5.96875 C 2.1875 -6.453125 2.6875 -6.828125 3.34375 -6.828125 C 4.109375 -6.828125 4.59375 -6.390625 4.65625 -5.65625 Z M 6.125 -5.65625 "
              id="path2858"
            />
          </symbol>
          <symbol overflow="visible" id="glyph2-7">
            <path
              style={{ stroke: 'none' }}
              d="M 0.828125 -5.703125 L 0.828125 0 L 2.296875 0 L 2.296875 -5.703125 Z M 1.59375 -8.15625 C 1.0625 -8.15625 0.703125 -7.8125 0.703125 -7.28125 C 0.703125 -6.765625 1.046875 -6.4375 1.578125 -6.4375 C 2.09375 -6.4375 2.421875 -6.78125 2.421875 -7.3125 C 2.421875 -7.8125 2.09375 -8.15625 1.59375 -8.15625 Z M 1.59375 -8.15625 "
              id="path2861"
            />
          </symbol>
          <symbol overflow="visible" id="glyph2-8">
            <path
              style={{ stroke: 'none' }}
              d="M 5.515625 -3.8125 C 5.34375 -5.140625 4.515625 -5.859375 3.15625 -5.859375 C 1.5 -5.859375 0.390625 -4.65625 0.390625 -2.84375 C 0.390625 -1.0625 1.5 0.15625 3.125 0.15625 C 4.515625 0.15625 5.484375 -0.71875 5.5625 -2.03125 L 4.125 -2.03125 C 4.046875 -1.359375 3.71875 -1.03125 3.125 -1.03125 C 2.359375 -1.03125 1.90625 -1.703125 1.90625 -2.84375 C 1.90625 -3.953125 2.40625 -4.671875 3.15625 -4.671875 C 3.671875 -4.671875 3.984375 -4.375 4.0625 -3.8125 Z M 5.515625 -3.8125 "
              id="path2864"
            />
          </symbol>
          <symbol overflow="visible" id="glyph2-9">
            <path
              style={{ stroke: 'none' }}
              d="M 0.75 -5.703125 C 0.796875 -5.390625 0.796875 -5.265625 0.796875 -4.953125 C 0.8125 -4.53125 0.8125 -4.203125 0.8125 -3.953125 L 0.8125 0 L 2.296875 0 L 2.296875 -2.65625 C 2.296875 -3.921875 2.65625 -4.53125 3.4375 -4.53125 C 3.75 -4.53125 4.046875 -4.421875 4.3125 -4.25 L 4.3125 -5.75 C 4.078125 -5.8125 4.03125 -5.8125 3.875 -5.8125 C 3.1875 -5.8125 2.6875 -5.4375 2.234375 -4.515625 C 2.25 -4.640625 2.25 -4.75 2.25 -4.8125 C 2.25 -5.140625 2.203125 -5.453125 2.140625 -5.703125 Z M 0.75 -5.703125 "
              id="path2867"
            />
          </symbol>
          <symbol overflow="visible" id="glyph2-10">
            <path
              style={{ stroke: 'none' }}
              d="M 2.65625 -5.703125 L 2.671875 -7.34375 L 1.25 -7.34375 L 1.21875 -5.703125 L 0.28125 -5.703125 L 0.28125 -4.546875 L 1.15625 -4.546875 L 1.078125 -2.328125 L 1.0625 -1.765625 C 1.0625 -1.140625 1.125 -0.859375 1.3125 -0.578125 C 1.578125 -0.125 2.078125 0.125 2.71875 0.125 C 3.171875 0.125 3.5625 0.03125 4.015625 -0.140625 L 4.015625 -1.375 C 3.703125 -1.234375 3.4375 -1.171875 3.171875 -1.171875 C 2.71875 -1.171875 2.578125 -1.359375 2.578125 -1.953125 C 2.578125 -2.0625 2.578125 -2.0625 2.59375 -2.359375 L 2.625 -4.546875 L 3.8125 -4.546875 L 3.8125 -5.703125 Z M 2.65625 -5.703125 "
              id="path2870"
            />
          </symbol>
          <symbol overflow="visible" id="glyph2-11">
            <path
              style={{ stroke: 'none' }}
              d="M 5.265625 -3.96875 C 5.1875 -5.171875 4.34375 -5.875 2.953125 -5.875 C 1.578125 -5.875 0.671875 -5.125 0.671875 -4.015625 C 0.671875 -3.609375 0.8125 -3.234375 1.0625 -2.984375 C 1.296875 -2.765625 1.625 -2.609375 2.25 -2.40625 C 3.265625 -2.109375 3.265625 -2.109375 3.4375 -2.03125 C 3.734375 -1.90625 3.828125 -1.78125 3.828125 -1.578125 C 3.828125 -1.203125 3.484375 -0.953125 2.921875 -0.953125 C 2.21875 -0.953125 1.890625 -1.234375 1.84375 -1.90625 L 0.453125 -1.90625 C 0.453125 -0.546875 1.3125 0.15625 2.984375 0.15625 C 4.453125 0.15625 5.296875 -0.53125 5.296875 -1.6875 C 5.296875 -2.0625 5.1875 -2.40625 4.96875 -2.65625 C 4.734375 -2.9375 4.375 -3.125 3.53125 -3.375 C 2.65625 -3.625 2.546875 -3.65625 2.375 -3.765625 C 2.21875 -3.859375 2.140625 -4.015625 2.140625 -4.171875 C 2.140625 -4.515625 2.46875 -4.765625 2.921875 -4.765625 C 3.484375 -4.765625 3.765625 -4.515625 3.84375 -3.96875 Z M 5.265625 -3.96875 "
              id="path2873"
            />
          </symbol>
          <symbol overflow="visible" id="glyph2-12">
            <path
              style={{ stroke: 'none' }}
              d="M 0.640625 -5.703125 C 0.8125 -5.140625 0.828125 -5.046875 0.828125 -3.65625 L 0.828125 0 L 2.296875 0 L 2.296875 -2.921875 C 2.296875 -3.484375 2.34375 -3.703125 2.453125 -3.9375 C 2.609375 -4.296875 2.96875 -4.53125 3.390625 -4.53125 C 3.75 -4.53125 4.03125 -4.359375 4.171875 -4.046875 C 4.265625 -3.828125 4.3125 -3.546875 4.3125 -2.96875 L 4.3125 0 L 5.78125 0 L 5.78125 -3.28125 C 5.78125 -4.3125 5.734375 -4.609375 5.515625 -4.984375 C 5.21875 -5.515625 4.59375 -5.8125 3.890625 -5.8125 C 3.1875 -5.8125 2.609375 -5.53125 2.203125 -4.96875 C 2.203125 -5.28125 2.15625 -5.515625 2.078125 -5.703125 Z M 0.640625 -5.703125 "
              id="path2876"
            />
          </symbol>
          <symbol overflow="visible" id="glyph2-13">
            <path
              style={{ stroke: 'none' }}
              d="M 0.78125 -5.703125 L 0.78125 -2.375 C 0.78125 -1.625 0.890625 -1.078125 1.109375 -0.75 C 1.453125 -0.203125 2.109375 0.125 2.875 0.125 C 3.5625 0.125 4.015625 -0.09375 4.46875 -0.65625 C 4.46875 -0.390625 4.53125 -0.125 4.578125 0 L 5.96875 0 C 5.828125 -0.5 5.828125 -0.5 5.828125 -1.765625 L 5.828125 -5.703125 L 4.359375 -5.703125 L 4.359375 -2.65625 C 4.359375 -1.65625 3.984375 -1.171875 3.234375 -1.171875 C 2.890625 -1.171875 2.609375 -1.296875 2.453125 -1.515625 C 2.328125 -1.6875 2.25 -2 2.25 -2.453125 L 2.25 -5.703125 Z M 0.78125 -5.703125 "
              id="path2879"
            />
          </symbol>
          <symbol overflow="visible" id="glyph2-14">
            <path
              style={{ stroke: 'none' }}
              d="M 6.140625 -5.703125 L 4.265625 -5.65625 C 3.796875 -5.78125 3.53125 -5.8125 3.171875 -5.8125 C 1.71875 -5.8125 0.796875 -5.046875 0.796875 -3.8125 C 0.796875 -3.03125 1.09375 -2.53125 1.765625 -2.203125 C 1.03125 -1.90625 0.75 -1.671875 0.75 -1.28125 C 0.75 -0.96875 0.9375 -0.78125 1.390625 -0.59375 C 0.59375 -0.328125 0.234375 0.078125 0.234375 0.734375 C 0.234375 1.765625 1.328125 2.40625 3.078125 2.40625 C 4.875 2.40625 5.921875 1.71875 5.921875 0.5 C 5.921875 -0.09375 5.640625 -0.59375 5.171875 -0.84375 C 4.828125 -1.03125 4.375 -1.125 3.40625 -1.21875 C 2.234375 -1.328125 2.15625 -1.359375 2.15625 -1.578125 C 2.15625 -1.75 2.390625 -1.890625 2.71875 -1.90625 C 3.953125 -2.03125 4 -2.03125 4.390625 -2.203125 C 4.96875 -2.453125 5.28125 -2.953125 5.28125 -3.625 C 5.28125 -4 5.171875 -4.359375 4.984375 -4.640625 L 6.140625 -4.640625 Z M 3.078125 -4.703125 C 3.640625 -4.703125 4.046875 -4.359375 4.046875 -3.828125 C 4.046875 -3.328125 3.640625 -2.984375 3.046875 -2.984375 C 2.453125 -2.984375 2.0625 -3.328125 2.0625 -3.828125 C 2.0625 -4.375 2.453125 -4.703125 3.078125 -4.703125 Z M 2.90625 -0.109375 C 3.90625 -0.109375 4.5 0.171875 4.5 0.640625 C 4.5 1.09375 4 1.34375 3.09375 1.34375 C 2.09375 1.34375 1.5 1.0625 1.5 0.609375 C 1.5 0.15625 2.015625 -0.109375 2.90625 -0.109375 Z M 2.90625 -0.109375 "
              id="path2882"
            />
          </symbol>
          <symbol overflow="visible" id="glyph2-15">
            <path
              style={{ stroke: 'none' }}
              d="M 0.953125 -8 L 0.953125 0 L 2.5 0 L 2.5 -3.0625 L 3.59375 -3.0625 L 5.234375 0 L 7.015625 0 L 5.1875 -3.328125 C 6.125 -3.75 6.59375 -4.5 6.59375 -5.546875 C 6.59375 -6.46875 6.1875 -7.234375 5.453125 -7.625 C 4.90625 -7.921875 4.375 -8 2.953125 -8 Z M 2.5 -4.375 L 2.5 -6.703125 L 2.9375 -6.703125 C 3.984375 -6.703125 4.203125 -6.671875 4.515625 -6.484375 C 4.84375 -6.296875 5.03125 -5.96875 5.03125 -5.5625 C 5.03125 -5.046875 4.78125 -4.65625 4.359375 -4.5 C 4.0625 -4.390625 3.796875 -4.375 3.046875 -4.375 Z M 2.5 -4.375 "
              id="path2885"
            />
          </symbol>
          <symbol overflow="visible" id="glyph2-16">
            <path
              style={{ stroke: 'none' }}
              d="M 4.421875 -5.703125 L 2.328125 -3.03125 L 4.40625 0 L 6.390625 0 L 4.0625 -3.0625 L 6.1875 -5.703125 Z M 0.828125 -8.046875 L 0.828125 0 L 2.296875 0 L 2.296875 -8.046875 Z M 0.828125 -8.046875 "
              id="path2888"
            />
          </symbol>
          <symbol overflow="visible" id="glyph2-17">
            <path
              style={{ stroke: 'none' }}
              d="M 0.8125 -8.046875 L 0.8125 -1.5 C 0.8125 -0.546875 0.8125 -0.375 0.78125 0 L 2.046875 0 C 2.109375 -0.234375 2.140625 -0.390625 2.15625 -0.765625 C 2.46875 -0.171875 2.96875 0.125 3.6875 0.125 C 5.140625 0.125 6.171875 -1.109375 6.171875 -2.859375 C 6.171875 -4.578125 5.203125 -5.8125 3.859375 -5.8125 C 3.203125 -5.8125 2.75 -5.578125 2.296875 -4.984375 L 2.296875 -8.046875 Z M 3.5 -4.578125 C 4.21875 -4.578125 4.65625 -3.9375 4.65625 -2.875 C 4.65625 -1.796875 4.1875 -1.109375 3.453125 -1.109375 C 2.734375 -1.109375 2.296875 -1.78125 2.296875 -2.828125 C 2.296875 -3.9375 2.75 -4.578125 3.5 -4.578125 Z M 3.5 -4.578125 "
              id="path2891"
            />
          </symbol>
          <symbol overflow="visible" id="glyph2-18">
            <path
              style={{ stroke: 'none' }}
              d="M 2.09375 -4 C 2.171875 -4.4375 2.5 -4.65625 3.0625 -4.65625 C 3.6875 -4.65625 3.921875 -4.421875 3.921875 -3.796875 L 3.921875 -3.703125 C 2.375 -3.421875 2.296875 -3.40625 1.78125 -3.203125 C 0.9375 -2.890625 0.484375 -2.296875 0.484375 -1.5 C 0.484375 -0.484375 1.25 0.125 2.5625 0.125 C 3.3125 0.125 3.8125 -0.125 4.125 -0.640625 C 4.125 -0.359375 4.140625 -0.234375 4.203125 0 L 5.546875 0 C 5.40625 -0.296875 5.359375 -0.59375 5.359375 -1.265625 L 5.359375 -3.5625 C 5.359375 -4.28125 5.296875 -4.625 5.125 -4.96875 C 4.859375 -5.515625 4.15625 -5.8125 3.171875 -5.8125 C 2.40625 -5.8125 1.734375 -5.625 1.3125 -5.28125 C 0.9375 -4.984375 0.75 -4.625 0.6875 -4 Z M 3.921875 -2.390625 C 3.921875 -1.9375 3.890625 -1.71875 3.8125 -1.53125 C 3.65625 -1.21875 3.296875 -1.015625 2.859375 -1.015625 C 2.359375 -1.015625 1.984375 -1.296875 1.984375 -1.6875 C 1.984375 -1.9375 2.125 -2.171875 2.34375 -2.328125 C 2.59375 -2.515625 2.96875 -2.59375 3.921875 -2.71875 Z M 3.921875 -2.390625 "
              id="path2894"
            />
          </symbol>
          <symbol overflow="visible" id="glyph2-19">
            <path
              style={{ stroke: 'none' }}
              d="M 2.421875 -5.703125 L 2.421875 -5.84375 C 2.421875 -6.75 2.546875 -6.96875 3.046875 -6.96875 C 3.3125 -6.96875 3.5625 -6.921875 4.015625 -6.796875 L 4.015625 -7.984375 C 3.546875 -8.15625 3.140625 -8.25 2.71875 -8.25 C 2.046875 -8.25 1.546875 -8.015625 1.265625 -7.578125 C 1.03125 -7.234375 0.953125 -6.828125 0.953125 -6.0625 L 0.953125 -5.703125 L 0.1875 -5.703125 L 0.1875 -4.546875 L 0.953125 -4.546875 L 0.953125 0 L 2.421875 0 L 2.421875 -4.546875 L 3.78125 -4.546875 L 3.78125 -5.703125 Z M 2.421875 -5.703125 "
              id="path2897"
            />
          </symbol>
          <symbol overflow="visible" id="glyph2-20">
            <path
              style={{ stroke: 'none' }}
              d="M 5.75 -8.046875 L 4.265625 -8.046875 L 4.265625 -5.078125 C 3.859375 -5.609375 3.453125 -5.8125 2.796875 -5.8125 C 1.40625 -5.8125 0.390625 -4.5625 0.390625 -2.796875 C 0.390625 -1.0625 1.375 0.125 2.8125 0.125 C 3.59375 0.125 4.0625 -0.140625 4.4375 -0.796875 C 4.421875 -0.640625 4.421875 -0.578125 4.421875 -0.5 C 4.421875 -0.359375 4.4375 -0.234375 4.46875 0 L 5.859375 0 C 5.765625 -0.390625 5.75 -0.84375 5.75 -1.796875 Z M 3.125 -4.578125 C 3.859375 -4.578125 4.296875 -3.9375 4.296875 -2.859375 C 4.296875 -1.78125 3.828125 -1.109375 3.078125 -1.109375 C 2.34375 -1.109375 1.890625 -1.75 1.890625 -2.796875 C 1.890625 -3.921875 2.359375 -4.578125 3.125 -4.578125 Z M 3.125 -4.578125 "
              id="path2900"
            />
          </symbol>
          <symbol overflow="visible" id="glyph2-21">
            <path
              style={{ stroke: 'none' }}
              d="M 0.15625 -5.703125 L 1.828125 0.03125 L 3.40625 0.03125 L 4.453125 -3.390625 L 5.515625 0.03125 L 7.109375 0.03125 L 8.8125 -5.703125 L 7.328125 -5.703125 L 6.25 -1.6875 L 5.078125 -5.703125 L 3.890625 -5.703125 L 2.703125 -1.6875 L 1.640625 -5.703125 Z M 0.15625 -5.703125 "
              id="path2903"
            />
          </symbol>
          <symbol overflow="visible" id="glyph3-0">
            <path style={{ stroke: 'none' }} d="" id="path2906" />
          </symbol>
          <symbol overflow="visible" id="glyph3-1">
            <path
              style={{ stroke: 'none' }}
              d="M 3.53125 -10 L 0.15625 0 L 2.109375 0 L 2.75 -2.078125 L 6.265625 -2.078125 L 6.890625 0 L 8.875 0 L 5.46875 -10 Z M 5.796875 -3.71875 L 3.21875 -3.71875 L 4.5 -7.796875 Z M 5.796875 -3.71875 "
              id="path2909"
            />
          </symbol>
          <symbol overflow="visible" id="glyph3-2">
            <path
              style={{ stroke: 'none' }}
              d="M 0.8125 -7.125 C 1.015625 -6.4375 1.03125 -6.296875 1.03125 -4.578125 L 1.03125 0 L 2.875 0 L 2.875 -3.640625 C 2.875 -4.34375 2.921875 -4.640625 3.0625 -4.921875 C 3.265625 -5.375 3.71875 -5.65625 4.234375 -5.65625 C 4.6875 -5.65625 5.046875 -5.4375 5.21875 -5.0625 C 5.34375 -4.78125 5.390625 -4.421875 5.390625 -3.703125 L 5.390625 0 L 7.234375 0 L 7.234375 -4.109375 C 7.234375 -5.40625 7.171875 -5.765625 6.90625 -6.234375 C 6.53125 -6.890625 5.75 -7.28125 4.859375 -7.28125 C 3.984375 -7.28125 3.265625 -6.921875 2.75 -6.203125 C 2.75 -6.59375 2.703125 -6.90625 2.59375 -7.125 Z M 0.8125 -7.125 "
              id="path2912"
            />
          </symbol>
          <symbol overflow="visible" id="glyph3-3">
            <path
              style={{ stroke: 'none' }}
              d="M 1.03125 -10.0625 L 1.03125 0 L 2.875 0 L 2.875 -10.0625 Z M 1.03125 -10.0625 "
              id="path2915"
            />
          </symbol>
          <symbol overflow="visible" id="glyph3-4">
            <path
              style={{ stroke: 'none' }}
              d="M 2.609375 -5 C 2.71875 -5.546875 3.125 -5.8125 3.828125 -5.8125 C 4.609375 -5.8125 4.90625 -5.515625 4.90625 -4.734375 L 4.90625 -4.625 C 2.96875 -4.28125 2.859375 -4.265625 2.21875 -4 C 1.171875 -3.609375 0.59375 -2.859375 0.59375 -1.875 C 0.59375 -0.59375 1.5625 0.15625 3.1875 0.15625 C 4.140625 0.15625 4.765625 -0.171875 5.15625 -0.8125 C 5.15625 -0.453125 5.171875 -0.28125 5.25 0 L 6.9375 0 C 6.75 -0.375 6.6875 -0.734375 6.6875 -1.59375 L 6.6875 -4.453125 C 6.6875 -5.359375 6.609375 -5.796875 6.40625 -6.203125 C 6.078125 -6.890625 5.1875 -7.28125 3.953125 -7.28125 C 3.015625 -7.28125 2.171875 -7.03125 1.640625 -6.59375 C 1.171875 -6.21875 0.9375 -5.78125 0.859375 -5 Z M 4.90625 -2.984375 C 4.90625 -2.4375 4.859375 -2.140625 4.765625 -1.921875 C 4.578125 -1.515625 4.125 -1.265625 3.5625 -1.265625 C 2.9375 -1.265625 2.484375 -1.625 2.484375 -2.109375 C 2.484375 -2.421875 2.65625 -2.71875 2.921875 -2.90625 C 3.234375 -3.140625 3.703125 -3.234375 4.90625 -3.390625 Z M 4.90625 -2.984375 "
              id="path2918"
            />
          </symbol>
          <symbol overflow="visible" id="glyph3-5">
            <path
              style={{ stroke: 'none' }}
              d="M 7.6875 -7.125 L 5.328125 -7.078125 C 4.734375 -7.234375 4.40625 -7.28125 3.953125 -7.28125 C 2.140625 -7.28125 0.984375 -6.296875 0.984375 -4.765625 C 0.984375 -3.796875 1.359375 -3.171875 2.203125 -2.75 C 1.296875 -2.390625 0.9375 -2.078125 0.9375 -1.609375 C 0.9375 -1.21875 1.171875 -0.96875 1.734375 -0.75 C 0.734375 -0.40625 0.296875 0.109375 0.296875 0.921875 C 0.296875 2.203125 1.671875 3.015625 3.859375 3.015625 C 6.09375 3.015625 7.390625 2.140625 7.390625 0.625 C 7.390625 -0.125 7.046875 -0.75 6.46875 -1.046875 C 6.03125 -1.296875 5.46875 -1.40625 4.265625 -1.515625 C 2.796875 -1.671875 2.703125 -1.6875 2.703125 -1.96875 C 2.703125 -2.1875 2.984375 -2.359375 3.40625 -2.390625 C 4.953125 -2.53125 5 -2.53125 5.484375 -2.75 C 6.203125 -3.0625 6.59375 -3.6875 6.59375 -4.53125 C 6.59375 -5 6.46875 -5.4375 6.21875 -5.8125 L 7.6875 -5.8125 Z M 3.84375 -5.875 C 4.5625 -5.875 5.0625 -5.4375 5.0625 -4.78125 C 5.0625 -4.15625 4.5625 -3.734375 3.8125 -3.734375 C 3.0625 -3.734375 2.578125 -4.15625 2.578125 -4.78125 C 2.578125 -5.453125 3.078125 -5.875 3.84375 -5.875 Z M 3.625 -0.140625 C 4.875 -0.140625 5.625 0.203125 5.625 0.796875 C 5.625 1.359375 5 1.6875 3.875 1.6875 C 2.609375 1.6875 1.875 1.328125 1.875 0.765625 C 1.875 0.1875 2.515625 -0.140625 3.625 -0.140625 Z M 3.625 -0.140625 "
              id="path2921"
            />
          </symbol>
          <symbol overflow="visible" id="glyph3-6">
            <path
              style={{ stroke: 'none' }}
              d="M 7.21875 -3.125 L 7.21875 -3.484375 C 7.21875 -5.84375 5.96875 -7.3125 3.953125 -7.3125 C 1.875 -7.3125 0.5 -5.796875 0.5 -3.484375 C 0.5 -1.234375 1.859375 0.1875 4.015625 0.1875 C 5.59375 0.1875 6.765625 -0.640625 7.078125 -2.015625 L 5.4375 -2.078125 C 5.203125 -1.546875 4.734375 -1.296875 4.0625 -1.296875 C 3.03125 -1.296875 2.40625 -1.953125 2.34375 -3.125 Z M 2.390625 -4.46875 C 2.625 -5.4375 3.140625 -5.890625 3.9375 -5.890625 C 4.75 -5.890625 5.203125 -5.4375 5.359375 -4.46875 Z M 2.390625 -4.46875 "
              id="path2924"
            />
          </symbol>
          <symbol overflow="visible" id="glyph3-7">
            <path
              style={{ stroke: 'none' }}
              d="M 1.03125 2.953125 L 2.875 2.953125 L 2.875 -0.765625 C 3.4375 -0.125 3.96875 0.15625 4.765625 0.15625 C 6.5 0.15625 7.71875 -1.421875 7.71875 -3.609375 C 7.71875 -5.796875 6.515625 -7.28125 4.703125 -7.28125 C 3.84375 -7.28125 3.25 -6.96875 2.75 -6.28125 C 2.734375 -6.671875 2.6875 -6.953125 2.625 -7.125 L 0.90625 -7.125 C 1 -6.625 1.03125 -6.078125 1.03125 -4.859375 Z M 4.375 -5.734375 C 5.296875 -5.734375 5.84375 -4.921875 5.84375 -3.578125 C 5.84375 -2.203125 5.296875 -1.390625 4.375 -1.390625 C 3.453125 -1.390625 2.84375 -2.21875 2.84375 -3.53125 C 2.84375 -4.890625 3.4375 -5.734375 4.375 -5.734375 Z M 4.375 -5.734375 "
              id="path2927"
            />
          </symbol>
          <symbol overflow="visible" id="glyph3-8">
            <path
              style={{ stroke: 'none' }}
              d="M 0.9375 -7.125 C 0.984375 -6.734375 1 -6.578125 1 -6.1875 C 1.015625 -5.671875 1.015625 -5.25 1.015625 -4.9375 L 1.015625 0 L 2.859375 0 L 2.859375 -3.3125 C 2.859375 -4.90625 3.3125 -5.65625 4.296875 -5.65625 C 4.6875 -5.65625 5.0625 -5.53125 5.40625 -5.3125 L 5.40625 -7.1875 C 5.09375 -7.265625 5.046875 -7.28125 4.84375 -7.28125 C 3.96875 -7.28125 3.359375 -6.796875 2.796875 -5.640625 C 2.8125 -5.8125 2.8125 -5.9375 2.8125 -6.015625 C 2.8125 -6.421875 2.765625 -6.8125 2.6875 -7.125 Z M 0.9375 -7.125 "
              id="path2930"
            />
          </symbol>
          <symbol overflow="visible" id="glyph3-9">
            <path
              style={{ stroke: 'none' }}
              d="M 4.015625 -7.3125 C 2 -7.3125 0.5 -5.75 0.5 -3.609375 C 0.5 -1.359375 1.9375 0.1875 4.015625 0.1875 C 6.0625 0.1875 7.53125 -1.375 7.53125 -3.5625 C 7.53125 -5.75 6.0625 -7.3125 4.015625 -7.3125 Z M 4.015625 -5.828125 C 4.984375 -5.828125 5.640625 -4.90625 5.640625 -3.5625 C 5.640625 -2.21875 4.984375 -1.296875 4.015625 -1.296875 C 3.03125 -1.296875 2.390625 -2.203125 2.390625 -3.578125 C 2.390625 -4.90625 3.0625 -5.828125 4.015625 -5.828125 Z M 4.015625 -5.828125 "
              id="path2933"
            />
          </symbol>
          <symbol overflow="visible" id="glyph3-10">
            <path
              style={{ stroke: 'none' }}
              d="M 7.1875 -10.0625 L 5.34375 -10.0625 L 5.34375 -6.34375 C 4.8125 -7.015625 4.3125 -7.28125 3.5 -7.28125 C 1.75 -7.28125 0.5 -5.703125 0.5 -3.5 C 0.5 -1.3125 1.71875 0.15625 3.53125 0.15625 C 4.484375 0.15625 5.078125 -0.1875 5.546875 -0.984375 C 5.53125 -0.8125 5.53125 -0.71875 5.53125 -0.625 C 5.53125 -0.453125 5.546875 -0.296875 5.59375 0 L 7.3125 0 C 7.21875 -0.5 7.1875 -1.046875 7.1875 -2.25 Z M 3.921875 -5.734375 C 4.828125 -5.734375 5.375 -4.921875 5.375 -3.5625 C 5.375 -2.234375 4.78125 -1.390625 3.84375 -1.390625 C 2.921875 -1.390625 2.375 -2.1875 2.375 -3.5 C 2.375 -4.90625 2.9375 -5.734375 3.921875 -5.734375 Z M 3.921875 -5.734375 "
              id="path2936"
            />
          </symbol>
          <symbol overflow="visible" id="glyph3-11">
            <path
              style={{ stroke: 'none' }}
              d="M 0.96875 -7.125 L 0.96875 -2.96875 C 0.96875 -2.046875 1.109375 -1.34375 1.375 -0.9375 C 1.8125 -0.25 2.640625 0.15625 3.578125 0.15625 C 4.453125 0.15625 5.03125 -0.125 5.578125 -0.828125 C 5.59375 -0.5 5.65625 -0.171875 5.734375 0 L 7.46875 0 C 7.296875 -0.625 7.296875 -0.625 7.296875 -2.203125 L 7.296875 -7.125 L 5.4375 -7.125 L 5.4375 -3.3125 C 5.4375 -2.0625 4.984375 -1.46875 4.03125 -1.46875 C 3.609375 -1.46875 3.265625 -1.625 3.078125 -1.890625 C 2.90625 -2.109375 2.8125 -2.5 2.8125 -3.078125 L 2.8125 -7.125 Z M 0.96875 -7.125 "
              id="path2939"
            />
          </symbol>
          <symbol overflow="visible" id="glyph3-12">
            <path
              style={{ stroke: 'none' }}
              d="M 5.515625 -7.125 L 2.90625 -3.796875 L 5.5 0 L 7.984375 0 L 5.0625 -3.828125 L 7.734375 -7.125 Z M 1.03125 -10.0625 L 1.03125 0 L 2.875 0 L 2.875 -10.0625 Z M 1.03125 -10.0625 "
              id="path2942"
            />
          </symbol>
          <symbol overflow="visible" id="glyph3-13">
            <path
              style={{ stroke: 'none' }}
              d="M 3.3125 -7.125 L 3.34375 -9.1875 L 1.5625 -9.1875 L 1.515625 -7.125 L 0.34375 -7.125 L 0.34375 -5.6875 L 1.453125 -5.6875 L 1.34375 -2.90625 L 1.328125 -2.203125 C 1.328125 -1.421875 1.40625 -1.078125 1.640625 -0.71875 C 1.984375 -0.15625 2.59375 0.15625 3.390625 0.15625 C 3.953125 0.15625 4.453125 0.046875 5.03125 -0.1875 L 5.03125 -1.703125 C 4.625 -1.546875 4.3125 -1.46875 3.953125 -1.46875 C 3.40625 -1.46875 3.21875 -1.6875 3.21875 -2.4375 C 3.21875 -2.578125 3.21875 -2.578125 3.234375 -2.9375 L 3.28125 -5.6875 L 4.765625 -5.6875 L 4.765625 -7.125 Z M 3.3125 -7.125 "
              id="path2945"
            />
          </symbol>
          <symbol overflow="visible" id="glyph3-14">
            <path style={{ stroke: 'none' }} d="" id="path2948" />
          </symbol>
          <symbol overflow="visible" id="glyph3-15">
            <path
              style={{ stroke: 'none' }}
              d="M 0.84375 -7.125 C 1 -6.6875 1.03125 -6.453125 1.03125 -5.4375 L 1.03125 0 L 2.875 0 L 2.875 -3.953125 C 2.875 -4.46875 2.890625 -4.65625 2.984375 -4.875 C 3.171875 -5.375 3.609375 -5.65625 4.234375 -5.65625 C 4.6875 -5.65625 5.0625 -5.46875 5.21875 -5.171875 C 5.34375 -4.96875 5.375 -4.6875 5.375 -3.953125 L 5.375 0 L 7.21875 0 L 7.21875 -4.03125 C 7.21875 -5.125 7.65625 -5.65625 8.546875 -5.65625 C 9 -5.65625 9.34375 -5.5 9.53125 -5.21875 C 9.65625 -5.015625 9.703125 -4.71875 9.703125 -4.109375 L 9.703125 0 L 11.546875 0 L 11.546875 -4.15625 C 11.546875 -5.5625 11.53125 -5.75 11.3125 -6.203125 C 11 -6.90625 10.296875 -7.28125 9.3125 -7.28125 C 8.328125 -7.28125 7.640625 -6.9375 7 -6.125 C 6.5625 -6.921875 5.921875 -7.28125 4.953125 -7.28125 C 4 -7.28125 3.328125 -6.9375 2.78125 -6.1875 L 2.78125 -6.3125 C 2.78125 -6.625 2.734375 -6.875 2.625 -7.125 Z M 0.84375 -7.125 "
              id="path2951"
            />
          </symbol>
          <symbol overflow="visible" id="glyph3-16">
            <path
              style={{ stroke: 'none' }}
              d="M 1.03125 -7.125 L 1.03125 0 L 2.875 0 L 2.875 -7.125 Z M 2 -10.203125 C 1.328125 -10.203125 0.890625 -9.765625 0.890625 -9.109375 C 0.890625 -8.453125 1.3125 -8.0625 1.96875 -8.0625 C 2.609375 -8.0625 3.03125 -8.46875 3.03125 -9.140625 C 3.03125 -9.765625 2.609375 -10.203125 2 -10.203125 Z M 2 -10.203125 "
              id="path2954"
            />
          </symbol>
          <symbol overflow="visible" id="glyph3-17">
            <path
              style={{ stroke: 'none' }}
              d="M 2.46875 -7 L 4.1875 -7 L 4.1875 0 L 6.0625 0 L 6.0625 -9.796875 L 4.78125 -9.796875 C 4.546875 -8.609375 3.8125 -8.0625 2.46875 -8.03125 Z M 2.46875 -7 "
              id="path2957"
            />
          </symbol>
          <symbol overflow="visible" id="glyph3-18">
            <path
              style={{ stroke: 'none' }}
              d="M 4.296875 -9.984375 C 2.0625 -9.984375 0.71875 -8.078125 0.71875 -5 C 0.71875 -1.734375 2.03125 0.15625 4.296875 0.15625 C 6.515625 0.15625 7.84375 -1.75 7.84375 -4.921875 C 7.84375 -8.09375 6.515625 -9.984375 4.296875 -9.984375 Z M 4.296875 -8.4375 C 4.71875 -8.4375 5.09375 -8.234375 5.34375 -7.84375 C 5.75 -7.234375 5.96875 -6.171875 5.96875 -4.921875 C 5.96875 -3.671875 5.75 -2.640625 5.34375 -1.984375 C 5.09375 -1.609375 4.734375 -1.390625 4.296875 -1.390625 C 3.1875 -1.390625 2.59375 -2.6875 2.59375 -4.96875 C 2.59375 -6.171875 2.8125 -7.21875 3.21875 -7.84375 C 3.46875 -8.234375 3.828125 -8.4375 4.296875 -8.4375 Z M 4.296875 -8.4375 "
              id="path2960"
            />
          </symbol>
          <symbol overflow="visible" id="glyph3-19">
            <path style={{ stroke: 'none' }} d="" id="path2963" />
          </symbol>
          <symbol overflow="visible" id="glyph3-20">
            <path
              style={{ stroke: 'none' }}
              d="M 7.5 -10 L 1.6875 0 L 3.171875 0 L 8.96875 -10 Z M 8.078125 -4.75 C 6.921875 -4.75 5.984375 -3.6875 5.984375 -2.34375 C 5.984375 -1 6.921875 0.078125 8.0625 0.078125 C 9.265625 0.078125 10.203125 -0.96875 10.203125 -2.34375 C 10.203125 -3.6875 9.265625 -4.75 8.078125 -4.75 Z M 8.09375 -3.734375 C 8.65625 -3.734375 9.03125 -3.171875 9.03125 -2.34375 C 9.03125 -1.5 8.65625 -0.9375 8.09375 -0.9375 C 7.53125 -0.9375 7.15625 -1.5 7.15625 -2.34375 C 7.15625 -3.1875 7.53125 -3.734375 8.09375 -3.734375 Z M 2.59375 -10.078125 C 1.40625 -10.078125 0.484375 -9.015625 0.484375 -7.671875 C 0.484375 -6.328125 1.40625 -5.25 2.578125 -5.25 C 3.78125 -5.25 4.703125 -6.296875 4.703125 -7.671875 C 4.703125 -9.015625 3.78125 -10.078125 2.59375 -10.078125 Z M 2.609375 -9.0625 C 3.171875 -9.0625 3.546875 -8.484375 3.546875 -7.671875 C 3.546875 -6.828125 3.171875 -6.265625 2.59375 -6.265625 C 2.03125 -6.265625 1.65625 -6.828125 1.65625 -7.671875 C 1.65625 -8.5 2.03125 -9.0625 2.609375 -9.0625 Z M 2.609375 -9.0625 "
              id="path2966"
            />
          </symbol>
          <symbol overflow="visible" id="glyph3-21">
            <path
              style={{ stroke: 'none' }}
              d="M 6.8125 -10 L 3.15625 -5.3125 L 6.828125 0 L 9.265625 0 L 5.296875 -5.375 L 9.03125 -10 Z M 1.203125 -10 L 1.203125 0 L 3.125 0 L 3.125 -10 Z M 1.203125 -10 "
              id="path2969"
            />
          </symbol>
          <symbol overflow="visible" id="glyph3-22">
            <path
              style={{ stroke: 'none' }}
              d="M 6.578125 -4.96875 C 6.484375 -6.46875 5.4375 -7.328125 3.6875 -7.328125 C 1.984375 -7.328125 0.84375 -6.40625 0.84375 -5.03125 C 0.84375 -4.515625 1.015625 -4.046875 1.328125 -3.734375 C 1.625 -3.453125 2.03125 -3.25 2.8125 -3.015625 C 4.078125 -2.640625 4.078125 -2.640625 4.3125 -2.53125 C 4.671875 -2.390625 4.78125 -2.234375 4.78125 -1.96875 C 4.78125 -1.5 4.359375 -1.203125 3.65625 -1.203125 C 2.78125 -1.203125 2.375 -1.546875 2.3125 -2.390625 L 0.5625 -2.390625 C 0.5625 -0.6875 1.65625 0.1875 3.734375 0.1875 C 5.5625 0.1875 6.625 -0.65625 6.625 -2.09375 C 6.625 -2.578125 6.484375 -3.015625 6.203125 -3.328125 C 5.90625 -3.671875 5.453125 -3.90625 4.40625 -4.21875 C 3.328125 -4.53125 3.1875 -4.578125 2.96875 -4.703125 C 2.78125 -4.8125 2.671875 -5.015625 2.671875 -5.21875 C 2.671875 -5.640625 3.09375 -5.953125 3.65625 -5.953125 C 4.34375 -5.953125 4.703125 -5.640625 4.796875 -4.96875 Z M 6.578125 -4.96875 "
              id="path2972"
            />
          </symbol>
          <symbol overflow="visible" id="glyph3-23">
            <path
              style={{ stroke: 'none' }}
              d="M 6.90625 -4.765625 C 6.671875 -6.421875 5.640625 -7.3125 3.9375 -7.3125 C 1.875 -7.3125 0.5 -5.8125 0.5 -3.5625 C 0.5 -1.3125 1.875 0.1875 3.921875 0.1875 C 5.640625 0.1875 6.859375 -0.90625 6.9375 -2.53125 L 5.15625 -2.53125 C 5.0625 -1.6875 4.65625 -1.296875 3.921875 -1.296875 C 2.953125 -1.296875 2.390625 -2.125 2.390625 -3.5625 C 2.390625 -4.9375 3 -5.828125 3.9375 -5.828125 C 4.59375 -5.828125 4.984375 -5.46875 5.078125 -4.765625 Z M 6.90625 -4.765625 "
              id="path2975"
            />
          </symbol>
          <symbol overflow="visible" id="glyph3-24">
            <path
              style={{ stroke: 'none' }}
              d="M 1.03125 -10.0625 L 1.03125 0 L 2.875 0 L 2.875 -3.640625 C 2.875 -4.265625 2.9375 -4.625 3.078125 -4.90625 C 3.3125 -5.375 3.78125 -5.65625 4.296875 -5.65625 C 4.75 -5.65625 5.125 -5.4375 5.328125 -5.03125 C 5.453125 -4.75 5.5 -4.40625 5.5 -3.703125 L 5.5 0 L 7.34375 0 L 7.34375 -4.109375 C 7.34375 -5.40625 7.28125 -5.8125 6.984375 -6.28125 C 6.59375 -6.890625 5.8125 -7.28125 4.9375 -7.28125 C 4.109375 -7.28125 3.4375 -6.953125 2.875 -6.34375 L 2.875 -10.0625 Z M 1.03125 -10.0625 "
              id="path2978"
            />
          </symbol>
          <symbol overflow="visible" id="glyph3-25">
            <path
              style={{ stroke: 'none' }}
              d="M 0.71875 -7.125 L 0.71875 -5.59375 L 3.71875 -5.59375 L 0.34375 -1.421875 L 0.34375 0 L 6 0 L 6 -1.53125 L 2.515625 -1.53125 L 5.9375 -5.734375 L 5.9375 -7.125 Z M 0.71875 -7.125 "
              id="path2981"
            />
          </symbol>
          <symbol overflow="visible" id="glyph3-26">
            <path
              style={{ stroke: 'none' }}
              d="M 3.125 -6.015625 L 3.125 -10 L 1.203125 -10 L 1.203125 0 L 3.125 0 L 3.125 -4.421875 L 7.09375 -4.421875 L 7.09375 0 L 9.015625 0 L 9.015625 -10 L 7.09375 -10 L 7.09375 -6.015625 Z M 3.125 -6.015625 "
              id="path2984"
            />
          </symbol>
          <symbol overflow="visible" id="glyph3-27">
            <path
              style={{ stroke: 'none' }}
              d="M 1.015625 -10.0625 L 1.015625 -1.875 C 1.015625 -0.671875 1.015625 -0.46875 0.96875 0 L 2.5625 0 C 2.640625 -0.296875 2.671875 -0.484375 2.703125 -0.953125 C 3.09375 -0.203125 3.71875 0.15625 4.609375 0.15625 C 6.421875 0.15625 7.703125 -1.390625 7.703125 -3.5625 C 7.703125 -5.71875 6.5 -7.28125 4.8125 -7.28125 C 4 -7.28125 3.4375 -6.96875 2.859375 -6.21875 L 2.859375 -10.0625 Z M 4.375 -5.734375 C 5.265625 -5.734375 5.8125 -4.921875 5.8125 -3.59375 C 5.8125 -2.25 5.234375 -1.390625 4.3125 -1.390625 C 3.421875 -1.390625 2.859375 -2.21875 2.859375 -3.546875 C 2.859375 -4.921875 3.4375 -5.734375 4.375 -5.734375 Z M 4.375 -5.734375 "
              id="path2987"
            />
          </symbol>
        </g>
        <clipPath id="clip1">
          <path
            d="M 637 87 L 639 87 L 639 255 L 637 255 Z M 637 87 "
            id="path2992"
          />
        </clipPath>
        <clipPath id="clip2">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path2995"
          />
        </clipPath>
        <clipPath id="clip3">
          <path
            d="M 623 87 L 653 87 L 653 255 L 623 255 Z M 623 87 "
            id="path2998"
          />
        </clipPath>
        <clipPath id="clip4">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3001"
          />
        </clipPath>
        <clipPath id="clip5">
          <path
            d="M 647 87 L 648 87 L 648 255 L 647 255 Z M 647 87 "
            id="path3004"
          />
        </clipPath>
        <clipPath id="clip6">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3007"
          />
        </clipPath>
        <clipPath id="clip7">
          <path
            d="M 632 87 L 662 87 L 662 255 L 632 255 Z M 632 87 "
            id="path3010"
          />
        </clipPath>
        <clipPath id="clip8">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3013"
          />
        </clipPath>
        <clipPath id="clip9">
          <path
            d="M 656 87 L 658 87 L 658 255 L 656 255 Z M 656 87 "
            id="path3016"
          />
        </clipPath>
        <clipPath id="clip10">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3019"
          />
        </clipPath>
        <clipPath id="clip11">
          <path
            d="M 642 87 L 672 87 L 672 255 L 642 255 Z M 642 87 "
            id="path3022"
          />
        </clipPath>
        <clipPath id="clip12">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3025"
          />
        </clipPath>
        <clipPath id="clip13">
          <path
            d="M 665 87 L 667 87 L 667 255 L 665 255 Z M 665 87 "
            id="path3028"
          />
        </clipPath>
        <clipPath id="clip14">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3031"
          />
        </clipPath>
        <clipPath id="clip15">
          <path
            d="M 651 87 L 681 87 L 681 255 L 651 255 Z M 651 87 "
            id="path3034"
          />
        </clipPath>
        <clipPath id="clip16">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3037"
          />
        </clipPath>
        <clipPath id="clip17">
          <path
            d="M 674 87 L 676 87 L 676 255 L 674 255 Z M 674 87 "
            id="path3040"
          />
        </clipPath>
        <clipPath id="clip18">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3043"
          />
        </clipPath>
        <clipPath id="clip19">
          <path
            d="M 660 87 L 690 87 L 690 255 L 660 255 Z M 660 87 "
            id="path3046"
          />
        </clipPath>
        <clipPath id="clip20">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3049"
          />
        </clipPath>
        <clipPath id="clip21">
          <path
            d="M 683 87 L 685 87 L 685 255 L 683 255 Z M 683 87 "
            id="path3052"
          />
        </clipPath>
        <clipPath id="clip22">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3055"
          />
        </clipPath>
        <clipPath id="clip23">
          <path
            d="M 669 87 L 699 87 L 699 255 L 669 255 Z M 669 87 "
            id="path3058"
          />
        </clipPath>
        <clipPath id="clip24">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3061"
          />
        </clipPath>
        <clipPath id="clip25">
          <path
            d="M 693 87 L 694 87 L 694 255 L 693 255 Z M 693 87 "
            id="path3064"
          />
        </clipPath>
        <clipPath id="clip26">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3067"
          />
        </clipPath>
        <clipPath id="clip27">
          <path
            d="M 678 87 L 709 87 L 709 255 L 678 255 Z M 678 87 "
            id="path3070"
          />
        </clipPath>
        <clipPath id="clip28">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3073"
          />
        </clipPath>
        <clipPath id="clip29">
          <path
            d="M 702 87 L 704 87 L 704 255 L 702 255 Z M 702 87 "
            id="path3076"
          />
        </clipPath>
        <clipPath id="clip30">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3079"
          />
        </clipPath>
        <clipPath id="clip31">
          <path
            d="M 688 87 L 718 87 L 718 255 L 688 255 Z M 688 87 "
            id="path3082"
          />
        </clipPath>
        <clipPath id="clip32">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3085"
          />
        </clipPath>
        <clipPath id="clip33">
          <path
            d="M 711 87 L 713 87 L 713 255 L 711 255 Z M 711 87 "
            id="path3088"
          />
        </clipPath>
        <clipPath id="clip34">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3091"
          />
        </clipPath>
        <clipPath id="clip35">
          <path
            d="M 697 87 L 727 87 L 727 255 L 697 255 Z M 697 87 "
            id="path3094"
          />
        </clipPath>
        <clipPath id="clip36">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3097"
          />
        </clipPath>
        <clipPath id="clip37">
          <path
            d="M 720 87 L 722 87 L 722 255 L 720 255 Z M 720 87 "
            id="path3100"
          />
        </clipPath>
        <clipPath id="clip38">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3103"
          />
        </clipPath>
        <clipPath id="clip39">
          <path
            d="M 706 87 L 736 87 L 736 255 L 706 255 Z M 706 87 "
            id="path3106"
          />
        </clipPath>
        <clipPath id="clip40">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3109"
          />
        </clipPath>
        <clipPath id="clip41">
          <path
            d="M 729 87 L 731 87 L 731 255 L 729 255 Z M 729 87 "
            id="path3112"
          />
        </clipPath>
        <clipPath id="clip42">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3115"
          />
        </clipPath>
        <clipPath id="clip43">
          <path
            d="M 715 87 L 745 87 L 745 255 L 715 255 Z M 715 87 "
            id="path3118"
          />
        </clipPath>
        <clipPath id="clip44">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3121"
          />
        </clipPath>
        <clipPath id="clip45">
          <path
            d="M 739 87 L 741 87 L 741 255 L 739 255 Z M 739 87 "
            id="path3124"
          />
        </clipPath>
        <clipPath id="clip46">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3127"
          />
        </clipPath>
        <clipPath id="clip47">
          <path
            d="M 725 87 L 755 87 L 755 255 L 725 255 Z M 725 87 "
            id="path3130"
          />
        </clipPath>
        <clipPath id="clip48">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3133"
          />
        </clipPath>
        <clipPath id="clip49">
          <path
            d="M 748 87 L 750 87 L 750 255 L 748 255 Z M 748 87 "
            id="path3136"
          />
        </clipPath>
        <clipPath id="clip50">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3139"
          />
        </clipPath>
        <clipPath id="clip51">
          <path
            d="M 734 87 L 764 87 L 764 255 L 734 255 Z M 734 87 "
            id="path3142"
          />
        </clipPath>
        <clipPath id="clip52">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3145"
          />
        </clipPath>
        <clipPath id="clip53">
          <path
            d="M 757 87 L 759 87 L 759 255 L 757 255 Z M 757 87 "
            id="path3148"
          />
        </clipPath>
        <clipPath id="clip54">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3151"
          />
        </clipPath>
        <clipPath id="clip55">
          <path
            d="M 743 87 L 773 87 L 773 255 L 743 255 Z M 743 87 "
            id="path3154"
          />
        </clipPath>
        <clipPath id="clip56">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3157"
          />
        </clipPath>
        <clipPath id="clip57">
          <path
            d="M 766 87 L 768 87 L 768 255 L 766 255 Z M 766 87 "
            id="path3160"
          />
        </clipPath>
        <clipPath id="clip58">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3163"
          />
        </clipPath>
        <clipPath id="clip59">
          <path
            d="M 752 87 L 782 87 L 782 255 L 752 255 Z M 752 87 "
            id="path3166"
          />
        </clipPath>
        <clipPath id="clip60">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3169"
          />
        </clipPath>
        <clipPath id="clip61">
          <path
            d="M 776 87 L 777 87 L 777 255 L 776 255 Z M 776 87 "
            id="path3172"
          />
        </clipPath>
        <clipPath id="clip62">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3175"
          />
        </clipPath>
        <clipPath id="clip63">
          <path
            d="M 761 87 L 792 87 L 792 255 L 761 255 Z M 761 87 "
            id="path3178"
          />
        </clipPath>
        <clipPath id="clip64">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3181"
          />
        </clipPath>
        <clipPath id="clip65">
          <path
            d="M 785 87 L 787 87 L 787 255 L 785 255 Z M 785 87 "
            id="path3184"
          />
        </clipPath>
        <clipPath id="clip66">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3187"
          />
        </clipPath>
        <clipPath id="clip67">
          <path
            d="M 771 87 L 801 87 L 801 255 L 771 255 Z M 771 87 "
            id="path3190"
          />
        </clipPath>
        <clipPath id="clip68">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3193"
          />
        </clipPath>
        <clipPath id="clip69">
          <path
            d="M 794 87 L 796 87 L 796 255 L 794 255 Z M 794 87 "
            id="path3196"
          />
        </clipPath>
        <clipPath id="clip70">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3199"
          />
        </clipPath>
        <clipPath id="clip71">
          <path
            d="M 780 87 L 806 87 L 806 255 L 780 255 Z M 780 87 "
            id="path3202"
          />
        </clipPath>
        <clipPath id="clip72">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3205"
          />
        </clipPath>
        <clipPath id="clip73">
          <path
            d="M 803 87 L 805 87 L 805 255 L 803 255 Z M 803 87 "
            id="path3208"
          />
        </clipPath>
        <clipPath id="clip74">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3211"
          />
        </clipPath>
        <clipPath id="clip75">
          <path
            d="M 789 87 L 806 87 L 806 255 L 789 255 Z M 789 87 "
            id="path3214"
          />
        </clipPath>
        <clipPath id="clip76">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3217"
          />
        </clipPath>
        <clipPath id="clip77">
          <path
            d="M 798 87 L 806 87 L 806 255 L 798 255 Z M 798 87 "
            id="path3220"
          />
        </clipPath>
        <clipPath id="clip78">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3223"
          />
        </clipPath>
        <clipPath id="clip79">
          <path
            d="M 425 87 L 427 87 L 427 255 L 425 255 Z M 425 87 "
            id="path3226"
          />
        </clipPath>
        <clipPath id="clip80">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3229"
          />
        </clipPath>
        <clipPath id="clip81">
          <path
            d="M 411 87 L 441 87 L 441 255 L 411 255 Z M 411 87 "
            id="path3232"
          />
        </clipPath>
        <clipPath id="clip82">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3235"
          />
        </clipPath>
        <clipPath id="clip83">
          <path
            d="M 434 87 L 436 87 L 436 255 L 434 255 Z M 434 87 "
            id="path3238"
          />
        </clipPath>
        <clipPath id="clip84">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3241"
          />
        </clipPath>
        <clipPath id="clip85">
          <path
            d="M 420 87 L 450 87 L 450 255 L 420 255 Z M 420 87 "
            id="path3244"
          />
        </clipPath>
        <clipPath id="clip86">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3247"
          />
        </clipPath>
        <clipPath id="clip87">
          <path
            d="M 443 87 L 445 87 L 445 255 L 443 255 Z M 443 87 "
            id="path3250"
          />
        </clipPath>
        <clipPath id="clip88">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3253"
          />
        </clipPath>
        <clipPath id="clip89">
          <path
            d="M 429 87 L 459 87 L 459 255 L 429 255 Z M 429 87 "
            id="path3256"
          />
        </clipPath>
        <clipPath id="clip90">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3259"
          />
        </clipPath>
        <clipPath id="clip91">
          <path
            d="M 453 87 L 454 87 L 454 255 L 453 255 Z M 453 87 "
            id="path3262"
          />
        </clipPath>
        <clipPath id="clip92">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3265"
          />
        </clipPath>
        <clipPath id="clip93">
          <path
            d="M 438 87 L 469 87 L 469 255 L 438 255 Z M 438 87 "
            id="path3268"
          />
        </clipPath>
        <clipPath id="clip94">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3271"
          />
        </clipPath>
        <clipPath id="clip95">
          <path
            d="M 462 87 L 464 87 L 464 255 L 462 255 Z M 462 87 "
            id="path3274"
          />
        </clipPath>
        <clipPath id="clip96">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3277"
          />
        </clipPath>
        <clipPath id="clip97">
          <path
            d="M 448 87 L 478 87 L 478 255 L 448 255 Z M 448 87 "
            id="path3280"
          />
        </clipPath>
        <clipPath id="clip98">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3283"
          />
        </clipPath>
        <clipPath id="clip99">
          <path
            d="M 471 87 L 473 87 L 473 255 L 471 255 Z M 471 87 "
            id="path3286"
          />
        </clipPath>
        <clipPath id="clip100">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3289"
          />
        </clipPath>
        <clipPath id="clip101">
          <path
            d="M 457 87 L 487 87 L 487 255 L 457 255 Z M 457 87 "
            id="path3292"
          />
        </clipPath>
        <clipPath id="clip102">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3295"
          />
        </clipPath>
        <clipPath id="clip103">
          <path
            d="M 480 87 L 482 87 L 482 255 L 480 255 Z M 480 87 "
            id="path3298"
          />
        </clipPath>
        <clipPath id="clip104">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3301"
          />
        </clipPath>
        <clipPath id="clip105">
          <path
            d="M 466 87 L 496 87 L 496 255 L 466 255 Z M 466 87 "
            id="path3304"
          />
        </clipPath>
        <clipPath id="clip106">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3307"
          />
        </clipPath>
        <clipPath id="clip107">
          <path
            d="M 489 87 L 491 87 L 491 255 L 489 255 Z M 489 87 "
            id="path3310"
          />
        </clipPath>
        <clipPath id="clip108">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3313"
          />
        </clipPath>
        <clipPath id="clip109">
          <path
            d="M 475 87 L 505 87 L 505 255 L 475 255 Z M 475 87 "
            id="path3316"
          />
        </clipPath>
        <clipPath id="clip110">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3319"
          />
        </clipPath>
        <clipPath id="clip111">
          <path
            d="M 499 87 L 500 87 L 500 255 L 499 255 Z M 499 87 "
            id="path3322"
          />
        </clipPath>
        <clipPath id="clip112">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3325"
          />
        </clipPath>
        <clipPath id="clip113">
          <path
            d="M 485 87 L 515 87 L 515 255 L 485 255 Z M 485 87 "
            id="path3328"
          />
        </clipPath>
        <clipPath id="clip114">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3331"
          />
        </clipPath>
        <clipPath id="clip115">
          <path
            d="M 508 87 L 510 87 L 510 255 L 508 255 Z M 508 87 "
            id="path3334"
          />
        </clipPath>
        <clipPath id="clip116">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3337"
          />
        </clipPath>
        <clipPath id="clip117">
          <path
            d="M 494 87 L 524 87 L 524 255 L 494 255 Z M 494 87 "
            id="path3340"
          />
        </clipPath>
        <clipPath id="clip118">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3343"
          />
        </clipPath>
        <clipPath id="clip119">
          <path
            d="M 517 87 L 519 87 L 519 255 L 517 255 Z M 517 87 "
            id="path3346"
          />
        </clipPath>
        <clipPath id="clip120">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3349"
          />
        </clipPath>
        <clipPath id="clip121">
          <path
            d="M 503 87 L 533 87 L 533 255 L 503 255 Z M 503 87 "
            id="path3352"
          />
        </clipPath>
        <clipPath id="clip122">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3355"
          />
        </clipPath>
        <clipPath id="clip123">
          <path
            d="M 526 87 L 528 87 L 528 255 L 526 255 Z M 526 87 "
            id="path3358"
          />
        </clipPath>
        <clipPath id="clip124">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3361"
          />
        </clipPath>
        <clipPath id="clip125">
          <path
            d="M 512 87 L 542 87 L 542 255 L 512 255 Z M 512 87 "
            id="path3364"
          />
        </clipPath>
        <clipPath id="clip126">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3367"
          />
        </clipPath>
        <clipPath id="clip127">
          <path
            d="M 536 87 L 537 87 L 537 255 L 536 255 Z M 536 87 "
            id="path3370"
          />
        </clipPath>
        <clipPath id="clip128">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3373"
          />
        </clipPath>
        <clipPath id="clip129">
          <path
            d="M 521 87 L 552 87 L 552 255 L 521 255 Z M 521 87 "
            id="path3376"
          />
        </clipPath>
        <clipPath id="clip130">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3379"
          />
        </clipPath>
        <clipPath id="clip131">
          <path
            d="M 545 87 L 547 87 L 547 255 L 545 255 Z M 545 87 "
            id="path3382"
          />
        </clipPath>
        <clipPath id="clip132">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3385"
          />
        </clipPath>
        <clipPath id="clip133">
          <path
            d="M 531 87 L 561 87 L 561 255 L 531 255 Z M 531 87 "
            id="path3388"
          />
        </clipPath>
        <clipPath id="clip134">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3391"
          />
        </clipPath>
        <clipPath id="clip135">
          <path
            d="M 554 87 L 556 87 L 556 255 L 554 255 Z M 554 87 "
            id="path3394"
          />
        </clipPath>
        <clipPath id="clip136">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3397"
          />
        </clipPath>
        <clipPath id="clip137">
          <path
            d="M 540 87 L 570 87 L 570 255 L 540 255 Z M 540 87 "
            id="path3400"
          />
        </clipPath>
        <clipPath id="clip138">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3403"
          />
        </clipPath>
        <clipPath id="clip139">
          <path
            d="M 563 87 L 565 87 L 565 255 L 563 255 Z M 563 87 "
            id="path3406"
          />
        </clipPath>
        <clipPath id="clip140">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3409"
          />
        </clipPath>
        <clipPath id="clip141">
          <path
            d="M 549 87 L 579 87 L 579 255 L 549 255 Z M 549 87 "
            id="path3412"
          />
        </clipPath>
        <clipPath id="clip142">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3415"
          />
        </clipPath>
        <clipPath id="clip143">
          <path
            d="M 572 87 L 574 87 L 574 255 L 572 255 Z M 572 87 "
            id="path3418"
          />
        </clipPath>
        <clipPath id="clip144">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3421"
          />
        </clipPath>
        <clipPath id="clip145">
          <path
            d="M 558 87 L 588 87 L 588 255 L 558 255 Z M 558 87 "
            id="path3424"
          />
        </clipPath>
        <clipPath id="clip146">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3427"
          />
        </clipPath>
        <clipPath id="clip147">
          <path
            d="M 582 87 L 583 87 L 583 255 L 582 255 Z M 582 87 "
            id="path3430"
          />
        </clipPath>
        <clipPath id="clip148">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3433"
          />
        </clipPath>
        <clipPath id="clip149">
          <path
            d="M 568 87 L 598 87 L 598 255 L 568 255 Z M 568 87 "
            id="path3436"
          />
        </clipPath>
        <clipPath id="clip150">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3439"
          />
        </clipPath>
        <clipPath id="clip151">
          <path
            d="M 591 87 L 593 87 L 593 255 L 591 255 Z M 591 87 "
            id="path3442"
          />
        </clipPath>
        <clipPath id="clip152">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3445"
          />
        </clipPath>
        <clipPath id="clip153">
          <path
            d="M 577 87 L 607 87 L 607 255 L 577 255 Z M 577 87 "
            id="path3448"
          />
        </clipPath>
        <clipPath id="clip154">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3451"
          />
        </clipPath>
        <clipPath id="clip155">
          <path
            d="M 600 87 L 602 87 L 602 255 L 600 255 Z M 600 87 "
            id="path3454"
          />
        </clipPath>
        <clipPath id="clip156">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3457"
          />
        </clipPath>
        <clipPath id="clip157">
          <path
            d="M 586 87 L 616 87 L 616 255 L 586 255 Z M 586 87 "
            id="path3460"
          />
        </clipPath>
        <clipPath id="clip158">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3463"
          />
        </clipPath>
        <clipPath id="clip159">
          <path
            d="M 609 87 L 611 87 L 611 255 L 609 255 Z M 609 87 "
            id="path3466"
          />
        </clipPath>
        <clipPath id="clip160">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3469"
          />
        </clipPath>
        <clipPath id="clip161">
          <path
            d="M 595 87 L 625 87 L 625 255 L 595 255 Z M 595 87 "
            id="path3472"
          />
        </clipPath>
        <clipPath id="clip162">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3475"
          />
        </clipPath>
        <clipPath id="clip163">
          <path
            d="M 619 87 L 620 87 L 620 255 L 619 255 Z M 619 87 "
            id="path3478"
          />
        </clipPath>
        <clipPath id="clip164">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3481"
          />
        </clipPath>
        <clipPath id="clip165">
          <path
            d="M 604 87 L 634 87 L 634 255 L 604 255 Z M 604 87 "
            id="path3484"
          />
        </clipPath>
        <clipPath id="clip166">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3487"
          />
        </clipPath>
        <clipPath id="clip167">
          <path
            d="M 628 87 L 630 87 L 630 255 L 628 255 Z M 628 87 "
            id="path3490"
          />
        </clipPath>
        <clipPath id="clip168">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3493"
          />
        </clipPath>
        <clipPath id="clip169">
          <path
            d="M 614 87 L 644 87 L 644 255 L 614 255 Z M 614 87 "
            id="path3496"
          />
        </clipPath>
        <clipPath id="clip170">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3499"
          />
        </clipPath>
        <clipPath id="clip171">
          <path
            d="M 213 87 L 214 87 L 214 255 L 213 255 Z M 213 87 "
            id="path3502"
          />
        </clipPath>
        <clipPath id="clip172">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3505"
          />
        </clipPath>
        <clipPath id="clip173">
          <path
            d="M 198 87 L 229 87 L 229 255 L 198 255 Z M 198 87 "
            id="path3508"
          />
        </clipPath>
        <clipPath id="clip174">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3511"
          />
        </clipPath>
        <clipPath id="clip175">
          <path
            d="M 222 87 L 224 87 L 224 255 L 222 255 Z M 222 87 "
            id="path3514"
          />
        </clipPath>
        <clipPath id="clip176">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3517"
          />
        </clipPath>
        <clipPath id="clip177">
          <path
            d="M 208 87 L 238 87 L 238 255 L 208 255 Z M 208 87 "
            id="path3520"
          />
        </clipPath>
        <clipPath id="clip178">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3523"
          />
        </clipPath>
        <clipPath id="clip179">
          <path
            d="M 231 87 L 233 87 L 233 255 L 231 255 Z M 231 87 "
            id="path3526"
          />
        </clipPath>
        <clipPath id="clip180">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3529"
          />
        </clipPath>
        <clipPath id="clip181">
          <path
            d="M 217 87 L 247 87 L 247 255 L 217 255 Z M 217 87 "
            id="path3532"
          />
        </clipPath>
        <clipPath id="clip182">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3535"
          />
        </clipPath>
        <clipPath id="clip183">
          <path
            d="M 240 87 L 242 87 L 242 255 L 240 255 Z M 240 87 "
            id="path3538"
          />
        </clipPath>
        <clipPath id="clip184">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3541"
          />
        </clipPath>
        <clipPath id="clip185">
          <path
            d="M 226 87 L 256 87 L 256 255 L 226 255 Z M 226 87 "
            id="path3544"
          />
        </clipPath>
        <clipPath id="clip186">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3547"
          />
        </clipPath>
        <clipPath id="clip187">
          <path
            d="M 249 87 L 251 87 L 251 255 L 249 255 Z M 249 87 "
            id="path3550"
          />
        </clipPath>
        <clipPath id="clip188">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3553"
          />
        </clipPath>
        <clipPath id="clip189">
          <path
            d="M 235 87 L 265 87 L 265 255 L 235 255 Z M 235 87 "
            id="path3556"
          />
        </clipPath>
        <clipPath id="clip190">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3559"
          />
        </clipPath>
        <clipPath id="clip191">
          <path
            d="M 259 87 L 260 87 L 260 255 L 259 255 Z M 259 87 "
            id="path3562"
          />
        </clipPath>
        <clipPath id="clip192">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3565"
          />
        </clipPath>
        <clipPath id="clip193">
          <path
            d="M 245 87 L 275 87 L 275 255 L 245 255 Z M 245 87 "
            id="path3568"
          />
        </clipPath>
        <clipPath id="clip194">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3571"
          />
        </clipPath>
        <clipPath id="clip195">
          <path
            d="M 268 87 L 270 87 L 270 255 L 268 255 Z M 268 87 "
            id="path3574"
          />
        </clipPath>
        <clipPath id="clip196">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3577"
          />
        </clipPath>
        <clipPath id="clip197">
          <path
            d="M 254 87 L 284 87 L 284 255 L 254 255 Z M 254 87 "
            id="path3580"
          />
        </clipPath>
        <clipPath id="clip198">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3583"
          />
        </clipPath>
        <clipPath id="clip199">
          <path
            d="M 277 87 L 279 87 L 279 255 L 277 255 Z M 277 87 "
            id="path3586"
          />
        </clipPath>
        <clipPath id="clip200">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3589"
          />
        </clipPath>
        <clipPath id="clip201">
          <path
            d="M 263 87 L 293 87 L 293 255 L 263 255 Z M 263 87 "
            id="path3592"
          />
        </clipPath>
        <clipPath id="clip202">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3595"
          />
        </clipPath>
        <clipPath id="clip203">
          <path
            d="M 286 87 L 288 87 L 288 255 L 286 255 Z M 286 87 "
            id="path3598"
          />
        </clipPath>
        <clipPath id="clip204">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3601"
          />
        </clipPath>
        <clipPath id="clip205">
          <path
            d="M 272 87 L 302 87 L 302 255 L 272 255 Z M 272 87 "
            id="path3604"
          />
        </clipPath>
        <clipPath id="clip206">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3607"
          />
        </clipPath>
        <clipPath id="clip207">
          <path
            d="M 296 87 L 297 87 L 297 255 L 296 255 Z M 296 87 "
            id="path3610"
          />
        </clipPath>
        <clipPath id="clip208">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3613"
          />
        </clipPath>
        <clipPath id="clip209">
          <path
            d="M 281 87 L 311 87 L 311 255 L 281 255 Z M 281 87 "
            id="path3616"
          />
        </clipPath>
        <clipPath id="clip210">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3619"
          />
        </clipPath>
        <clipPath id="clip211">
          <path
            d="M 305 87 L 307 87 L 307 255 L 305 255 Z M 305 87 "
            id="path3622"
          />
        </clipPath>
        <clipPath id="clip212">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3625"
          />
        </clipPath>
        <clipPath id="clip213">
          <path
            d="M 291 87 L 321 87 L 321 255 L 291 255 Z M 291 87 "
            id="path3628"
          />
        </clipPath>
        <clipPath id="clip214">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3631"
          />
        </clipPath>
        <clipPath id="clip215">
          <path
            d="M 314 87 L 316 87 L 316 255 L 314 255 Z M 314 87 "
            id="path3634"
          />
        </clipPath>
        <clipPath id="clip216">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3637"
          />
        </clipPath>
        <clipPath id="clip217">
          <path
            d="M 300 87 L 330 87 L 330 255 L 300 255 Z M 300 87 "
            id="path3640"
          />
        </clipPath>
        <clipPath id="clip218">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3643"
          />
        </clipPath>
        <clipPath id="clip219">
          <path
            d="M 323 87 L 325 87 L 325 255 L 323 255 Z M 323 87 "
            id="path3646"
          />
        </clipPath>
        <clipPath id="clip220">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3649"
          />
        </clipPath>
        <clipPath id="clip221">
          <path
            d="M 309 87 L 339 87 L 339 255 L 309 255 Z M 309 87 "
            id="path3652"
          />
        </clipPath>
        <clipPath id="clip222">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3655"
          />
        </clipPath>
        <clipPath id="clip223">
          <path
            d="M 332 87 L 334 87 L 334 255 L 332 255 Z M 332 87 "
            id="path3658"
          />
        </clipPath>
        <clipPath id="clip224">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3661"
          />
        </clipPath>
        <clipPath id="clip225">
          <path
            d="M 318 87 L 348 87 L 348 255 L 318 255 Z M 318 87 "
            id="path3664"
          />
        </clipPath>
        <clipPath id="clip226">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3667"
          />
        </clipPath>
        <clipPath id="clip227">
          <path
            d="M 342 87 L 343 87 L 343 255 L 342 255 Z M 342 87 "
            id="path3670"
          />
        </clipPath>
        <clipPath id="clip228">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3673"
          />
        </clipPath>
        <clipPath id="clip229">
          <path
            d="M 327 87 L 358 87 L 358 255 L 327 255 Z M 327 87 "
            id="path3676"
          />
        </clipPath>
        <clipPath id="clip230">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3679"
          />
        </clipPath>
        <clipPath id="clip231">
          <path
            d="M 351 87 L 353 87 L 353 255 L 351 255 Z M 351 87 "
            id="path3682"
          />
        </clipPath>
        <clipPath id="clip232">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3685"
          />
        </clipPath>
        <clipPath id="clip233">
          <path
            d="M 337 87 L 367 87 L 367 255 L 337 255 Z M 337 87 "
            id="path3688"
          />
        </clipPath>
        <clipPath id="clip234">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3691"
          />
        </clipPath>
        <clipPath id="clip235">
          <path
            d="M 360 87 L 362 87 L 362 255 L 360 255 Z M 360 87 "
            id="path3694"
          />
        </clipPath>
        <clipPath id="clip236">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3697"
          />
        </clipPath>
        <clipPath id="clip237">
          <path
            d="M 346 87 L 376 87 L 376 255 L 346 255 Z M 346 87 "
            id="path3700"
          />
        </clipPath>
        <clipPath id="clip238">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3703"
          />
        </clipPath>
        <clipPath id="clip239">
          <path
            d="M 369 87 L 371 87 L 371 255 L 369 255 Z M 369 87 "
            id="path3706"
          />
        </clipPath>
        <clipPath id="clip240">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3709"
          />
        </clipPath>
        <clipPath id="clip241">
          <path
            d="M 355 87 L 385 87 L 385 255 L 355 255 Z M 355 87 "
            id="path3712"
          />
        </clipPath>
        <clipPath id="clip242">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3715"
          />
        </clipPath>
        <clipPath id="clip243">
          <path
            d="M 379 87 L 380 87 L 380 255 L 379 255 Z M 379 87 "
            id="path3718"
          />
        </clipPath>
        <clipPath id="clip244">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3721"
          />
        </clipPath>
        <clipPath id="clip245">
          <path
            d="M 364 87 L 394 87 L 394 255 L 364 255 Z M 364 87 "
            id="path3724"
          />
        </clipPath>
        <clipPath id="clip246">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3727"
          />
        </clipPath>
        <clipPath id="clip247">
          <path
            d="M 388 87 L 390 87 L 390 255 L 388 255 Z M 388 87 "
            id="path3730"
          />
        </clipPath>
        <clipPath id="clip248">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3733"
          />
        </clipPath>
        <clipPath id="clip249">
          <path
            d="M 374 87 L 404 87 L 404 255 L 374 255 Z M 374 87 "
            id="path3736"
          />
        </clipPath>
        <clipPath id="clip250">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3739"
          />
        </clipPath>
        <clipPath id="clip251">
          <path
            d="M 397 87 L 399 87 L 399 255 L 397 255 Z M 397 87 "
            id="path3742"
          />
        </clipPath>
        <clipPath id="clip252">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3745"
          />
        </clipPath>
        <clipPath id="clip253">
          <path
            d="M 383 87 L 413 87 L 413 255 L 383 255 Z M 383 87 "
            id="path3748"
          />
        </clipPath>
        <clipPath id="clip254">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3751"
          />
        </clipPath>
        <clipPath id="clip255">
          <path
            d="M 406 87 L 408 87 L 408 255 L 406 255 Z M 406 87 "
            id="path3754"
          />
        </clipPath>
        <clipPath id="clip256">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3757"
          />
        </clipPath>
        <clipPath id="clip257">
          <path
            d="M 392 87 L 422 87 L 422 255 L 392 255 Z M 392 87 "
            id="path3760"
          />
        </clipPath>
        <clipPath id="clip258">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3763"
          />
        </clipPath>
        <clipPath id="clip259">
          <path
            d="M 415 87 L 417 87 L 417 255 L 415 255 Z M 415 87 "
            id="path3766"
          />
        </clipPath>
        <clipPath id="clip260">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3769"
          />
        </clipPath>
        <clipPath id="clip261">
          <path
            d="M 401 87 L 431 87 L 431 255 L 401 255 Z M 401 87 "
            id="path3772"
          />
        </clipPath>
        <clipPath id="clip262">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3775"
          />
        </clipPath>
        <clipPath id="clip263">
          <path
            d="M 36 87 L 44 87 L 44 255 L 36 255 Z M 36 87 "
            id="path3778"
          />
        </clipPath>
        <clipPath id="clip264">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3781"
          />
        </clipPath>
        <clipPath id="clip265">
          <path
            d="M 37 87 L 39 87 L 39 255 L 37 255 Z M 37 87 "
            id="path3784"
          />
        </clipPath>
        <clipPath id="clip266">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3787"
          />
        </clipPath>
        <clipPath id="clip267">
          <path
            d="M 36 87 L 53 87 L 53 255 L 36 255 Z M 36 87 "
            id="path3790"
          />
        </clipPath>
        <clipPath id="clip268">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3793"
          />
        </clipPath>
        <clipPath id="clip269">
          <path
            d="M 46 87 L 48 87 L 48 255 L 46 255 Z M 46 87 "
            id="path3796"
          />
        </clipPath>
        <clipPath id="clip270">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3799"
          />
        </clipPath>
        <clipPath id="clip271">
          <path
            d="M 36 87 L 62 87 L 62 255 L 36 255 Z M 36 87 "
            id="path3802"
          />
        </clipPath>
        <clipPath id="clip272">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3805"
          />
        </clipPath>
        <clipPath id="clip273">
          <path
            d="M 56 87 L 57 87 L 57 255 L 56 255 Z M 56 87 "
            id="path3808"
          />
        </clipPath>
        <clipPath id="clip274">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3811"
          />
        </clipPath>
        <clipPath id="clip275">
          <path
            d="M 41 87 L 71 87 L 71 255 L 41 255 Z M 41 87 "
            id="path3814"
          />
        </clipPath>
        <clipPath id="clip276">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3817"
          />
        </clipPath>
        <clipPath id="clip277">
          <path
            d="M 65 87 L 67 87 L 67 255 L 65 255 Z M 65 87 "
            id="path3820"
          />
        </clipPath>
        <clipPath id="clip278">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3823"
          />
        </clipPath>
        <clipPath id="clip279">
          <path
            d="M 51 87 L 81 87 L 81 255 L 51 255 Z M 51 87 "
            id="path3826"
          />
        </clipPath>
        <clipPath id="clip280">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3829"
          />
        </clipPath>
        <clipPath id="clip281">
          <path
            d="M 74 87 L 76 87 L 76 255 L 74 255 Z M 74 87 "
            id="path3832"
          />
        </clipPath>
        <clipPath id="clip282">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3835"
          />
        </clipPath>
        <clipPath id="clip283">
          <path
            d="M 60 87 L 90 87 L 90 255 L 60 255 Z M 60 87 "
            id="path3838"
          />
        </clipPath>
        <clipPath id="clip284">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3841"
          />
        </clipPath>
        <clipPath id="clip285">
          <path
            d="M 83 87 L 85 87 L 85 255 L 83 255 Z M 83 87 "
            id="path3844"
          />
        </clipPath>
        <clipPath id="clip286">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3847"
          />
        </clipPath>
        <clipPath id="clip287">
          <path
            d="M 69 87 L 99 87 L 99 255 L 69 255 Z M 69 87 "
            id="path3850"
          />
        </clipPath>
        <clipPath id="clip288">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3853"
          />
        </clipPath>
        <clipPath id="clip289">
          <path
            d="M 92 87 L 94 87 L 94 255 L 92 255 Z M 92 87 "
            id="path3856"
          />
        </clipPath>
        <clipPath id="clip290">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3859"
          />
        </clipPath>
        <clipPath id="clip291">
          <path
            d="M 78 87 L 108 87 L 108 255 L 78 255 Z M 78 87 "
            id="path3862"
          />
        </clipPath>
        <clipPath id="clip292">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3865"
          />
        </clipPath>
        <clipPath id="clip293">
          <path
            d="M 102 87 L 103 87 L 103 255 L 102 255 Z M 102 87 "
            id="path3868"
          />
        </clipPath>
        <clipPath id="clip294">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3871"
          />
        </clipPath>
        <clipPath id="clip295">
          <path
            d="M 87 87 L 118 87 L 118 255 L 87 255 Z M 87 87 "
            id="path3874"
          />
        </clipPath>
        <clipPath id="clip296">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3877"
          />
        </clipPath>
        <clipPath id="clip297">
          <path
            d="M 111 87 L 113 87 L 113 255 L 111 255 Z M 111 87 "
            id="path3880"
          />
        </clipPath>
        <clipPath id="clip298">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3883"
          />
        </clipPath>
        <clipPath id="clip299">
          <path
            d="M 97 87 L 127 87 L 127 255 L 97 255 Z M 97 87 "
            id="path3886"
          />
        </clipPath>
        <clipPath id="clip300">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3889"
          />
        </clipPath>
        <clipPath id="clip301">
          <path
            d="M 120 87 L 122 87 L 122 255 L 120 255 Z M 120 87 "
            id="path3892"
          />
        </clipPath>
        <clipPath id="clip302">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3895"
          />
        </clipPath>
        <clipPath id="clip303">
          <path
            d="M 106 87 L 136 87 L 136 255 L 106 255 Z M 106 87 "
            id="path3898"
          />
        </clipPath>
        <clipPath id="clip304">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3901"
          />
        </clipPath>
        <clipPath id="clip305">
          <path
            d="M 129 87 L 131 87 L 131 255 L 129 255 Z M 129 87 "
            id="path3904"
          />
        </clipPath>
        <clipPath id="clip306">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3907"
          />
        </clipPath>
        <clipPath id="clip307">
          <path
            d="M 115 87 L 145 87 L 145 255 L 115 255 Z M 115 87 "
            id="path3910"
          />
        </clipPath>
        <clipPath id="clip308">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3913"
          />
        </clipPath>
        <clipPath id="clip309">
          <path
            d="M 138 87 L 140 87 L 140 255 L 138 255 Z M 138 87 "
            id="path3916"
          />
        </clipPath>
        <clipPath id="clip310">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3919"
          />
        </clipPath>
        <clipPath id="clip311">
          <path
            d="M 124 87 L 154 87 L 154 255 L 124 255 Z M 124 87 "
            id="path3922"
          />
        </clipPath>
        <clipPath id="clip312">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3925"
          />
        </clipPath>
        <clipPath id="clip313">
          <path
            d="M 148 87 L 150 87 L 150 255 L 148 255 Z M 148 87 "
            id="path3928"
          />
        </clipPath>
        <clipPath id="clip314">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3931"
          />
        </clipPath>
        <clipPath id="clip315">
          <path
            d="M 134 87 L 164 87 L 164 255 L 134 255 Z M 134 87 "
            id="path3934"
          />
        </clipPath>
        <clipPath id="clip316">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3937"
          />
        </clipPath>
        <clipPath id="clip317">
          <path
            d="M 157 87 L 159 87 L 159 255 L 157 255 Z M 157 87 "
            id="path3940"
          />
        </clipPath>
        <clipPath id="clip318">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3943"
          />
        </clipPath>
        <clipPath id="clip319">
          <path
            d="M 143 87 L 173 87 L 173 255 L 143 255 Z M 143 87 "
            id="path3946"
          />
        </clipPath>
        <clipPath id="clip320">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3949"
          />
        </clipPath>
        <clipPath id="clip321">
          <path
            d="M 166 87 L 168 87 L 168 255 L 166 255 Z M 166 87 "
            id="path3952"
          />
        </clipPath>
        <clipPath id="clip322">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3955"
          />
        </clipPath>
        <clipPath id="clip323">
          <path
            d="M 152 87 L 182 87 L 182 255 L 152 255 Z M 152 87 "
            id="path3958"
          />
        </clipPath>
        <clipPath id="clip324">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3961"
          />
        </clipPath>
        <clipPath id="clip325">
          <path
            d="M 175 87 L 177 87 L 177 255 L 175 255 Z M 175 87 "
            id="path3964"
          />
        </clipPath>
        <clipPath id="clip326">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3967"
          />
        </clipPath>
        <clipPath id="clip327">
          <path
            d="M 161 87 L 191 87 L 191 255 L 161 255 Z M 161 87 "
            id="path3970"
          />
        </clipPath>
        <clipPath id="clip328">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3973"
          />
        </clipPath>
        <clipPath id="clip329">
          <path
            d="M 185 87 L 186 87 L 186 255 L 185 255 Z M 185 87 "
            id="path3976"
          />
        </clipPath>
        <clipPath id="clip330">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3979"
          />
        </clipPath>
        <clipPath id="clip331">
          <path
            d="M 170 87 L 201 87 L 201 255 L 170 255 Z M 170 87 "
            id="path3982"
          />
        </clipPath>
        <clipPath id="clip332">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3985"
          />
        </clipPath>
        <clipPath id="clip333">
          <path
            d="M 194 87 L 196 87 L 196 255 L 194 255 Z M 194 87 "
            id="path3988"
          />
        </clipPath>
        <clipPath id="clip334">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3991"
          />
        </clipPath>
        <clipPath id="clip335">
          <path
            d="M 180 87 L 210 87 L 210 255 L 180 255 Z M 180 87 "
            id="path3994"
          />
        </clipPath>
        <clipPath id="clip336">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path3997"
          />
        </clipPath>
        <clipPath id="clip337">
          <path
            d="M 203 87 L 205 87 L 205 255 L 203 255 Z M 203 87 "
            id="path4000"
          />
        </clipPath>
        <clipPath id="clip338">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path4003"
          />
        </clipPath>
        <clipPath id="clip339">
          <path
            d="M 189 87 L 219 87 L 219 255 L 189 255 Z M 189 87 "
            id="path4006"
          />
        </clipPath>
        <clipPath id="clip340">
          <path
            d="M 36.738281 254.171875 L 805.890625 254.171875 L 805.890625 247.84375 C 89.5625 247.84375 36.738281 87.636719 36.738281 87.636719 Z M 36.738281 254.171875 "
            id="path4009"
          />
        </clipPath>
        <clipPath id="clip341">
          <path
            d="M 204 369 L 205 369 L 205 536 L 204 536 Z M 204 369 "
            id="path4012"
          />
        </clipPath>
        <clipPath id="clip342">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4015"
          />
        </clipPath>
        <clipPath id="clip343">
          <path
            d="M 189 369 L 219 369 L 219 536 L 189 536 Z M 189 369 "
            id="path4018"
          />
        </clipPath>
        <clipPath id="clip344">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4021"
          />
        </clipPath>
        <clipPath id="clip345">
          <path
            d="M 194 369 L 196 369 L 196 536 L 194 536 Z M 194 369 "
            id="path4024"
          />
        </clipPath>
        <clipPath id="clip346">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4027"
          />
        </clipPath>
        <clipPath id="clip347">
          <path
            d="M 180 369 L 210 369 L 210 536 L 180 536 Z M 180 369 "
            id="path4030"
          />
        </clipPath>
        <clipPath id="clip348">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4033"
          />
        </clipPath>
        <clipPath id="clip349">
          <path
            d="M 185 369 L 187 369 L 187 536 L 185 536 Z M 185 369 "
            id="path4036"
          />
        </clipPath>
        <clipPath id="clip350">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4039"
          />
        </clipPath>
        <clipPath id="clip351">
          <path
            d="M 171 369 L 201 369 L 201 536 L 171 536 Z M 171 369 "
            id="path4042"
          />
        </clipPath>
        <clipPath id="clip352">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4045"
          />
        </clipPath>
        <clipPath id="clip353">
          <path
            d="M 176 369 L 178 369 L 178 536 L 176 536 Z M 176 369 "
            id="path4048"
          />
        </clipPath>
        <clipPath id="clip354">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4051"
          />
        </clipPath>
        <clipPath id="clip355">
          <path
            d="M 162 369 L 192 369 L 192 536 L 162 536 Z M 162 369 "
            id="path4054"
          />
        </clipPath>
        <clipPath id="clip356">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4057"
          />
        </clipPath>
        <clipPath id="clip357">
          <path
            d="M 167 369 L 168 369 L 168 536 L 167 536 Z M 167 369 "
            id="path4060"
          />
        </clipPath>
        <clipPath id="clip358">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4063"
          />
        </clipPath>
        <clipPath id="clip359">
          <path
            d="M 152 369 L 183 369 L 183 536 L 152 536 Z M 152 369 "
            id="path4066"
          />
        </clipPath>
        <clipPath id="clip360">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4069"
          />
        </clipPath>
        <clipPath id="clip361">
          <path
            d="M 157 369 L 159 369 L 159 536 L 157 536 Z M 157 369 "
            id="path4072"
          />
        </clipPath>
        <clipPath id="clip362">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4075"
          />
        </clipPath>
        <clipPath id="clip363">
          <path
            d="M 143 369 L 173 369 L 173 536 L 143 536 Z M 143 369 "
            id="path4078"
          />
        </clipPath>
        <clipPath id="clip364">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4081"
          />
        </clipPath>
        <clipPath id="clip365">
          <path
            d="M 148 369 L 150 369 L 150 536 L 148 536 Z M 148 369 "
            id="path4084"
          />
        </clipPath>
        <clipPath id="clip366">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4087"
          />
        </clipPath>
        <clipPath id="clip367">
          <path
            d="M 134 369 L 164 369 L 164 536 L 134 536 Z M 134 369 "
            id="path4090"
          />
        </clipPath>
        <clipPath id="clip368">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4093"
          />
        </clipPath>
        <clipPath id="clip369">
          <path
            d="M 139 369 L 141 369 L 141 536 L 139 536 Z M 139 369 "
            id="path4096"
          />
        </clipPath>
        <clipPath id="clip370">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4099"
          />
        </clipPath>
        <clipPath id="clip371">
          <path
            d="M 125 369 L 155 369 L 155 536 L 125 536 Z M 125 369 "
            id="path4102"
          />
        </clipPath>
        <clipPath id="clip372">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4105"
          />
        </clipPath>
        <clipPath id="clip373">
          <path
            d="M 130 369 L 132 369 L 132 536 L 130 536 Z M 130 369 "
            id="path4108"
          />
        </clipPath>
        <clipPath id="clip374">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4111"
          />
        </clipPath>
        <clipPath id="clip375">
          <path
            d="M 116 369 L 146 369 L 146 536 L 116 536 Z M 116 369 "
            id="path4114"
          />
        </clipPath>
        <clipPath id="clip376">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4117"
          />
        </clipPath>
        <clipPath id="clip377">
          <path
            d="M 121 369 L 122 369 L 122 536 L 121 536 Z M 121 369 "
            id="path4120"
          />
        </clipPath>
        <clipPath id="clip378">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4123"
          />
        </clipPath>
        <clipPath id="clip379">
          <path
            d="M 106 369 L 137 369 L 137 536 L 106 536 Z M 106 369 "
            id="path4126"
          />
        </clipPath>
        <clipPath id="clip380">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4129"
          />
        </clipPath>
        <clipPath id="clip381">
          <path
            d="M 111 369 L 113 369 L 113 536 L 111 536 Z M 111 369 "
            id="path4132"
          />
        </clipPath>
        <clipPath id="clip382">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4135"
          />
        </clipPath>
        <clipPath id="clip383">
          <path
            d="M 97 369 L 127 369 L 127 536 L 97 536 Z M 97 369 "
            id="path4138"
          />
        </clipPath>
        <clipPath id="clip384">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4141"
          />
        </clipPath>
        <clipPath id="clip385">
          <path
            d="M 102 369 L 104 369 L 104 536 L 102 536 Z M 102 369 "
            id="path4144"
          />
        </clipPath>
        <clipPath id="clip386">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4147"
          />
        </clipPath>
        <clipPath id="clip387">
          <path
            d="M 88 369 L 118 369 L 118 536 L 88 536 Z M 88 369 "
            id="path4150"
          />
        </clipPath>
        <clipPath id="clip388">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4153"
          />
        </clipPath>
        <clipPath id="clip389">
          <path
            d="M 93 369 L 95 369 L 95 536 L 93 536 Z M 93 369 "
            id="path4156"
          />
        </clipPath>
        <clipPath id="clip390">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4159"
          />
        </clipPath>
        <clipPath id="clip391">
          <path
            d="M 79 369 L 109 369 L 109 536 L 79 536 Z M 79 369 "
            id="path4162"
          />
        </clipPath>
        <clipPath id="clip392">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4165"
          />
        </clipPath>
        <clipPath id="clip393">
          <path
            d="M 84 369 L 85 369 L 85 536 L 84 536 Z M 84 369 "
            id="path4168"
          />
        </clipPath>
        <clipPath id="clip394">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4171"
          />
        </clipPath>
        <clipPath id="clip395">
          <path
            d="M 70 369 L 100 369 L 100 536 L 70 536 Z M 70 369 "
            id="path4174"
          />
        </clipPath>
        <clipPath id="clip396">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4177"
          />
        </clipPath>
        <clipPath id="clip397">
          <path
            d="M 74 369 L 76 369 L 76 536 L 74 536 Z M 74 369 "
            id="path4180"
          />
        </clipPath>
        <clipPath id="clip398">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4183"
          />
        </clipPath>
        <clipPath id="clip399">
          <path
            d="M 60 369 L 90 369 L 90 536 L 60 536 Z M 60 369 "
            id="path4186"
          />
        </clipPath>
        <clipPath id="clip400">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4189"
          />
        </clipPath>
        <clipPath id="clip401">
          <path
            d="M 65 369 L 67 369 L 67 536 L 65 536 Z M 65 369 "
            id="path4192"
          />
        </clipPath>
        <clipPath id="clip402">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4195"
          />
        </clipPath>
        <clipPath id="clip403">
          <path
            d="M 51 369 L 81 369 L 81 536 L 51 536 Z M 51 369 "
            id="path4198"
          />
        </clipPath>
        <clipPath id="clip404">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4201"
          />
        </clipPath>
        <clipPath id="clip405">
          <path
            d="M 56 369 L 58 369 L 58 536 L 56 536 Z M 56 369 "
            id="path4204"
          />
        </clipPath>
        <clipPath id="clip406">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4207"
          />
        </clipPath>
        <clipPath id="clip407">
          <path
            d="M 42 369 L 72 369 L 72 536 L 42 536 Z M 42 369 "
            id="path4210"
          />
        </clipPath>
        <clipPath id="clip408">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4213"
          />
        </clipPath>
        <clipPath id="clip409">
          <path
            d="M 47 369 L 49 369 L 49 536 L 47 536 Z M 47 369 "
            id="path4216"
          />
        </clipPath>
        <clipPath id="clip410">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4219"
          />
        </clipPath>
        <clipPath id="clip411">
          <path
            d="M 36 369 L 63 369 L 63 536 L 36 536 Z M 36 369 "
            id="path4222"
          />
        </clipPath>
        <clipPath id="clip412">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4225"
          />
        </clipPath>
        <clipPath id="clip413">
          <path
            d="M 38 369 L 39 369 L 39 536 L 38 536 Z M 38 369 "
            id="path4228"
          />
        </clipPath>
        <clipPath id="clip414">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4231"
          />
        </clipPath>
        <clipPath id="clip415">
          <path
            d="M 36 369 L 54 369 L 54 536 L 36 536 Z M 36 369 "
            id="path4234"
          />
        </clipPath>
        <clipPath id="clip416">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4237"
          />
        </clipPath>
        <clipPath id="clip417">
          <path
            d="M 36 369 L 44 369 L 44 536 L 36 536 Z M 36 369 "
            id="path4240"
          />
        </clipPath>
        <clipPath id="clip418">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4243"
          />
        </clipPath>
        <clipPath id="clip419">
          <path
            d="M 416 369 L 418 369 L 418 536 L 416 536 Z M 416 369 "
            id="path4246"
          />
        </clipPath>
        <clipPath id="clip420">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4249"
          />
        </clipPath>
        <clipPath id="clip421">
          <path
            d="M 402 369 L 432 369 L 432 536 L 402 536 Z M 402 369 "
            id="path4252"
          />
        </clipPath>
        <clipPath id="clip422">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4255"
          />
        </clipPath>
        <clipPath id="clip423">
          <path
            d="M 407 369 L 408 369 L 408 536 L 407 536 Z M 407 369 "
            id="path4258"
          />
        </clipPath>
        <clipPath id="clip424">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4261"
          />
        </clipPath>
        <clipPath id="clip425">
          <path
            d="M 393 369 L 423 369 L 423 536 L 393 536 Z M 393 369 "
            id="path4264"
          />
        </clipPath>
        <clipPath id="clip426">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4267"
          />
        </clipPath>
        <clipPath id="clip427">
          <path
            d="M 397 369 L 399 369 L 399 536 L 397 536 Z M 397 369 "
            id="path4270"
          />
        </clipPath>
        <clipPath id="clip428">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4273"
          />
        </clipPath>
        <clipPath id="clip429">
          <path
            d="M 383 369 L 413 369 L 413 536 L 383 536 Z M 383 369 "
            id="path4276"
          />
        </clipPath>
        <clipPath id="clip430">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4279"
          />
        </clipPath>
        <clipPath id="clip431">
          <path
            d="M 388 369 L 390 369 L 390 536 L 388 536 Z M 388 369 "
            id="path4282"
          />
        </clipPath>
        <clipPath id="clip432">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4285"
          />
        </clipPath>
        <clipPath id="clip433">
          <path
            d="M 374 369 L 404 369 L 404 536 L 374 536 Z M 374 369 "
            id="path4288"
          />
        </clipPath>
        <clipPath id="clip434">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4291"
          />
        </clipPath>
        <clipPath id="clip435">
          <path
            d="M 379 369 L 381 369 L 381 536 L 379 536 Z M 379 369 "
            id="path4294"
          />
        </clipPath>
        <clipPath id="clip436">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4297"
          />
        </clipPath>
        <clipPath id="clip437">
          <path
            d="M 365 369 L 395 369 L 395 536 L 365 536 Z M 365 369 "
            id="path4300"
          />
        </clipPath>
        <clipPath id="clip438">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4303"
          />
        </clipPath>
        <clipPath id="clip439">
          <path
            d="M 370 369 L 372 369 L 372 536 L 370 536 Z M 370 369 "
            id="path4306"
          />
        </clipPath>
        <clipPath id="clip440">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4309"
          />
        </clipPath>
        <clipPath id="clip441">
          <path
            d="M 356 369 L 386 369 L 386 536 L 356 536 Z M 356 369 "
            id="path4312"
          />
        </clipPath>
        <clipPath id="clip442">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4315"
          />
        </clipPath>
        <clipPath id="clip443">
          <path
            d="M 361 369 L 362 369 L 362 536 L 361 536 Z M 361 369 "
            id="path4318"
          />
        </clipPath>
        <clipPath id="clip444">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4321"
          />
        </clipPath>
        <clipPath id="clip445">
          <path
            d="M 346 369 L 377 369 L 377 536 L 346 536 Z M 346 369 "
            id="path4324"
          />
        </clipPath>
        <clipPath id="clip446">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4327"
          />
        </clipPath>
        <clipPath id="clip447">
          <path
            d="M 351 369 L 353 369 L 353 536 L 351 536 Z M 351 369 "
            id="path4330"
          />
        </clipPath>
        <clipPath id="clip448">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4333"
          />
        </clipPath>
        <clipPath id="clip449">
          <path
            d="M 337 369 L 367 369 L 367 536 L 337 536 Z M 337 369 "
            id="path4336"
          />
        </clipPath>
        <clipPath id="clip450">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4339"
          />
        </clipPath>
        <clipPath id="clip451">
          <path
            d="M 342 369 L 344 369 L 344 536 L 342 536 Z M 342 369 "
            id="path4342"
          />
        </clipPath>
        <clipPath id="clip452">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4345"
          />
        </clipPath>
        <clipPath id="clip453">
          <path
            d="M 328 369 L 358 369 L 358 536 L 328 536 Z M 328 369 "
            id="path4348"
          />
        </clipPath>
        <clipPath id="clip454">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4351"
          />
        </clipPath>
        <clipPath id="clip455">
          <path
            d="M 333 369 L 335 369 L 335 536 L 333 536 Z M 333 369 "
            id="path4354"
          />
        </clipPath>
        <clipPath id="clip456">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4357"
          />
        </clipPath>
        <clipPath id="clip457">
          <path
            d="M 319 369 L 349 369 L 349 536 L 319 536 Z M 319 369 "
            id="path4360"
          />
        </clipPath>
        <clipPath id="clip458">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4363"
          />
        </clipPath>
        <clipPath id="clip459">
          <path
            d="M 324 369 L 326 369 L 326 536 L 324 536 Z M 324 369 "
            id="path4366"
          />
        </clipPath>
        <clipPath id="clip460">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4369"
          />
        </clipPath>
        <clipPath id="clip461">
          <path
            d="M 310 369 L 340 369 L 340 536 L 310 536 Z M 310 369 "
            id="path4372"
          />
        </clipPath>
        <clipPath id="clip462">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4375"
          />
        </clipPath>
        <clipPath id="clip463">
          <path
            d="M 314 369 L 316 369 L 316 536 L 314 536 Z M 314 369 "
            id="path4378"
          />
        </clipPath>
        <clipPath id="clip464">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4381"
          />
        </clipPath>
        <clipPath id="clip465">
          <path
            d="M 300 369 L 330 369 L 330 536 L 300 536 Z M 300 369 "
            id="path4384"
          />
        </clipPath>
        <clipPath id="clip466">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4387"
          />
        </clipPath>
        <clipPath id="clip467">
          <path
            d="M 305 369 L 307 369 L 307 536 L 305 536 Z M 305 369 "
            id="path4390"
          />
        </clipPath>
        <clipPath id="clip468">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4393"
          />
        </clipPath>
        <clipPath id="clip469">
          <path
            d="M 291 369 L 321 369 L 321 536 L 291 536 Z M 291 369 "
            id="path4396"
          />
        </clipPath>
        <clipPath id="clip470">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4399"
          />
        </clipPath>
        <clipPath id="clip471">
          <path
            d="M 296 369 L 298 369 L 298 536 L 296 536 Z M 296 369 "
            id="path4402"
          />
        </clipPath>
        <clipPath id="clip472">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4405"
          />
        </clipPath>
        <clipPath id="clip473">
          <path
            d="M 282 369 L 312 369 L 312 536 L 282 536 Z M 282 369 "
            id="path4408"
          />
        </clipPath>
        <clipPath id="clip474">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4411"
          />
        </clipPath>
        <clipPath id="clip475">
          <path
            d="M 287 369 L 289 369 L 289 536 L 287 536 Z M 287 369 "
            id="path4414"
          />
        </clipPath>
        <clipPath id="clip476">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4417"
          />
        </clipPath>
        <clipPath id="clip477">
          <path
            d="M 273 369 L 303 369 L 303 536 L 273 536 Z M 273 369 "
            id="path4420"
          />
        </clipPath>
        <clipPath id="clip478">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4423"
          />
        </clipPath>
        <clipPath id="clip479">
          <path
            d="M 278 369 L 279 369 L 279 536 L 278 536 Z M 278 369 "
            id="path4426"
          />
        </clipPath>
        <clipPath id="clip480">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4429"
          />
        </clipPath>
        <clipPath id="clip481">
          <path
            d="M 263 369 L 294 369 L 294 536 L 263 536 Z M 263 369 "
            id="path4432"
          />
        </clipPath>
        <clipPath id="clip482">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4435"
          />
        </clipPath>
        <clipPath id="clip483">
          <path
            d="M 268 369 L 270 369 L 270 536 L 268 536 Z M 268 369 "
            id="path4438"
          />
        </clipPath>
        <clipPath id="clip484">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4441"
          />
        </clipPath>
        <clipPath id="clip485">
          <path
            d="M 254 369 L 284 369 L 284 536 L 254 536 Z M 254 369 "
            id="path4444"
          />
        </clipPath>
        <clipPath id="clip486">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4447"
          />
        </clipPath>
        <clipPath id="clip487">
          <path
            d="M 259 369 L 261 369 L 261 536 L 259 536 Z M 259 369 "
            id="path4450"
          />
        </clipPath>
        <clipPath id="clip488">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4453"
          />
        </clipPath>
        <clipPath id="clip489">
          <path
            d="M 245 369 L 275 369 L 275 536 L 245 536 Z M 245 369 "
            id="path4456"
          />
        </clipPath>
        <clipPath id="clip490">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4459"
          />
        </clipPath>
        <clipPath id="clip491">
          <path
            d="M 250 369 L 252 369 L 252 536 L 250 536 Z M 250 369 "
            id="path4462"
          />
        </clipPath>
        <clipPath id="clip492">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4465"
          />
        </clipPath>
        <clipPath id="clip493">
          <path
            d="M 236 369 L 266 369 L 266 536 L 236 536 Z M 236 369 "
            id="path4468"
          />
        </clipPath>
        <clipPath id="clip494">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4471"
          />
        </clipPath>
        <clipPath id="clip495">
          <path
            d="M 241 369 L 243 369 L 243 536 L 241 536 Z M 241 369 "
            id="path4474"
          />
        </clipPath>
        <clipPath id="clip496">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4477"
          />
        </clipPath>
        <clipPath id="clip497">
          <path
            d="M 227 369 L 257 369 L 257 536 L 227 536 Z M 227 369 "
            id="path4480"
          />
        </clipPath>
        <clipPath id="clip498">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4483"
          />
        </clipPath>
        <clipPath id="clip499">
          <path
            d="M 232 369 L 233 369 L 233 536 L 232 536 Z M 232 369 "
            id="path4486"
          />
        </clipPath>
        <clipPath id="clip500">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4489"
          />
        </clipPath>
        <clipPath id="clip501">
          <path
            d="M 217 369 L 247 369 L 247 536 L 217 536 Z M 217 369 "
            id="path4492"
          />
        </clipPath>
        <clipPath id="clip502">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4495"
          />
        </clipPath>
        <clipPath id="clip503">
          <path
            d="M 222 369 L 224 369 L 224 536 L 222 536 Z M 222 369 "
            id="path4498"
          />
        </clipPath>
        <clipPath id="clip504">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4501"
          />
        </clipPath>
        <clipPath id="clip505">
          <path
            d="M 208 369 L 238 369 L 238 536 L 208 536 Z M 208 369 "
            id="path4504"
          />
        </clipPath>
        <clipPath id="clip506">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4507"
          />
        </clipPath>
        <clipPath id="clip507">
          <path
            d="M 213 369 L 215 369 L 215 536 L 213 536 Z M 213 369 "
            id="path4510"
          />
        </clipPath>
        <clipPath id="clip508">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4513"
          />
        </clipPath>
        <clipPath id="clip509">
          <path
            d="M 199 369 L 229 369 L 229 536 L 199 536 Z M 199 369 "
            id="path4516"
          />
        </clipPath>
        <clipPath id="clip510">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4519"
          />
        </clipPath>
        <clipPath id="clip511">
          <path
            d="M 628 369 L 630 369 L 630 536 L 628 536 Z M 628 369 "
            id="path4522"
          />
        </clipPath>
        <clipPath id="clip512">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4525"
          />
        </clipPath>
        <clipPath id="clip513">
          <path
            d="M 614 369 L 644 369 L 644 536 L 614 536 Z M 614 369 "
            id="path4528"
          />
        </clipPath>
        <clipPath id="clip514">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4531"
          />
        </clipPath>
        <clipPath id="clip515">
          <path
            d="M 619 369 L 621 369 L 621 536 L 619 536 Z M 619 369 "
            id="path4534"
          />
        </clipPath>
        <clipPath id="clip516">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4537"
          />
        </clipPath>
        <clipPath id="clip517">
          <path
            d="M 605 369 L 635 369 L 635 536 L 605 536 Z M 605 369 "
            id="path4540"
          />
        </clipPath>
        <clipPath id="clip518">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4543"
          />
        </clipPath>
        <clipPath id="clip519">
          <path
            d="M 610 369 L 612 369 L 612 536 L 610 536 Z M 610 369 "
            id="path4546"
          />
        </clipPath>
        <clipPath id="clip520">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4549"
          />
        </clipPath>
        <clipPath id="clip521">
          <path
            d="M 596 369 L 626 369 L 626 536 L 596 536 Z M 596 369 "
            id="path4552"
          />
        </clipPath>
        <clipPath id="clip522">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4555"
          />
        </clipPath>
        <clipPath id="clip523">
          <path
            d="M 601 369 L 602 369 L 602 536 L 601 536 Z M 601 369 "
            id="path4558"
          />
        </clipPath>
        <clipPath id="clip524">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4561"
          />
        </clipPath>
        <clipPath id="clip525">
          <path
            d="M 586 369 L 617 369 L 617 536 L 586 536 Z M 586 369 "
            id="path4564"
          />
        </clipPath>
        <clipPath id="clip526">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4567"
          />
        </clipPath>
        <clipPath id="clip527">
          <path
            d="M 591 369 L 593 369 L 593 536 L 591 536 Z M 591 369 "
            id="path4570"
          />
        </clipPath>
        <clipPath id="clip528">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4573"
          />
        </clipPath>
        <clipPath id="clip529">
          <path
            d="M 577 369 L 607 369 L 607 536 L 577 536 Z M 577 369 "
            id="path4576"
          />
        </clipPath>
        <clipPath id="clip530">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4579"
          />
        </clipPath>
        <clipPath id="clip531">
          <path
            d="M 582 369 L 584 369 L 584 536 L 582 536 Z M 582 369 "
            id="path4582"
          />
        </clipPath>
        <clipPath id="clip532">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4585"
          />
        </clipPath>
        <clipPath id="clip533">
          <path
            d="M 568 369 L 598 369 L 598 536 L 568 536 Z M 568 369 "
            id="path4588"
          />
        </clipPath>
        <clipPath id="clip534">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4591"
          />
        </clipPath>
        <clipPath id="clip535">
          <path
            d="M 573 369 L 575 369 L 575 536 L 573 536 Z M 573 369 "
            id="path4594"
          />
        </clipPath>
        <clipPath id="clip536">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4597"
          />
        </clipPath>
        <clipPath id="clip537">
          <path
            d="M 559 369 L 589 369 L 589 536 L 559 536 Z M 559 369 "
            id="path4600"
          />
        </clipPath>
        <clipPath id="clip538">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4603"
          />
        </clipPath>
        <clipPath id="clip539">
          <path
            d="M 564 369 L 566 369 L 566 536 L 564 536 Z M 564 369 "
            id="path4606"
          />
        </clipPath>
        <clipPath id="clip540">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4609"
          />
        </clipPath>
        <clipPath id="clip541">
          <path
            d="M 550 369 L 580 369 L 580 536 L 550 536 Z M 550 369 "
            id="path4612"
          />
        </clipPath>
        <clipPath id="clip542">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4615"
          />
        </clipPath>
        <clipPath id="clip543">
          <path
            d="M 554 369 L 556 369 L 556 536 L 554 536 Z M 554 369 "
            id="path4618"
          />
        </clipPath>
        <clipPath id="clip544">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4621"
          />
        </clipPath>
        <clipPath id="clip545">
          <path
            d="M 540 369 L 570 369 L 570 536 L 540 536 Z M 540 369 "
            id="path4624"
          />
        </clipPath>
        <clipPath id="clip546">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4627"
          />
        </clipPath>
        <clipPath id="clip547">
          <path
            d="M 545 369 L 547 369 L 547 536 L 545 536 Z M 545 369 "
            id="path4630"
          />
        </clipPath>
        <clipPath id="clip548">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4633"
          />
        </clipPath>
        <clipPath id="clip549">
          <path
            d="M 531 369 L 561 369 L 561 536 L 531 536 Z M 531 369 "
            id="path4636"
          />
        </clipPath>
        <clipPath id="clip550">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4639"
          />
        </clipPath>
        <clipPath id="clip551">
          <path
            d="M 536 369 L 538 369 L 538 536 L 536 536 Z M 536 369 "
            id="path4642"
          />
        </clipPath>
        <clipPath id="clip552">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4645"
          />
        </clipPath>
        <clipPath id="clip553">
          <path
            d="M 522 369 L 552 369 L 552 536 L 522 536 Z M 522 369 "
            id="path4648"
          />
        </clipPath>
        <clipPath id="clip554">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4651"
          />
        </clipPath>
        <clipPath id="clip555">
          <path
            d="M 527 369 L 529 369 L 529 536 L 527 536 Z M 527 369 "
            id="path4654"
          />
        </clipPath>
        <clipPath id="clip556">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4657"
          />
        </clipPath>
        <clipPath id="clip557">
          <path
            d="M 513 369 L 543 369 L 543 536 L 513 536 Z M 513 369 "
            id="path4660"
          />
        </clipPath>
        <clipPath id="clip558">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4663"
          />
        </clipPath>
        <clipPath id="clip559">
          <path
            d="M 518 369 L 519 369 L 519 536 L 518 536 Z M 518 369 "
            id="path4666"
          />
        </clipPath>
        <clipPath id="clip560">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4669"
          />
        </clipPath>
        <clipPath id="clip561">
          <path
            d="M 503 369 L 534 369 L 534 536 L 503 536 Z M 503 369 "
            id="path4672"
          />
        </clipPath>
        <clipPath id="clip562">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4675"
          />
        </clipPath>
        <clipPath id="clip563">
          <path
            d="M 508 369 L 510 369 L 510 536 L 508 536 Z M 508 369 "
            id="path4678"
          />
        </clipPath>
        <clipPath id="clip564">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4681"
          />
        </clipPath>
        <clipPath id="clip565">
          <path
            d="M 494 369 L 524 369 L 524 536 L 494 536 Z M 494 369 "
            id="path4684"
          />
        </clipPath>
        <clipPath id="clip566">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4687"
          />
        </clipPath>
        <clipPath id="clip567">
          <path
            d="M 499 369 L 501 369 L 501 536 L 499 536 Z M 499 369 "
            id="path4690"
          />
        </clipPath>
        <clipPath id="clip568">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4693"
          />
        </clipPath>
        <clipPath id="clip569">
          <path
            d="M 485 369 L 515 369 L 515 536 L 485 536 Z M 485 369 "
            id="path4696"
          />
        </clipPath>
        <clipPath id="clip570">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4699"
          />
        </clipPath>
        <clipPath id="clip571">
          <path
            d="M 490 369 L 492 369 L 492 536 L 490 536 Z M 490 369 "
            id="path4702"
          />
        </clipPath>
        <clipPath id="clip572">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4705"
          />
        </clipPath>
        <clipPath id="clip573">
          <path
            d="M 476 369 L 506 369 L 506 536 L 476 536 Z M 476 369 "
            id="path4708"
          />
        </clipPath>
        <clipPath id="clip574">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4711"
          />
        </clipPath>
        <clipPath id="clip575">
          <path
            d="M 481 369 L 483 369 L 483 536 L 481 536 Z M 481 369 "
            id="path4714"
          />
        </clipPath>
        <clipPath id="clip576">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4717"
          />
        </clipPath>
        <clipPath id="clip577">
          <path
            d="M 467 369 L 497 369 L 497 536 L 467 536 Z M 467 369 "
            id="path4720"
          />
        </clipPath>
        <clipPath id="clip578">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4723"
          />
        </clipPath>
        <clipPath id="clip579">
          <path
            d="M 472 369 L 473 369 L 473 536 L 472 536 Z M 472 369 "
            id="path4726"
          />
        </clipPath>
        <clipPath id="clip580">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4729"
          />
        </clipPath>
        <clipPath id="clip581">
          <path
            d="M 457 369 L 487 369 L 487 536 L 457 536 Z M 457 369 "
            id="path4732"
          />
        </clipPath>
        <clipPath id="clip582">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4735"
          />
        </clipPath>
        <clipPath id="clip583">
          <path
            d="M 462 369 L 464 369 L 464 536 L 462 536 Z M 462 369 "
            id="path4738"
          />
        </clipPath>
        <clipPath id="clip584">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4741"
          />
        </clipPath>
        <clipPath id="clip585">
          <path
            d="M 448 369 L 478 369 L 478 536 L 448 536 Z M 448 369 "
            id="path4744"
          />
        </clipPath>
        <clipPath id="clip586">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4747"
          />
        </clipPath>
        <clipPath id="clip587">
          <path
            d="M 453 369 L 455 369 L 455 536 L 453 536 Z M 453 369 "
            id="path4750"
          />
        </clipPath>
        <clipPath id="clip588">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4753"
          />
        </clipPath>
        <clipPath id="clip589">
          <path
            d="M 439 369 L 469 369 L 469 536 L 439 536 Z M 439 369 "
            id="path4756"
          />
        </clipPath>
        <clipPath id="clip590">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4759"
          />
        </clipPath>
        <clipPath id="clip591">
          <path
            d="M 444 369 L 446 369 L 446 536 L 444 536 Z M 444 369 "
            id="path4762"
          />
        </clipPath>
        <clipPath id="clip592">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4765"
          />
        </clipPath>
        <clipPath id="clip593">
          <path
            d="M 430 369 L 460 369 L 460 536 L 430 536 Z M 430 369 "
            id="path4768"
          />
        </clipPath>
        <clipPath id="clip594">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4771"
          />
        </clipPath>
        <clipPath id="clip595">
          <path
            d="M 435 369 L 436 369 L 436 536 L 435 536 Z M 435 369 "
            id="path4774"
          />
        </clipPath>
        <clipPath id="clip596">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4777"
          />
        </clipPath>
        <clipPath id="clip597">
          <path
            d="M 421 369 L 451 369 L 451 536 L 421 536 Z M 421 369 "
            id="path4780"
          />
        </clipPath>
        <clipPath id="clip598">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4783"
          />
        </clipPath>
        <clipPath id="clip599">
          <path
            d="M 425 369 L 427 369 L 427 536 L 425 536 Z M 425 369 "
            id="path4786"
          />
        </clipPath>
        <clipPath id="clip600">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4789"
          />
        </clipPath>
        <clipPath id="clip601">
          <path
            d="M 411 369 L 441 369 L 441 536 L 411 536 Z M 411 369 "
            id="path4792"
          />
        </clipPath>
        <clipPath id="clip602">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4795"
          />
        </clipPath>
        <clipPath id="clip603">
          <path
            d="M 799 369 L 806 369 L 806 536 L 799 536 Z M 799 369 "
            id="path4798"
          />
        </clipPath>
        <clipPath id="clip604">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4801"
          />
        </clipPath>
        <clipPath id="clip605">
          <path
            d="M 804 369 L 806 369 L 806 536 L 804 536 Z M 804 369 "
            id="path4804"
          />
        </clipPath>
        <clipPath id="clip606">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4807"
          />
        </clipPath>
        <clipPath id="clip607">
          <path
            d="M 790 369 L 806 369 L 806 536 L 790 536 Z M 790 369 "
            id="path4810"
          />
        </clipPath>
        <clipPath id="clip608">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4813"
          />
        </clipPath>
        <clipPath id="clip609">
          <path
            d="M 794 369 L 796 369 L 796 536 L 794 536 Z M 794 369 "
            id="path4816"
          />
        </clipPath>
        <clipPath id="clip610">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4819"
          />
        </clipPath>
        <clipPath id="clip611">
          <path
            d="M 780 369 L 806 369 L 806 536 L 780 536 Z M 780 369 "
            id="path4822"
          />
        </clipPath>
        <clipPath id="clip612">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4825"
          />
        </clipPath>
        <clipPath id="clip613">
          <path
            d="M 785 369 L 787 369 L 787 536 L 785 536 Z M 785 369 "
            id="path4828"
          />
        </clipPath>
        <clipPath id="clip614">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4831"
          />
        </clipPath>
        <clipPath id="clip615">
          <path
            d="M 771 369 L 801 369 L 801 536 L 771 536 Z M 771 369 "
            id="path4834"
          />
        </clipPath>
        <clipPath id="clip616">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4837"
          />
        </clipPath>
        <clipPath id="clip617">
          <path
            d="M 776 369 L 778 369 L 778 536 L 776 536 Z M 776 369 "
            id="path4840"
          />
        </clipPath>
        <clipPath id="clip618">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4843"
          />
        </clipPath>
        <clipPath id="clip619">
          <path
            d="M 762 369 L 792 369 L 792 536 L 762 536 Z M 762 369 "
            id="path4846"
          />
        </clipPath>
        <clipPath id="clip620">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4849"
          />
        </clipPath>
        <clipPath id="clip621">
          <path
            d="M 767 369 L 769 369 L 769 536 L 767 536 Z M 767 369 "
            id="path4852"
          />
        </clipPath>
        <clipPath id="clip622">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4855"
          />
        </clipPath>
        <clipPath id="clip623">
          <path
            d="M 753 369 L 783 369 L 783 536 L 753 536 Z M 753 369 "
            id="path4858"
          />
        </clipPath>
        <clipPath id="clip624">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4861"
          />
        </clipPath>
        <clipPath id="clip625">
          <path
            d="M 758 369 L 759 369 L 759 536 L 758 536 Z M 758 369 "
            id="path4864"
          />
        </clipPath>
        <clipPath id="clip626">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4867"
          />
        </clipPath>
        <clipPath id="clip627">
          <path
            d="M 743 369 L 774 369 L 774 536 L 743 536 Z M 743 369 "
            id="path4870"
          />
        </clipPath>
        <clipPath id="clip628">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4873"
          />
        </clipPath>
        <clipPath id="clip629">
          <path
            d="M 748 369 L 750 369 L 750 536 L 748 536 Z M 748 369 "
            id="path4876"
          />
        </clipPath>
        <clipPath id="clip630">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4879"
          />
        </clipPath>
        <clipPath id="clip631">
          <path
            d="M 734 369 L 764 369 L 764 536 L 734 536 Z M 734 369 "
            id="path4882"
          />
        </clipPath>
        <clipPath id="clip632">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4885"
          />
        </clipPath>
        <clipPath id="clip633">
          <path
            d="M 739 369 L 741 369 L 741 536 L 739 536 Z M 739 369 "
            id="path4888"
          />
        </clipPath>
        <clipPath id="clip634">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4891"
          />
        </clipPath>
        <clipPath id="clip635">
          <path
            d="M 725 369 L 755 369 L 755 536 L 725 536 Z M 725 369 "
            id="path4894"
          />
        </clipPath>
        <clipPath id="clip636">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4897"
          />
        </clipPath>
        <clipPath id="clip637">
          <path
            d="M 730 369 L 732 369 L 732 536 L 730 536 Z M 730 369 "
            id="path4900"
          />
        </clipPath>
        <clipPath id="clip638">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4903"
          />
        </clipPath>
        <clipPath id="clip639">
          <path
            d="M 716 369 L 746 369 L 746 536 L 716 536 Z M 716 369 "
            id="path4906"
          />
        </clipPath>
        <clipPath id="clip640">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4909"
          />
        </clipPath>
        <clipPath id="clip641">
          <path
            d="M 721 369 L 723 369 L 723 536 L 721 536 Z M 721 369 "
            id="path4912"
          />
        </clipPath>
        <clipPath id="clip642">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4915"
          />
        </clipPath>
        <clipPath id="clip643">
          <path
            d="M 707 369 L 737 369 L 737 536 L 707 536 Z M 707 369 "
            id="path4918"
          />
        </clipPath>
        <clipPath id="clip644">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4921"
          />
        </clipPath>
        <clipPath id="clip645">
          <path
            d="M 712 369 L 713 369 L 713 536 L 712 536 Z M 712 369 "
            id="path4924"
          />
        </clipPath>
        <clipPath id="clip646">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4927"
          />
        </clipPath>
        <clipPath id="clip647">
          <path
            d="M 697 369 L 727 369 L 727 536 L 697 536 Z M 697 369 "
            id="path4930"
          />
        </clipPath>
        <clipPath id="clip648">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4933"
          />
        </clipPath>
        <clipPath id="clip649">
          <path
            d="M 702 369 L 704 369 L 704 536 L 702 536 Z M 702 369 "
            id="path4936"
          />
        </clipPath>
        <clipPath id="clip650">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4939"
          />
        </clipPath>
        <clipPath id="clip651">
          <path
            d="M 688 369 L 718 369 L 718 536 L 688 536 Z M 688 369 "
            id="path4942"
          />
        </clipPath>
        <clipPath id="clip652">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4945"
          />
        </clipPath>
        <clipPath id="clip653">
          <path
            d="M 693 369 L 695 369 L 695 536 L 693 536 Z M 693 369 "
            id="path4948"
          />
        </clipPath>
        <clipPath id="clip654">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4951"
          />
        </clipPath>
        <clipPath id="clip655">
          <path
            d="M 679 369 L 709 369 L 709 536 L 679 536 Z M 679 369 "
            id="path4954"
          />
        </clipPath>
        <clipPath id="clip656">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4957"
          />
        </clipPath>
        <clipPath id="clip657">
          <path
            d="M 684 369 L 686 369 L 686 536 L 684 536 Z M 684 369 "
            id="path4960"
          />
        </clipPath>
        <clipPath id="clip658">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4963"
          />
        </clipPath>
        <clipPath id="clip659">
          <path
            d="M 670 369 L 700 369 L 700 536 L 670 536 Z M 670 369 "
            id="path4966"
          />
        </clipPath>
        <clipPath id="clip660">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4969"
          />
        </clipPath>
        <clipPath id="clip661">
          <path
            d="M 675 369 L 676 369 L 676 536 L 675 536 Z M 675 369 "
            id="path4972"
          />
        </clipPath>
        <clipPath id="clip662">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4975"
          />
        </clipPath>
        <clipPath id="clip663">
          <path
            d="M 661 369 L 691 369 L 691 536 L 661 536 Z M 661 369 "
            id="path4978"
          />
        </clipPath>
        <clipPath id="clip664">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4981"
          />
        </clipPath>
        <clipPath id="clip665">
          <path
            d="M 665 369 L 667 369 L 667 536 L 665 536 Z M 665 369 "
            id="path4984"
          />
        </clipPath>
        <clipPath id="clip666">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4987"
          />
        </clipPath>
        <clipPath id="clip667">
          <path
            d="M 651 369 L 681 369 L 681 536 L 651 536 Z M 651 369 "
            id="path4990"
          />
        </clipPath>
        <clipPath id="clip668">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4993"
          />
        </clipPath>
        <clipPath id="clip669">
          <path
            d="M 656 369 L 658 369 L 658 536 L 656 536 Z M 656 369 "
            id="path4996"
          />
        </clipPath>
        <clipPath id="clip670">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path4999"
          />
        </clipPath>
        <clipPath id="clip671">
          <path
            d="M 642 369 L 672 369 L 672 536 L 642 536 Z M 642 369 "
            id="path5002"
          />
        </clipPath>
        <clipPath id="clip672">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path5005"
          />
        </clipPath>
        <clipPath id="clip673">
          <path
            d="M 647 369 L 649 369 L 649 536 L 647 536 Z M 647 369 "
            id="path5008"
          />
        </clipPath>
        <clipPath id="clip674">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path5011"
          />
        </clipPath>
        <clipPath id="clip675">
          <path
            d="M 633 369 L 663 369 L 663 536 L 633 536 Z M 633 369 "
            id="path5014"
          />
        </clipPath>
        <clipPath id="clip676">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path5017"
          />
        </clipPath>
        <clipPath id="clip677">
          <path
            d="M 638 369 L 640 369 L 640 536 L 638 536 Z M 638 369 "
            id="path5020"
          />
        </clipPath>
        <clipPath id="clip678">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path5023"
          />
        </clipPath>
        <clipPath id="clip679">
          <path
            d="M 624 369 L 654 369 L 654 536 L 624 536 Z M 624 369 "
            id="path5026"
          />
        </clipPath>
        <clipPath id="clip680">
          <path
            d="M 36.738281 369.378906 L 36.738281 375.707031 C 753.066406 375.707031 805.890625 535.914062 805.890625 535.914062 L 805.890625 369.378906 Z M 36.738281 369.378906 "
            id="path5029"
          />
        </clipPath>
      </defs>
      <g id="surface77529">
        <g
          style={{
            fill: 'rgb(7.843018%,14.117432%,27.058411%)',
            fillOpacity: 1
          }}
          id="g5040"
        >
          <g id="use5034" transform="translate(36,55.677299)" />
          <g id="use5036" transform="translate(49.650002,55.677299)" />
          <g id="use5038" transform="translate(60.716999,55.677299)" />
        </g>
        <g
          style={{
            fill: 'rgb(7.843018%,14.117432%,27.058411%)',
            fillOpacity: 1
          }}
          id="g5046"
        >
          <g id="use5042" transform="translate(78.819,55.677299)" />
          <g id="use5044" transform="translate(87.029999,55.677299)" />
        </g>
        <g
          style={{
            fill: 'rgb(7.843018%,14.117432%,27.058411%)',
            fillOpacity: 1
          }}
          id="g5050"
        >
          <g id="use5048" transform="translate(99.273003,55.677299)" />
        </g>
        <g
          style={{
            fill: 'rgb(7.843018%,14.117432%,27.058411%)',
            fillOpacity: 1
          }}
          id="g5084"
        >
          <g id="use5052" transform="translate(108.387,55.677299)" />
          <g id="use5054" transform="translate(120.273,55.677299)" />
          <g id="use5056" transform="translate(132.68401,55.677299)" />
          <g id="use5058" transform="translate(145.64101,55.677299)" />
          <g id="use5060" transform="translate(157.86301,55.677299)" />
          <g id="use5062" transform="translate(164.961,55.677299)" />
          <g id="use5064" transform="translate(177.183,55.677299)" />
          <g id="use5066" transform="translate(183.714,55.677299)" />
          <g id="use5068" transform="translate(194.78101,55.677299)" />
          <g id="use5070" transform="translate(204.168,55.677299)" />
          <g id="use5072" transform="translate(213.55499,55.677299)" />
          <g id="use5074" transform="translate(220.12801,55.677299)" />
          <g id="use5076" transform="translate(233.00101,55.677299)" />
          <g id="use5078" transform="translate(242.85001,55.677299)" />
          <g id="use5080" transform="translate(249.423,55.677299)" />
          <g id="use5082" transform="translate(260.34299,55.677299)" />
        </g>
        <g
          style={{
            fill: 'rgb(7.843018%,14.117432%,27.058411%)',
            fillOpacity: 1
          }}
          id="g5088"
        >
          <g id="use5086" transform="translate(269.66699,55.677299)" />
        </g>
        <g
          style={{
            fill: 'rgb(7.843018%,14.117432%,27.058411%)',
            fillOpacity: 1
          }}
          id="g5092"
        >
          <g id="use5090" transform="translate(282.20401,55.677299)" />
        </g>
        <g
          id="circle-2"
          onMouseEnter={handleCircleMouseEnter}
          onMouseLeave={handleCircleMouseLeave}
          onMouseDown={handleCircleMouseDown}
        >
          <path
            className="circle-color"
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: 'rgb(32.156372%,47.058105%,63.922119%)',
              fillOpacity: 1
            }}
            d="M 131.210938 362.292969 C 148.234375 362.292969 162.035156 348.492188 162.035156 331.464844 C 162.035156 314.441406 148.234375 300.640625 131.210938 300.640625 C 114.1875 300.640625 100.386719 314.441406 100.386719 331.464844 C 100.386719 348.492188 114.1875 362.292969 131.210938 362.292969 "
            id="circle-2-path"
          />
          <g style={{ pointerEvents: 'none' }}>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5102"
            >
              <g id="use5100" transform="translate(106.932,329.13809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5108"
            >
              <g id="use5104" transform="translate(111.7984,329.13809)" />
              <g id="use5106" transform="translate(114.764,329.13809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5120"
            >
              <g id="use5110" transform="translate(117.8616,329.13809)" />
              <g id="use5112" transform="translate(122.508,329.13809)" />
              <g id="use5114" transform="translate(127.0048,329.13809)" />
              <g id="use5116" transform="translate(129.9704,329.13809)" />
              <g id="use5118" transform="translate(134.61681,329.13809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5128"
            >
              <g id="use5122" transform="translate(137.69679,329.13809)" />
              <g id="use5124" transform="translate(139.8264,329.13809)" />
              <g id="use5126" transform="translate(144.2352,329.13809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5132"
            >
              <g id="use5130" transform="translate(147.52551,329.13809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5138"
            >
              <g id="use5134" transform="translate(150.42952,329.13809)" />
              <g id="use5136" transform="translate(154.83832,329.13809)" />
            </g>
            {props.lang === 'en' ? (
              <g
                style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
                id="g5156"
              >
                <g id="use5140" transform="translate(114.7992,350.25809)" />
                <g id="use5142" transform="translate(116.6868,350.25809)" />
                <g id="use5144" transform="translate(116.6868,350.25809)" />
                <g id="use5146" transform="translate(121.9668,350.25809)" />
                <g id="use5148" transform="translate(126.5516,350.25809)" />
                <g id="use5150" transform="translate(131.198,350.25809)" />
                <g id="use5152" transform="translate(135.8532,350.25809)" />
                <g id="use5154" transform="translate(140.438,350.25809)">
                  <path
                    id="path19414"
                    style={{ stroke: 'none' }}
                    d="M 0.515625,-4.171875 C 0.625,-3.78125 0.625,-3.734375 0.625,-2.71875 V 0 h 0.859375 v -2.21875 c 0,-0.40625 0.046875,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 C 3.15625,-2.953125 3.1875,-2.765625 3.1875,-2.265625 V 0 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 C 3.671875,-4.03125 3.234375,-4.28125 2.6875,-4.28125 c -0.546875,0 -0.96875,0.21875 -1.25,0.671875 C 1.421875,-3.875 1.40625,-4.015625 1.34375,-4.171875 Z m 0,0 m -2.80355,-0.125 c -1.125,0 -1.953125,0.921875 -1.953125,2.171875 0,1.328125 0.796875,2.234375 1.953125,2.234375 1.140625,0 1.9375,-0.90625 1.9375,-2.1875 0,-1.296875 -0.796875,-2.21875 -1.9375,-2.21875 z m 0,0.703125 c 0.625,0 1.0625,0.625 1.0625,1.515625 0,0.875 -0.4375,1.484375 -1.0625,1.484375 -0.640625,0 -1.0625,-0.59375 -1.0625,-1.515625 0,-0.875 0.4375,-1.484375 1.0625,-1.484375 z m 0,0 M -8.615,1.734375 h 0.859375 v -2.25 c 0.328125,0.4375 0.65625,0.609375 1.15625,0.609375 0.984375,0 1.671875,-0.90625 1.671875,-2.203125 0,-1.296875 -0.6875,-2.171875 -1.703125,-2.171875 -0.53125,0 -0.890625,0.203125 -1.171875,0.640625 0,-0.1875 -0.03125,-0.40625 -0.078125,-0.53125 h -0.8125 c 0.0625,0.28125 0.078125,0.546875 0.078125,1.28125 z m 1.84375,-5.28125 c 0.59375,0 0.953125,0.5625 0.953125,1.453125 0,0.921875 -0.359375,1.453125 -0.953125,1.453125 -0.609375,0 -1,-0.578125 -1,-1.4375 0,-0.890625 0.390625,-1.46875 1,-1.46875 z m 0,0 m -6.5214,-0.625 V -1.6875 c 0,0.5625 0.0625,0.90625 0.21875,1.15625 0.25,0.390625 0.703125,0.625 1.25,0.625 0.53125,0 0.859375,-0.1875 1.140625,-0.609375 C -10.66765,-0.3125 -10.6364,-0.125 -10.589525,0 H -9.7614 C -9.870775,-0.34375 -9.870775,-0.34375 -9.870775,-1.28125 V -4.171875 H -10.73015 V -1.875 c 0,0.359375 -0.04687,0.59375 -0.140625,0.78125 -0.171875,0.28125 -0.4375,0.421875 -0.765625,0.421875 -0.28125,0 -0.515625,-0.109375 -0.65625,-0.28125 -0.09375,-0.140625 -0.140625,-0.390625 -0.140625,-0.765625 v -2.453125 z m 0,0 m -2.881675,-0.125 c -1.125,0 -1.953125,0.921875 -1.953125,2.171875 0,1.328125 0.796875,2.234375 1.953125,2.234375 1.140625,0 1.9375,-0.90625 1.9375,-2.1875 0,-1.296875 -0.796875,-2.21875 -1.9375,-2.21875 z m 0,0.703125 c 0.625,0 1.0625,0.625 1.0625,1.515625 0,0.875 -0.4375,1.484375 -1.0625,1.484375 -0.640625,0 -1.0625,-0.59375 -1.0625,-1.515625 0,-0.875 0.4375,-1.484375 1.0625,-1.484375 z m 0,0 m -2.68625,-0.5 c -0.109375,-1.203125 -0.828125,-1.875 -2,-1.875 -0.609375,0 -1.1875,0.21875 -1.609375,0.609375 -0.59375,0.53125 -0.90625,1.390625 -0.90625,2.4375 0,1.84375 1,3.03125 2.546875,3.03125 1.25,0 1.96875,-0.78125 2.0625,-2.203125 h -0.828125 c -0.09375,0.9375 -0.515625,1.40625 -1.265625,1.40625 -0.96875,0 -1.5625,-0.859375 -1.5625,-2.234375 0,-1.390625 0.59375,-2.265625 1.546875,-2.265625 0.65625,0 1.078125,0.375 1.21875,1.09375 z m 0,0 M 12.0298,-16.46625 V -10.56 h 0.859375 v -2.21875 c 0,-0.375 0.04687,-0.625 0.15625,-0.828125 0.15625,-0.28125 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.671875,0.390625 0.09375,0.171875 0.109375,0.40625 0.109375,0.859375 V -10.56 h 0.875 v -2.40625 c 0,-0.765625 -0.04687,-1.046875 -0.21875,-1.3125 -0.21875,-0.34375 -0.671875,-0.5625 -1.171875,-0.5625 -0.5,0 -0.890625,0.1875 -1.203125,0.578125 v -2.203125 z m 0,0 M 10.217575,-14.731875 10.2332,-15.935 H 9.405075 l -0.03125,1.203125 H 8.717575 L 8.70195,-14.06 H 9.342575 L 9.2957,-12.200625 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L 11.2332,-11.3725 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L 10.20195,-14.06 h 0.921875 v -0.671875 z m 0,0 m -3.238975,0 V -10.56 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -7.183525,1.796875 1.21875,4.203125 h 0.890625 l 0.859375,-2.859375 0.875,2.859375 h 0.890625 l 1.234375,-4.203125 h -0.875 L 4.4982,-11.6225 3.59195,-14.731875 H 2.8732 L 1.951325,-11.6225 1.1232,-14.731875 Z m 0,0 m -2.74315,1.21875 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 0,-0.296875 -0.078125,-0.53125 -0.234375,-0.734375 -0.1875,-0.1875 -0.453125,-0.328125 -1.09375,-0.515625 -0.84375,-0.234375 -0.984375,-0.328125 -0.984375,-0.640625 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 M -7.382425,-14.731875 -7.3668,-15.935 h -0.828125 l -0.03125,1.203125 h -0.65625 L -8.89805,-14.06 h 0.640625 l -0.046875,1.859375 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L -6.3668,-11.3725 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -7.39805,-14.06 h 0.921875 v -0.671875 z m 0,0 m -2.100975,1.375 c -0.125,-0.96875 -0.6875,-1.5 -1.625,-1.5 -1.15625,0 -1.90625,0.875 -1.90625,2.21875 0,1.3125 0.75,2.1875 1.90625,2.1875 0.953125,0 1.578125,-0.59375 1.640625,-1.5625 h -0.84375 c -0.0625,0.59375 -0.3125,0.859375 -0.796875,0.859375 -0.640625,0 -1.015625,-0.546875 -1.015625,-1.484375 0,-0.921875 0.390625,-1.515625 1,-1.515625 0.453125,0 0.6875,0.234375 0.78125,0.796875 z m 0,0 m -7.92765,-1.375 v 2.484375 c 0,0.5625 0.0625,0.90625 0.21875,1.15625 0.25,0.390625 0.703125,0.625 1.25,0.625 0.53125,0 0.859375,-0.1875 1.140625,-0.609375 0.01563,0.203125 0.04687,0.390625 0.09375,0.515625 h 0.828125 c -0.109375,-0.34375 -0.109375,-0.34375 -0.109375,-1.28125 v -2.890625 H -14.84855 V -12.435 c 0,0.359375 -0.04687,0.59375 -0.140625,0.78125 -0.171875,0.28125 -0.4375,0.421875 -0.765625,0.421875 -0.28125,0 -0.515625,-0.109375 -0.65625,-0.28125 -0.09375,-0.140625 -0.140625,-0.390625 -0.140625,-0.765625 v -2.453125 z m 0,0 m -1.2177,-1.734375 h -0.859375 v 2.25 c -0.3125,-0.453125 -0.609375,-0.625 -1.125,-0.625 -0.984375,0 -1.6875,0.921875 -1.6875,2.234375 0,1.296875 0.671875,2.140625 1.71875,2.140625 0.546875,0 0.890625,-0.203125 1.171875,-0.6875 0,0.09375 0,0.140625 0,0.1875 0,0.140625 0,0.234375 0.04687,0.40625 h 0.8125 c -0.04687,-0.28125 -0.07813,-0.546875 -0.07813,-1.28125 z m -1.796875,2.359375 c 0.59375,0 0.953125,0.5625 0.953125,1.453125 0,0.890625 -0.375,1.453125 -0.984375,1.453125 -0.59375,0 -0.96875,-0.53125 -0.96875,-1.421875 0,-0.921875 0.390625,-1.484375 1,-1.484375 z m 0,0 m -4.5223,-0.75 c -1.125,0 -1.953125,0.921875 -1.953125,2.171875 0,1.328125 0.796875,2.234375 1.953125,2.234375 1.140625,0 1.9375,-0.90625 1.9375,-2.1875 0,-1.296875 -0.796875,-2.21875 -1.9375,-2.21875 z m 0,0.703125 c 0.625,0 1.0625,0.625 1.0625,1.515625 0,0.875 -0.4375,1.484375 -1.0625,1.484375 -0.640625,0 -1.0625,-0.59375 -1.0625,-1.515625 0,-0.875 0.4375,-1.484375 1.0625,-1.484375 z m 0,0 m -4.849575,-0.578125 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V -10.56 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.04687 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 M -34.439225,-16.435 v 5.875 h 0.90625 v -2.28125 h 0.375 c 0.84375,0 1.21875,-0.03125 1.5625,-0.15625 0.640625,-0.21875 1.046875,-0.828125 1.046875,-1.609375 0,-0.796875 -0.40625,-1.4375 -1.078125,-1.65625 -0.375,-0.125 -0.765625,-0.171875 -1.640625,-0.171875 z m 0.90625,2.8125 v -2.015625 h 0.375 c 0.65625,0 0.921875,0.03125 1.171875,0.140625 0.3125,0.140625 0.484375,0.453125 0.484375,0.875 0,0.46875 -0.21875,0.8125 -0.609375,0.90625 -0.234375,0.07813 -0.421875,0.09375 -1.046875,0.09375 z m 0,0 m 38.50139,-11.669375 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V -21.12 h 0.859375 v -2.21875 c 0,-0.40625 0.046875,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.078125,0.171875 0.109375,0.359375 0.109375,0.859375 V -21.12 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.015625,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -2.80354,-0.125 c -1.125,0 -1.953125,0.921875 -1.953125,2.171875 0,1.328125 0.796875,2.234375 1.953125,2.234375 1.140625,0 1.9375,-0.90625 1.9375,-2.1875 0,-1.296875 -0.796875,-2.21875 -1.9375,-2.21875 z m 0,0.703125 c 0.625,0 1.0625,0.625 1.0625,1.515625 0,0.875 -0.4375,1.484375 -1.0625,1.484375 -0.640625,0 -1.0625,-0.59375 -1.0625,-1.515625 0,-0.875 0.4375,-1.484375 1.0625,-1.484375 z m 0,0 M -1.63659,-25.291875 V -21.12 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -2.30936,1.796875 L -3.4772,-26.495 h -0.828125 l -0.03125,1.203125 h -0.65625 L -5.00845,-24.62 h 0.640625 l -0.046875,1.859375 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L -2.4772,-21.9325 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -3.50845,-24.62 h 0.921875 v -0.671875 z m 0,0 m -2.100985,1.375 c -0.125,-0.96875 -0.6875,-1.5 -1.625,-1.5 -1.15625,0 -1.90625,0.875 -1.90625,2.21875 0,1.3125 0.75,2.1875 1.90625,2.1875 0.953125,0 1.578125,-0.59375 1.640625,-1.5625 h -0.84375 c -0.0625,0.59375 -0.3125,0.859375 -0.796875,0.859375 -0.640625,0 -1.015625,-0.546875 -1.015625,-1.484375 0,-0.921875 0.390625,-1.515625 1,-1.515625 0.453125,0 0.6875,0.234375 0.78125,0.796875 z m 0,0 m -4.22129,0.890625 c 0.015625,-0.07813 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.04687 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -2.404,-1.625 0.01563,-1.203125 h -0.828125 l -0.03125,1.203125 h -0.65625 L -16.56285,-24.62 h 0.640625 l -0.04687,1.859375 c -0.01563,0.421875 -0.01563,0.421875 -0.01563,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 l 0.01563,-0.734375 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -15.06285,-24.62 h 0.921875 v -0.671875 z m 0,0 m -3.9167,-0.125 c -1.125,0 -1.953125,0.921875 -1.953125,2.171875 0,1.328125 0.796875,2.234375 1.953125,2.234375 1.140625,0 1.9375,-0.90625 1.9375,-2.1875 0,-1.296875 -0.796875,-2.21875 -1.9375,-2.21875 z m 0,0.703125 c 0.625,0 1.0625,0.625 1.0625,1.515625 0,0.875 -0.4375,1.484375 -1.0625,1.484375 -0.640625,0 -1.0625,-0.59375 -1.0625,-1.515625 0,-0.875 0.4375,-1.484375 1.0625,-1.484375 z m 0,0 m -4.849575,-0.578125 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V -21.12 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.04687 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 M -28.455225,-26.995 v 5.875 h 0.90625 v -2.28125 h 0.375 c 0.84375,0 1.21875,-0.03125 1.5625,-0.15625 0.640625,-0.21875 1.046875,-0.828125 1.046875,-1.609375 0,-0.796875 -0.40625,-1.4375 -1.078125,-1.65625 -0.375,-0.125 -0.765625,-0.171875 -1.640625,-0.171875 z m 0.90625,2.8125 v -2.015625 h 0.375 c 0.65625,0 0.921875,0.03125 1.171875,0.140625 0.3125,0.140625 0.484375,0.453125 0.484375,0.875 0,0.46875 -0.21875,0.8125 -0.609375,0.90625 -0.234375,0.07813 -0.421875,0.09375 -1.046875,0.09375 z m 0,0 M 2.99132,-37.58625 V -31.68 h 0.875 v -5.90625 z m 0,0 M -0.630305,-34.68 c 0.078125,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.015625,0.328125 0.0625,0.515625 H 1.88532 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 m -4.162995,-2.375 L -3.2308,-37.055 h -0.828125 l -0.03125,1.203125 h -0.65625 L -4.76205,-35.18 h 0.640625 l -0.046875,1.859375 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L -2.2308,-32.4925 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -3.26205,-35.18 h 0.921875 v -0.671875 z m 0,0 m -3.238965,0 V -31.68 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -5.108345,7.703125 h 0.859375 v -2.25 c 0.328125,0.4375 0.65625,0.609375 1.15625,0.609375 0.984375,0 1.671875,-0.90625 1.671875,-2.203125 0,-1.296875 -0.6875,-2.171875 -1.703125,-2.171875 -0.53125,0 -0.890625,0.203125 -1.171875,0.640625 0,-0.1875 -0.03125,-0.40625 -0.07813,-0.53125 h -0.8125 c 0.0625,0.28125 0.07813,0.546875 0.07813,1.28125 z m 1.84375,-5.28125 c 0.59375,0 0.953125,0.5625 0.953125,1.453125 0,0.921875 -0.359375,1.453125 -0.953125,1.453125 -0.609375,0 -1,-0.578125 -1,-1.4375 0,-0.890625 0.390625,-1.46875 1,-1.46875 z m 0,0 M -14.762225,-34.68 c 0.07813,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.01563,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 m -3.295625,-2.296875 c -0.109375,-1.203125 -0.828125,-1.875 -2,-1.875 -0.609375,0 -1.1875,0.21875 -1.609375,0.609375 -0.59375,0.53125 -0.90625,1.390625 -0.90625,2.4375 0,1.84375 1,3.03125 2.546875,3.03125 1.25,0 1.96875,-0.78125 2.0625,-2.203125 h -0.828125 c -0.09375,0.9375 -0.515625,1.40625 -1.265625,1.40625 -0.96875,0 -1.5625,-0.859375 -1.5625,-2.234375 0,-1.390625 0.59375,-2.265625 1.546875,-2.265625 0.65625,0 1.078125,0.375 1.21875,1.09375 z m 0,0"
                  />
                </g>
              </g>
            ) : (
              <g
                style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
                id="g5156"
              >
                <g id="use5140" transform="translate(114.7992,339.69809)" />
                <g id="use5142" transform="translate(119.9472,339.69809)" />
                <g id="use5144" transform="translate(124.5848,339.69809)" />
                <g id="use5146" transform="translate(126.7144,339.69809)" />
                <g id="use5148" transform="translate(131.1232,339.69809)" />
                <g id="use5150" transform="translate(133.25281,339.69809)" />
                <g id="use5152" transform="translate(137.91679,339.69809)" />
                <g id="use5154" transform="translate(142.32561,339.69809)">
                  <path
                    id="path19414"
                    style={{ stroke: 'none' }}
                    d="M 0.515625,-4.171875 C 0.625,-3.78125 0.625,-3.734375 0.625,-2.71875 V 0 h 0.859375 v -2.21875 c 0,-0.40625 0.046875,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 C 3.15625,-2.953125 3.1875,-2.765625 3.1875,-2.265625 V 0 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 C 3.671875,-4.03125 3.234375,-4.28125 2.6875,-4.28125 c -0.546875,0 -0.96875,0.21875 -1.25,0.671875 C 1.421875,-3.875 1.40625,-4.015625 1.34375,-4.171875 Z m 0,0 M -0.34632,-1.90625 c 0.015625,-0.078125 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z M -3.174445,-2.546875 C -3.03382,-3.25 -2.705695,-3.59375 -2.15882,-3.59375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 M -8.4478,-5.90625 V 0 h 0.859375 v -2.21875 c 0,-0.375 0.046875,-0.625 0.15625,-0.828125 0.15625,-0.28125 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.671875,0.390625 0.09375,0.171875 0.109375,0.40625 0.109375,0.859375 V 0 h 0.875 v -2.40625 c 0,-0.765625 -0.046875,-1.046875 -0.21875,-1.3125 -0.21875,-0.34375 -0.671875,-0.5625 -1.171875,-0.5625 -0.5,0 -0.890625,0.1875 -1.203125,0.578125 V -5.90625 Z m 0,0 m -2.12961,1.734375 V 0 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -1.424425,4.0625 c 0.01563,-0.078125 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 M -17.11581,-5.90625 V 0 h 0.875 v -5.90625 z m 0,0 m -4.746975,1.734375 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V 0 h 0.859375 v -2.21875 c 0,-0.40625 0.04687,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.07813,0.171875 0.109375,0.359375 0.109375,0.859375 V 0 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.01563,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -3.538625,-1.71875 -2,5.890625 h 0.9375 l 0.4375,-1.375 h 2.140625 l 0.4375,1.375 h 0.9375 l -2,-5.890625 z m 1.28125,3.734375 h -1.671875 l 0.828125,-2.640625 z m 0,0 m 36.28657,-10.31 c 0.01563,-0.07813 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.04687 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z M 9.338285,-13.106875 C 9.47891,-13.81 9.807035,-14.15375 10.35391,-14.15375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -2.40401,-1.625 L 6.9499,-15.935 H 6.121775 l -0.03125,1.203125 H 5.434275 L 5.41865,-14.06 H 6.059275 L 6.0124,-12.200625 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L 7.9499,-11.3725 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L 6.91865,-14.06 h 0.921875 v -0.671875 z m 0,0 m -4.462185,0 c 0.046875,0.359375 0.046875,0.4375 0.046875,1.34375 V -10.56 h 0.875 v -1.90625 c 0,-0.46875 0.046875,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.04687 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.015625,-0.109375 0.015625,-0.171875 0.015625,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 m -0.9088,2.265625 c 0.015625,-0.07813 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.04687 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -2.738985,-1.625 V -10.56 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -3.595605,1.796875 c 0.046875,0.359375 0.046875,0.4375 0.046875,1.34375 V -10.56 h 0.875 v -1.90625 c 0,-0.46875 0.046875,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.04687 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.015625,-0.109375 0.015625,-0.171875 0.015625,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 m -4.61516,0 v 2.484375 c 0,0.5625 0.0625,0.90625 0.21875,1.15625 0.25,0.390625 0.703125,0.625 1.25,0.625 0.53125,0 0.859375,-0.1875 1.140625,-0.609375 0.015625,0.203125 0.046875,0.390625 0.09375,0.515625 h 0.828125 c -0.109375,-0.34375 -0.109375,-0.34375 -0.109375,-1.28125 v -2.890625 H -9.19896 V -12.435 c 0,0.359375 -0.046875,0.59375 -0.140625,0.78125 -0.171875,0.28125 -0.4375,0.421875 -0.765625,0.421875 -0.28125,0 -0.515625,-0.109375 -0.65625,-0.28125 -0.09375,-0.140625 -0.140625,-0.390625 -0.140625,-0.765625 v -2.453125 z m 0,0 m -1.824975,0 0.01563,-1.203125 h -0.828125 l -0.03125,1.203125 h -0.65625 L -15.10206,-14.06 h 0.640625 l -0.04687,1.859375 c -0.01563,0.421875 -0.01563,0.421875 -0.01563,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 l 0.01563,-0.734375 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -13.60206,-14.06 h 0.921875 v -0.671875 z m 0,0 m -3.09055,0 -1.640625,1.921875 1.65625,2.25 h 1.15625 l -1.78125,-2.265625 1.65625,-1.90625 z M -19.19261,-16.46625 V -10.56 h 0.859375 v -5.90625 z m 0,0 m -4.67765,1.734375 v 2.484375 c 0,0.5625 0.0625,0.90625 0.21875,1.15625 0.25,0.390625 0.703125,0.625 1.25,0.625 0.53125,0 0.859375,-0.1875 1.140625,-0.609375 0.01563,0.203125 0.04687,0.390625 0.09375,0.515625 h 0.828125 c -0.109375,-0.34375 -0.109375,-0.34375 -0.109375,-1.28125 v -2.890625 H -21.30776 V -12.435 c 0,0.359375 -0.04687,0.59375 -0.140625,0.78125 -0.171875,0.28125 -0.4375,0.421875 -0.765625,0.421875 -0.28125,0 -0.515625,-0.109375 -0.65625,-0.28125 -0.09375,-0.140625 -0.140625,-0.390625 -0.140625,-0.765625 v -2.453125 z m 0,0 m -3.12885,0 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V -10.56 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.04687 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 m -1.793725,0 0.01563,-1.203125 h -0.828125 l -0.03125,1.203125 h -0.65625 L -30.30846,-14.06 h 0.640625 l -0.04687,1.859375 c -0.01563,0.421875 -0.01563,0.421875 -0.01563,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 l 0.01563,-0.734375 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -28.80846,-14.06 h 0.921875 v -0.671875 z m 0,0 m -2.257025,-0.0625 c -0.03125,-0.46875 -0.109375,-0.734375 -0.3125,-1.015625 -0.328125,-0.453125 -0.90625,-0.71875 -1.578125,-0.71875 -1.109375,0 -1.90625,0.671875 -1.90625,1.625 0,0.421875 0.171875,0.796875 0.46875,1.078125 0.21875,0.203125 0.59375,0.40625 1.203125,0.671875 0.6875,0.28125 0.796875,0.34375 0.96875,0.46875 0.265625,0.171875 0.390625,0.375 0.390625,0.640625 0,0.46875 -0.453125,0.796875 -1.078125,0.796875 -0.765625,0 -1.1875,-0.40625 -1.265625,-1.21875 h -0.875 c 0.0625,1.3125 0.796875,2.015625 2.125,2.015625 1.234375,0 2.015625,-0.6875 2.015625,-1.75 0,-0.421875 -0.125,-0.78125 -0.375,-1.046875 -0.21875,-0.25 -0.484375,-0.40625 -1.34375,-0.75 -0.71875,-0.3125 -0.8125,-0.359375 -1,-0.46875 -0.203125,-0.125 -0.328125,-0.3125 -0.328125,-0.515625 0,-0.4375 0.421875,-0.765625 0.96875,-0.765625 0.609375,0 0.984375,0.34375 1.046875,0.953125 z m 0,0"
                  />
                </g>
              </g>
            )}
          </g>
        </g>
        <g
          id="circle-1"
          onMouseEnter={handleCircleMouseEnter}
          onMouseLeave={handleCircleMouseLeave}
          onMouseDown={handleCircleMouseDown}
        >
          <path
            id="circle-1-path"
            className="circle-color"
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: 'rgb(32.156372%,47.058105%,63.922119%)',
              fillOpacity: 1
            }}
            d="M 66.824219 362.292969 C 83.851562 362.292969 97.652344 348.492188 97.652344 331.464844 C 97.652344 314.441406 83.851562 300.640625 66.824219 300.640625 C 49.800781 300.640625 36 314.441406 36 331.464844 C 36 348.492188 49.800781 362.292969 66.824219 362.292969 "
          />
          <g style={{ pointerEvents: 'none' }}>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5162"
            >
              <g id="use5160" transform="translate(42.1199,323.85809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5168"
            >
              <g id="use5164" transform="translate(46.5023,323.85809)" />
              <g id="use5166" transform="translate(50.911098,323.85809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5192"
            >
              <g id="use5170" transform="translate(54.959099,323.85809)" />
              <g id="use5172" transform="translate(57.924702,323.85809)" />
              <g id="use5174" transform="translate(61.550301,323.85809)" />
              <g id="use5176" transform="translate(63.679901,323.85809)" />
              <g id="use5178" transform="translate(68.317497,323.85809)" />
              <g id="use5180" transform="translate(72.391899,323.85809)" />
              <g id="use5182" transform="translate(74.741501,323.85809)" />
              <g id="use5184" transform="translate(76.941498,323.85809)" />
              <g id="use5186" transform="translate(81.587898,323.85809)" />
              <g id="use5188" transform="translate(86.225502,323.85809)" />
              <g id="use5190" transform="translate(90.880699,323.85809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5196"
            >
              <g id="use5194" transform="translate(45.5079,334.41809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5204"
            >
              <g id="use5198" transform="translate(50.374298,334.41809)" />
              <g id="use5200" transform="translate(53.339901,334.41809)" />
              <g id="use5202" transform="translate(57.986301,334.41809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5220"
            >
              <g id="use5206" transform="translate(60.635101,334.41809)" />
              <g id="use5208" transform="translate(65.0439,334.41809)" />
              <g id="use5210" transform="translate(69.681503,334.41809)" />
              <g id="use5212" transform="translate(73.307098,334.41809)" />
              <g id="use5214" transform="translate(75.436699,334.41809)" />
              <g id="use5216" transform="translate(80.074303,334.41809)" />
              <g id="use5218" transform="translate(84.148697,334.41809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5224"
            >
              <use x="86.4949" y="334.4181" id="use5222" />
            </g>
            {props.lang === 'en' ? (
              <g
                style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
                id="circle-text-1"
              >
                <g id="use5226" transform="translate(50.814301,344.97809)" />
                <g id="use5228" transform="translate(55.1703,344.97809)" />
                <g id="use5230" transform="translate(55.0135,344.97809)" />
                <g id="use5232" transform="translate(55.0135,344.97809)" />
                <g id="use5234" transform="translate(60.029499,344.97809)" />
                <g id="use5236" transform="translate(64.614304,344.97809)" />
                <g id="use5238" transform="translate(69.2519,344.97809)" />
                <g id="use5240" transform="translate(73.907097,344.97809)">
                  <path
                    id="path19288"
                    style={{ stroke: 'none' }}
                    d="m 3.65625,-2.953125 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 C 3.6875,-1.5 3.609375,-1.734375 3.453125,-1.9375 3.265625,-2.125 3,-2.265625 2.359375,-2.453125 1.515625,-2.6875 1.375,-2.78125 1.375,-3.09375 c 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 M -0.623947,-5.90625 h -0.859375 v 2.25 c -0.3125,-0.453125 -0.609375,-0.625 -1.125,-0.625 -0.984375,0 -1.6875,0.921875 -1.6875,2.234375 0,1.296875 0.671875,2.140625 1.71875,2.140625 0.546875,0 0.890625,-0.203125 1.171875,-0.6875 0,0.09375 0,0.140625 0,0.1875 0,0.140625 0,0.234375 0.046875,0.40625 h 0.8125 c -0.046875,-0.28125 -0.078125,-0.546875 -0.078125,-1.28125 z m -1.796875,2.359375 c 0.59375,0 0.953125,0.5625 0.953125,1.453125 0,0.890625 -0.375,1.453125 -0.984375,1.453125 -0.59375,0 -0.96875,-0.53125 -0.96875,-1.421875 0,-0.921875 0.390625,-1.484375 1,-1.484375 z m 0,0 m -6.356346,-0.625 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V 0 h 0.859375 v -2.21875 c 0,-0.40625 0.046875,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.078125,0.171875 0.109375,0.359375 0.109375,0.859375 V 0 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.015625,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -2.803555,-0.125 c -1.125,0 -1.953125,0.921875 -1.953125,2.171875 0,1.328125 0.796875,2.234375 1.953125,2.234375 1.140625,0 1.9375,-0.90625 1.9375,-2.1875 0,-1.296875 -0.796875,-2.21875 -1.9375,-2.21875 z m 0,0.703125 c 0.625,0 1.0625,0.625 1.0625,1.515625 0,0.875 -0.4375,1.484375 -1.0625,1.484375 -0.640625,0 -1.0625,-0.59375 -1.0625,-1.515625 0,-0.875 0.4375,-1.484375 1.0625,-1.484375 z m 0,0 M -18.159222,-5.875 V 0 h 1.203125 c 1.03125,0 1.3125,-0.03125 1.71875,-0.15625 0.625,-0.203125 1.03125,-0.796875 1.03125,-1.5 0,-0.796875 -0.40625,-1.265625 -1.28125,-1.46875 0.671875,-0.21875 0.96875,-0.609375 0.96875,-1.28125 0,-0.625 -0.34375,-1.125 -0.90625,-1.328125 -0.328125,-0.09375 -0.65625,-0.140625 -1.40625,-0.140625 z m 0.890625,2.453125 V -5.125 h 0.453125 c 0.546875,0 0.765625,0.03125 0.96875,0.109375 0.265625,0.109375 0.421875,0.390625 0.421875,0.71875 0,0.34375 -0.140625,0.609375 -0.390625,0.734375 -0.203125,0.109375 -0.46875,0.140625 -0.9375,0.140625 z m 0,2.671875 v -1.9375 h 0.5625 c 0.5625,0 0.78125,0.015625 1.015625,0.09375 0.34375,0.140625 0.546875,0.453125 0.546875,0.875 0,0.40625 -0.171875,0.71875 -0.453125,0.84375 -0.234375,0.09375 -0.46875,0.125 -1.140625,0.125 z m 0,0 M 10.744125,-8.825625 H 11.6035 v -2.25 c 0.328125,0.4375 0.65625,0.609375 1.15625,0.609375 0.984375,0 1.671875,-0.90625 1.671875,-2.203125 0,-1.296875 -0.6875,-2.171875 -1.703125,-2.171875 -0.53125,0 -0.890625,0.203125 -1.171875,0.640625 0,-0.1875 -0.03125,-0.40625 -0.07813,-0.53125 H 10.666 c 0.0625,0.28125 0.07813,0.546875 0.07813,1.28125 z m 1.84375,-5.28125 c 0.59375,0 0.953125,0.5625 0.953125,1.453125 0,0.921875 -0.359375,1.453125 -0.953125,1.453125 -0.609375,0 -1,-0.578125 -1,-1.4375 0,-0.890625 0.390625,-1.46875 1,-1.46875 z m 0,0 M 5.10025,-16.435 v 3.421875 c 0,0.875 0.03125,1.125 0.1875,1.46875 0.3125,0.6875 1.0625,1.09375 2.03125,1.09375 0.953125,0 1.703125,-0.40625 2.015625,-1.09375 0.15625,-0.328125 0.1875,-0.59375 0.1875,-1.46875 V -16.435 h -0.90625 v 3.40625 c 0,0.625 -0.015625,0.828125 -0.09375,1.046875 -0.15625,0.46875 -0.609375,0.734375 -1.203125,0.734375 -0.5625,0 -1,-0.234375 -1.171875,-0.625 C 6.03775,-12.1225 6.0065,-12.325625 6.0065,-13.02875 V -16.435 Z m 0,0 m -3.005844,3.34375 v 0.640625 h 2.34375 v -0.640625 z m 0,0 m -4.030205,4.265625 h 0.859375 v -2.25 c 0.328125,0.4375 0.65625,0.609375 1.15625,0.609375 0.984375,0 1.671875,-0.90625 1.671875,-2.203125 0,-1.296875 -0.6875,-2.171875 -1.703125,-2.171875 -0.53125,0 -0.890625,0.203125 -1.171875,0.640625 0,-0.1875 -0.03125,-0.40625 -0.078125,-0.53125 h -0.8125 c 0.0625,0.28125 0.078125,0.546875 0.078125,1.28125 z m 1.84375,-5.28125 c 0.59375,0 0.953125,0.5625 0.953125,1.453125 0,0.921875 -0.359375,1.453125 -0.953125,1.453125 -0.609375,0 -1,-0.578125 -1,-1.4375 0,-0.890625 0.390625,-1.46875 1,-1.46875 z m 0,0 m -2.815048,1.640625 c 0.015625,-0.07813 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.04687 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -2.403999,-1.625 0.015625,-1.203125 h -0.828125 l -0.03125,1.203125 h -0.65625 L -9.654846,-14.06 h 0.640625 l -0.046875,1.859375 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 l 0.015625,-0.734375 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -8.154846,-14.06 h 0.921875 v -0.671875 z m 0,0 m -2.257027,-0.0625 c -0.03125,-0.46875 -0.109375,-0.734375 -0.3125,-1.015625 -0.328125,-0.453125 -0.90625,-0.71875 -1.578125,-0.71875 -1.109375,0 -1.90625,0.671875 -1.90625,1.625 0,0.421875 0.171875,0.796875 0.46875,1.078125 0.21875,0.203125 0.59375,0.40625 1.203125,0.671875 0.6875,0.28125 0.796875,0.34375 0.96875,0.46875 0.265625,0.171875 0.390625,0.375 0.390625,0.640625 0,0.46875 -0.453125,0.796875 -1.078125,0.796875 -0.765625,0 -1.1875,-0.40625 -1.265625,-1.21875 h -0.875 c 0.0625,1.3125 0.796875,2.015625 2.125,2.015625 1.234375,0 2.015625,-0.6875 2.015625,-1.75 0,-0.421875 -0.125,-0.78125 -0.375,-1.046875 -0.21875,-0.25 -0.484375,-0.40625 -1.34375,-0.75 -0.71875,-0.3125 -0.8125,-0.359375 -1,-0.46875 -0.203125,-0.125 -0.328125,-0.3125 -0.328125,-0.515625 0,-0.4375 0.421875,-0.765625 0.96875,-0.765625 0.609375,0 0.984375,0.34375 1.046875,0.953125 z m 0,0 m -7.167698,-1.671875 h -0.859375 v 2.25 c -0.3125,-0.453125 -0.609375,-0.625 -1.125,-0.625 -0.984375,0 -1.6875,0.921875 -1.6875,2.234375 0,1.296875 0.671875,2.140625 1.71875,2.140625 0.546875,0 0.890625,-0.203125 1.171875,-0.6875 0,0.09375 0,0.140625 0,0.1875 0,0.140625 0,0.234375 0.04687,0.40625 h 0.8125 c -0.04687,-0.28125 -0.07813,-0.546875 -0.07813,-1.28125 z m -1.796875,2.359375 c 0.59375,0 0.953125,0.5625 0.953125,1.453125 0,0.890625 -0.375,1.453125 -0.984375,1.453125 -0.59375,0 -0.96875,-0.53125 -0.96875,-1.421875 0,-0.921875 0.390625,-1.484375 1,-1.484375 z m 0,0 m -6.35635,-0.625 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V -10.56 h 0.859375 v -2.21875 c 0,-0.40625 0.04687,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.07813,0.171875 0.109375,0.359375 0.109375,0.859375 V -10.56 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.01563,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 M -29.229424,-13.56 c 0.07813,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.01563,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 M 11.5672,-23.02625 c 0.01563,-0.07813 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.04687 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z M 8.739075,-23.666875 C 8.8797,-24.37 9.207825,-24.71375 9.7547,-24.71375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -2.404,-1.625 L 6.3507,-26.495 H 5.522575 l -0.03125,1.203125 H 4.835075 L 4.81945,-24.62 H 5.460075 L 5.4132,-22.760625 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L 7.3507,-21.9325 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L 6.31945,-24.62 h 0.921875 v -0.671875 z m 0,0 M 1.60408,-24.12 c 0.078125,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.015625,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 M -4.010521,-26.995 v 5.875 h 0.90625 v -2.359375 h 0.90625 L -0.869896,-21.12 h 1.0625 l -1.4375,-2.5 c 0.734375,-0.3125 1.125,-0.859375 1.125,-1.625 0,-0.671875 -0.34375,-1.234375 -0.890625,-1.5 -0.40625,-0.1875 -0.765625,-0.25 -1.75,-0.25 z m 0.90625,2.734375 v -1.9375 h 0.359375 c 0.78125,0 0.96875,0.01563 1.21875,0.140625 0.296875,0.140625 0.453125,0.4375 0.453125,0.796875 0,0.4375 -0.203125,0.765625 -0.5625,0.890625 -0.234375,0.09375 -0.4375,0.109375 -1.0625,0.109375 z m 0,0 m -3.990227,0.609375 v 0.640625 h 2.34375 v -0.640625 z m 0,0 m -0.623951,-3.375 h -0.859375 v 2.25 c -0.3125,-0.453125 -0.609375,-0.625 -1.125,-0.625 -0.984375,0 -1.6875,0.921875 -1.6875,2.234375 0,1.296875 0.671875,2.140625 1.71875,2.140625 0.546875,0 0.890625,-0.203125 1.171875,-0.6875 0,0.09375 0,0.140625 0,0.1875 0,0.140625 0,0.234375 0.046875,0.40625 h 0.8125 c -0.046875,-0.28125 -0.078125,-0.546875 -0.078125,-1.28125 z m -1.796875,2.359375 c 0.59375,0 0.953125,0.5625 0.953125,1.453125 0,0.890625 -0.375,1.453125 -0.984375,1.453125 -0.59375,0 -0.96875,-0.53125 -0.96875,-1.421875 0,-0.921875 0.390625,-1.484375 1,-1.484375 z m 0,0 m -2.580673,1.640625 c 0.01563,-0.07813 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.04687 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -5.021599,-1.625 1.328125,1.953125 -1.53125,2.21875 h 1.046875 l 1,-1.546875 1,1.546875 h 1.046875 l -1.515625,-2.21875 1.328125,-1.953125 h -1.03125 l -0.828125,1.3125 -0.8125,-1.3125 z m 0,0 m -1.738975,0 V -21.12 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -3.855103,2.53125 v -1.640625 h 2.5625 V -26.995 h -3.46875 v 5.875 h 0.90625 v -2.640625 h 2.359375 V -24.5575 Z m 0,0"
                  />
                </g>
              </g>
            ) : (
              <g
                style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
                id="circle-text-1"
              >
                <g id="use5226" transform="translate(50.814301,344.97809)" />
                <g id="use5228" transform="translate(55.1703,344.97809)" />
                <g id="use5230" transform="translate(59.807899,344.97809)" />
                <g id="use5232" transform="translate(61.9375,344.97809)" />
                <g id="use5234" transform="translate(66.346298,344.97809)" />
                <g id="use5236" transform="translate(68.475899,344.97809)" />
                <g id="use5238" transform="translate(73.1399,344.97809)" />
                <g id="use5240" transform="translate(77.548698,344.97809)">
                  <path
                    id="path19288"
                    style={{ stroke: 'none' }}
                    d="M 0.515625,-4.171875 C 0.625,-3.78125 0.625,-3.734375 0.625,-2.71875 V 0 h 0.859375 v -2.21875 c 0,-0.40625 0.046875,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 C 3.15625,-2.953125 3.1875,-2.765625 3.1875,-2.265625 V 0 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 C 3.671875,-4.03125 3.234375,-4.28125 2.6875,-4.28125 c -0.546875,0 -0.96875,0.21875 -1.25,0.671875 C 1.421875,-3.875 1.40625,-4.015625 1.34375,-4.171875 Z m 0,0 m -0.861923,2.265625 c 0.015625,-0.078125 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 M -8.447799,-5.90625 V 0 h 0.859375 v -2.21875 c 0,-0.375 0.046875,-0.625 0.15625,-0.828125 0.15625,-0.28125 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.671875,0.390625 0.09375,0.171875 0.109375,0.40625 0.109375,0.859375 V 0 h 0.875 v -2.40625 c 0,-0.765625 -0.046875,-1.046875 -0.21875,-1.3125 -0.21875,-0.34375 -0.671875,-0.5625 -1.171875,-0.5625 -0.5,0 -0.890625,0.1875 -1.203125,0.578125 V -5.90625 Z m 0,0 M -10.5774,-4.171875 V 0 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -1.424423,4.0625 c 0.01563,-0.078125 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 M -17.115799,-5.90625 V 0 h 0.875 v -5.90625 z m 0,0 m -4.746974,1.734375 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V 0 h 0.859375 v -2.21875 c 0,-0.40625 0.04687,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.07813,0.171875 0.109375,0.359375 0.109375,0.859375 V 0 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.01563,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 M -25.375022,-3 c 0.07813,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.01563,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 M 6.599999,-13.09125 v 0.640625 h 2.34375 v -0.640625 z m 0,0 m -0.418144,-0.421875 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 0,-0.296875 -0.078125,-0.53125 -0.234375,-0.734375 -0.1875,-0.1875 -0.453125,-0.328125 -1.09375,-0.515625 -0.84375,-0.234375 -0.984375,-0.328125 -0.984375,-0.640625 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 m -7.778229,-1.21875 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V -10.56 h 0.859375 v -2.21875 c 0,-0.40625 0.046875,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.078125,0.171875 0.109375,0.359375 0.109375,0.859375 V -10.56 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.015625,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -2.020226,0 V -10.56 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -4.313095,1.796875 v 0.703125 h 1.953125 l -2.15625,2.796875 V -10.56 h 3.203125 v -0.71875 h -2.171875 l 2.1875,-2.8125 v -0.640625 z m 0,0 m -4.512603,0 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V -10.56 h 0.859375 v -2.21875 c 0,-0.40625 0.04687,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.078125,0.171875 0.109375,0.359375 0.109375,0.859375 V -10.56 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.01563,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -0.861924,2.265625 c 0.01563,-0.07813 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.04687 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -2.30505,-1.625 v -0.1875 c 0,-0.328125 0.01563,-0.5 0.04687,-0.609375 0.07813,-0.1875 0.234375,-0.296875 0.453125,-0.296875 0.1875,0 0.375,0.03125 0.65625,0.140625 v -0.734375 c -0.28125,-0.109375 -0.546875,-0.15625 -0.8125,-0.15625 -0.4375,0 -0.796875,0.171875 -1,0.484375 -0.15625,0.234375 -0.203125,0.515625 -0.203125,1.09375 v 0.265625 h -0.578125 V -14.06 h 0.578125 v 3.5 h 0.875 v -3.5 h 1 v -0.671875 z m 0,0 m -5.630775,0 v 2.484375 c 0,0.5625 0.0625,0.90625 0.21875,1.15625 0.25,0.390625 0.703125,0.625 1.25,0.625 0.53125,0 0.859375,-0.1875 1.140625,-0.609375 0.01563,0.203125 0.04687,0.390625 0.09375,0.515625 h 0.828125 c -0.109375,-0.34375 -0.109375,-0.34375 -0.109375,-1.28125 v -2.890625 h -0.859375 V -12.435 c 0,0.359375 -0.04687,0.59375 -0.140625,0.78125 -0.171875,0.28125 -0.4375,0.421875 -0.765625,0.421875 -0.28125,0 -0.515625,-0.109375 -0.65625,-0.28125 -0.09375,-0.140625 -0.140625,-0.390625 -0.140625,-0.765625 v -2.453125 z m 0,0 m -1.824978,0 0.01563,-1.203125 h -0.828125 l -0.03125,1.203125 h -0.65625 L -26.95565,-14.06 h 0.640625 l -0.04687,1.859375 c -0.01563,0.421875 -0.01563,0.421875 -0.01563,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 l 0.01563,-0.734375 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -25.45565,-14.06 h 0.921875 v -0.671875 z m 0,0 m -2.257023,-0.0625 c -0.03125,-0.46875 -0.109375,-0.734375 -0.3125,-1.015625 -0.328125,-0.453125 -0.90625,-0.71875 -1.578125,-0.71875 -1.109375,0 -1.90625,0.671875 -1.90625,1.625 0,0.421875 0.171875,0.796875 0.46875,1.078125 0.21875,0.203125 0.59375,0.40625 1.203125,0.671875 0.6875,0.28125 0.796875,0.34375 0.96875,0.46875 0.265625,0.171875 0.390625,0.375 0.390625,0.640625 0,0.46875 -0.453125,0.796875 -1.078125,0.796875 -0.765625,0 -1.1875,-0.40625 -1.265625,-1.21875 h -0.875 c 0.0625,1.3125 0.796875,2.015625 2.125,2.015625 1.234375,0 2.015625,-0.6875 2.015625,-1.75 0,-0.421875 -0.125,-0.78125 -0.375,-1.046875 -0.21875,-0.25 -0.484375,-0.40625 -1.34375,-0.75 -0.71875,-0.3125 -0.8125,-0.359375 -1,-0.46875 -0.203125,-0.125 -0.328125,-0.3125 -0.328125,-0.515625 0,-0.4375 0.421875,-0.765625 0.96875,-0.765625 0.609375,0 0.984375,0.34375 1.046875,0.953125 z m 0,0 M 12.708054,-27.02625 h -0.859375 v 2.25 c -0.3125,-0.453125 -0.609375,-0.625 -1.125,-0.625 -0.984375,0 -1.6875,0.921875 -1.6875,2.234375 0,1.296875 0.671875,2.140625 1.71875,2.140625 0.546875,0 0.890625,-0.203125 1.171875,-0.6875 0,0.09375 0,0.140625 0,0.1875 0,0.140625 0,0.234375 0.04687,0.40625 h 0.8125 c -0.04687,-0.28125 -0.07813,-0.546875 -0.07813,-1.28125 z m -1.796875,2.359375 c 0.59375,0 0.953125,0.5625 0.953125,1.453125 0,0.890625 -0.375,1.453125 -0.984375,1.453125 -0.59375,0 -0.96875,-0.53125 -0.96875,-1.421875 0,-0.921875 0.390625,-1.484375 1,-1.484375 z m 0,0 m -6.356354,-0.625 C 4.6642,-24.90125 4.6642,-24.854375 4.6642,-23.83875 V -21.12 h 0.859375 v -2.21875 c 0,-0.40625 0.046875,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.078125,0.171875 0.109375,0.359375 0.109375,0.859375 V -21.12 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.015625,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -4.568275,0 v 2.484375 c 0,0.5625 0.0625,0.90625 0.21875,1.15625 0.25,0.390625 0.703125,0.625 1.25,0.625 0.53125,0 0.859375,-0.1875 1.140625,-0.609375 C 2.61155,-21.4325 2.6428,-21.245 2.689675,-21.12 H 3.5178 c -0.109375,-0.34375 -0.109375,-0.34375 -0.109375,-1.28125 v -2.890625 H 2.54905 V -22.995 c 0,0.359375 -0.046875,0.59375 -0.140625,0.78125 -0.171875,0.28125 -0.4375,0.421875 -0.765625,0.421875 -0.28125,0 -0.515625,-0.109375 -0.65625,-0.28125 C 0.8928,-22.21375 0.845925,-22.46375 0.845925,-22.83875 v -2.453125 z m 0,0 m -5.143349,1.640625 v 0.640625 h 2.34375 v -0.640625 z m 0,0 m -0.418152,-0.421875 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 0,-0.296875 -0.078125,-0.53125 -0.234375,-0.734375 -0.1875,-0.1875 -0.453125,-0.328125 -1.09375,-0.515625 -0.84375,-0.234375 -0.984375,-0.328125 -0.984375,-0.640625 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 m -7.778221,-1.21875 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V -21.12 h 0.859375 v -2.21875 c 0,-0.40625 0.04687,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.07813,0.171875 0.109375,0.359375 0.109375,0.859375 V -21.12 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.01563,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -2.020225,0 V -21.12 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -4.313099,1.796875 v 0.703125 h 1.953125 l -2.15625,2.796875 V -21.12 h 3.203125 v -0.71875 h -2.171875 l 2.1875,-2.8125 v -0.640625 z m 0,0 m -1.621853,0 0.01563,-1.203125 h -0.828125 l -0.03125,1.203125 h -0.65625 l -0.01563,0.671875 h 0.640625 l -0.04687,1.859375 c -0.01563,0.421875 -0.01563,0.421875 -0.01563,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 l 0.01563,-0.734375 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 l 0.03125,-1.859375 h 0.921875 v -0.671875 z m 0,0 m -2.126126,1.21875 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 0,-0.296875 -0.07813,-0.53125 -0.234375,-0.734375 -0.1875,-0.1875 -0.453125,-0.328125 -1.09375,-0.515625 -0.84375,-0.234375 -0.984375,-0.328125 -0.984375,-0.640625 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 m -4.002548,1.046875 c 0.01563,-0.07813 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.04687 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -3.97615,-0.890625 v -1.640625 h 2.5625 V -26.995 h -3.46875 v 5.875 h 0.90625 v -2.640625 h 2.359375 V -24.5575 Z m 0,0"
                  />
                </g>
              </g>
            )}
          </g>
        </g>
        <g
          id="circle-3"
          onMouseEnter={handleCircleMouseEnter}
          onMouseLeave={handleCircleMouseLeave}
          onMouseDown={handleCircleMouseDown}
        >
          <path
            className="circle-color"
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: 'rgb(32.156372%,47.058105%,63.922119%)',
              fillOpacity: 1
            }}
            d="M 195.597656 362.292969 C 212.621094 362.292969 226.421875 348.492188 226.421875 331.464844 C 226.421875 314.441406 212.621094 300.640625 195.597656 300.640625 C 178.570312 300.640625 164.769531 314.441406 164.769531 331.464844 C 164.769531 348.492188 178.570312 362.292969 195.597656 362.292969 "
            id="circle-3-path"
          />
          <g style={{ pointerEvents: 'none' }}>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5248"
            >
              <g id="use5246" transform="translate(169.14391,329.13809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5258"
            >
              <g id="use5250" transform="translate(174.2567,329.13809)" />
              <g id="use5252" transform="translate(178.6127,329.13809)" />
              <g id="use5254" transform="translate(183.2679,329.13809)" />
              <g id="use5256" transform="translate(185.39751,329.13809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5268"
            >
              <g id="use5260" transform="translate(188.38863,329.13809)" />
              <g id="use5262" transform="translate(192.74461,329.13809)" />
              <g id="use5264" transform="translate(194.87422,329.13809)" />
              <g id="use5266" transform="translate(198.94862,329.13809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5280"
            >
              <g id="use5270" transform="translate(203.14622,329.13809)" />
              <g id="use5272" transform="translate(207.81023,329.13809)" />
              <g id="use5274" transform="translate(212.45662,329.13809)" />
              <g id="use5276" transform="translate(215.42223,329.13809)" />
              <g id="use5278" transform="translate(219.04782,329.13809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5284"
            >
              <use x="221.3974" y="329.1381" id="use5282" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5292"
            >
              <g id="use5286" transform="translate(176.2937,339.69809)" />
              <g id="use5288" transform="translate(180.6673,339.69809)" />
              <g id="use5290" transform="translate(185.0761,339.69809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5302"
            >
              <g id="use5294" transform="translate(188.36729,339.69809)" />
              <g id="use5296" transform="translate(191.3329,339.69809)" />
              <g id="use5298" transform="translate(193.46249,339.69809)" />
              <g id="use5300" transform="translate(198.2585,339.69809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5308"
            >
              <g id="use5304" transform="translate(202.5793,339.69809)" />
              <g id="use5306" transform="translate(206.9353,339.69809)" />
            </g>
            {props.lang === 'en' ? (
              <g
                style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
                id="g5312"
              >
                <g id="use5310" transform="translate(207.7361,350.25809)">
                  <path
                    id="path19529"
                    style={{ stroke: 'none' }}
                    d="m 3.65625,-2.953125 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 C 3.6875,-1.5 3.609375,-1.734375 3.453125,-1.9375 3.265625,-2.125 3,-2.265625 2.359375,-2.453125 1.515625,-2.6875 1.375,-2.78125 1.375,-3.09375 c 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 M -1.231235,-4.171875 -1.21561,-5.375 h -0.828125 l -0.03125,1.203125 h -0.65625 L -2.74686,-3.5 h 0.640625 l -0.046875,1.859375 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L -0.21561,-0.8125 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -1.24686,-3.5 h 0.921875 v -0.671875 z m 0,0 m -2.100965,1.375 c -0.125,-0.96875 -0.6875,-1.5 -1.625,-1.5 -1.15625,0 -1.90625,0.875 -1.90625,2.21875 0,1.3125 0.75,2.1875 1.90625,2.1875 0.953125,0 1.578125,-0.59375 1.640625,-1.5625 h -0.84375 c -0.0625,0.59375 -0.3125,0.859375 -0.796875,0.859375 -0.640625,0 -1.015625,-0.546875 -1.015625,-1.484375 0,-0.921875 0.390625,-1.515625 1,-1.515625 0.453125,0 0.6875,0.234375 0.78125,0.796875 z m 0,0 m -7.92764,-1.375 V -1.6875 c 0,0.5625 0.0625,0.90625 0.21875,1.15625 0.25,0.390625 0.703125,0.625 1.25,0.625 0.53125,0 0.859375,-0.1875 1.140625,-0.609375 C -8.63484,-0.3125 -8.60359,-0.125 -8.556715,0 H -7.72859 C -7.837965,-0.34375 -7.837965,-0.34375 -7.837965,-1.28125 V -4.171875 H -8.69734 V -1.875 c 0,0.359375 -0.046875,0.59375 -0.140625,0.78125 -0.171875,0.28125 -0.4375,0.421875 -0.765625,0.421875 -0.28125,0 -0.515625,-0.109375 -0.65625,-0.28125 -0.09375,-0.140625 -0.140625,-0.390625 -0.140625,-0.765625 v -2.453125 z m 0,0 m -1.21772,-1.734375 h -0.859375 v 2.25 c -0.3125,-0.453125 -0.609375,-0.625 -1.125,-0.625 -0.984375,0 -1.6875,0.921875 -1.6875,2.234375 0,1.296875 0.671875,2.140625 1.71875,2.140625 0.546875,0 0.890625,-0.203125 1.171875,-0.6875 0,0.09375 0,0.140625 0,0.1875 0,0.140625 0,0.234375 0.04687,0.40625 h 0.8125 c -0.04687,-0.28125 -0.07813,-0.546875 -0.07813,-1.28125 z m -1.796875,2.359375 c 0.59375,0 0.953125,0.5625 0.953125,1.453125 0,0.890625 -0.375,1.453125 -0.984375,1.453125 -0.59375,0 -0.96875,-0.53125 -0.96875,-1.421875 0,-0.921875 0.390625,-1.484375 1,-1.484375 z m 0,0 m -4.52229,-0.75 c -1.125,0 -1.953125,0.921875 -1.953125,2.171875 0,1.328125 0.796875,2.234375 1.953125,2.234375 1.140625,0 1.9375,-0.90625 1.9375,-2.1875 0,-1.296875 -0.796875,-2.21875 -1.9375,-2.21875 z m 0,0.703125 c 0.625,0 1.0625,0.625 1.0625,1.515625 0,0.875 -0.4375,1.484375 -1.0625,1.484375 -0.640625,0 -1.0625,-0.59375 -1.0625,-1.515625 0,-0.875 0.4375,-1.484375 1.0625,-1.484375 z m 0,0 M -23.6463,-4.171875 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V 0 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.046875 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 M -28.288025,-5.875 V 0 h 0.90625 v -2.28125 h 0.375 c 0.84375,0 1.21875,-0.03125 1.5625,-0.15625 0.640625,-0.21875 1.046875,-0.828125 1.046875,-1.609375 0,-0.796875 -0.40625,-1.4375 -1.078125,-1.65625 -0.375,-0.125 -0.765625,-0.171875 -1.640625,-0.171875 z m 0.90625,2.8125 v -2.015625 h 0.375 c 0.65625,0 0.921875,0.03125 1.171875,0.140625 0.3125,0.140625 0.484375,0.453125 0.484375,0.875 0,0.46875 -0.21875,0.8125 -0.609375,0.90625 -0.234375,0.078125 -0.421875,0.09375 -1.046875,0.09375 z m 0,0 m 29.93021,-11.669375 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V -10.56 h 0.859375 v -2.21875 c 0,-0.40625 0.046875,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.078125,0.171875 0.109375,0.359375 0.109375,0.859375 V -10.56 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.015625,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -2.80356,-0.125 c -1.125,0 -1.953125,0.921875 -1.953125,2.171875 0,1.328125 0.796875,2.234375 1.953125,2.234375 1.140625,0 1.9375,-0.90625 1.9375,-2.1875 0,-1.296875 -0.796875,-2.21875 -1.9375,-2.21875 z m 0,0.703125 c 0.625,0 1.0625,0.625 1.0625,1.515625 0,0.875 -0.4375,1.484375 -1.0625,1.484375 -0.640625,0 -1.0625,-0.59375 -1.0625,-1.515625 0,-0.875 0.4375,-1.484375 1.0625,-1.484375 z m 0,0 M -4.0566,-14.731875 V -10.56 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -2.30935,1.796875 L -5.8972,-15.935 h -0.828125 l -0.03125,1.203125 h -0.65625 L -7.42845,-14.06 h 0.640625 l -0.046875,1.859375 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L -4.8972,-11.3725 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -5.92845,-14.06 h 0.921875 v -0.671875 z m 0,0 m -2.100965,1.375 c -0.125,-0.96875 -0.6875,-1.5 -1.625,-1.5 -1.15625,0 -1.90625,0.875 -1.90625,2.21875 0,1.3125 0.75,2.1875 1.90625,2.1875 0.953125,0 1.578125,-0.59375 1.640625,-1.5625 h -0.84375 c -0.0625,0.59375 -0.3125,0.859375 -0.796875,0.859375 -0.640625,0 -1.015625,-0.546875 -1.015625,-1.484375 0,-0.921875 0.390625,-1.515625 1,-1.515625 0.453125,0 0.6875,0.234375 0.78125,0.796875 z m 0,0 m -4.2213,0.890625 c 0.01563,-0.07813 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.04687 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -2.40401,-1.625 0.01563,-1.203125 h -0.828125 l -0.03125,1.203125 h -0.65625 L -18.98285,-14.06 h 0.640625 l -0.04687,1.859375 c -0.01563,0.421875 -0.01563,0.421875 -0.01563,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 l 0.01563,-0.734375 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -17.48285,-14.06 h 0.921875 v -0.671875 z m 0,0 m -3.9167,-0.125 c -1.125,0 -1.953125,0.921875 -1.953125,2.171875 0,1.328125 0.796875,2.234375 1.953125,2.234375 1.140625,0 1.9375,-0.90625 1.9375,-2.1875 0,-1.296875 -0.796875,-2.21875 -1.9375,-2.21875 z m 0,0.703125 c 0.625,0 1.0625,0.625 1.0625,1.515625 0,0.875 -0.4375,1.484375 -1.0625,1.484375 -0.640625,0 -1.0625,-0.59375 -1.0625,-1.515625 0,-0.875 0.4375,-1.484375 1.0625,-1.484375 z m 0,0 m -4.849585,-0.578125 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V -10.56 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.04687 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 M -30.875225,-16.435 v 5.875 h 0.90625 v -2.28125 h 0.375 c 0.84375,0 1.21875,-0.03125 1.5625,-0.15625 0.640625,-0.21875 1.046875,-0.828125 1.046875,-1.609375 0,-0.796875 -0.40625,-1.4375 -1.078125,-1.65625 -0.375,-0.125 -0.765625,-0.171875 -1.640625,-0.171875 z m 0.90625,2.8125 v -2.015625 h 0.375 c 0.65625,0 0.921875,0.03125 1.171875,0.140625 0.3125,0.140625 0.484375,0.453125 0.484375,0.875 0,0.46875 -0.21875,0.8125 -0.609375,0.90625 -0.234375,0.07813 -0.421875,0.09375 -1.046875,0.09375 z m 0,0 M -1.52309,-27.02625 V -21.12 h 0.875 v -5.90625 z m 0,0 M -5.144695,-24.12 c 0.078125,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.015625,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 m -4.162995,-2.375 0.015625,-1.203125 h -0.828125 l -0.03125,1.203125 h -0.65625 L -9.27644,-24.62 h 0.640625 l -0.046875,1.859375 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L -6.74519,-21.9325 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -7.77644,-24.62 h 0.921875 v -0.671875 z m 0,0 m -3.238985,0 V -21.12 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -5.108325,7.703125 h 0.859375 v -2.25 c 0.328125,0.4375 0.65625,0.609375 1.15625,0.609375 0.984375,0 1.671875,-0.90625 1.671875,-2.203125 0,-1.296875 -0.6875,-2.171875 -1.703125,-2.171875 -0.53125,0 -0.890625,0.203125 -1.171875,0.640625 0,-0.1875 -0.03125,-0.40625 -0.07813,-0.53125 h -0.8125 c 0.0625,0.28125 0.07813,0.546875 0.07813,1.28125 z m 1.84375,-5.28125 c 0.59375,0 0.953125,0.5625 0.953125,1.453125 0,0.921875 -0.359375,1.453125 -0.953125,1.453125 -0.609375,0 -1,-0.578125 -1,-1.4375 0,-0.890625 0.390625,-1.46875 1,-1.46875 z m 0,0 M -19.276625,-24.12 c 0.07813,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.01563,0.328125 0.0625,0.515625 H -16.761 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 m -3.295625,-2.296875 c -0.109375,-1.203125 -0.828125,-1.875 -2,-1.875 -0.609375,0 -1.1875,0.21875 -1.609375,0.609375 -0.59375,0.53125 -0.90625,1.390625 -0.90625,2.4375 0,1.84375 1,3.03125 2.546875,3.03125 1.25,0 1.96875,-0.78125 2.0625,-2.203125 h -0.828125 c -0.09375,0.9375 -0.515625,1.40625 -1.265625,1.40625 -0.96875,0 -1.5625,-0.859375 -1.5625,-2.234375 0,-1.390625 0.59375,-2.265625 1.546875,-2.265625 0.65625,0 1.078125,0.375 1.21875,1.09375 z m 0,0 M 5.55365,-37.58625 H 4.694275 v 2.25 c -0.3125,-0.453125 -0.609375,-0.625 -1.125,-0.625 -0.984375,0 -1.6875,0.921875 -1.6875,2.234375 0,1.296875 0.671875,2.140625 1.71875,2.140625 0.546875,0 0.890625,-0.203125 1.171875,-0.6875 0,0.09375 0,0.140625 0,0.1875 0,0.140625 0,0.234375 0.046875,0.40625 h 0.8125 C 5.5849,-31.96125 5.55365,-32.226875 5.55365,-32.96125 Z m -1.796875,2.359375 c 0.59375,0 0.953125,0.5625 0.953125,1.453125 0,0.890625 -0.375,1.453125 -0.984375,1.453125 -0.59375,0 -0.96875,-0.53125 -0.96875,-1.421875 0,-0.921875 0.390625,-1.484375 1,-1.484375 z m 0,0 M 1.1761,-33.58625 c 0.015625,-0.07813 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.04687 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 C -1.5114,-34.93 -1.183275,-35.27375 -0.6364,-35.27375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -5.264575,4.28125 h 0.859375 v -2.25 c 0.328125,0.4375 0.65625,0.609375 1.15625,0.609375 0.984375,0 1.671875,-0.90625 1.671875,-2.203125 0,-1.296875 -0.6875,-2.171875 -1.703125,-2.171875 -0.53125,0 -0.890625,0.203125 -1.171875,0.640625 0,-0.1875 -0.03125,-0.40625 -0.078125,-0.53125 h -0.8125 c 0.0625,0.28125 0.078125,0.546875 0.078125,1.28125 z m 1.84375,-5.28125 c 0.59375,0 0.953125,0.5625 0.953125,1.453125 0,0.921875 -0.359375,1.453125 -0.953125,1.453125 -0.609375,0 -1,-0.578125 -1,-1.4375 0,-0.890625 0.390625,-1.46875 1,-1.46875 z m 0,0 m -6.49894,5.28125 h 0.859375 v -2.25 c 0.328125,0.4375 0.65625,0.609375 1.15625,0.609375 0.984375,0 1.671875,-0.90625 1.671875,-2.203125 0,-1.296875 -0.6875,-2.171875 -1.703125,-2.171875 -0.53125,0 -0.890625,0.203125 -1.171875,0.640625 0,-0.1875 -0.03125,-0.40625 -0.07813,-0.53125 h -0.8125 c 0.0625,0.28125 0.07813,0.546875 0.07813,1.28125 z m 1.84375,-5.28125 c 0.59375,0 0.953125,0.5625 0.953125,1.453125 0,0.921875 -0.359375,1.453125 -0.953125,1.453125 -0.609375,0 -1,-0.578125 -1,-1.4375 0,-0.890625 0.390625,-1.46875 1,-1.46875 z m 0,0 M -15.193425,-34.68 c 0.07813,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.01563,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 m -3.27285,-1 c -0.125,-0.96875 -0.6875,-1.5 -1.625,-1.5 -1.15625,0 -1.90625,0.875 -1.90625,2.21875 0,1.3125 0.75,2.1875 1.90625,2.1875 0.953125,0 1.578125,-0.59375 1.640625,-1.5625 h -0.84375 c -0.0625,0.59375 -0.3125,0.859375 -0.796875,0.859375 -0.640625,0 -1.015625,-0.546875 -1.015625,-1.484375 0,-0.921875 0.390625,-1.515625 1,-1.515625 0.453125,0 0.6875,0.234375 0.78125,0.796875 z m 0,0 m -7.996985,-1.375 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V -31.68 h 0.859375 v -2.21875 c 0,-0.40625 0.04687,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.07813,0.171875 0.109375,0.359375 0.109375,0.859375 V -31.68 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.01563,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 M -30.45175,-37.555 v 3.421875 c 0,0.875 0.03125,1.125 0.1875,1.46875 0.3125,0.6875 1.0625,1.09375 2.03125,1.09375 0.953125,0 1.703125,-0.40625 2.015625,-1.09375 0.15625,-0.328125 0.1875,-0.59375 0.1875,-1.46875 V -37.555 h -0.90625 v 3.40625 c 0,0.625 -0.01563,0.828125 -0.09375,1.046875 -0.15625,0.46875 -0.609375,0.734375 -1.203125,0.734375 -0.5625,0 -1,-0.234375 -1.171875,-0.625 -0.109375,-0.25 -0.140625,-0.453125 -0.140625,-1.15625 V -37.555 Z m 0,0"
                  />
                </g>
              </g>
            ) : (
              <g
                style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
                id="g5312"
              >
                <g id="use5310" transform="translate(209.83929,339.69809)">
                  <path
                    id="path19529"
                    style={{ stroke: 'none' }}
                    d="m 4.0625,-1.90625 c 0.015625,-0.078125 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 C 3.15625,0.109375 3.75,-0.3125 3.96875,-1.09375 L 3.203125,-1.140625 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z M 1.234375,-2.546875 C 1.375,-3.25 1.703125,-3.59375 2.25,-3.59375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -2.40399,-1.625 L -1.15399,-5.375 h -0.828125 l -0.03125,1.203125 h -0.65625 L -2.68524,-3.5 h 0.640625 l -0.046875,1.859375 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L -0.15399,-0.8125 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -1.18524,-3.5 h 0.921875 v -0.671875 z m 0,0 M -5.900615,-3 c 0.078125,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.015625,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 m -4.086425,-2.375 L -10.08079,-2.25 -8.42454,0 h 1.15625 l -1.78125,-2.265625 1.65625,-1.90625 z M -10.95579,-5.90625 V 0 h 0.859375 v -5.90625 z m 0,0 m -3.842885,1.734375 v -0.1875 c 0,-0.328125 0.01563,-0.5 0.04687,-0.609375 0.07813,-0.1875 0.234375,-0.296875 0.453125,-0.296875 0.1875,0 0.375,0.03125 0.65625,0.140625 v -0.734375 c -0.28125,-0.109375 -0.546875,-0.15625 -0.8125,-0.15625 -0.4375,0 -0.796875,0.171875 -1,0.484375 -0.15625,0.234375 -0.203125,0.515625 -0.203125,1.09375 v 0.265625 h -0.578125 V -3.5 h 0.578125 V 0 h 0.875 v -3.5 h 1 v -0.671875 z m 1.71875,0 V 0 h 0.875 V -4.171875 Z M -12.6268,-5.96875 c -0.34375,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -5.25459,1.796875 V 0 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -2.30936,1.796875 L -19.722,-5.375 h -0.828125 l -0.03125,1.203125 h -0.65625 L -21.25325,-3.5 h 0.640625 l -0.04687,1.859375 c -0.01563,0.421875 -0.01563,0.421875 -0.01563,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L -18.722,-0.8125 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -19.75325,-3.5 h 0.921875 v -0.671875 z m 0,0 m -4.463065,0 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V 0 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.046875 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 m -0.9088,2.265625 c 0.01563,-0.078125 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 M -33.092465,-5.875 v 0.765625 h 2.59375 l -2.8125,4.390625 V 0 h 3.84375 v -0.78125 h -2.78125 l 2.859375,-4.453125 V -5.875 Z m 0,0 M 9.20853,-13.09125 v 0.640625 h 2.34375 v -0.640625 z m 0,0 m -3.234965,-1.640625 v 0.703125 H 7.92669 l -2.15625,2.796875 V -10.56 h 3.203125 v -0.71875 H 6.80169 l 2.1875,-2.8125 v -0.640625 z m 0,0 m -1.62186,0 L 4.36733,-15.935 H 3.539205 l -0.03125,1.203125 H 2.851705 L 2.83608,-14.06 h 0.640625 l -0.046875,1.859375 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L 5.36733,-11.3725 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L 4.33608,-14.06 h 0.921875 v -0.671875 z m 0,0 m -5.787015,0 v 2.484375 c 0,0.5625 0.0625,0.90625 0.21875,1.15625 0.25,0.390625 0.703125,0.625 1.25,0.625 0.53125,0 0.859375,-0.1875 1.140625,-0.609375 C 1.18969,-10.8725 1.22094,-10.685 1.267815,-10.56 H 2.09594 c -0.109375,-0.34375 -0.109375,-0.34375 -0.109375,-1.28125 v -2.890625 H 1.12719 V -12.435 c 0,0.359375 -0.046875,0.59375 -0.140625,0.78125 -0.171875,0.28125 -0.4375,0.421875 -0.765625,0.421875 -0.28125,0 -0.515625,-0.109375 -0.65625,-0.28125 -0.09375,-0.140625 -0.140625,-0.390625 -0.140625,-0.765625 v -2.453125 z m 0,0 M -6.06807,-16.46625 V -10.56 h 0.859375 v -2.21875 c 0,-0.375 0.046875,-0.625 0.15625,-0.828125 0.15625,-0.28125 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.671875,0.390625 0.09375,0.171875 0.109375,0.40625 0.109375,0.859375 V -10.56 h 0.875 v -2.40625 c 0,-0.765625 -0.046875,-1.046875 -0.21875,-1.3125 -0.21875,-0.34375 -0.671875,-0.5625 -1.171875,-0.5625 -0.5,0 -0.890625,0.1875 -1.203125,0.578125 v -2.203125 z m 0,0 m -0.9476,3.109375 c -0.125,-0.96875 -0.6875,-1.5 -1.625,-1.5 -1.15625,0 -1.90625,0.875 -1.90625,2.21875 0,1.3125 0.75,2.1875 1.90625,2.1875 0.953125,0 1.578125,-0.59375 1.640625,-1.5625 h -0.84375 c -0.0625,0.59375 -0.3125,0.859375 -0.796875,0.859375 -0.640625,0 -1.015625,-0.546875 -1.015625,-1.484375 0,-0.921875 0.390625,-1.515625 1,-1.515625 0.453125,0 0.6875,0.234375 0.78125,0.796875 z m 0,0 m -4.29315,-0.15625 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 0,-0.296875 -0.07813,-0.53125 -0.234375,-0.734375 -0.1875,-0.1875 -0.453125,-0.328125 -1.09375,-0.515625 -0.84375,-0.234375 -0.984375,-0.328125 -0.984375,-0.640625 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 m -5.16086,-2.953125 V -10.56 h 0.875 v -5.90625 z m 0,0 m -3.621605,2.90625 c 0.07813,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.01563,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 m -4.162995,-2.375 0.01563,-1.203125 h -0.828125 l -0.03125,1.203125 h -0.65625 L -24.22303,-14.06 h 0.640625 l -0.04687,1.859375 c -0.01563,0.421875 -0.01563,0.421875 -0.01563,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 l 0.01563,-0.734375 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -22.72303,-14.06 h 0.921875 v -0.671875 z m 0,0 m -3.238985,0 V -10.56 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -5.108325,7.703125 h 0.859375 v -2.25 c 0.328125,0.4375 0.65625,0.609375 1.15625,0.609375 0.984375,0 1.671875,-0.90625 1.671875,-2.203125 0,-1.296875 -0.6875,-2.171875 -1.703125,-2.171875 -0.53125,0 -0.890625,0.203125 -1.171875,0.640625 0,-0.1875 -0.03125,-0.40625 -0.07813,-0.53125 h -0.8125 c 0.0625,0.28125 0.07813,0.546875 0.07813,1.28125 z m 1.84375,-5.28125 c 0.59375,0 0.953125,0.5625 0.953125,1.453125 0,0.921875 -0.359375,1.453125 -0.953125,1.453125 -0.609375,0 -1,-0.578125 -1,-1.4375 0,-0.890625 0.390625,-1.46875 1,-1.46875 z m 0,0 M -34.223215,-13.56 c 0.07813,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.01563,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 m -4.11279,-4.078125 -2.25,2.78125 2.3125,3.09375 h 1.1875 l -2.46875,-3.125 2.28125,-2.75 z m -3.171875,0 v 5.875 h 0.90625 v -5.875 z m 0,0"
                  />
                </g>
              </g>
            )}
          </g>
        </g>
        <g
          id="circle-4"
          onMouseEnter={handleCircleMouseEnter}
          onMouseLeave={handleCircleMouseLeave}
          onMouseDown={handleCircleMouseDown}
        >
          <path
            className="circle-color"
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: 'rgb(0%,52.941895%,49.01886%)',
              fillOpacity: 1
            }}
            d="M 259.980469 362.292969 C 277.007812 362.292969 290.808594 348.492188 290.808594 331.464844 C 290.808594 314.441406 277.007812 300.640625 259.980469 300.640625 C 242.957031 300.640625 229.15625 314.441406 229.15625 331.464844 C 229.15625 348.492188 242.957031 362.292969 259.980469 362.292969 "
            id="circle-4-path"
          />
          <g style={{ pointerEvents: 'none' }}>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5326"
            >
              <g id="use5316" transform="translate(243.1035,318.57809)" />
              <g id="use5318" transform="translate(248.11951,318.57809)" />
              <g id="use5320" transform="translate(252.7043,318.57809)" />
              <g id="use5322" transform="translate(257.34189,318.57809)" />
              <g id="use5324" transform="translate(259.4715,318.57809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5334"
            >
              <g id="use5328" transform="translate(262.46262,318.57809)" />
              <g id="use5330" transform="translate(266.81863,318.57809)" />
              <g id="use5332" transform="translate(269.78421,318.57809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5338"
            >
              <g id="use5336" transform="translate(273.85861,318.57809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5356"
            >
              <g id="use5340" transform="translate(240.1203,329.13809)" />
              <g id="use5342" transform="translate(244.4763,329.13809)" />
              <g id="use5344" transform="translate(249.1403,329.13809)" />
              <g id="use5346" transform="translate(253.80431,329.13809)" />
              <g id="use5348" transform="translate(258.16031,329.13809)" />
              <g id="use5350" transform="translate(262.79791,329.13809)" />
              <g id="use5352" transform="translate(267.26831,329.13809)" />
              <g id="use5354" transform="translate(269.39789,329.13809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5362"
            >
              <g id="use5358" transform="translate(273.7803,329.13809)" />
              <g id="use5360" transform="translate(278.18909,329.13809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5368"
            >
              <g id="use5364" transform="translate(230.80991,339.69809)" />
              <g id="use5366" transform="translate(235.44749,339.69809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5380"
            >
              <g id="use5370" transform="translate(239.3811,339.69809)" />
              <g id="use5372" transform="translate(243.7811,339.69809)" />
              <g id="use5374" transform="translate(248.1635,339.69809)" />
              <g id="use5376" transform="translate(250.0291,339.69809)" />
              <g id="use5378" transform="translate(254.4203,339.69809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5386"
            >
              <g id="use5382" transform="translate(258.13391,339.69809)" />
              <g id="use5384" transform="translate(262.27869,339.69809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5392"
            >
              <g id="use5388" transform="translate(265.14749,339.69809)" />
              <g id="use5390" transform="translate(268.95789,339.69809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5398"
            >
              <g id="use5394" transform="translate(272.89151,339.69809)" />
              <g id="use5396" transform="translate(277.2915,339.69809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5404"
            >
              <g id="use5400" transform="translate(280.1427,339.69809)" />
              <g id="use5402" transform="translate(284.28751,339.69809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5408"
            >
              <g id="use5406" transform="translate(286.1524,339.69809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5418"
            >
              <g id="use5410" transform="translate(246.4077,350.25809)" />
              <g id="use5412" transform="translate(250.89571,350.25809)" />
              <g id="use5414" transform="translate(255.3661,350.25809)" />
              <g id="use5416" transform="translate(259.8277,350.25809)" />
            </g>
            {props.lang === 'en' ? (
              <g
                style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
                id="g5424"
              >
                <g id="use5420" transform="translate(266.0849,339.69809)" />
                <g id="use5422" transform="translate(266.0849,339.69809)">
                  <path
                    id="path19895"
                    style={{ stroke: 'none' }}
                    d="m 3.65625,-2.953125 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 C 3.6875,-1.5 3.609375,-1.734375 3.453125,-1.9375 3.265625,-2.125 3,-2.265625 2.359375,-2.453125 1.515625,-2.6875 1.375,-2.78125 1.375,-3.09375 c 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 m -3.82654,1.046875 c 0.015625,-0.078125 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z M -2.998415,-2.546875 C -2.85779,-3.25 -2.529665,-3.59375 -1.98279,-3.59375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -2.228,-1.625 L -5.21079,-5.375 h -0.828125 l -0.03125,1.203125 h -0.65625 L -6.74204,-3.5 h 0.640625 l -0.046875,1.859375 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L -4.21079,-0.8125 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -5.24204,-3.5 h 0.921875 v -0.671875 z m 0,0 m -3.7407,-0.125 c -1.125,0 -1.953125,0.921875 -1.953125,2.171875 0,1.328125 0.796875,2.234375 1.953125,2.234375 1.140625,0 1.9375,-0.90625 1.9375,-2.1875 0,-1.296875 -0.796875,-2.21875 -1.9375,-2.21875 z m 0,0.703125 c 0.625,0 1.0625,0.625 1.0625,1.515625 0,0.875 -0.4375,1.484375 -1.0625,1.484375 -0.640625,0 -1.0625,-0.59375 -1.0625,-1.515625 0,-0.875 0.4375,-1.484375 1.0625,-1.484375 z m 0,0 M -16.205625,-5.875 V 0 h 0.859375 V -4.484375 L -12.736875,0 h 0.9375 v -5.875 h -0.859375 v 4.5 l -2.578125,-4.5 z m 0,0 M 16.55453,-16.46625 h -0.859375 v 2.25 c -0.3125,-0.453125 -0.609375,-0.625 -1.125,-0.625 -0.984375,0 -1.6875,0.921875 -1.6875,2.234375 0,1.296875 0.671875,2.140625 1.71875,2.140625 0.546875,0 0.890625,-0.203125 1.171875,-0.6875 0,0.09375 0,0.140625 0,0.1875 0,0.140625 0,0.234375 0.04687,0.40625 h 0.8125 c -0.04687,-0.28125 -0.07813,-0.546875 -0.07813,-1.28125 z m -1.796875,2.359375 c 0.59375,0 0.953125,0.5625 0.953125,1.453125 0,0.890625 -0.375,1.453125 -0.984375,1.453125 -0.59375,0 -0.96875,-0.53125 -0.96875,-1.421875 0,-0.921875 0.390625,-1.484375 1,-1.484375 z m 0,0 m -2.404685,1.640625 c 0.01563,-0.07813 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.04687 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z M 9.524845,-13.106875 C 9.66547,-13.81 9.993595,-14.15375 10.54047,-14.15375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -2.14261,-1.625 -1.640625,1.921875 1.65625,2.25 h 1.15625 l -1.78125,-2.265625 1.65625,-1.90625 z M 4.86661,-16.46625 V -10.56 h 0.859375 v -5.90625 z m 0,0 m -4.570985,1.734375 C 0.405,-14.34125 0.405,-14.294375 0.405,-13.27875 V -10.56 h 0.859375 v -2.21875 c 0,-0.40625 0.046875,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.078125,0.171875 0.109375,0.359375 0.109375,0.859375 V -10.56 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.015625,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -1.844235,0 V -10.56 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -4.53254,0.09375 v 5.875 H -2.1749 v -0.78125 H -4.70615 V -16.435 Z m 0,0 m -2.907985,3.34375 v 0.640625 h 2.34375 v -0.640625 z m 0,0 M -9.591235,-14.731875 -9.57561,-15.935 h -0.828125 l -0.03125,1.203125 h -0.65625 L -11.10686,-14.06 h 0.640625 l -0.04687,1.859375 c -0.01563,0.421875 -0.01563,0.421875 -0.01563,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L -8.57561,-11.3725 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -9.60686,-14.06 h 0.921875 v -0.671875 z m 0,0 m -3.062975,0 V -10.56 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -1.526055,0.0625 h -0.859375 v 2.25 c -0.3125,-0.453125 -0.609375,-0.625 -1.125,-0.625 -0.984375,0 -1.6875,0.921875 -1.6875,2.234375 0,1.296875 0.671875,2.140625 1.71875,2.140625 0.546875,0 0.890625,-0.203125 1.171875,-0.6875 0,0.09375 0,0.140625 0,0.1875 0,0.140625 0,0.234375 0.04687,0.40625 h 0.8125 c -0.04687,-0.28125 -0.07813,-0.546875 -0.07813,-1.28125 z m -1.796875,2.359375 c 0.59375,0 0.953125,0.5625 0.953125,1.453125 0,0.890625 -0.375,1.453125 -0.984375,1.453125 -0.59375,0 -0.96875,-0.53125 -0.96875,-1.421875 0,-0.921875 0.390625,-1.484375 1,-1.484375 z m 0,0 m -2.404685,1.640625 c 0.01563,-0.07813 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.04687 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -3.611075,-1.625 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V -10.56 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.04687 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 m -0.775865,0.07813 c -0.109375,-1.203125 -0.828125,-1.875 -2,-1.875 -0.609375,0 -1.1875,0.21875 -1.609375,0.609375 -0.59375,0.53125 -0.90625,1.390625 -0.90625,2.4375 0,1.84375 1,3.03125 2.546875,3.03125 1.25,0 1.96875,-0.78125 2.0625,-2.203125 h -0.828125 c -0.09375,0.9375 -0.515625,1.40625 -1.265625,1.40625 -0.96875,0 -1.5625,-0.859375 -1.5625,-2.234375 0,-1.390625 0.59375,-2.265625 1.546875,-2.265625 0.65625,0 1.078125,0.375 1.21875,1.09375 z m 0,0"
                  />
                </g>
              </g>
            ) : (
              <g
                style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
                id="g5424"
              >
                <g id="use5420" transform="translate(264.03409,350.25809)" />
                <g id="use5422" transform="translate(268.26691,350.25809)">
                  <path
                    id="path19895"
                    style={{ stroke: 'none' }}
                    d="M 0.515625,-4.171875 C 0.625,-3.78125 0.625,-3.734375 0.625,-2.71875 V 0 h 0.859375 v -2.21875 c 0,-0.40625 0.046875,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 C 3.15625,-2.953125 3.1875,-2.765625 3.1875,-2.265625 V 0 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 C 3.671875,-4.03125 3.234375,-4.28125 2.6875,-4.28125 c -0.546875,0 -0.96875,0.21875 -1.25,0.671875 C 1.421875,-3.875 1.40625,-4.015625 1.34375,-4.171875 Z m 0,0 M -0.17032,-1.90625 c 0.015625,-0.078125 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z M -2.998445,-2.546875 C -2.85782,-3.25 -2.529695,-3.59375 -1.98282,-3.59375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -1.14389,-1.625 -1.328125,0.03125 C -5.767335,-4.234375 -5.954835,-4.25 -6.204835,-4.25 c -1,0 -1.640625,0.5625 -1.640625,1.453125 0,0.578125 0.234375,0.953125 0.765625,1.203125 -0.546875,0.1875 -0.75,0.375 -0.75,0.65625 0,0.21875 0.140625,0.375 0.46875,0.5 -0.609375,0.203125 -0.859375,0.515625 -0.859375,1 0,0.734375 0.765625,1.21875 1.984375,1.21875 1.25,0 1.984375,-0.5 1.984375,-1.34375 0,-0.4375 -0.203125,-0.796875 -0.546875,-0.984375 C -5.06421,-0.6875 -5.31421,-0.734375 -6.09546,-0.8125 c -0.65625,-0.078125 -0.671875,-0.078125 -0.765625,-0.109375 -0.078125,-0.03125 -0.125,-0.09375 -0.125,-0.171875 0,-0.125 0.1875,-0.265625 0.453125,-0.296875 0.828125,-0.125 0.921875,-0.140625 1.21875,-0.28125 0.375,-0.171875 0.59375,-0.5625 0.59375,-1.03125 0,-0.328125 -0.109375,-0.671875 -0.28125,-0.84375 h 0.859375 z M -6.25171,-3.59375 c 0.453125,0 0.78125,0.328125 0.78125,0.78125 0,0.453125 -0.328125,0.734375 -0.8125,0.734375 -0.46875,0 -0.796875,-0.28125 -0.796875,-0.734375 0,-0.453125 0.328125,-0.78125 0.828125,-0.78125 z m -0.078125,3.484375 c 0.796875,0 1.25,0.21875 1.25,0.609375 0,0.375 -0.4375,0.625 -1.140625,0.625 -0.765625,0 -1.25,-0.25 -1.25,-0.625 0,-0.390625 0.421875,-0.609375 1.140625,-0.609375 z m 0,0 m -6.05535,-4.0625 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V 0 h 0.859375 v -2.21875 c 0,-0.40625 0.04687,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.078125,0.171875 0.109375,0.359375 0.109375,0.859375 V 0 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.01563,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -4.392265,0 V -1.6875 c 0,0.5625 0.0625,0.90625 0.21875,1.15625 0.25,0.390625 0.703125,0.625 1.25,0.625 0.53125,0 0.859375,-0.1875 1.140625,-0.609375 C -14.15245,-0.3125 -14.1212,-0.125 -14.074325,0 h 0.828125 c -0.109375,-0.34375 -0.109375,-0.34375 -0.109375,-1.28125 V -4.171875 H -14.21495 V -1.875 c 0,0.359375 -0.04687,0.59375 -0.140625,0.78125 -0.171875,0.28125 -0.4375,0.421875 -0.765625,0.421875 -0.28125,0 -0.515625,-0.109375 -0.65625,-0.28125 -0.09375,-0.140625 -0.140625,-0.390625 -0.140625,-0.765625 v -2.453125 z m 0,0 m -4.472385,-1.734375 v 4.765625 c 0,0.734375 0,0.828125 -0.03125,1.140625 h 0.765625 c 0.04687,-0.171875 0.0625,-0.328125 0.07813,-0.578125 0.25,0.46875 0.609375,0.671875 1.125,0.671875 1.046875,0 1.765625,-0.890625 1.765625,-2.1875 0,-1.28125 -0.6875,-2.1875 -1.671875,-2.1875 -0.5,0 -0.828125,0.203125 -1.15625,0.671875 V -5.90625 Z m 1.875,2.375 c 0.578125,0 0.9375,0.546875 0.9375,1.421875 0,0.90625 -0.375,1.46875 -0.984375,1.46875 -0.59375,0 -0.96875,-0.5625 -0.96875,-1.421875 0,-0.90625 0.390625,-1.46875 1.015625,-1.46875 z m 0,0 m 37.260325,-9.56 v 0.640625 h 2.34375 v -0.640625 z m 0,0 M 16.6456,-14.731875 V -10.56 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -1.160435,4.0625 c 0.01563,-0.07813 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.04687 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -3.523075,-1.625 c 0.046875,0.359375 0.046875,0.4375 0.046875,1.34375 V -10.56 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.04687 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 M 5.2496,-16.46625 V -10.56 h 0.859375 v -2.21875 c 0,-0.375 0.046875,-0.625 0.15625,-0.828125 0.15625,-0.28125 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.671875,0.390625 0.09375,0.171875 0.109375,0.40625 0.109375,0.859375 V -10.56 h 0.875 v -2.40625 c 0,-0.765625 -0.046875,-1.046875 -0.21875,-1.3125 -0.21875,-0.34375 -0.671875,-0.5625 -1.171875,-0.5625 -0.5,0 -0.890625,0.1875 -1.203125,0.578125 v -2.203125 z m 0,0 m -0.68362,3.109375 c -0.125,-0.96875 -0.6875,-1.5 -1.625,-1.5 -1.15625,0 -1.90625,0.875 -1.90625,2.21875 0,1.3125 0.75,2.1875 1.90625,2.1875 0.953125,0 1.578125,-0.59375 1.640625,-1.5625 h -0.84375 c -0.0625,0.59375 -0.3125,0.859375 -0.796875,0.859375 -0.640625,0 -1.015625,-0.546875 -1.015625,-1.484375 0,-0.921875 0.390625,-1.515625 1,-1.515625 0.453125,0 0.6875,0.234375 0.78125,0.796875 z m 0,0 m -4.02915,-0.15625 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 0,-0.296875 -0.078125,-0.53125 -0.234375,-0.734375 -0.1875,-0.1875 -0.453125,-0.328125 -1.09375,-0.515625 -0.84375,-0.234375 -0.984375,-0.328125 -0.984375,-0.640625 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 m -5.96255,-1.21875 c 0.046875,0.359375 0.046875,0.4375 0.046875,1.34375 V -10.56 h 0.875 v -1.90625 c 0,-0.46875 0.046875,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.04687 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.015625,-0.109375 0.015625,-0.171875 0.015625,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 m -0.64478,2.265625 c 0.015625,-0.07813 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.04687 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 C -8.758,-13.81 -8.429875,-14.15375 -7.883,-14.15375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -4.854235,-1.625 1.484375,4.203125 h 0.953125 l 1.484375,-4.203125 h -0.90625 l -1.046875,3.234375 -1.0625,-3.234375 z m 0,0 m -0.4537,-1.734375 h -0.859375 v 2.25 c -0.3125,-0.453125 -0.609375,-0.625 -1.125,-0.625 -0.984375,0 -1.6875,0.921875 -1.6875,2.234375 0,1.296875 0.671875,2.140625 1.71875,2.140625 0.546875,0 0.890625,-0.203125 1.171875,-0.6875 0,0.09375 0,0.140625 0,0.1875 0,0.140625 0,0.234375 0.04687,0.40625 h 0.8125 c -0.04687,-0.28125 -0.07813,-0.546875 -0.07813,-1.28125 z m -1.796875,2.359375 c 0.59375,0 0.953125,0.5625 0.953125,1.453125 0,0.890625 -0.375,1.453125 -0.984375,1.453125 -0.59375,0 -0.96875,-0.53125 -0.96875,-1.421875 0,-0.921875 0.390625,-1.484375 1,-1.484375 z m 0,0 M -19.47841,-16.46625 V -10.56 h 0.875 v -5.90625 z m 0,0 m -4.41365,1.734375 v 2.484375 c 0,0.5625 0.0625,0.90625 0.21875,1.15625 0.25,0.390625 0.703125,0.625 1.25,0.625 0.53125,0 0.859375,-0.1875 1.140625,-0.609375 0.01563,0.203125 0.04687,0.390625 0.09375,0.515625 h 0.828125 c -0.109375,-0.34375 -0.109375,-0.34375 -0.109375,-1.28125 v -2.890625 H -21.32956 V -12.435 c 0,0.359375 -0.04687,0.59375 -0.140625,0.78125 -0.171875,0.28125 -0.4375,0.421875 -0.765625,0.421875 -0.28125,0 -0.515625,-0.109375 -0.65625,-0.28125 -0.09375,-0.140625 -0.140625,-0.390625 -0.140625,-0.765625 v -2.453125 z m 0,0 m -4.36875,-1.734375 V -10.56 h 0.859375 v -2.21875 c 0,-0.375 0.04687,-0.625 0.15625,-0.828125 0.15625,-0.28125 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.671875,0.390625 0.09375,0.171875 0.109375,0.40625 0.109375,0.859375 V -10.56 h 0.875 v -2.40625 c 0,-0.765625 -0.04687,-1.046875 -0.21875,-1.3125 -0.21875,-0.34375 -0.671875,-0.5625 -1.171875,-0.5625 -0.5,0 -0.890625,0.1875 -1.203125,0.578125 v -2.203125 z m 0,0 m -0.68361,3.109375 c -0.125,-0.96875 -0.6875,-1.5 -1.625,-1.5 -1.15625,0 -1.90625,0.875 -1.90625,2.21875 0,1.3125 0.75,2.1875 1.90625,2.1875 0.953125,0 1.578125,-0.59375 1.640625,-1.5625 h -0.84375 c -0.0625,0.59375 -0.3125,0.859375 -0.796875,0.859375 -0.640625,0 -1.015625,-0.546875 -1.015625,-1.484375 0,-0.921875 0.390625,-1.515625 1,-1.515625 0.453125,0 0.6875,0.234375 0.78125,0.796875 z m 0,0 m -4.16883,-1.4375 c -0.03125,-0.46875 -0.109375,-0.734375 -0.3125,-1.015625 -0.328125,-0.453125 -0.90625,-0.71875 -1.578125,-0.71875 -1.109375,0 -1.90625,0.671875 -1.90625,1.625 0,0.421875 0.171875,0.796875 0.46875,1.078125 0.21875,0.203125 0.59375,0.40625 1.203125,0.671875 0.6875,0.28125 0.796875,0.34375 0.96875,0.46875 0.265625,0.171875 0.390625,0.375 0.390625,0.640625 0,0.46875 -0.453125,0.796875 -1.078125,0.796875 -0.765625,0 -1.1875,-0.40625 -1.265625,-1.21875 h -0.875 c 0.0625,1.3125 0.796875,2.015625 2.125,2.015625 1.234375,0 2.015625,-0.6875 2.015625,-1.75 0,-0.421875 -0.125,-0.78125 -0.375,-1.046875 -0.21875,-0.25 -0.484375,-0.40625 -1.34375,-0.75 -0.71875,-0.3125 -0.8125,-0.359375 -1,-0.46875 -0.203125,-0.125 -0.328125,-0.3125 -0.328125,-0.515625 0,-0.4375 0.421875,-0.765625 0.96875,-0.765625 0.609375,0 0.984375,0.34375 1.046875,0.953125 z m 0,0 M 9.57589,-23.02625 c 0.015625,-0.07813 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.04687 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z M 6.747765,-23.666875 C 6.88839,-24.37 7.216515,-24.71375 7.76339,-24.71375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -1.31991,-1.625 -1.328125,0.03125 C 3.802855,-25.354375 3.615355,-25.37 3.365355,-25.37 c -1,0 -1.640625,0.5625 -1.640625,1.453125 0,0.578125 0.234375,0.953125 0.765625,1.203125 -0.546875,0.1875 -0.75,0.375 -0.75,0.65625 0,0.21875 0.140625,0.375 0.46875,0.5 -0.609375,0.203125 -0.859375,0.515625 -0.859375,1 0,0.734375 0.765625,1.21875 1.984375,1.21875 1.25,0 1.984375,-0.5 1.984375,-1.34375 0,-0.4375 -0.203125,-0.796875 -0.546875,-0.984375 C 4.50598,-21.8075 4.25598,-21.854375 3.47473,-21.9325 c -0.65625,-0.07813 -0.671875,-0.07813 -0.765625,-0.109375 -0.078125,-0.03125 -0.125,-0.09375 -0.125,-0.171875 0,-0.125 0.1875,-0.265625 0.453125,-0.296875 0.828125,-0.125 0.921875,-0.140625 1.21875,-0.28125 0.375,-0.171875 0.59375,-0.5625 0.59375,-1.03125 0,-0.328125 -0.109375,-0.671875 -0.28125,-0.84375 H 5.427855 Z M 3.31848,-24.71375 c 0.453125,0 0.78125,0.328125 0.78125,0.78125 0,0.453125 -0.328125,0.734375 -0.8125,0.734375 -0.46875,0 -0.796875,-0.28125 -0.796875,-0.734375 0,-0.453125 0.328125,-0.78125 0.828125,-0.78125 z m -0.078125,3.484375 c 0.796875,0 1.25,0.21875 1.25,0.609375 0,0.375 -0.4375,0.625 -1.140625,0.625 -0.765625,0 -1.25,-0.25 -1.25,-0.625 0,-0.390625 0.421875,-0.609375 1.140625,-0.609375 z m 0,0 m -3.613955,-4.0625 V -21.12 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -1.25165,1.796875 -1.328125,0.03125 C -2.797125,-25.354375 -2.984625,-25.37 -3.234625,-25.37 c -1,0 -1.640625,0.5625 -1.640625,1.453125 0,0.578125 0.234375,0.953125 0.765625,1.203125 -0.546875,0.1875 -0.75,0.375 -0.75,0.65625 0,0.21875 0.140625,0.375 0.46875,0.5 -0.609375,0.203125 -0.859375,0.515625 -0.859375,1 0,0.734375 0.765625,1.21875 1.984375,1.21875 1.25,0 1.984375,-0.5 1.984375,-1.34375 0,-0.4375 -0.203125,-0.796875 -0.546875,-0.984375 C -2.094,-21.8075 -2.344,-21.854375 -3.12525,-21.9325 c -0.65625,-0.07813 -0.671875,-0.07813 -0.765625,-0.109375 -0.078125,-0.03125 -0.125,-0.09375 -0.125,-0.171875 0,-0.125 0.1875,-0.265625 0.453125,-0.296875 0.828125,-0.125 0.921875,-0.140625 1.21875,-0.28125 0.375,-0.171875 0.59375,-0.5625 0.59375,-1.03125 0,-0.328125 -0.109375,-0.671875 -0.28125,-0.84375 h 0.859375 z M -3.2815,-24.71375 c 0.453125,0 0.78125,0.328125 0.78125,0.78125 0,0.453125 -0.328125,0.734375 -0.8125,0.734375 -0.46875,0 -0.796875,-0.28125 -0.796875,-0.734375 0,-0.453125 0.328125,-0.78125 0.828125,-0.78125 z m -0.078125,3.484375 c 0.796875,0 1.25,0.21875 1.25,0.609375 0,0.375 -0.4375,0.625 -1.140625,0.625 -0.765625,0 -1.25,-0.25 -1.25,-0.625 0,-0.390625 0.421875,-0.609375 1.140625,-0.609375 z m 0,0 m -6.23135,-4.0625 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V -21.12 h 0.859375 v -2.21875 c 0,-0.40625 0.046875,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.078125,0.171875 0.109375,0.359375 0.109375,0.859375 V -21.12 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.015625,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -3.51225,1.171875 c 0.07813,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.01563,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m -1.5,-4.171875 c -0.296875,0 -0.53125,0.234375 -0.53125,0.53125 0,0.296875 0.234375,0.53125 0.53125,0.53125 0.296875,0 0.53125,-0.234375 0.53125,-0.53125 0,-0.296875 -0.234375,-0.53125 -0.53125,-0.53125 z m 1.515625,-0.01563 c -0.296875,0 -0.53125,0.234375 -0.53125,0.546875 0,0.296875 0.234375,0.53125 0.53125,0.53125 0.296875,0 0.53125,-0.234375 0.53125,-0.53125 0,-0.296875 -0.234375,-0.546875 -0.53125,-0.546875 z m 0,0 m -6.960885,0.07813 V -21.12 h 0.859375 v -2.21875 c 0,-0.375 0.04687,-0.625 0.15625,-0.828125 0.15625,-0.28125 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.671875,0.390625 0.09375,0.171875 0.109375,0.40625 0.109375,0.859375 V -21.12 h 0.875 v -2.40625 c 0,-0.765625 -0.04687,-1.046875 -0.21875,-1.3125 -0.21875,-0.34375 -0.671875,-0.5625 -1.171875,-0.5625 -0.5,0 -0.890625,0.1875 -1.203125,0.578125 v -2.203125 z m 0,0 m -4.679625,0 v 4.765625 c 0,0.734375 0,0.828125 -0.03125,1.140625 h 0.765625 c 0.04687,-0.171875 0.0625,-0.328125 0.07813,-0.578125 0.25,0.46875 0.609375,0.671875 1.125,0.671875 1.046875,0 1.765625,-0.890625 1.765625,-2.1875 0,-1.28125 -0.6875,-2.1875 -1.671875,-2.1875 -0.5,0 -0.828125,0.203125 -1.15625,0.671875 v -2.296875 z m 1.875,2.375 c 0.578125,0 0.9375,0.546875 0.9375,1.421875 0,0.90625 -0.375,1.46875 -0.984375,1.46875 -0.59375,0 -0.96875,-0.5625 -0.96875,-1.421875 0,-0.90625 0.390625,-1.46875 1.015625,-1.46875 z m 0,0 m -5.481,0.53125 c 0.07813,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.01563,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 M 5.5917,-34.21125 v 0.640625 h 2.34375 v -0.640625 z m 0,0 m -0.41815,-0.421875 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 0,-0.296875 -0.078125,-0.53125 -0.234375,-0.734375 C 4.782925,-33.805 4.5173,-33.945625 3.876675,-34.133125 3.032925,-34.3675 2.8923,-34.46125 2.8923,-34.77375 c 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 M 0.286095,-35.851875 0.30172,-37.055 h -0.828125 l -0.03125,1.203125 h -0.65625 L -1.22953,-35.18 h 0.640625 l -0.046875,1.859375 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L 1.30172,-32.4925 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L 0.27047,-35.18 h 0.921875 v -0.671875 z m 0,0 M -4.444915,-34.68 c 0.078125,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.015625,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m -1.5,-4.171875 c -0.296875,0 -0.53125,0.234375 -0.53125,0.53125 0,0.296875 0.234375,0.53125 0.53125,0.53125 0.296875,0 0.53125,-0.234375 0.53125,-0.53125 0,-0.296875 -0.234375,-0.53125 -0.53125,-0.53125 z m 1.515625,-0.01563 c -0.296875,0 -0.53125,0.234375 -0.53125,0.546875 0,0.296875 0.234375,0.53125 0.53125,0.53125 0.296875,0 0.53125,-0.234375 0.53125,-0.53125 0,-0.296875 -0.234375,-0.546875 -0.53125,-0.546875 z m 0,0 m -4.17862,1.8125 0.015625,-1.203125 h -0.828125 l -0.03125,1.203125 h -0.65625 L -8.57666,-35.18 h 0.640625 l -0.046875,1.859375 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L -6.04541,-32.4925 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -7.07666,-35.18 h 0.921875 v -0.671875 z m 0,0 m -3.238985,0 V -31.68 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -5.20009,1.796875 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V -31.68 h 0.859375 v -2.21875 c 0,-0.40625 0.04687,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.07813,0.171875 0.109375,0.359375 0.109375,0.859375 V -31.68 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.01563,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -2.80354,-0.125 c -1.125,0 -1.953125,0.921875 -1.953125,2.171875 0,1.328125 0.796875,2.234375 1.953125,2.234375 1.140625,0 1.9375,-0.90625 1.9375,-2.1875 0,-1.296875 -0.796875,-2.21875 -1.9375,-2.21875 z m 0,0.703125 c 0.625,0 1.0625,0.625 1.0625,1.515625 0,0.875 -0.4375,1.484375 -1.0625,1.484375 -0.640625,0 -1.0625,-0.59375 -1.0625,-1.515625 0,-0.875 0.4375,-1.484375 1.0625,-1.484375 z m 0,0 m -6.57851,-2.28125 v 5.875 h 1.203125 c 1.03125,0 1.3125,-0.03125 1.71875,-0.15625 0.625,-0.203125 1.03125,-0.796875 1.03125,-1.5 0,-0.796875 -0.40625,-1.265625 -1.28125,-1.46875 0.671875,-0.21875 0.96875,-0.609375 0.96875,-1.28125 0,-0.625 -0.34375,-1.125 -0.90625,-1.328125 -0.328125,-0.09375 -0.65625,-0.140625 -1.40625,-0.140625 z m 0.890625,2.453125 V -36.805 h 0.453125 c 0.546875,0 0.765625,0.03125 0.96875,0.109375 0.265625,0.109375 0.421875,0.390625 0.421875,0.71875 0,0.34375 -0.140625,0.609375 -0.390625,0.734375 -0.203125,0.109375 -0.46875,0.140625 -0.9375,0.140625 z m 0,2.671875 v -1.9375 h 0.5625 c 0.5625,0 0.78125,0.01563 1.015625,0.09375 0.34375,0.140625 0.546875,0.453125 0.546875,0.875 0,0.40625 -0.171875,0.71875 -0.453125,0.84375 -0.234375,0.09375 -0.46875,0.125 -1.140625,0.125 z m 0,0"
                  />
                </g>
              </g>
            )}
          </g>
        </g>
        <g
          id="circle-5"
          onMouseEnter={handleCircleMouseEnter}
          onMouseLeave={handleCircleMouseLeave}
          onMouseDown={handleCircleMouseDown}
        >
          <path
            className="circle-color"
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: 'rgb(0%,52.941895%,49.01886%)',
              fillOpacity: 1
            }}
            d="M 324.367188 362.292969 C 341.390625 362.292969 355.191406 348.492188 355.191406 331.464844 C 355.191406 314.441406 341.390625 300.640625 324.367188 300.640625 C 307.34375 300.640625 293.539062 314.441406 293.539062 331.464844 C 293.539062 348.492188 307.34375 362.292969 324.367188 362.292969 "
            id="circle-5-path"
          />
          <g style={{ pointerEvents: 'none' }}>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5436"
            >
              <g id="use5428" transform="translate(308.33359,329.13809)" />
              <g id="use5430" transform="translate(312.90961,329.13809)" />
              <g id="use5432" transform="translate(317.07199,329.13809)" />
              <g id="use5434" transform="translate(321.7272,329.13809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5446"
            >
              <g id="use5438" transform="translate(324.84241,329.13809)" />
              <g id="use5440" transform="translate(329.25119,329.13809)" />
              <g id="use5442" transform="translate(333.32559,329.13809)" />
              <g id="use5444" transform="translate(337.39999,329.13809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5450"
            >
              <use x="339.7491" y="329.1381" id="use5448" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5458"
            >
              <g id="use5452" transform="translate(305.06439,339.69809)" />
              <g id="use5454" transform="translate(309.43799,339.69809)" />
              <g id="use5456" transform="translate(313.8468,339.69809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5468"
            >
              <g id="use5460" transform="translate(317.138,339.69809)" />
              <g id="use5462" transform="translate(320.10361,339.69809)" />
              <g id="use5464" transform="translate(322.23318,339.69809)" />
              <g id="use5466" transform="translate(327.02921,339.69809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5474"
            >
              <g id="use5470" transform="translate(331.35001,339.69809)" />
              <g id="use5472" transform="translate(335.70599,339.69809)" />
            </g>
            {props.lang === 'en' ? (
              <g
                style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
                id="g5478"
              >
                <g id="use5476" transform="translate(341.3996,339.69809)">
                  <path
                    id="path19986"
                    style={{ stroke: 'none' }}
                    d="m 3.65625,-2.953125 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 C 3.6875,-1.5 3.609375,-1.734375 3.453125,-1.9375 3.265625,-2.125 3,-2.265625 2.359375,-2.453125 1.515625,-2.6875 1.375,-2.78125 1.375,-3.09375 c 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 m -4.00254,1.046875 c 0.015625,-0.078125 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z M -3.174415,-2.546875 C -3.03379,-3.25 -2.705665,-3.59375 -2.15879,-3.59375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -2.40402,-1.625 L -5.56281,-5.375 h -0.828125 l -0.03125,1.203125 h -0.65625 L -7.09406,-3.5 h 0.640625 l -0.046875,1.859375 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L -4.56281,-0.8125 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -5.59406,-3.5 h 0.921875 v -0.671875 z m 0,0 M -10.309425,-3 c 0.07813,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.015625,0.328125 0.0625,0.515625 H -7.7938 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 m -3.27285,-1 c -0.125,-0.96875 -0.6875,-1.5 -1.625,-1.5 -1.15625,0 -1.90625,0.875 -1.90625,2.21875 0,1.3125 0.75,2.1875 1.90625,2.1875 0.953125,0 1.578125,-0.59375 1.640625,-1.5625 h -0.84375 c -0.0625,0.59375 -0.3125,0.859375 -0.796875,0.859375 -0.640625,0 -1.015625,-0.546875 -1.015625,-1.484375 0,-0.921875 0.390625,-1.515625 1,-1.515625 0.453125,0 0.6875,0.234375 0.78125,0.796875 z m 0,0 m -7.092865,-1.375 v -0.1875 c 0,-0.328125 0.01563,-0.5 0.04687,-0.609375 0.07813,-0.1875 0.234375,-0.296875 0.453125,-0.296875 0.1875,0 0.375,0.03125 0.65625,0.140625 v -0.734375 c -0.28125,-0.109375 -0.546875,-0.15625 -0.8125,-0.15625 -0.4375,0 -0.796875,0.171875 -1,0.484375 -0.15625,0.234375 -0.203125,0.515625 -0.203125,1.09375 v 0.265625 h -0.578125 V -3.5 h 0.578125 V 0 h 0.875 v -3.5 h 1 v -0.671875 z m 1.71875,0 V 0 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.34375,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 M -22.211,-4.171875 V 0 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -2.30936,1.796875 0.01563,-1.203125 h -0.828125 l -0.03125,1.203125 h -0.65625 L -25.58286,-3.5 h 0.640625 l -0.04687,1.859375 c -0.01563,0.421875 -0.01563,0.421875 -0.01563,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 l 0.01563,-0.734375 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -24.08286,-3.5 h 0.921875 v -0.671875 z m 0,0 m -4.463075,0 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V 0 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.046875 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 m -0.90878,2.265625 c 0.01563,-0.078125 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -1.62375,-1.546875 c -0.109375,-1.203125 -0.828125,-1.875 -2,-1.875 -0.609375,0 -1.1875,0.21875 -1.609375,0.609375 -0.59375,0.53125 -0.90625,1.390625 -0.90625,2.4375 0,1.84375 1,3.03125 2.546875,3.03125 1.25,0 1.96875,-0.78125 2.0625,-2.203125 h -0.828125 c -0.09375,0.9375 -0.515625,1.40625 -1.265625,1.40625 -0.96875,0 -1.5625,-0.859375 -1.5625,-2.234375 0,-1.390625 0.59375,-2.265625 1.546875,-2.265625 0.65625,0 1.078125,0.375 1.21875,1.09375 z m 0,0 m 30.648015,-9.419375 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 0,-0.296875 -0.078125,-0.53125 -0.234375,-0.734375 -0.1875,-0.1875 -0.453125,-0.328125 -1.09375,-0.515625 -0.84375,-0.234375 -0.984375,-0.328125 -0.984375,-0.640625 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 m -4.07441,0 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 0,-0.296875 -0.078125,-0.53125 -0.234375,-0.734375 -0.1875,-0.1875 -0.453125,-0.328125 -1.09375,-0.515625 -0.84375,-0.234375 -0.984375,-0.328125 -0.984375,-0.640625 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 m -4.00253,1.046875 c 0.01563,-0.07813 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.04687 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -3.787075,-1.625 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V -10.56 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.04687 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 m -4.59271,5.90625 h 0.859375 v -2.25 c 0.328125,0.4375 0.65625,0.609375 1.15625,0.609375 0.984375,0 1.671875,-0.90625 1.671875,-2.203125 0,-1.296875 -0.6875,-2.171875 -1.703125,-2.171875 -0.53125,0 -0.890625,0.203125 -1.171875,0.640625 0,-0.1875 -0.03125,-0.40625 -0.07813,-0.53125 h -0.8125 c 0.0625,0.28125 0.07813,0.546875 0.07813,1.28125 z m 1.84375,-5.28125 c 0.59375,0 0.953125,0.5625 0.953125,1.453125 0,0.921875 -0.359375,1.453125 -0.953125,1.453125 -0.609375,0 -1,-0.578125 -1,-1.4375 0,-0.890625 0.390625,-1.46875 1,-1.46875 z m 0,0 m -6.396765,-0.625 1.328125,1.953125 -1.53125,2.21875 h 1.046875 l 1,-1.546875 1,1.546875 h 1.046875 l -1.515625,-2.21875 1.328125,-1.953125 h -1.03125 l -0.828125,1.3125 -0.8125,-1.3125 z m 0,0 m -3.16977,0.734375 v -1.640625 h 2.5625 V -16.435 h -3.46875 v 5.875 h 3.546875 v -0.78125 h -2.640625 v -1.859375 h 2.359375 V -13.9975 Z m 0,0"
                  />
                </g>
              </g>
            ) : (
              <g
                style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
                id="g5478"
              >
                <g id="use5476" transform="translate(338.60913,339.69809)">
                  <path
                    id="path19986"
                    style={{ stroke: 'none' }}
                    d="m 4.0625,-1.90625 c 0.015625,-0.078125 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 C 3.15625,0.109375 3.75,-0.3125 3.96875,-1.09375 L 3.203125,-1.140625 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z M 1.234375,-2.546875 C 1.375,-3.25 1.703125,-3.59375 2.25,-3.59375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -2.40314,-1.625 L -1.15314,-5.375 h -0.828125 l -0.03125,1.203125 h -0.65625 L -2.68439,-3.5 h 0.640625 l -0.046875,1.859375 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L -0.15314,-0.8125 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -1.18439,-3.5 h 0.921875 v -0.671875 z m 0,0 M -5.899745,-3 c 0.078125,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.015625,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 m -4.086425,-2.375 L -10.07992,-2.25 -8.42367,0 h 1.15625 l -1.78125,-2.265625 1.65625,-1.90625 z M -10.95492,-5.90625 V 0 h 0.859375 v -5.90625 z m 0,0 m -3.842905,1.734375 v -0.1875 c 0,-0.328125 0.01563,-0.5 0.04687,-0.609375 0.07813,-0.1875 0.234375,-0.296875 0.453125,-0.296875 0.1875,0 0.375,0.03125 0.65625,0.140625 v -0.734375 c -0.28125,-0.109375 -0.546875,-0.15625 -0.8125,-0.15625 -0.4375,0 -0.796875,0.171875 -1,0.484375 -0.15625,0.234375 -0.203125,0.515625 -0.203125,1.09375 v 0.265625 h -0.578125 V -3.5 H -15.6572 V 0 h 0.875 v -3.5 h 1 v -0.671875 z m 1.71875,0 V 0 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.34375,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -5.25457,1.796875 V 0 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -2.30936,1.796875 0.01563,-1.203125 h -0.828125 l -0.03125,1.203125 h -0.65625 L -21.25238,-3.5 h 0.640625 l -0.04687,1.859375 c -0.01563,0.421875 -0.01563,0.421875 -0.01563,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 l 0.01563,-0.734375 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -19.75238,-3.5 h 0.921875 v -0.671875 z m 0,0 m -4.463075,0 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V 0 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.046875 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 m -0.90881,2.265625 c 0.01563,-0.078125 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 M -33.091615,-5.875 v 0.765625 h 2.59375 l -2.8125,4.390625 V 0 h 3.84375 v -0.78125 h -2.78125 l 2.859375,-4.453125 V -5.875 Z m 0,0 m 31.882475,-7.21625 v 0.640625 h 2.34375 v -0.640625 z m 0,0 m -0.41815,-0.421875 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 0,-0.296875 -0.078125,-0.53125 -0.234375,-0.734375 -0.1875,-0.1875 -0.453125,-0.328125 -1.09375,-0.515625 -0.84375,-0.234375 -0.984375,-0.328125 -0.984375,-0.640625 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 m -4.0744,0 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 0,-0.296875 -0.078125,-0.53125 -0.234375,-0.734375 -0.1875,-0.1875 -0.453125,-0.328125 -1.09375,-0.515625 -0.84375,-0.234375 -0.984375,-0.328125 -0.984375,-0.640625 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 m -4.00253,1.046875 c 0.015625,-0.07813 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.04687 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -3.787085,-1.625 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V -10.56 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.04687 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 m -4.59271,5.90625 h 0.859375 v -2.25 c 0.328125,0.4375 0.65625,0.609375 1.15625,0.609375 0.984375,0 1.671875,-0.90625 1.671875,-2.203125 0,-1.296875 -0.6875,-2.171875 -1.703125,-2.171875 -0.53125,0 -0.890625,0.203125 -1.171875,0.640625 0,-0.1875 -0.03125,-0.40625 -0.07813,-0.53125 h -0.8125 c 0.0625,0.28125 0.07813,0.546875 0.07813,1.28125 z m 1.84375,-5.28125 c 0.59375,0 0.953125,0.5625 0.953125,1.453125 0,0.921875 -0.359375,1.453125 -0.953125,1.453125 -0.609375,0 -1,-0.578125 -1,-1.4375 0,-0.890625 0.390625,-1.46875 1,-1.46875 z m 0,0 m -6.396755,-0.625 1.328125,1.953125 -1.53125,2.21875 h 1.046875 l 1,-1.546875 1,1.546875 h 1.046875 l -1.515625,-2.21875 1.328125,-1.953125 h -1.03125 l -0.828125,1.3125 -0.8125,-1.3125 z m 0,0 m -3.16977,0.734375 v -1.640625 h 2.5625 V -16.435 h -3.46875 v 5.875 h 3.546875 v -0.78125 h -2.640625 v -1.859375 h 2.359375 V -13.9975 Z m 0,0"
                  />
                </g>
              </g>
            )}
          </g>
        </g>
        <g
          id="circle-6"
          onMouseEnter={handleCircleMouseEnter}
          onMouseLeave={handleCircleMouseLeave}
          onMouseDown={handleCircleMouseDown}
        >
          <path
            className="circle-color"
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: 'rgb(0%,52.941895%,49.01886%)',
              fillOpacity: 1
            }}
            d="M 388.753906 362.292969 C 405.777344 362.292969 419.578125 348.492188 419.578125 331.464844 C 419.578125 314.441406 405.777344 300.640625 388.753906 300.640625 C 371.726562 300.640625 357.925781 314.441406 357.925781 331.464844 C 357.925781 348.492188 371.726562 362.292969 388.753906 362.292969 "
            id="circle-6-path"
          />
          <g style={{ pointerEvents: 'none' }}>
            {props.lang === 'en' ? (
              <g
                style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
                id="g5510"
              >
                <g id="use5482" transform="translate(391.26031,339.69809)" />
                <g id="use5484" transform="translate(391.26031,339.69809)" />
                <g id="use5486" transform="translate(391.26031,339.69809)" />
                <g id="use5488" transform="translate(391.26031,339.69809)" />
                <g id="use5490" transform="translate(391.26031,339.69809)" />
                <g id="use5492" transform="translate(391.26031,339.69809)" />
                <g id="use5494" transform="translate(391.26031,339.69809)" />
                <g id="use5496" transform="translate(391.26031,339.69809)" />
                <g id="use5498" transform="translate(391.26031,339.69809)" />
                <g id="use5500" transform="translate(394.22589,339.69809)" />
                <g id="use5502" transform="translate(396.3555,339.69809)" />
                <g id="use5504" transform="translate(401.0195,339.69809)" />
                <g id="use5506" transform="translate(403.14911,339.69809)" />
                <g id="use5508" transform="translate(407.55789,339.69809)">
                  <path
                    id="path20061"
                    style={{ stroke: 'none' }}
                    d="m 3.65625,-2.953125 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 C 3.6875,-1.5 3.609375,-1.734375 3.453125,-1.9375 3.265625,-2.125 3,-2.265625 2.359375,-2.453125 1.515625,-2.6875 1.375,-2.78125 1.375,-3.09375 c 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 m -4.00253,1.046875 c 0.015625,-0.078125 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z M -3.174405,-2.546875 C -3.03378,-3.25 -2.705655,-3.59375 -2.15878,-3.59375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 M -5.91339,-5.90625 V 0 h 0.875 v -5.90625 z m 0,0 m -4.679625,0 v 4.765625 c 0,0.734375 0,0.828125 -0.03125,1.140625 h 0.765625 c 0.046875,-0.171875 0.0625,-0.328125 0.078125,-0.578125 0.25,0.46875 0.609375,0.671875 1.125,0.671875 1.046875,0 1.765625,-0.890625 1.765625,-2.1875 0,-1.28125 -0.6875,-2.1875 -1.671875,-2.1875 -0.5,0 -0.828125,0.203125 -1.15625,0.671875 V -5.90625 Z m 1.875,2.375 c 0.578125,0 0.9375,0.546875 0.9375,1.421875 0,0.90625 -0.375,1.46875 -0.984375,1.46875 -0.59375,0 -0.96875,-0.5625 -0.96875,-1.421875 0,-0.90625 0.390625,-1.46875 1.015625,-1.46875 z m 0,0 M -12.707,-4.171875 V 0 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -2.30933,1.796875 0.01563,-1.203125 h -0.828125 l -0.03125,1.203125 h -0.65625 L -16.07883,-3.5 h 0.640625 l -0.04687,1.859375 c -0.01563,0.421875 -0.01563,0.421875 -0.01563,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 l 0.01563,-0.734375 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -14.57883,-3.5 h 0.921875 v -0.671875 z m 0,0 m -4.463095,0 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V 0 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.046875 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 m -0.90879,2.265625 c 0.01563,-0.078125 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -5.118225,-1.625 1.484375,4.203125 h 0.953125 l 1.484375,-4.203125 h -0.90625 l -1.046875,3.234375 -1.0625,-3.234375 z m 0,0 m -4.074915,0 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V 0 h 0.859375 v -2.21875 c 0,-0.40625 0.04687,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.07813,0.171875 0.109375,0.359375 0.109375,0.859375 V 0 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.01563,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -2.80356,-0.125 c -1.125,0 -1.953125,0.921875 -1.953125,2.171875 0,1.328125 0.796875,2.234375 1.953125,2.234375 1.140625,0 1.9375,-0.90625 1.9375,-2.1875 0,-1.296875 -0.796875,-2.21875 -1.9375,-2.21875 z m 0,0.703125 c 0.625,0 1.0625,0.625 1.0625,1.515625 0,0.875 -0.4375,1.484375 -1.0625,1.484375 -0.640625,0 -1.0625,-0.59375 -1.0625,-1.515625 0,-0.875 0.4375,-1.484375 1.0625,-1.484375 z m 0,0 m -2.68625,-0.5 c -0.109375,-1.203125 -0.828125,-1.875 -2,-1.875 -0.609375,0 -1.1875,0.21875 -1.609375,0.609375 -0.59375,0.53125 -0.90625,1.390625 -0.90625,2.4375 0,1.84375 1,3.03125 2.546875,3.03125 1.25,0 1.96875,-0.78125 2.0625,-2.203125 h -0.828125 c -0.09375,0.9375 -0.515625,1.40625 -1.265625,1.40625 -0.96875,0 -1.5625,-0.859375 -1.5625,-2.234375 0,-1.390625 0.59375,-2.265625 1.546875,-2.265625 0.65625,0 1.078125,0.375 1.21875,1.09375 z m 0,0 m 32.603085,-8.3725 c 0.015625,-0.07813 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.04687 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -1.652525,-0.40625 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 0,-0.296875 -0.078125,-0.53125 -0.234375,-0.734375 -0.1875,-0.1875 -0.453125,-0.328125 -1.09375,-0.515625 -0.84375,-0.234375 -0.984375,-0.328125 -0.984375,-0.640625 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 m -6.22656,-1.21875 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V -10.56 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.04687 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 m -0.90881,2.265625 c 0.01563,-0.07813 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.04687 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -5.118225,-1.625 1.484375,4.203125 h 0.953125 l 1.484375,-4.203125 h -0.90625 l -1.046875,3.234375 -1.0625,-3.234375 z m 0,0 m -0.29923,2.265625 c 0.01563,-0.07813 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.04687 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -5.49841,-3.328125 v 5.875 h 0.90625 v -2.359375 h 0.90625 L -29.89059,-10.56 h 1.0625 l -1.4375,-2.5 c 0.734375,-0.3125 1.125,-0.859375 1.125,-1.625 0,-0.671875 -0.34375,-1.234375 -0.890625,-1.5 -0.40625,-0.1875 -0.765625,-0.25 -1.75,-0.25 z m 0.90625,2.734375 v -1.9375 h 0.359375 c 0.78125,0 0.96875,0.01563 1.21875,0.140625 0.296875,0.140625 0.453125,0.4375 0.453125,0.796875 0,0.4375 -0.203125,0.765625 -0.5625,0.890625 -0.234375,0.09375 -0.4375,0.109375 -1.0625,0.109375 z m 0,0"
                  />
                </g>
              </g>
            ) : (
              <g
                style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
                id="g5510"
              >
                <g id="use5482" transform="translate(360.84799,334.41809)" />
                <g id="use5484" transform="translate(365.996,334.41809)" />
                <g id="use5486" transform="translate(370.4928,334.41809)" />
                <g id="use5488" transform="translate(373.4584,334.41809)" />
                <g id="use5490" transform="translate(375.58801,334.41809)" />
                <g id="use5492" transform="translate(379.9968,334.41809)" />
                <g id="use5494" transform="translate(384.6344,334.41809)" />
                <g id="use5496" transform="translate(388.99039,334.41809)" />
                <g id="use5498" transform="translate(393.62799,334.41809)" />
                <g id="use5500" transform="translate(395.7576,334.41809)" />
                <g id="use5502" transform="translate(400.16641,334.41809)" />
                <g id="use5504" transform="translate(402.29599,334.41809)" />
                <g id="use5506" transform="translate(406.95999,334.41809)" />
                <g id="use5508" transform="translate(411.3688,334.41809)">
                  <path
                    id="path20061"
                    style={{ stroke: 'none' }}
                    d="M 0.515625,-4.171875 C 0.625,-3.78125 0.625,-3.734375 0.625,-2.71875 V 0 h 0.859375 v -2.21875 c 0,-0.40625 0.046875,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 C 3.15625,-2.953125 3.1875,-2.765625 3.1875,-2.265625 V 0 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 C 3.671875,-4.03125 3.234375,-4.28125 2.6875,-4.28125 c -0.546875,0 -0.96875,0.21875 -1.25,0.671875 C 1.421875,-3.875 1.40625,-4.015625 1.34375,-4.171875 Z m 0,0 M -0.34631,-1.90625 c 0.015625,-0.078125 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z M -3.174435,-2.546875 C -3.03381,-3.25 -2.705685,-3.59375 -2.15881,-3.59375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 M -8.44781,-5.90625 V 0 h 0.859375 v -2.21875 c 0,-0.375 0.046875,-0.625 0.15625,-0.828125 0.15625,-0.28125 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.671875,0.390625 0.09375,0.171875 0.109375,0.40625 0.109375,0.859375 V 0 h 0.875 v -2.40625 c 0,-0.765625 -0.046875,-1.046875 -0.21875,-1.3125 -0.21875,-0.34375 -0.671875,-0.5625 -1.171875,-0.5625 -0.5,0 -0.890625,0.1875 -1.203125,0.578125 V -5.90625 Z m 0,0 m -2.12958,1.734375 V 0 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -1.424435,4.0625 c 0.01563,-0.078125 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 C -14.2362,-3.25 -13.908075,-3.59375 -13.3612,-3.59375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 M -17.11581,-5.90625 V 0 h 0.875 v -5.90625 z m 0,0 m -4.746975,1.734375 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V 0 h 0.859375 v -2.21875 c 0,-0.40625 0.04687,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.07813,0.171875 0.109375,0.359375 0.109375,0.859375 V 0 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.01563,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 M -25.375025,-3 c 0.07813,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.01563,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 m -7.028225,-2.375 C -30.747,-3.78125 -30.747,-3.734375 -30.747,-2.71875 V 0 h 0.859375 v -2.21875 c 0,-0.40625 0.04687,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.07813,0.171875 0.109375,0.359375 0.109375,0.859375 V 0 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.01563,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -0.861915,2.265625 c 0.01563,-0.078125 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -2.738985,-1.625 V 0 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -2.30935,1.796875 L -39.126,-5.375 h -0.828125 l -0.03125,1.203125 h -0.65625 L -40.65725,-3.5 h 0.640625 l -0.04687,1.859375 c -0.01563,0.421875 -0.01563,0.421875 -0.01563,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L -38.126,-0.8125 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -39.15725,-3.5 h 0.921875 v -0.671875 z m 0,0 m -3.09055,0 L -43.8728,-2.25 -42.21655,0 h 1.15625 l -1.78125,-2.265625 1.65625,-1.90625 z M -44.7478,-5.90625 V 0 h 0.859375 v -5.90625 z m 0,0 m -3.64801,0.015625 -2,5.890625 h 0.9375 l 0.4375,-1.375 h 2.140625 l 0.4375,1.375 h 0.9375 l -2,-5.890625 z m 1.28125,3.734375 h -1.671875 l 0.828125,-2.640625 z m 0,0"
                  />
                </g>
              </g>
            )}
          </g>
        </g>
        <g
          id="circle-7"
          onMouseEnter={handleCircleMouseEnter}
          onMouseLeave={handleCircleMouseLeave}
          onMouseDown={handleCircleMouseDown}
        >
          <path
            className="circle-color"
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: 'rgb(0%,52.941895%,49.01886%)',
              fillOpacity: 1
            }}
            d="M 453.136719 362.292969 C 470.164062 362.292969 483.964844 348.492188 483.964844 331.464844 C 483.964844 314.441406 470.164062 300.640625 453.136719 300.640625 C 436.113281 300.640625 422.3125 314.441406 422.3125 331.464844 C 422.3125 348.492188 436.113281 362.292969 453.136719 362.292969 "
            id="circle-7-path"
          />
          <g style={{ pointerEvents: 'none' }}>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5532"
            >
              <g id="use5514" transform="translate(435.19461,329.13809)" />
              <g id="use5516" transform="translate(440.8002,329.13809)" />
              <g id="use5518" transform="translate(442.92981,329.13809)" />
              <g id="use5520" transform="translate(447.00421,329.13809)" />
              <g id="use5522" transform="translate(451.24579,329.13809)" />
              <g id="use5524" transform="translate(455.8306,329.13809)" />
              <g id="use5526" transform="translate(460.47699,329.13809)" />
              <g id="use5528" transform="translate(465.11459,329.13809)" />
              <g id="use5530" transform="translate(468.0802,329.13809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5536"
            >
              <use x="470.4293" y="329.1381" id="use5534" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5544"
            >
              <g id="use5538" transform="translate(433.83511,339.69809)" />
              <g id="use5540" transform="translate(438.20871,339.69809)" />
              <g id="use5542" transform="translate(442.61749,339.69809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5554"
            >
              <g id="use5546" transform="translate(445.90869,339.69809)" />
              <g id="use5548" transform="translate(448.8743,339.69809)" />
              <g id="use5550" transform="translate(451.00391,339.69809)" />
              <g id="use5552" transform="translate(455.7999,339.69809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5560"
            >
              <g id="use5556" transform="translate(460.1207,339.69809)" />
              <g id="use5558" transform="translate(464.47672,339.69809)" />
            </g>
            {props.lang === 'en' ? (
              <g
                style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
                id="g5564"
              >
                <g id="use5562" transform="translate(470.1702,339.69809)">
                  <path
                    id="path20156"
                    style={{ stroke: 'none' }}
                    d="m 3.65625,-2.953125 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 C 3.6875,-1.5 3.609375,-1.734375 3.453125,-1.9375 3.265625,-2.125 3,-2.265625 2.359375,-2.453125 1.515625,-2.6875 1.375,-2.78125 1.375,-3.09375 c 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 m -4.00254,1.046875 c 0.015625,-0.078125 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z M -3.174415,-2.546875 C -3.03379,-3.25 -2.705665,-3.59375 -2.15879,-3.59375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -2.40402,-1.625 L -5.56281,-5.375 h -0.828125 l -0.03125,1.203125 h -0.65625 L -7.09406,-3.5 h 0.640625 l -0.046875,1.859375 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L -4.56281,-0.8125 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -5.59406,-3.5 h 0.921875 v -0.671875 z m 0,0 M -10.309425,-3 c 0.07813,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.015625,0.328125 0.0625,0.515625 H -7.7938 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 m -3.27285,-1 c -0.125,-0.96875 -0.6875,-1.5 -1.625,-1.5 -1.15625,0 -1.90625,0.875 -1.90625,2.21875 0,1.3125 0.75,2.1875 1.90625,2.1875 0.953125,0 1.578125,-0.59375 1.640625,-1.5625 h -0.84375 c -0.0625,0.59375 -0.3125,0.859375 -0.796875,0.859375 -0.640625,0 -1.015625,-0.546875 -1.015625,-1.484375 0,-0.921875 0.390625,-1.515625 1,-1.515625 0.453125,0 0.6875,0.234375 0.78125,0.796875 z m 0,0 m -7.092865,-1.375 v -0.1875 c 0,-0.328125 0.01563,-0.5 0.04687,-0.609375 0.07813,-0.1875 0.234375,-0.296875 0.453125,-0.296875 0.1875,0 0.375,0.03125 0.65625,0.140625 v -0.734375 c -0.28125,-0.109375 -0.546875,-0.15625 -0.8125,-0.15625 -0.4375,0 -0.796875,0.171875 -1,0.484375 -0.15625,0.234375 -0.203125,0.515625 -0.203125,1.09375 v 0.265625 h -0.578125 V -3.5 h 0.578125 V 0 h 0.875 v -3.5 h 1 v -0.671875 z m 1.71875,0 V 0 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.34375,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 M -22.211,-4.171875 V 0 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -2.30936,1.796875 0.01563,-1.203125 h -0.828125 l -0.03125,1.203125 h -0.65625 L -25.58286,-3.5 h 0.640625 l -0.04687,1.859375 c -0.01563,0.421875 -0.01563,0.421875 -0.01563,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 l 0.01563,-0.734375 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -24.08286,-3.5 h 0.921875 v -0.671875 z m 0,0 m -4.463075,0 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V 0 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.046875 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 m -0.90878,2.265625 c 0.01563,-0.078125 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -1.62375,-1.546875 c -0.109375,-1.203125 -0.828125,-1.875 -2,-1.875 -0.609375,0 -1.1875,0.21875 -1.609375,0.609375 -0.59375,0.53125 -0.90625,1.390625 -0.90625,2.4375 0,1.84375 1,3.03125 2.546875,3.03125 1.25,0 1.96875,-0.78125 2.0625,-2.203125 h -0.828125 c -0.09375,0.9375 -0.515625,1.40625 -1.265625,1.40625 -0.96875,0 -1.5625,-0.859375 -1.5625,-2.234375 0,-1.390625 0.59375,-2.265625 1.546875,-2.265625 0.65625,0 1.078125,0.375 1.21875,1.09375 z m 0,0 M -2.146425,-14.731875 -2.1308,-15.935 h -0.828125 l -0.03125,1.203125 h -0.65625 L -3.66205,-14.06 h 0.640625 l -0.046875,1.859375 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L -1.1308,-11.3725 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -2.16205,-14.06 h 0.921875 v -0.671875 z m 0,0 m -5.85636,0 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V -10.56 h 0.859375 v -2.21875 c 0,-0.40625 0.046875,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.078125,0.171875 0.109375,0.359375 0.109375,0.859375 V -10.56 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.015625,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -4.568265,0 v 2.484375 c 0,0.5625 0.0625,0.90625 0.21875,1.15625 0.25,0.390625 0.703125,0.625 1.25,0.625 0.53125,0 0.859375,-0.1875 1.140625,-0.609375 C -9.94605,-10.8725 -9.9148,-10.685 -9.867925,-10.56 H -9.0398 c -0.109375,-0.34375 -0.109375,-0.34375 -0.109375,-1.28125 v -2.890625 H -10.00855 V -12.435 c 0,0.359375 -0.04687,0.59375 -0.140625,0.78125 -0.171875,0.28125 -0.4375,0.421875 -0.765625,0.421875 -0.28125,0 -0.515625,-0.109375 -0.65625,-0.28125 -0.09375,-0.140625 -0.140625,-0.390625 -0.140625,-0.765625 v -2.453125 z m 0,0 m -2.881685,-0.125 c -1.125,0 -1.953125,0.921875 -1.953125,2.171875 0,1.328125 0.796875,2.234375 1.953125,2.234375 1.140625,0 1.9375,-0.90625 1.9375,-2.1875 0,-1.296875 -0.796875,-2.21875 -1.9375,-2.21875 z m 0,0.703125 c 0.625,0 1.0625,0.625 1.0625,1.515625 0,0.875 -0.4375,1.484375 -1.0625,1.484375 -0.640625,0 -1.0625,-0.59375 -1.0625,-1.515625 0,-0.875 0.4375,-1.484375 1.0625,-1.484375 z m 0,0 m -2.663475,0.796875 c -0.125,-0.96875 -0.6875,-1.5 -1.625,-1.5 -1.15625,0 -1.90625,0.875 -1.90625,2.21875 0,1.3125 0.75,2.1875 1.90625,2.1875 0.953125,0 1.578125,-0.59375 1.640625,-1.5625 h -0.84375 c -0.0625,0.59375 -0.3125,0.859375 -0.796875,0.859375 -0.640625,0 -1.015625,-0.546875 -1.015625,-1.484375 0,-0.921875 0.390625,-1.515625 1,-1.515625 0.453125,0 0.6875,0.234375 0.78125,0.796875 z m 0,0 m -4.29313,-0.15625 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 0,-0.296875 -0.07813,-0.53125 -0.234375,-0.734375 -0.1875,-0.1875 -0.453125,-0.328125 -1.09375,-0.515625 -0.84375,-0.234375 -0.984375,-0.328125 -0.984375,-0.640625 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 m -5.16085,-1.21875 V -10.56 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -5.94938,0.09375 v 5.875 h 1.0625 c 1.21875,0 1.625,-0.0625 2.125,-0.34375 0.8125,-0.453125 1.296875,-1.4375 1.296875,-2.59375 0,-1.15625 -0.515625,-2.171875 -1.359375,-2.609375 -0.453125,-0.234375 -0.953125,-0.328125 -1.9375,-0.328125 z m 0.90625,5.09375 v -4.296875 h 0.25 c 0.953125,0 1.203125,0.03125 1.5625,0.25 0.53125,0.328125 0.828125,1.015625 0.828125,1.890625 0,0.859375 -0.28125,1.546875 -0.765625,1.875 -0.34375,0.21875 -0.640625,0.28125 -1.40625,0.28125 z m 0,0"
                  />
                </g>
              </g>
            ) : (
              <g
                style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
                id="g5564"
              >
                <g id="use5562" transform="translate(467.38071,339.69809)">
                  <path
                    id="path20156"
                    style={{ stroke: 'none' }}
                    d="m 4.0625,-1.90625 c 0.015625,-0.078125 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 C 3.15625,0.109375 3.75,-0.3125 3.96875,-1.09375 L 3.203125,-1.140625 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z M 1.234375,-2.546875 C 1.375,-3.25 1.703125,-3.59375 2.25,-3.59375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -2.40399,-1.625 L -1.15399,-5.375 h -0.828125 l -0.03125,1.203125 h -0.65625 L -2.68524,-3.5 h 0.640625 l -0.046875,1.859375 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L -0.15399,-0.8125 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -1.18524,-3.5 h 0.921875 v -0.671875 z m 0,0 M -5.900635,-3 c 0.078125,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.015625,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 m -4.086425,-2.375 L -10.08081,-2.25 -8.42456,0 h 1.15625 l -1.78125,-2.265625 1.65625,-1.90625 z M -10.95581,-5.90625 V 0 h 0.859375 v -5.90625 z m 0,0 m -3.842865,1.734375 v -0.1875 c 0,-0.328125 0.01563,-0.5 0.04687,-0.609375 0.07813,-0.1875 0.234375,-0.296875 0.453125,-0.296875 0.1875,0 0.375,0.03125 0.65625,0.140625 v -0.734375 c -0.28125,-0.109375 -0.546875,-0.15625 -0.8125,-0.15625 -0.4375,0 -0.796875,0.171875 -1,0.484375 -0.15625,0.234375 -0.203125,0.515625 -0.203125,1.09375 v 0.265625 h -0.578125 V -3.5 h 0.578125 V 0 h 0.875 v -3.5 h 1 v -0.671875 z m 1.71875,0 V 0 h 0.875 V -4.171875 Z M -12.6268,-5.96875 c -0.34375,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -5.25461,1.796875 V 0 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -2.30936,1.796875 0.01563,-1.203125 h -0.828125 l -0.03125,1.203125 h -0.65625 L -21.25327,-3.5 h 0.640625 l -0.04687,1.859375 c -0.01563,0.421875 -0.01563,0.421875 -0.01563,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 l 0.01563,-0.734375 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -19.75327,-3.5 h 0.921875 v -0.671875 z m 0,0 m -4.463075,0 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V 0 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.046875 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 m -0.90878,2.265625 c 0.01563,-0.078125 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 C -27.797,-3.25 -27.468875,-3.59375 -26.922,-3.59375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 M -33.092475,-5.875 v 0.765625 h 2.59375 l -2.8125,4.390625 V 0 h 3.84375 v -0.78125 h -2.78125 l 2.859375,-4.453125 V -5.875 Z m 0,0 M 0.69949,-13.09125 v 0.640625 h 2.34375 v -0.640625 z m 0,0 M -0.531745,-14.731875 -0.51612,-15.935 h -0.828125 l -0.03125,1.203125 h -0.65625 L -2.04737,-14.06 h 0.640625 l -0.046875,1.859375 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L 0.48388,-11.3725 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -0.54737,-14.06 h 0.921875 v -0.671875 z m 0,0 m -5.85635,0 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V -10.56 h 0.859375 v -2.21875 c 0,-0.40625 0.046875,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.078125,0.171875 0.109375,0.359375 0.109375,0.859375 V -10.56 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.015625,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -4.568265,0 v 2.484375 c 0,0.5625 0.0625,0.90625 0.21875,1.15625 0.25,0.390625 0.703125,0.625 1.25,0.625 0.53125,0 0.859375,-0.1875 1.140625,-0.609375 0.015625,0.203125 0.046875,0.390625 0.09375,0.515625 h 0.828125 c -0.109375,-0.34375 -0.109375,-0.34375 -0.109375,-1.28125 v -2.890625 H -8.39386 V -12.435 c 0,0.359375 -0.046875,0.59375 -0.140625,0.78125 -0.171875,0.28125 -0.4375,0.421875 -0.765625,0.421875 -0.28125,0 -0.515625,-0.109375 -0.65625,-0.28125 -0.09375,-0.140625 -0.140625,-0.390625 -0.140625,-0.765625 v -2.453125 z m 0,0 m -2.881685,-0.125 c -1.125,0 -1.953125,0.921875 -1.953125,2.171875 0,1.328125 0.796875,2.234375 1.953125,2.234375 1.140625,0 1.9375,-0.90625 1.9375,-2.1875 0,-1.296875 -0.796875,-2.21875 -1.9375,-2.21875 z m 0,0.703125 c 0.625,0 1.0625,0.625 1.0625,1.515625 0,0.875 -0.4375,1.484375 -1.0625,1.484375 -0.640625,0 -1.0625,-0.59375 -1.0625,-1.515625 0,-0.875 0.4375,-1.484375 1.0625,-1.484375 z m 0,0 m -2.663455,0.796875 c -0.125,-0.96875 -0.6875,-1.5 -1.625,-1.5 -1.15625,0 -1.90625,0.875 -1.90625,2.21875 0,1.3125 0.75,2.1875 1.90625,2.1875 0.953125,0 1.578125,-0.59375 1.640625,-1.5625 h -0.84375 c -0.0625,0.59375 -0.3125,0.859375 -0.796875,0.859375 -0.640625,0 -1.015625,-0.546875 -1.015625,-1.484375 0,-0.921875 0.390625,-1.515625 1,-1.515625 0.453125,0 0.6875,0.234375 0.78125,0.796875 z m 0,0 m -4.29315,-0.15625 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 0,-0.296875 -0.07813,-0.53125 -0.234375,-0.734375 -0.1875,-0.1875 -0.453125,-0.328125 -1.09375,-0.515625 -0.84375,-0.234375 -0.984375,-0.328125 -0.984375,-0.640625 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 m -5.16086,-1.21875 V -10.56 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -5.94934,0.09375 v 5.875 h 1.0625 c 1.21875,0 1.625,-0.0625 2.125,-0.34375 0.8125,-0.453125 1.296875,-1.4375 1.296875,-2.59375 0,-1.15625 -0.515625,-2.171875 -1.359375,-2.609375 -0.453125,-0.234375 -0.953125,-0.328125 -1.9375,-0.328125 z m 0.90625,5.09375 v -4.296875 h 0.25 c 0.953125,0 1.203125,0.03125 1.5625,0.25 0.53125,0.328125 0.828125,1.015625 0.828125,1.890625 0,0.859375 -0.28125,1.546875 -0.765625,1.875 -0.34375,0.21875 -0.640625,0.28125 -1.40625,0.28125 z m 0,0"
                  />
                </g>
              </g>
            )}
          </g>
        </g>
        <g
          id="circle-8"
          onMouseEnter={handleCircleMouseEnter}
          onMouseLeave={handleCircleMouseLeave}
          onMouseDown={handleCircleMouseDown}
        >
          <path
            className="circle-color"
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: 'rgb(0%,52.941895%,49.01886%)',
              fillOpacity: 1
            }}
            d="M 517.523438 362.292969 C 534.546875 362.292969 548.347656 348.492188 548.347656 331.464844 C 548.347656 314.441406 534.546875 300.640625 517.523438 300.640625 C 500.496094 300.640625 486.695312 314.441406 486.695312 331.464844 C 486.695312 348.492188 500.496094 362.292969 517.523438 362.292969 "
            id="circle-8-path"
          />
          <g style={{ pointerEvents: 'none' }}>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5580"
            >
              <g id="use5568" transform="translate(504.543,329.13809)" />
              <g id="use5570" transform="translate(509.55899,329.13809)" />
              <g id="use5572" transform="translate(514.1438,329.13809)" />
              <g id="use5574" transform="translate(518.78137,329.13809)" />
              <g id="use5576" transform="translate(523.4278,329.13809)" />
              <g id="use5578" transform="translate(527.5022,329.13809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5584"
            >
              <use x="529.8516" y="329.1381" id="use5582" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5592"
            >
              <g id="use5586" transform="translate(498.2204,339.69809)" />
              <g id="use5588" transform="translate(502.59399,339.69809)" />
              <g id="use5590" transform="translate(507.00281,339.69809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5602"
            >
              <g id="use5594" transform="translate(510.29401,339.69809)" />
              <g id="use5596" transform="translate(513.25958,339.69809)" />
              <g id="use5598" transform="translate(515.38922,339.69809)" />
              <g id="use5600" transform="translate(520.18518,339.69809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5608"
            >
              <g id="use5604" transform="translate(524.50598,339.69809)" />
              <g id="use5606" transform="translate(528.862,339.69809)" />
            </g>
            {props.lang === 'en' ? (
              <g
                style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
                id="g5614"
              >
                <g id="use5610" transform="translate(530.14648,339.69809)" />
                <g id="use5612" transform="translate(534.5553,339.69809)">
                  <path
                    id="path20243"
                    style={{ stroke: 'none' }}
                    d="m 3.65625,-2.953125 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 C 3.6875,-1.5 3.609375,-1.734375 3.453125,-1.9375 3.265625,-2.125 3,-2.265625 2.359375,-2.453125 1.515625,-2.6875 1.375,-2.78125 1.375,-3.09375 c 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 m -4.00257,1.046875 c 0.015625,-0.078125 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z M -3.174445,-2.546875 C -3.03382,-3.25 -2.705695,-3.59375 -2.15882,-3.59375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -2.40399,-1.625 L -5.56281,-5.375 h -0.828125 l -0.03125,1.203125 h -0.65625 L -7.09406,-3.5 h 0.640625 l -0.046875,1.859375 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L -4.56281,-0.8125 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -5.59406,-3.5 h 0.921875 v -0.671875 z m 0,0 M -10.309455,-3 c 0.07813,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.015625,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 m -3.27282,-1 c -0.125,-0.96875 -0.6875,-1.5 -1.625,-1.5 -1.15625,0 -1.90625,0.875 -1.90625,2.21875 0,1.3125 0.75,2.1875 1.90625,2.1875 0.953125,0 1.578125,-0.59375 1.640625,-1.5625 h -0.84375 c -0.0625,0.59375 -0.3125,0.859375 -0.796875,0.859375 -0.640625,0 -1.015625,-0.546875 -1.015625,-1.484375 0,-0.921875 0.390625,-1.515625 1,-1.515625 0.453125,0 0.6875,0.234375 0.78125,0.796875 z m 0,0 m -7.092895,-1.375 v -0.1875 c 0,-0.328125 0.01563,-0.5 0.04687,-0.609375 0.07813,-0.1875 0.234375,-0.296875 0.453125,-0.296875 0.1875,0 0.375,0.03125 0.65625,0.140625 v -0.734375 c -0.28125,-0.109375 -0.546875,-0.15625 -0.8125,-0.15625 -0.4375,0 -0.796875,0.171875 -1,0.484375 -0.15625,0.234375 -0.203125,0.515625 -0.203125,1.09375 v 0.265625 h -0.578125 V -3.5 h 0.578125 V 0 h 0.875 v -3.5 h 1 v -0.671875 z m 1.71875,0 V 0 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.34375,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 M -22.211,-4.171875 V 0 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -2.30936,1.796875 0.01563,-1.203125 h -0.828125 l -0.03125,1.203125 h -0.65625 L -25.58286,-3.5 h 0.640625 l -0.04687,1.859375 c -0.01563,0.421875 -0.01563,0.421875 -0.01563,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 l 0.01563,-0.734375 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -24.08286,-3.5 h 0.921875 v -0.671875 z m 0,0 m -4.463075,0 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V 0 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.046875 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 m -0.90878,2.265625 c 0.01563,-0.078125 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -1.62375,-1.546875 c -0.109375,-1.203125 -0.828125,-1.875 -2,-1.875 -0.609375,0 -1.1875,0.21875 -1.609375,0.609375 -0.59375,0.53125 -0.90625,1.390625 -0.90625,2.4375 0,1.84375 1,3.03125 2.546875,3.03125 1.25,0 1.96875,-0.78125 2.0625,-2.203125 h -0.828125 c -0.09375,0.9375 -0.515625,1.40625 -1.265625,1.40625 -0.96875,0 -1.5625,-0.859375 -1.5625,-2.234375 0,-1.390625 0.59375,-2.265625 1.546875,-2.265625 0.65625,0 1.078125,0.375 1.21875,1.09375 z m 0,0 m 27.594395,-9.419375 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 0,-0.296875 -0.078125,-0.53125 -0.234375,-0.734375 -0.1875,-0.1875 -0.453125,-0.328125 -1.09375,-0.515625 -0.84375,-0.234375 -0.984375,-0.328125 -0.984375,-0.640625 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 m -7.70886,-1.21875 v 2.484375 c 0,0.5625 0.0625,0.90625 0.21875,1.15625 0.25,0.390625 0.703125,0.625 1.25,0.625 0.53125,0 0.859375,-0.1875 1.140625,-0.609375 0.01563,0.203125 0.04687,0.390625 0.09375,0.515625 h 0.828125 c -0.109375,-0.34375 -0.109375,-0.34375 -0.109375,-1.28125 v -2.890625 H -11.44293 V -12.435 c 0,0.359375 -0.04687,0.59375 -0.140625,0.78125 -0.171875,0.28125 -0.4375,0.421875 -0.765625,0.421875 -0.28125,0 -0.515625,-0.109375 -0.65625,-0.28125 -0.09375,-0.140625 -0.140625,-0.390625 -0.140625,-0.765625 v -2.453125 z m 0,0 m -4.715765,0 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V -10.56 h 0.859375 v -2.21875 c 0,-0.40625 0.04687,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.07813,0.171875 0.109375,0.359375 0.109375,0.859375 V -10.56 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.01563,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -2.80353,-0.125 c -1.125,0 -1.953125,0.921875 -1.953125,2.171875 0,1.328125 0.796875,2.234375 1.953125,2.234375 1.140625,0 1.9375,-0.90625 1.9375,-2.1875 0,-1.296875 -0.796875,-2.21875 -1.9375,-2.21875 z m 0,0.703125 c 0.625,0 1.0625,0.625 1.0625,1.515625 0,0.875 -0.4375,1.484375 -1.0625,1.484375 -0.640625,0 -1.0625,-0.59375 -1.0625,-1.515625 0,-0.875 0.4375,-1.484375 1.0625,-1.484375 z m 0,0 m -6.57849,-2.28125 v 5.875 h 1.203125 c 1.03125,0 1.3125,-0.03125 1.71875,-0.15625 0.625,-0.203125 1.03125,-0.796875 1.03125,-1.5 0,-0.796875 -0.40625,-1.265625 -1.28125,-1.46875 0.671875,-0.21875 0.96875,-0.609375 0.96875,-1.28125 0,-0.625 -0.34375,-1.125 -0.90625,-1.328125 -0.328125,-0.09375 -0.65625,-0.140625 -1.40625,-0.140625 z m 0.890625,2.453125 V -15.685 h 0.453125 c 0.546875,0 0.765625,0.03125 0.96875,0.109375 0.265625,0.109375 0.421875,0.390625 0.421875,0.71875 0,0.34375 -0.140625,0.609375 -0.390625,0.734375 -0.203125,0.109375 -0.46875,0.140625 -0.9375,0.140625 z m 0,2.671875 v -1.9375 h 0.5625 c 0.5625,0 0.78125,0.01563 1.015625,0.09375 0.34375,0.140625 0.546875,0.453125 0.546875,0.875 0,0.40625 -0.171875,0.71875 -0.453125,0.84375 -0.234375,0.09375 -0.46875,0.125 -1.140625,0.125 z m 0,0"
                  />
                </g>
              </g>
            ) : (
              <g
                style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
                id="g5614"
              >
                <g id="use5610" transform="translate(531.76514,339.69809)" />
                <g id="use5612" transform="translate(536.17395,339.69809)">
                  <path
                    id="path20243"
                    style={{ stroke: 'none' }}
                    d="m -0.34631,-1.90625 c 0.015625,-0.078125 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z M -3.174435,-2.546875 C -3.03381,-3.25 -2.705685,-3.59375 -2.15881,-3.59375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -2.40314,-1.625 L -5.56195,-5.375 h -0.828125 l -0.03125,1.203125 h -0.65625 L -7.0932,-3.5 h 0.640625 l -0.046875,1.859375 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L -4.56195,-0.8125 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -5.5932,-3.5 h 0.921875 v -0.671875 z m 0,0 M -10.308595,-3 c 0.07813,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.015625,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 m -4.086425,-2.375 L -14.48877,-2.25 -12.83252,0 h 1.15625 l -1.78125,-2.265625 1.65625,-1.90625 z M -15.36377,-5.90625 V 0 h 0.859375 v -5.90625 z m 0,0 m -3.842835,1.734375 v -0.1875 c 0,-0.328125 0.01563,-0.5 0.04687,-0.609375 0.07813,-0.1875 0.234375,-0.296875 0.453125,-0.296875 0.1875,0 0.375,0.03125 0.65625,0.140625 v -0.734375 c -0.28125,-0.109375 -0.546875,-0.15625 -0.8125,-0.15625 -0.4375,0 -0.796875,0.171875 -1,0.484375 -0.15625,0.234375 -0.203125,0.515625 -0.203125,1.09375 v 0.265625 h -0.578125 V -3.5 h 0.578125 V 0 h 0.875 v -3.5 h 1 v -0.671875 z m 1.71875,0 V 0 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.34375,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -5.25464,1.796875 V 0 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -2.30932,1.796875 0.01563,-1.203125 h -0.828125 l -0.03125,1.203125 h -0.65625 L -25.66119,-3.5 h 0.640625 l -0.04687,1.859375 c -0.01563,0.421875 -0.01563,0.421875 -0.01563,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 l 0.01563,-0.734375 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -24.16119,-3.5 h 0.921875 v -0.671875 z m 0,0 m -4.463075,0 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V 0 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.046875 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 m -0.90882,2.265625 c 0.01563,-0.078125 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 M -37.500425,-5.875 v 0.765625 h 2.59375 l -2.8125,4.390625 V 0 h 3.84375 v -0.78125 h -2.78125 L -33.7973,-5.234375 V -5.875 Z m 0,0 m 28.828675,-7.21625 v 0.640625 H -6.328 v -0.640625 z m 0,0 m -0.41815,-0.421875 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 0,-0.296875 -0.078125,-0.53125 -0.234375,-0.734375 -0.1875,-0.1875 -0.453125,-0.328125 -1.09375,-0.515625 -0.84375,-0.234375 -0.984375,-0.328125 -0.984375,-0.640625 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 m -7.70893,-1.21875 v 2.484375 c 0,0.5625 0.0625,0.90625 0.21875,1.15625 0.25,0.390625 0.703125,0.625 1.25,0.625 0.53125,0 0.859375,-0.1875 1.140625,-0.609375 0.01563,0.203125 0.04687,0.390625 0.09375,0.515625 h 0.828125 c -0.109375,-0.34375 -0.109375,-0.34375 -0.109375,-1.28125 v -2.890625 H -14.23633 V -12.435 c 0,0.359375 -0.04687,0.59375 -0.140625,0.78125 -0.171875,0.28125 -0.4375,0.421875 -0.765625,0.421875 -0.28125,0 -0.515625,-0.109375 -0.65625,-0.28125 -0.09375,-0.140625 -0.140625,-0.390625 -0.140625,-0.765625 v -2.453125 z m 0,0 m -4.715695,0 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V -10.56 h 0.859375 v -2.21875 c 0,-0.40625 0.04687,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.07813,0.171875 0.109375,0.359375 0.109375,0.859375 V -10.56 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.01563,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -2.80356,-0.125 c -1.125,0 -1.953125,0.921875 -1.953125,2.171875 0,1.328125 0.796875,2.234375 1.953125,2.234375 1.140625,0 1.9375,-0.90625 1.9375,-2.1875 0,-1.296875 -0.796875,-2.21875 -1.9375,-2.21875 z m 0,0.703125 c 0.625,0 1.0625,0.625 1.0625,1.515625 0,0.875 -0.4375,1.484375 -1.0625,1.484375 -0.640625,0 -1.0625,-0.59375 -1.0625,-1.515625 0,-0.875 0.4375,-1.484375 1.0625,-1.484375 z m 0,0 m -6.57849,-2.28125 v 5.875 h 1.203125 c 1.03125,0 1.3125,-0.03125 1.71875,-0.15625 0.625,-0.203125 1.03125,-0.796875 1.03125,-1.5 0,-0.796875 -0.40625,-1.265625 -1.28125,-1.46875 0.671875,-0.21875 0.96875,-0.609375 0.96875,-1.28125 0,-0.625 -0.34375,-1.125 -0.90625,-1.328125 -0.328125,-0.09375 -0.65625,-0.140625 -1.40625,-0.140625 z m 0.890625,2.453125 V -15.685 h 0.453125 c 0.546875,0 0.765625,0.03125 0.96875,0.109375 0.265625,0.109375 0.421875,0.390625 0.421875,0.71875 0,0.34375 -0.140625,0.609375 -0.390625,0.734375 -0.203125,0.109375 -0.46875,0.140625 -0.9375,0.140625 z m 0,2.671875 v -1.9375 h 0.5625 c 0.5625,0 0.78125,0.01563 1.015625,0.09375 0.34375,0.140625 0.546875,0.453125 0.546875,0.875 0,0.40625 -0.171875,0.71875 -0.453125,0.84375 -0.234375,0.09375 -0.46875,0.125 -1.140625,0.125 z m 0,0"
                  />
                </g>
              </g>
            )}
          </g>
        </g>
        <g
          id="circle-9"
          onMouseEnter={handleCircleMouseEnter}
          onMouseLeave={handleCircleMouseLeave}
          onMouseDown={handleCircleMouseDown}
        >
          <path
            className="circle-color"
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: 'rgb(0%,52.941895%,49.01886%)',
              fillOpacity: 1
            }}
            d="M 581.90625 362.292969 C 598.933594 362.292969 612.734375 348.492188 612.734375 331.464844 C 612.734375 314.441406 598.933594 300.640625 581.90625 300.640625 C 564.882812 300.640625 551.082031 314.441406 551.082031 331.464844 C 551.082031 348.492188 564.882812 362.292969 581.90625 362.292969 "
            id="circle-9-path"
          />
          <g style={{ pointerEvents: 'none' }}>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5626"
            >
              <g id="use5618" transform="translate(562.29761,323.85809)" />
              <g id="use5620" transform="translate(564.66479,323.85809)" />
              <g id="use5622" transform="translate(569.30243,323.85809)" />
              <g id="use5624" transform="translate(573.95758,323.85809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5642"
            >
              <g id="use5628" transform="translate(578.2168,323.85809)" />
              <g id="use5630" transform="translate(582.37921,323.85809)" />
              <g id="use5632" transform="translate(584.72882,323.85809)" />
              <g id="use5634" transform="translate(586.92877,323.85809)" />
              <g id="use5636" transform="translate(591.5752,323.85809)" />
              <g id="use5638" transform="translate(596.21283,323.85809)" />
              <g id="use5640" transform="translate(600.86798,323.85809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5646"
            >
              <g id="use5644" transform="translate(554.58881,334.41809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5652"
            >
              <g id="use5648" transform="translate(559.32318,334.41809)" />
              <g id="use5650" transform="translate(563.6792,334.41809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5676"
            >
              <g id="use5654" transform="translate(566.9704,334.41809)" />
              <g id="use5656" transform="translate(569.93597,334.41809)" />
              <g id="use5658" transform="translate(572.06561,334.41809)" />
              <g id="use5660" transform="translate(575.69122,334.41809)" />
              <g id="use5662" transform="translate(577.8208,334.41809)" />
              <g id="use5664" transform="translate(582.47601,334.41809)" />
              <g id="use5666" transform="translate(586.83197,334.41809)" />
              <g id="use5668" transform="translate(589.79761,334.41809)" />
              <g id="use5670" transform="translate(591.92719,334.41809)" />
              <g id="use5672" transform="translate(596.51202,334.41809)" />
              <g id="use5674" transform="translate(601.1496,334.41809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5680"
            >
              <g id="use5678" transform="translate(605.224,334.41809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5688"
            >
              <g id="use5682" transform="translate(562.97522,344.97809)" />
              <g id="use5684" transform="translate(566.60083,344.97809)" />
              <g id="use5686" transform="translate(571.00958,344.97809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5698"
            >
              <g id="use5690" transform="translate(574.30078,344.97809)" />
              <g id="use5692" transform="translate(577.26642,344.97809)" />
              <g id="use5694" transform="translate(579.396,344.97809)" />
              <g id="use5696" transform="translate(584.19202,344.97809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5704"
            >
              <g id="use5700" transform="translate(588.51282,344.97809)" />
              <g id="use5702" transform="translate(592.86877,344.97809)" />
            </g>
            {props.lang === 'en' ? (
              <g
                style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
                id="g5710"
              >
                <g id="use5706" transform="translate(594.53192,339.69809)" />
                <g id="use5708" transform="translate(598.94067,339.69809)">
                  <path
                    id="path20410"
                    style={{ stroke: 'none' }}
                    d="m 3.65625,-2.953125 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 C 3.6875,-1.5 3.609375,-1.734375 3.453125,-1.9375 3.265625,-2.125 3,-2.265625 2.359375,-2.453125 1.515625,-2.6875 1.375,-2.78125 1.375,-3.09375 c 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 m -4.0025,1.046875 c 0.015625,-0.078125 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z M -3.174375,-2.546875 C -3.03375,-3.25 -2.705625,-3.59375 -2.15875,-3.59375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -2.40399,-1.625 L -5.56274,-5.375 h -0.828125 l -0.03125,1.203125 h -0.65625 L -7.09399,-3.5 h 0.640625 l -0.046875,1.859375 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L -4.56274,-0.8125 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -5.59399,-3.5 h 0.921875 v -0.671875 z m 0,0 M -10.309385,-3 c 0.07813,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.015625,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 m -3.27289,-1 c -0.125,-0.96875 -0.6875,-1.5 -1.625,-1.5 -1.15625,0 -1.90625,0.875 -1.90625,2.21875 0,1.3125 0.75,2.1875 1.90625,2.1875 0.953125,0 1.578125,-0.59375 1.640625,-1.5625 h -0.84375 c -0.0625,0.59375 -0.3125,0.859375 -0.796875,0.859375 -0.640625,0 -1.015625,-0.546875 -1.015625,-1.484375 0,-0.921875 0.390625,-1.515625 1,-1.515625 0.453125,0 0.6875,0.234375 0.78125,0.796875 z m 0,0 m -7.092835,-1.375 v -0.1875 c 0,-0.328125 0.01563,-0.5 0.04687,-0.609375 0.07813,-0.1875 0.234375,-0.296875 0.453125,-0.296875 0.1875,0 0.375,0.03125 0.65625,0.140625 v -0.734375 c -0.28125,-0.109375 -0.546875,-0.15625 -0.8125,-0.15625 -0.4375,0 -0.796875,0.171875 -1,0.484375 -0.15625,0.234375 -0.203125,0.515625 -0.203125,1.09375 v 0.265625 h -0.578125 V -3.5 h 0.578125 V 0 h 0.875 v -3.5 h 1 v -0.671875 z m 1.71875,0 V 0 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.34375,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -5.25463,1.796875 V 0 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -2.30933,1.796875 0.01563,-1.203125 h -0.828125 l -0.03125,1.203125 h -0.65625 L -25.58282,-3.5 h 0.640625 l -0.04687,1.859375 c -0.01563,0.421875 -0.01563,0.421875 -0.01563,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 l 0.01563,-0.734375 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -24.08282,-3.5 h 0.921875 v -0.671875 z m 0,0 m -4.463075,0 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V 0 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.046875 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 m -0.90881,2.265625 c 0.01563,-0.078125 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -1.62372,-1.546875 c -0.109375,-1.203125 -0.828125,-1.875 -2,-1.875 -0.609375,0 -1.1875,0.21875 -1.609375,0.609375 -0.59375,0.53125 -0.90625,1.390625 -0.90625,2.4375 0,1.84375 1,3.03125 2.546875,3.03125 1.25,0 1.96875,-0.78125 2.0625,-2.203125 H -34.6253 c -0.09375,0.9375 -0.515625,1.40625 -1.265625,1.40625 -0.96875,0 -1.5625,-0.859375 -1.5625,-2.234375 0,-1.390625 0.59375,-2.265625 1.546875,-2.265625 0.65625,0 1.078125,0.375 1.21875,1.09375 z m 0,0 M -6.31909,-14.731875 c 0.046875,0.359375 0.046875,0.4375 0.046875,1.34375 V -10.56 h 0.875 v -1.90625 c 0,-0.46875 0.046875,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.04687 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.015625,-0.109375 0.015625,-0.171875 0.015625,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 m -0.90875,2.265625 c 0.015625,-0.07813 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.04687 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -2.31781,-1.625 -1.640625,1.921875 1.65625,2.25 h 1.15625 l -1.78125,-2.265625 1.65625,-1.90625 z M -14.8894,-16.46625 V -10.56 h 0.859375 v -5.90625 z m 0,0 m -0.94757,3.109375 c -0.125,-0.96875 -0.6875,-1.5 -1.625,-1.5 -1.15625,0 -1.90625,0.875 -1.90625,2.21875 0,1.3125 0.75,2.1875 1.90625,2.1875 0.953125,0 1.578125,-0.59375 1.640625,-1.5625 h -0.84375 c -0.0625,0.59375 -0.3125,0.859375 -0.796875,0.859375 -0.640625,0 -1.015625,-0.546875 -1.015625,-1.484375 0,-0.921875 0.390625,-1.515625 1,-1.515625 0.453125,0 0.6875,0.234375 0.78125,0.796875 z m 0,0 M -22.708615,-13.56 c 0.07813,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.01563,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 m -5.46771,-2.375 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V -10.56 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.04687 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 M -30.800165,-16.435 v 0.796875 h 1.53125 V -10.56 h 0.90625 v -5.078125 h 1.546875 V -16.435 Z m 0,0"
                  />
                </g>
              </g>
            ) : (
              <g
                style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
                id="g5710"
              >
                <g id="use5706" transform="translate(595.77283,344.97809)" />
                <g id="use5708" transform="translate(600.18158,344.97809)">
                  <path
                    id="path20410"
                    style={{ stroke: 'none' }}
                    d="m -0.34625,-1.90625 c 0.015625,-0.078125 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z M -3.174375,-2.546875 C -3.03375,-3.25 -2.705625,-3.59375 -2.15875,-3.59375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -2.40406,-1.625 L -5.56281,-5.375 h -0.828125 l -0.03125,1.203125 h -0.65625 L -7.09406,-3.5 h 0.640625 l -0.046875,1.859375 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L -4.56281,-0.8125 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -5.59406,-3.5 h 0.921875 v -0.671875 z m 0,0 M -10.309385,-3 c 0.07813,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.015625,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 m -4.086425,-2.375 L -14.48956,-2.25 -12.83331,0 h 1.15625 l -1.78125,-2.265625 1.65625,-1.90625 z M -15.36456,-5.90625 V 0 h 0.859375 v -5.90625 z m 0,0 m -3.842895,1.734375 v -0.1875 c 0,-0.328125 0.01563,-0.5 0.04687,-0.609375 0.07813,-0.1875 0.234375,-0.296875 0.453125,-0.296875 0.1875,0 0.375,0.03125 0.65625,0.140625 v -0.734375 c -0.28125,-0.109375 -0.546875,-0.15625 -0.8125,-0.15625 -0.4375,0 -0.796875,0.171875 -1,0.484375 -0.15625,0.234375 -0.203125,0.515625 -0.203125,1.09375 v 0.265625 h -0.578125 V -3.5 h 0.578125 V 0 h 0.875 v -3.5 h 1 v -0.671875 z m 1.71875,0 V 0 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.34375,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -5.25458,1.796875 V 0 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -2.30939,1.796875 0.01563,-1.203125 h -0.828125 l -0.03125,1.203125 h -0.65625 L -25.66205,-3.5 h 0.640625 l -0.04687,1.859375 c -0.01563,0.421875 -0.01563,0.421875 -0.01563,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L -23.1308,-0.8125 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -24.16205,-3.5 h 0.921875 v -0.671875 z m 0,0 m -4.463075,0 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V 0 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.046875 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 m -0.90875,2.265625 c 0.01563,-0.078125 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -4.46936,-1.625 v 0.703125 h 1.953125 l -2.15625,2.796875 V 0 h 3.203125 v -0.71875 h -2.171875 l 2.1875,-2.8125 v -0.640625 z m 0,0 M 5.04242,-13.09125 v 0.640625 h 2.34375 v -0.640625 z m 0,0 m -0.41815,-0.421875 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 0,-0.296875 -0.078125,-0.53125 -0.234375,-0.734375 -0.1875,-0.1875 -0.453125,-0.328125 -1.09375,-0.515625 C 2.483645,-13.2475 2.34302,-13.34125 2.34302,-13.65375 c 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 m -7.778205,-1.21875 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V -10.56 h 0.859375 v -2.21875 c 0,-0.40625 0.046875,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.078125,0.171875 0.109375,0.359375 0.109375,0.859375 V -10.56 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.015625,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -2.80358,-0.125 c -1.125,0 -1.953125,0.921875 -1.953125,2.171875 0,1.328125 0.796875,2.234375 1.953125,2.234375 1.140625,0 1.9375,-0.90625 1.9375,-2.1875 0,-1.296875 -0.796875,-2.21875 -1.9375,-2.21875 z m 0,0.703125 c 0.625,0 1.0625,0.625 1.0625,1.515625 0,0.875 -0.4375,1.484375 -1.0625,1.484375 -0.640625,0 -1.0625,-0.59375 -1.0625,-1.515625 0,-0.875 0.4375,-1.484375 1.0625,-1.484375 z m 0,0 M -9.75897,-14.731875 V -10.56 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -2.30939,1.796875 0.01563,-1.203125 h -0.828125 l -0.03125,1.203125 h -0.65625 L -13.13086,-14.06 h 0.640625 l -0.04687,1.859375 c -0.01563,0.421875 -0.01563,0.421875 -0.01563,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 l 0.01563,-0.734375 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -11.63086,-14.06 h 0.921875 v -0.671875 z m 0,0 m -4.73096,1.171875 c 0.07813,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.01563,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 m -6.93646,3.53125 h 0.859375 v -2.25 c 0.328125,0.4375 0.65625,0.609375 1.15625,0.609375 0.984375,0 1.671875,-0.90625 1.671875,-2.203125 0,-1.296875 -0.6875,-2.171875 -1.703125,-2.171875 -0.53125,0 -0.890625,0.203125 -1.171875,0.640625 0,-0.1875 -0.03125,-0.40625 -0.07813,-0.53125 h -0.8125 c 0.0625,0.28125 0.07813,0.546875 0.07813,1.28125 z m 1.84375,-5.28125 c 0.59375,0 0.953125,0.5625 0.953125,1.453125 0,0.921875 -0.359375,1.453125 -0.953125,1.453125 -0.609375,0 -1,-0.578125 -1,-1.4375 0,-0.890625 0.390625,-1.46875 1,-1.46875 z m 0,0 m -3.97333,-0.625 V -10.56 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -4.31311,1.796875 v 0.703125 h 1.953125 l -2.15625,2.796875 V -10.56 h 3.203125 v -0.71875 h -2.171875 l 2.1875,-2.8125 v -0.640625 z m 0,0 m -1.895265,0 V -10.56 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -2.30932,1.796875 0.01563,-1.203125 h -0.828125 l -0.03125,1.203125 h -0.65625 L -32.99243,-14.06 h 0.640625 l -0.04687,1.859375 c -0.01563,0.421875 -0.01563,0.421875 -0.01563,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 l 0.01563,-0.734375 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -31.49243,-14.06 h 0.921875 v -0.671875 z m 0,0 m -4.463075,0 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V -10.56 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.04687 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 M -39.499025,-13.56 c 0.07813,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.01563,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 M -44.858395,-16.435 v 5.875 h 0.90625 v -2.28125 h 0.375 c 0.84375,0 1.21875,-0.03125 1.5625,-0.15625 0.640625,-0.21875 1.046875,-0.828125 1.046875,-1.609375 0,-0.796875 -0.40625,-1.4375 -1.078125,-1.65625 -0.375,-0.125 -0.765625,-0.171875 -1.640625,-0.171875 z m 0.90625,2.8125 v -2.015625 h 0.375 c 0.65625,0 0.921875,0.03125 1.171875,0.140625 0.3125,0.140625 0.484375,0.453125 0.484375,0.875 0,0.46875 -0.21875,0.8125 -0.609375,0.90625 -0.234375,0.07813 -0.421875,0.09375 -1.046875,0.09375 z m 0,0 M 0.0625,-27.02625 h -0.859375 v 2.25 c -0.3125,-0.453125 -0.609375,-0.625 -1.125,-0.625 -0.984375,0 -1.6875,0.921875 -1.6875,2.234375 0,1.296875 0.671875,2.140625 1.71875,2.140625 0.546875,0 0.890625,-0.203125 1.171875,-0.6875 0,0.09375 0,0.140625 0,0.1875 0,0.140625 0,0.234375 0.046875,0.40625 h 0.8125 C 0.09375,-21.40125 0.0625,-21.666875 0.0625,-22.40125 Z m -1.796875,2.359375 c 0.59375,0 0.953125,0.5625 0.953125,1.453125 0,0.890625 -0.375,1.453125 -0.984375,1.453125 -0.59375,0 -0.96875,-0.53125 -0.96875,-1.421875 0,-0.921875 0.390625,-1.484375 1,-1.484375 z m 0,0 m -6.35638,-0.625 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V -21.12 h 0.859375 v -2.21875 c 0,-0.40625 0.046875,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.078125,0.171875 0.109375,0.359375 0.109375,0.859375 V -21.12 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.015625,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -4.568305,0 v 2.484375 c 0,0.5625 0.0625,0.90625 0.21875,1.15625 0.25,0.390625 0.703125,0.625 1.25,0.625 0.53125,0 0.859375,-0.1875 1.140625,-0.609375 0.01563,0.203125 0.04687,0.390625 0.09375,0.515625 h 0.828125 c -0.109375,-0.34375 -0.109375,-0.34375 -0.109375,-1.28125 v -2.890625 H -10.09656 V -22.995 c 0,0.359375 -0.04687,0.59375 -0.140625,0.78125 -0.171875,0.28125 -0.4375,0.421875 -0.765625,0.421875 -0.28125,0 -0.515625,-0.109375 -0.65625,-0.28125 -0.09375,-0.140625 -0.140625,-0.390625 -0.140625,-0.765625 v -2.453125 z m 0,0 m -5.14331,1.640625 v 0.640625 h 2.34375 v -0.640625 z m 0,0 m -3.928035,-1.640625 1.328125,1.953125 -1.53125,2.21875 h 1.046875 l 1,-1.546875 1,1.546875 h 1.046875 l -1.515625,-2.21875 1.328125,-1.953125 h -1.03125 l -0.828125,1.3125 -0.8125,-1.3125 z m 0,0 m -0.431095,2.265625 c 0.01563,-0.07813 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.04687 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 M -26.8479,-27.02625 h -0.859375 v 2.25 c -0.3125,-0.453125 -0.609375,-0.625 -1.125,-0.625 -0.984375,0 -1.6875,0.921875 -1.6875,2.234375 0,1.296875 0.671875,2.140625 1.71875,2.140625 0.546875,0 0.890625,-0.203125 1.171875,-0.6875 0,0.09375 0,0.140625 0,0.1875 0,0.140625 0,0.234375 0.04687,0.40625 h 0.8125 c -0.04687,-0.28125 -0.07813,-0.546875 -0.07813,-1.28125 z m -1.796875,2.359375 c 0.59375,0 0.953125,0.5625 0.953125,1.453125 0,0.890625 -0.375,1.453125 -0.984375,1.453125 -0.59375,0 -0.96875,-0.53125 -0.96875,-1.421875 0,-0.921875 0.390625,-1.484375 1,-1.484375 z m 0,0 m -6.35639,-0.625 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V -21.12 h 0.859375 v -2.21875 c 0,-0.40625 0.04687,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.07813,0.171875 0.109375,0.359375 0.109375,0.859375 V -21.12 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.01563,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -1.24218,4.171875 v -5.875 h -0.921875 v 5.875 z m 0,0"
                  />
                </g>
              </g>
            )}
          </g>
        </g>
        <g
          id="circle-10"
          onMouseEnter={handleCircleMouseEnter}
          onMouseLeave={handleCircleMouseLeave}
          onMouseDown={handleCircleMouseDown}
        >
          <path
            className="circle-color"
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: 'rgb(41.175842%,25.097656%,39.99939%)',
              fillOpacity: 1
            }}
            d="M 646.292969 362.292969 C 663.316406 362.292969 677.121094 348.492188 677.121094 331.464844 C 677.121094 314.441406 663.316406 300.640625 646.292969 300.640625 C 629.269531 300.640625 615.46875 314.441406 615.46875 331.464844 C 615.46875 348.492188 629.269531 362.292969 646.292969 362.292969 "
            id="circle-10-path"
          />
          <g style={{ pointerEvents: 'none' }}>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5718"
            >
              <g id="use5714" transform="translate(617.32428,334.41809)" />
              <g id="use5716" transform="translate(623.13232,334.41809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5734"
            >
              <g id="use5720" transform="translate(627.69952,334.41809)" />
              <g id="use5722" transform="translate(630.6651,334.41809)" />
              <g id="use5724" transform="translate(632.79468,334.41809)" />
              <g id="use5726" transform="translate(637.37952,334.41809)" />
              <g id="use5728" transform="translate(642.01709,334.41809)" />
              <g id="use5730" transform="translate(646.09149,334.41809)" />
              <g id="use5732" transform="translate(650.16589,334.41809)" />
            </g>
            {props.lang === 'en' ? (
              <g
                style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
                id="g5746"
              >
                <g id="use5736" transform="translate(646.75568,334.41809)" />
                <g id="use5738" transform="translate(646.75568,334.41809)" />
                <g id="use5740" transform="translate(651.11169,334.41809)" />
                <g id="use5742" transform="translate(655.74933,334.41809)" />
                <g id="use5744" transform="translate(658.7149,334.41809)">
                  <path
                    id="path20485"
                    style={{ stroke: 'none' }}
                    d="m 3.65625,-2.953125 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 C 3.6875,-1.5 3.609375,-1.734375 3.453125,-1.9375 3.265625,-2.125 3,-2.265625 2.359375,-2.453125 1.515625,-2.6875 1.375,-2.78125 1.375,-3.09375 c 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 M -1.231195,-4.171875 -1.21557,-5.375 h -0.828125 l -0.03125,1.203125 h -0.65625 L -2.74682,-3.5 h 0.640625 l -0.046875,1.859375 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L -0.21557,-0.8125 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -1.24682,-3.5 h 0.921875 v -0.671875 z m 0,0 m -5.85639,0 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V 0 h 0.859375 v -2.21875 c 0,-0.40625 0.046875,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.078125,0.171875 0.109375,0.359375 0.109375,0.859375 V 0 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.015625,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 M -10.599845,-3 c 0.07813,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.015625,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 m -5.46772,-2.375 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V 0 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.046875 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 m -3.11523,0 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V 0 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.046875 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 M -21.195005,-3 c 0.07813,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.01563,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 M -29.458615,-5.875 -28.00549,0.015625 h 1.015625 l 1.046875,-4.171875 1.0625,4.171875 h 1 L -22.41174,-5.875 h -0.84375 l -1.140625,4.78125 -1.140625,-4.78125 h -0.78125 l -1.15625,4.78125 -1.125,-4.78125 z m 0,0"
                  />
                </g>
              </g>
            ) : (
              <g
                style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
                id="g5746"
              >
                <g id="use5736" transform="translate(654.36353,334.41809)" />
                <g id="use5738" transform="translate(659.02753,334.41809)" />
                <g id="use5740" transform="translate(663.43628,334.41809)" />
                <g id="use5742" transform="translate(665.56592,334.41809)" />
                <g id="use5744" transform="translate(670.20349,334.41809)">
                  <path
                    id="path20485"
                    style={{ stroke: 'none' }}
                    d="m 4.0625,-1.90625 c 0.015625,-0.078125 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 C 3.15625,0.109375 3.75,-0.3125 3.96875,-1.09375 L 3.203125,-1.140625 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z M 1.234375,-2.546875 C 1.375,-3.25 1.703125,-3.59375 2.25,-3.59375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -5.35632,-1.625 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V 0 h 0.859375 v -2.21875 c 0,-0.40625 0.046875,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.078125,0.171875 0.109375,0.359375 0.109375,0.859375 V 0 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.015625,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -2.020265,0 V 0 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -1.424375,4.0625 c 0.015625,-0.078125 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z M -9.941585,-2.546875 C -9.80096,-3.25 -9.472835,-3.59375 -8.92596,-3.59375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 M -15.21496,-5.90625 V 0 h 0.859375 v -2.21875 c 0,-0.375 0.04687,-0.625 0.15625,-0.828125 0.15625,-0.28125 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.671875,0.390625 0.09375,0.171875 0.109375,0.40625 0.109375,0.859375 V 0 h 0.875 v -2.40625 c 0,-0.765625 -0.04687,-1.046875 -0.21875,-1.3125 -0.21875,-0.34375 -0.671875,-0.5625 -1.171875,-0.5625 -0.5,0 -0.890625,0.1875 -1.203125,0.578125 V -5.90625 Z m 0,0 m -0.94764,3.109375 c -0.125,-0.96875 -0.6875,-1.5 -1.625,-1.5 -1.15625,0 -1.90625,0.875 -1.90625,2.21875 0,1.3125 0.75,2.1875 1.90625,2.1875 0.953125,0 1.578125,-0.59375 1.640625,-1.5625 h -0.84375 c -0.0625,0.59375 -0.3125,0.859375 -0.796875,0.859375 -0.640625,0 -1.015625,-0.546875 -1.015625,-1.484375 0,-0.921875 0.390625,-1.515625 1,-1.515625 0.453125,0 0.6875,0.234375 0.78125,0.796875 z m 0,0 m -4.29315,-0.15625 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 0,-0.296875 -0.07813,-0.53125 -0.234375,-0.734375 -0.1875,-0.1875 -0.453125,-0.328125 -1.09375,-0.515625 C -22.596375,-2.6875 -22.737,-2.78125 -22.737,-3.09375 c 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 m -4.0744,0 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 0,-0.296875 -0.07813,-0.53125 -0.234375,-0.734375 -0.1875,-0.1875 -0.453125,-0.328125 -1.09375,-0.515625 -0.84375,-0.234375 -0.984375,-0.328125 -0.984375,-0.640625 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 m -7.778195,-1.21875 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V 0 h 0.859375 v -2.21875 c 0,-0.40625 0.04687,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.07813,0.171875 0.109375,0.359375 0.109375,0.859375 V 0 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.01563,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -2.80359,-0.125 c -1.125,0 -1.953125,0.921875 -1.953125,2.171875 0,1.328125 0.796875,2.234375 1.953125,2.234375 1.140625,0 1.9375,-0.90625 1.9375,-2.1875 0,-1.296875 -0.796875,-2.21875 -1.9375,-2.21875 z m 0,0.703125 c 0.625,0 1.0625,0.625 1.0625,1.515625 0,0.875 -0.4375,1.484375 -1.0625,1.484375 -0.640625,0 -1.0625,-0.59375 -1.0625,-1.515625 0,-0.875 0.4375,-1.484375 1.0625,-1.484375 z m 0,0 M -38.91339,-4.171875 V 0 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -2.30933,1.796875 0.01563,-1.203125 h -0.828125 l -0.03125,1.203125 h -0.65625 L -42.28522,-3.5 h 0.640625 l -0.04687,1.859375 c -0.01563,0.421875 -0.01563,0.421875 -0.01563,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 l 0.01563,-0.734375 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -40.78522,-3.5 h 0.921875 v -0.671875 z m 0,0 m -5.676575,5.90625 h 0.859375 v -2.25 c 0.328125,0.4375 0.65625,0.609375 1.15625,0.609375 0.984375,0 1.671875,-0.90625 1.671875,-2.203125 0,-1.296875 -0.6875,-2.171875 -1.703125,-2.171875 -0.53125,0 -0.890625,0.203125 -1.171875,0.640625 0,-0.1875 -0.03125,-0.40625 -0.07813,-0.53125 h -0.8125 c 0.0625,0.28125 0.07813,0.546875 0.07813,1.28125 z m 1.84375,-5.28125 c 0.59375,0 0.953125,0.5625 0.953125,1.453125 0,0.921875 -0.359375,1.453125 -0.953125,1.453125 -0.609375,0 -1,-0.578125 -1,-1.4375 0,-0.890625 0.390625,-1.46875 1,-1.46875 z m 0,0 m -5.37054,-2.421875 c -1.484375,0 -2.53125,1.21875 -2.53125,3 0,1.859375 1,3.078125 2.53125,3.078125 1.515625,0 2.53125,-1.234375 2.53125,-3.046875 0,-1.8125 -1.015625,-3.03125 -2.53125,-3.03125 z m 0,0.78125 c 0.96875,0 1.578125,0.875 1.578125,2.25 0,1.390625 -0.609375,2.265625 -1.578125,2.265625 -0.984375,0 -1.578125,-0.875 -1.578125,-2.296875 0,-1.34375 0.609375,-2.21875 1.578125,-2.21875 z m 0,0"
                  />
                </g>
              </g>
            )}
          </g>
        </g>
        <g
          id="circle-11"
          onMouseEnter={handleCircleMouseEnter}
          onMouseLeave={handleCircleMouseLeave}
          onMouseDown={handleCircleMouseDown}
        >
          <path
            className="circle-color"
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: 'rgb(41.175842%,25.097656%,39.99939%)',
              fillOpacity: 1
            }}
            d="M 710.679688 362.292969 C 727.703125 362.292969 741.503906 348.492188 741.503906 331.464844 C 741.503906 314.441406 727.703125 300.640625 710.679688 300.640625 C 693.652344 300.640625 679.851562 314.441406 679.851562 331.464844 C 679.851562 348.492188 693.652344 362.292969 710.679688 362.292969 "
            id="circle-11-path"
          />
          <g style={{ pointerEvents: 'none' }}>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5752"
            >
              <g id="use5750" transform="translate(697.39972,329.13809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5760"
            >
              <g id="use5754" transform="translate(701.71167,329.13809)" />
              <g id="use5756" transform="translate(706.06769,329.13809)" />
              <g id="use5758" transform="translate(710.56451,329.13809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5766"
            >
              <g id="use5762" transform="translate(713.45972,329.13809)" />
              <g id="use5764" transform="translate(718.04449,329.13809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5770"
            >
              <g id="use5768" transform="translate(720.95728,329.13809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5774"
            >
              <use x="723.3068" y="329.1381" id="use5772" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5780"
            >
              <g id="use5776" transform="translate(681.70972,339.69809)" />
              <g id="use5778" transform="translate(687.5177,339.69809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5796"
            >
              <g id="use5782" transform="translate(692.0849,339.69809)" />
              <g id="use5784" transform="translate(695.05048,339.69809)" />
              <g id="use5786" transform="translate(697.18011,339.69809)" />
              <g id="use5788" transform="translate(701.76489,339.69809)" />
              <g id="use5790" transform="translate(706.40253,339.69809)" />
              <g id="use5792" transform="translate(710.47693,339.69809)" />
              <g id="use5794" transform="translate(714.55127,339.69809)" />
            </g>
            {props.lang === 'en' ? (
              <g
                style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
                id="g5808"
              >
                <g id="use5798" transform="translate(711.14111,344.97809)" />
                <g id="use5800" transform="translate(711.14111,344.97809)" />
                <g id="use5802" transform="translate(715.49707,344.97809)" />
                <g id="use5804" transform="translate(720.1347,344.97809)" />
                <g id="use5806" transform="translate(723.10028,344.97809)">
                  <path
                    id="path20588"
                    style={{ stroke: 'none' }}
                    d="m 3.65625,-2.953125 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 C 3.6875,-1.5 3.609375,-1.734375 3.453125,-1.9375 3.265625,-2.125 3,-2.265625 2.359375,-2.453125 1.515625,-2.6875 1.375,-2.78125 1.375,-3.09375 c 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 M -1.231205,-4.171875 -1.21558,-5.375 h -0.828125 l -0.03125,1.203125 h -0.65625 L -2.74683,-3.5 h 0.640625 l -0.046875,1.859375 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L -0.21558,-0.8125 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -1.24683,-3.5 h 0.921875 v -0.671875 z m 0,0 m -5.85638,0 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V 0 h 0.859375 v -2.21875 c 0,-0.40625 0.046875,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.078125,0.171875 0.109375,0.359375 0.109375,0.859375 V 0 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.015625,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 M -10.599795,-3 c 0.07813,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.015625,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 m -5.46777,-2.375 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V 0 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.046875 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 m -3.11517,0 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V 0 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.046875 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 M -21.195005,-3 c 0.07813,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.01563,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 M -29.458615,-5.875 -28.00549,0.015625 h 1.015625 l 1.046875,-4.171875 1.0625,4.171875 h 1 L -22.41174,-5.875 h -0.84375 l -1.140625,4.78125 -1.140625,-4.78125 h -0.78125 l -1.15625,4.78125 -1.125,-4.78125 z m 0,0 M 3.05054,-12.46625 c 0.015625,-0.07813 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.04687 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z M 0.222415,-13.106875 C 0.36304,-13.81 0.691165,-14.15375 1.23804,-14.15375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -1.31995,-1.625 -1.328125,0.03125 C -2.722535,-14.794375 -2.910035,-14.81 -3.160035,-14.81 c -1,0 -1.640625,0.5625 -1.640625,1.453125 0,0.578125 0.234375,0.953125 0.765625,1.203125 -0.546875,0.1875 -0.75,0.375 -0.75,0.65625 0,0.21875 0.140625,0.375 0.46875,0.5 -0.609375,0.203125 -0.859375,0.515625 -0.859375,1 0,0.734375 0.765625,1.21875 1.984375,1.21875 1.25,0 1.984375,-0.5 1.984375,-1.34375 0,-0.4375 -0.203125,-0.796875 -0.546875,-0.984375 -0.265625,-0.140625 -0.515625,-0.1875 -1.296875,-0.265625 -0.65625,-0.07813 -0.671875,-0.07813 -0.765625,-0.109375 -0.078125,-0.03125 -0.125,-0.09375 -0.125,-0.171875 0,-0.125 0.1875,-0.265625 0.453125,-0.296875 0.828125,-0.125 0.921875,-0.140625 1.21875,-0.28125 0.375,-0.171875 0.59375,-0.5625 0.59375,-1.03125 0,-0.328125 -0.109375,-0.671875 -0.28125,-0.84375 h 0.859375 z m -2.109375,0.578125 c 0.453125,0 0.78125,0.328125 0.78125,0.78125 0,0.453125 -0.328125,0.734375 -0.8125,0.734375 -0.46875,0 -0.796875,-0.28125 -0.796875,-0.734375 0,-0.453125 0.328125,-0.78125 0.828125,-0.78125 z m -0.078125,3.484375 c 0.796875,0 1.25,0.21875 1.25,0.609375 0,0.375 -0.4375,0.625 -1.140625,0.625 -0.765625,0 -1.25,-0.25 -1.25,-0.625 0,-0.390625 0.421875,-0.609375 1.140625,-0.609375 z m 0,0 M -8.390995,-13.56 c 0.078125,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.015625,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 m -5.46777,-2.375 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V -10.56 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.04687 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 m -0.90881,2.265625 c 0.01563,-0.07813 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.04687 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -5.118225,-1.625 1.484375,4.203125 h 0.953125 l 1.484375,-4.203125 h -0.90625 l -1.046875,3.234375 -1.0625,-3.234375 z m 0,0 m -0.29926,2.265625 c 0.01563,-0.07813 0.01563,-0.15625 0.01563,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.04687 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z m -2.828125,-0.640625 c 0.140625,-0.703125 0.46875,-1.046875 1.015625,-1.046875 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -4.86474,-3.328125 v 5.875 h 3.453125 v -0.78125 H -28.2373 V -16.435 Z m 0,0 M 2.772765,-25.291875 2.78839,-26.495 H 1.960265 l -0.03125,1.203125 H 1.272765 L 1.25714,-24.62 h 0.640625 l -0.046875,1.859375 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L 3.78839,-21.9325 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L 2.75714,-24.62 h 0.921875 v -0.671875 z m 0,0 m -5.85632,0 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V -21.12 h 0.859375 v -2.21875 c 0,-0.40625 0.046875,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.078125,0.171875 0.109375,0.359375 0.109375,0.859375 V -21.12 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.015625,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 M -6.595825,-24.12 c 0.078125,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.015625,0.328125 0.0625,0.515625 H -4.0802 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 m -4.163875,-2.375 L -9.1972,-26.495 h -0.828125 l -0.03125,1.203125 h -0.65625 L -10.72845,-24.62 h 0.640625 l -0.04687,1.859375 c -0.01563,0.421875 -0.01563,0.421875 -0.01563,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L -8.1972,-21.9325 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -9.22845,-24.62 h 0.921875 v -0.671875 z m 0,0 m -2.126105,1.21875 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 0,-0.296875 -0.07813,-0.53125 -0.234375,-0.734375 -0.1875,-0.1875 -0.453125,-0.328125 -1.09375,-0.515625 -0.84375,-0.234375 -0.984375,-0.328125 -0.984375,-0.640625 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 m -7.778195,-1.21875 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V -21.12 h 0.859375 v -2.21875 c 0,-0.40625 0.04687,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.07813,0.171875 0.109375,0.359375 0.109375,0.859375 V -21.12 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.01563,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -2.80359,-0.125 c -1.125,0 -1.953125,0.921875 -1.953125,2.171875 0,1.328125 0.796875,2.234375 1.953125,2.234375 1.140625,0 1.9375,-0.90625 1.9375,-2.1875 0,-1.296875 -0.796875,-2.21875 -1.9375,-2.21875 z m 0,0.703125 c 0.625,0 1.0625,0.625 1.0625,1.515625 0,0.875 -0.4375,1.484375 -1.0625,1.484375 -0.640625,0 -1.0625,-0.59375 -1.0625,-1.515625 0,-0.875 0.4375,-1.484375 1.0625,-1.484375 z m 0,0 m -2.68622,-0.5 c -0.109375,-1.203125 -0.828125,-1.875 -2,-1.875 -0.609375,0 -1.1875,0.21875 -1.609375,0.609375 -0.59375,0.53125 -0.90625,1.390625 -0.90625,2.4375 0,1.84375 1,3.03125 2.546875,3.03125 1.25,0 1.96875,-0.78125 2.0625,-2.203125 h -0.828125 c -0.09375,0.9375 -0.515625,1.40625 -1.265625,1.40625 -0.96875,0 -1.5625,-0.859375 -1.5625,-2.234375 0,-1.390625 0.59375,-2.265625 1.546875,-2.265625 0.65625,0 1.078125,0.375 1.21875,1.09375 z m 0,0"
                  />
                </g>
              </g>
            ) : (
              <g
                style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
                id="g5808"
              >
                <g id="use5798" transform="translate(718.7489,339.69809)" />
                <g id="use5800" transform="translate(723.4129,339.69809)" />
                <g id="use5802" transform="translate(727.82172,339.69809)" />
                <g id="use5804" transform="translate(729.95129,339.69809)" />
                <g id="use5806" transform="translate(734.58893,339.69809)">
                  <path
                    id="path20588"
                    style={{ stroke: 'none' }}
                    d="m 4.0625,-1.90625 c 0.015625,-0.078125 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 C 3.15625,0.109375 3.75,-0.3125 3.96875,-1.09375 L 3.203125,-1.140625 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z M 1.234375,-2.546875 C 1.375,-3.25 1.703125,-3.59375 2.25,-3.59375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -5.35639,-1.625 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V 0 h 0.859375 v -2.21875 c 0,-0.40625 0.046875,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.078125,0.171875 0.109375,0.359375 0.109375,0.859375 V 0 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.015625,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -2.020195,0 V 0 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -1.424445,4.0625 c 0.015625,-0.078125 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z M -9.941655,-2.546875 C -9.80103,-3.25 -9.472905,-3.59375 -8.92603,-3.59375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 M -15.21503,-5.90625 V 0 h 0.859375 v -2.21875 c 0,-0.375 0.04687,-0.625 0.15625,-0.828125 0.15625,-0.28125 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.671875,0.390625 0.09375,0.171875 0.109375,0.40625 0.109375,0.859375 V 0 h 0.875 v -2.40625 c 0,-0.765625 -0.04687,-1.046875 -0.21875,-1.3125 -0.21875,-0.34375 -0.671875,-0.5625 -1.171875,-0.5625 -0.5,0 -0.890625,0.1875 -1.203125,0.578125 V -5.90625 Z m 0,0 m -0.94763,3.109375 c -0.125,-0.96875 -0.6875,-1.5 -1.625,-1.5 -1.15625,0 -1.90625,0.875 -1.90625,2.21875 0,1.3125 0.75,2.1875 1.90625,2.1875 0.953125,0 1.578125,-0.59375 1.640625,-1.5625 h -0.84375 c -0.0625,0.59375 -0.3125,0.859375 -0.796875,0.859375 -0.640625,0 -1.015625,-0.546875 -1.015625,-1.484375 0,-0.921875 0.390625,-1.515625 1,-1.515625 0.453125,0 0.6875,0.234375 0.78125,0.796875 z m 0,0 m -4.29309,-0.15625 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 0,-0.296875 -0.07813,-0.53125 -0.234375,-0.734375 -0.1875,-0.1875 -0.453125,-0.328125 -1.09375,-0.515625 C -22.596375,-2.6875 -22.737,-2.78125 -22.737,-3.09375 c 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 m -4.0744,0 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 0,-0.296875 -0.07813,-0.53125 -0.234375,-0.734375 -0.1875,-0.1875 -0.453125,-0.328125 -1.09375,-0.515625 -0.84375,-0.234375 -0.984375,-0.328125 -0.984375,-0.640625 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 m -7.778265,-1.21875 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V 0 h 0.859375 v -2.21875 c 0,-0.40625 0.04687,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.07813,0.171875 0.109375,0.359375 0.109375,0.859375 V 0 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.01563,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -2.80353,-0.125 c -1.125,0 -1.953125,0.921875 -1.953125,2.171875 0,1.328125 0.796875,2.234375 1.953125,2.234375 1.140625,0 1.9375,-0.90625 1.9375,-2.1875 0,-1.296875 -0.796875,-2.21875 -1.9375,-2.21875 z m 0,0.703125 c 0.625,0 1.0625,0.625 1.0625,1.515625 0,0.875 -0.4375,1.484375 -1.0625,1.484375 -0.640625,0 -1.0625,-0.59375 -1.0625,-1.515625 0,-0.875 0.4375,-1.484375 1.0625,-1.484375 z m 0,0 M -38.91345,-4.171875 V 0 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -2.30933,1.796875 0.01563,-1.203125 h -0.828125 l -0.03125,1.203125 h -0.65625 L -42.28528,-3.5 h 0.640625 l -0.04687,1.859375 c -0.01563,0.421875 -0.01563,0.421875 -0.01563,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 l 0.01563,-0.734375 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -40.78528,-3.5 h 0.921875 v -0.671875 z m 0,0 m -5.676575,5.90625 h 0.859375 v -2.25 c 0.328125,0.4375 0.65625,0.609375 1.15625,0.609375 0.984375,0 1.671875,-0.90625 1.671875,-2.203125 0,-1.296875 -0.6875,-2.171875 -1.703125,-2.171875 -0.53125,0 -0.890625,0.203125 -1.171875,0.640625 0,-0.1875 -0.03125,-0.40625 -0.07813,-0.53125 h -0.8125 c 0.0625,0.28125 0.07813,0.546875 0.07813,1.28125 z m 1.84375,-5.28125 c 0.59375,0 0.953125,0.5625 0.953125,1.453125 0,0.921875 -0.359375,1.453125 -0.953125,1.453125 -0.609375,0 -1,-0.578125 -1,-1.4375 0,-0.890625 0.390625,-1.46875 1,-1.46875 z m 0,0 m -5.37048,-2.421875 c -1.484375,0 -2.53125,1.21875 -2.53125,3 0,1.859375 1,3.078125 2.53125,3.078125 1.515625,0 2.53125,-1.234375 2.53125,-3.046875 0,-1.8125 -1.015625,-3.03125 -2.53125,-3.03125 z m 0,0.78125 c 0.96875,0 1.578125,0.875 1.578125,2.25 0,1.390625 -0.609375,2.265625 -1.578125,2.265625 -0.984375,0 -1.578125,-0.875 -1.578125,-2.296875 0,-1.34375 0.609375,-2.21875 1.578125,-2.21875 z m 0,0 m 36.34131,-7.90375 v 0.640625 h 2.34375 v -0.640625 z m 0,0 m -2.35029,-1.640625 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V -10.56 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.04687 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 m -2.850395,-0.125 c -1.125,0 -1.953125,0.921875 -1.953125,2.171875 0,1.328125 0.796875,2.234375 1.953125,2.234375 1.140625,0 1.9375,-0.90625 1.9375,-2.1875 0,-1.296875 -0.796875,-2.21875 -1.9375,-2.21875 z m 0,0.703125 c 0.625,0 1.0625,0.625 1.0625,1.515625 0,0.875 -0.4375,1.484375 -1.0625,1.484375 -0.640625,0 -1.0625,-0.59375 -1.0625,-1.515625 0,-0.875 0.4375,-1.484375 1.0625,-1.484375 z m 0,0 m -3.45771,-0.578125 0.01563,-1.203125 h -0.828125 l -0.03125,1.203125 h -0.65625 L -23.80567,-14.06 h 0.640625 l -0.04687,1.859375 c -0.01563,0.421875 -0.01563,0.421875 -0.01563,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 l 0.01563,-0.734375 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -22.30567,-14.06 h 0.921875 v -0.671875 z m 0,0 m -3.09057,0 -1.640625,1.921875 1.65625,2.25 h 1.15625 l -1.78125,-2.265625 1.65625,-1.90625 z M -27.89624,-16.46625 V -10.56 h 0.859375 v -5.90625 z m 0,0 m -3.621645,2.90625 c 0.07813,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.01563,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 m -5.577575,-1.640625 v -1.640625 h 2.5625 V -16.435 h -3.46875 v 5.875 h 0.90625 v -2.640625 h 2.359375 V -13.9975 Z m 0,0"
                  />
                </g>
              </g>
            )}
          </g>
        </g>
        <g
          id="circle-12"
          onMouseEnter={handleCircleMouseEnter}
          onMouseLeave={handleCircleMouseLeave}
          onMouseDown={handleCircleMouseDown}
        >
          <path
            className="circle-color"
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: 'rgb(41.175842%,25.097656%,39.99939%)',
              fillOpacity: 1
            }}
            d="M 775.0625 362.292969 C 792.089844 362.292969 805.890625 348.492188 805.890625 331.464844 C 805.890625 314.441406 792.089844 300.640625 775.0625 300.640625 C 758.039062 300.640625 744.238281 314.441406 744.238281 331.464844 C 744.238281 348.492188 758.039062 362.292969 775.0625 362.292969 "
            id="circle-12-path"
          />
          <g style={{ pointerEvents: 'none' }}>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5820"
            >
              <g id="use5812" transform="translate(754.83752,329.13809)" />
              <g id="use5814" transform="translate(760.05591,329.13809)" />
              <g id="use5816" transform="translate(764.69348,329.13809)" />
              <g id="use5818" transform="translate(769.27832,329.13809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5824"
            >
              <g id="use5822" transform="translate(773.47589,329.13809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5836"
            >
              <g id="use5826" transform="translate(777.7439,329.13809)" />
              <g id="use5828" transform="translate(780.09351,329.13809)" />
              <g id="use5830" transform="translate(784.67828,329.13809)" />
              <g id="use5832" transform="translate(789.32471,329.13809)" />
              <g id="use5834" transform="translate(792.29028,329.13809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5840"
            >
              <use x="794.6396" y="329.1381" id="use5838" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5846"
            >
              <g id="use5842" transform="translate(746.09491,339.69809)" />
              <g id="use5844" transform="translate(751.90289,339.69809)" />
            </g>
            <g
              style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
              id="g5862"
            >
              <g id="use5848" transform="translate(756.47009,339.69809)" />
              <g id="use5850" transform="translate(759.43573,339.69809)" />
              <g id="use5852" transform="translate(761.56531,339.69809)" />
              <g id="use5854" transform="translate(766.15009,339.69809)" />
              <g id="use5856" transform="translate(770.78772,339.69809)" />
              <g id="use5858" transform="translate(774.86212,339.69809)" />
              <g id="use5860" transform="translate(778.93652,339.69809)" />
            </g>
            {props.lang === 'en' ? (
              <g
                style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
                id="g5874"
              >
                <g id="use5864" transform="translate(775.52643,339.69809)" />
                <g id="use5866" transform="translate(775.52643,339.69809)" />
                <g id="use5868" transform="translate(779.88239,339.69809)" />
                <g id="use5870" transform="translate(784.52002,339.69809)" />
                <g id="use5872" transform="translate(787.4856,339.69809)">
                  <path
                    id="path20703"
                    style={{ stroke: 'none' }}
                    d="m 3.65625,-2.953125 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 C 3.6875,-1.5 3.609375,-1.734375 3.453125,-1.9375 3.265625,-2.125 3,-2.265625 2.359375,-2.453125 1.515625,-2.6875 1.375,-2.78125 1.375,-3.09375 c 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 M -1.231205,-4.171875 -1.21558,-5.375 h -0.828125 l -0.03125,1.203125 h -0.65625 L -2.74683,-3.5 h 0.640625 l -0.046875,1.859375 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L -0.21558,-0.8125 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -1.24683,-3.5 h 0.921875 v -0.671875 z m 0,0 m -5.85638,0 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V 0 h 0.859375 v -2.21875 c 0,-0.40625 0.046875,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.078125,0.171875 0.109375,0.359375 0.109375,0.859375 V 0 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.015625,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 M -10.599795,-3 c 0.07813,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.015625,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 m -5.46778,-2.375 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V 0 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.046875 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 m -3.11523,0 c 0.04687,0.359375 0.04687,0.4375 0.04687,1.34375 V 0 h 0.875 v -1.90625 c 0,-0.46875 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.375 0.421875,-0.578125 0.75,-0.578125 0.203125,0 0.375,0.046875 0.609375,0.1875 v -0.875 c -0.171875,-0.0625 -0.296875,-0.09375 -0.40625,-0.09375 -0.484375,0 -0.84375,0.3125 -1.15625,0.984375 0.01563,-0.109375 0.01563,-0.171875 0.01563,-0.234375 0,-0.21875 -0.03125,-0.4375 -0.0625,-0.640625 z m 0,0 M -21.195015,-3 c 0.07813,-0.390625 0.34375,-0.578125 0.828125,-0.578125 0.515625,0 0.71875,0.203125 0.71875,0.75 v 0.109375 c -0.921875,0.171875 -1.171875,0.21875 -1.5625,0.375 -0.625,0.234375 -0.953125,0.65625 -0.953125,1.25 0,0.734375 0.546875,1.1875 1.421875,1.1875 0.578125,0 0.96875,-0.203125 1.203125,-0.609375 0,0.21875 0.01563,0.328125 0.0625,0.515625 h 0.796875 c -0.09375,-0.25 -0.125,-0.453125 -0.125,-1.015625 v -1.625 c 0,-0.53125 -0.03125,-0.75 -0.140625,-0.984375 -0.171875,-0.40625 -0.671875,-0.65625 -1.375,-0.65625 -0.53125,0 -0.984375,0.140625 -1.28125,0.390625 -0.25,0.21875 -0.375,0.46875 -0.421875,0.890625 z m 1.546875,1.203125 c 0,0.375 -0.03125,0.609375 -0.125,0.765625 -0.140625,0.28125 -0.4375,0.4375 -0.796875,0.4375 -0.421875,0 -0.703125,-0.234375 -0.703125,-0.609375 0,-0.5 0.421875,-0.734375 1.625,-0.921875 z m 0,0 M -29.458625,-5.875 -28.0055,0.015625 h 1.015625 l 1.046875,-4.171875 1.0625,4.171875 h 1 L -22.41175,-5.875 H -23.2555 L -24.396125,-1.09375 -25.53675,-5.875 H -26.318 l -1.15625,4.78125 -1.125,-4.78125 z m 0,0 M 5.359985,-14.731875 5.37561,-15.935 H 4.547485 l -0.03125,1.203125 H 3.859985 L 3.84436,-14.06 h 0.640625 l -0.046875,1.859375 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L 6.37561,-11.3725 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L 5.34436,-14.06 h 0.921875 v -0.671875 z m 0,0 m -5.787055,0 v 2.484375 c 0,0.5625 0.0625,0.90625 0.21875,1.15625 0.25,0.390625 0.703125,0.625 1.25,0.625 0.53125,0 0.859375,-0.1875 1.140625,-0.609375 C 2.19793,-10.8725 2.22918,-10.685 2.276055,-10.56 H 3.10418 c -0.109375,-0.34375 -0.109375,-0.34375 -0.109375,-1.28125 v -2.890625 H 2.13543 V -12.435 c 0,0.359375 -0.046875,0.59375 -0.140625,0.78125 -0.171875,0.28125 -0.4375,0.421875 -0.765625,0.421875 -0.28125,0 -0.515625,-0.109375 -0.65625,-0.28125 C 0.47918,-11.65375 0.432305,-11.90375 0.432305,-12.27875 v -2.453125 z m 0,0 m -3.49548,-1.796875 c -1.484375,0 -2.53125,1.21875 -2.53125,3 0,1.859375 1,3.078125 2.53125,3.078125 1.515625,0 2.53125,-1.234375 2.53125,-3.046875 0,-1.8125 -1.015625,-3.03125 -2.53125,-3.03125 z m 0,0.78125 c 0.96875,0 1.578125,0.875 1.578125,2.25 0,1.390625 -0.609375,2.265625 -1.578125,2.265625 -0.984375,0 -1.578125,-0.875 -1.578125,-2.296875 0,-1.34375 0.609375,-2.21875 1.578125,-2.21875 z m 0,0 m -5.25586,2.65625 v 0.640625 h 2.34375 v -0.640625 z m 0,0 m -1.127385,-1.640625 -1.640625,1.921875 1.65625,2.25 h 1.15625 l -1.78125,-2.265625 1.65625,-1.90625 z M -12.82142,-16.46625 V -10.56 h 0.859375 v -5.90625 z m 0,0 m -0.94757,3.109375 c -0.125,-0.96875 -0.6875,-1.5 -1.625,-1.5 -1.15625,0 -1.90625,0.875 -1.90625,2.21875 0,1.3125 0.75,2.1875 1.90625,2.1875 0.953125,0 1.578125,-0.59375 1.640625,-1.5625 h -0.84375 c -0.0625,0.59375 -0.3125,0.859375 -0.796875,0.859375 -0.640625,0 -1.015625,-0.546875 -1.015625,-1.484375 0,-0.921875 0.390625,-1.515625 1,-1.515625 0.453125,0 0.6875,0.234375 0.78125,0.796875 z m 0,0 m -6.162965,-1.5 c -1.125,0 -1.953125,0.921875 -1.953125,2.171875 0,1.328125 0.796875,2.234375 1.953125,2.234375 1.140625,0 1.9375,-0.90625 1.9375,-2.1875 0,-1.296875 -0.796875,-2.21875 -1.9375,-2.21875 z m 0,0.703125 c 0.625,0 1.0625,0.625 1.0625,1.515625 0,0.875 -0.4375,1.484375 -1.0625,1.484375 -0.640625,0 -1.0625,-0.59375 -1.0625,-1.515625 0,-0.875 0.4375,-1.484375 1.0625,-1.484375 z m 0,0 m -6.41882,-0.578125 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V -10.56 h 0.859375 v -2.21875 c 0,-0.40625 0.04687,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.07813,0.171875 0.109375,0.359375 0.109375,0.859375 V -10.56 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.01563,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -1.827755,-1.703125 -2.25,2.78125 2.3125,3.09375 h 1.1875 l -2.46875,-3.125 2.28125,-2.75 z m -3.171875,0 v 5.875 h 0.90625 v -5.875 z m 0,0"
                  />
                </g>
              </g>
            ) : (
              <g
                style={{ fill: 'rgb(100%,100%,100%)', fillOpacity: 1 }}
                id="g5874"
              >
                <g id="use5864" transform="translate(783.13409,339.69809)" />
                <g id="use5866" transform="translate(787.7981,339.69809)" />
                <g id="use5868" transform="translate(792.20691,339.69809)" />
                <g id="use5870" transform="translate(794.33649,339.69809)" />
                <g id="use5872" transform="translate(798.97412,339.69809)">
                  <path
                    id="path20703"
                    style={{ stroke: 'none' }}
                    d="m 4.0625,-1.90625 c 0.015625,-0.078125 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 C 3.15625,0.109375 3.75,-0.3125 3.96875,-1.09375 L 3.203125,-1.140625 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z M 1.234375,-2.546875 C 1.375,-3.25 1.703125,-3.59375 2.25,-3.59375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 m -5.35638,-1.625 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V 0 h 0.859375 v -2.21875 c 0,-0.40625 0.046875,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.078125,0.171875 0.109375,0.359375 0.109375,0.859375 V 0 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.015625,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -2.020205,0 V 0 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -1.424435,4.0625 c 0.015625,-0.078125 0.015625,-0.15625 0.015625,-0.171875 0,-1.359375 -0.703125,-2.21875 -1.8125,-2.21875 -1.15625,0 -1.921875,0.90625 -1.921875,2.25 0,1.3125 0.78125,2.15625 1.953125,2.15625 0.859375,0 1.453125,-0.421875 1.671875,-1.203125 l -0.765625,-0.046875 c -0.1875,0.375 -0.453125,0.546875 -0.875,0.546875 -0.6875,0 -1.078125,-0.46875 -1.109375,-1.3125 z M -9.941645,-2.546875 C -9.80102,-3.25 -9.472895,-3.59375 -8.92602,-3.59375 c 0.53125,0 0.859375,0.34375 0.9375,1.046875 z m 0,0 M -15.21503,-5.90625 V 0 h 0.859375 v -2.21875 c 0,-0.375 0.04687,-0.625 0.15625,-0.828125 0.15625,-0.28125 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.671875,0.390625 0.09375,0.171875 0.109375,0.40625 0.109375,0.859375 V 0 h 0.875 v -2.40625 c 0,-0.765625 -0.04687,-1.046875 -0.21875,-1.3125 -0.21875,-0.34375 -0.671875,-0.5625 -1.171875,-0.5625 -0.5,0 -0.890625,0.1875 -1.203125,0.578125 V -5.90625 Z m 0,0 m -0.94757,3.109375 c -0.125,-0.96875 -0.6875,-1.5 -1.625,-1.5 -1.15625,0 -1.90625,0.875 -1.90625,2.21875 0,1.3125 0.75,2.1875 1.90625,2.1875 0.953125,0 1.578125,-0.59375 1.640625,-1.5625 h -0.84375 c -0.0625,0.59375 -0.3125,0.859375 -0.796875,0.859375 -0.640625,0 -1.015625,-0.546875 -1.015625,-1.484375 0,-0.921875 0.390625,-1.515625 1,-1.515625 0.453125,0 0.6875,0.234375 0.78125,0.796875 z m 0,0 m -4.29315,-0.15625 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 0,-0.296875 -0.07813,-0.53125 -0.234375,-0.734375 -0.1875,-0.1875 -0.453125,-0.328125 -1.09375,-0.515625 C -22.596375,-2.6875 -22.737,-2.78125 -22.737,-3.09375 c 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 m -4.0744,0 c -0.0625,-0.859375 -0.625,-1.34375 -1.578125,-1.34375 -0.9375,0 -1.5625,0.515625 -1.5625,1.28125 0,0.28125 0.09375,0.546875 0.265625,0.734375 0.171875,0.171875 0.40625,0.296875 0.859375,0.421875 0.671875,0.203125 0.765625,0.234375 0.90625,0.3125 0.203125,0.109375 0.28125,0.21875 0.28125,0.40625 0,0.34375 -0.296875,0.578125 -0.765625,0.578125 -0.5625,0 -0.84375,-0.25 -0.890625,-0.78125 h -0.8125 c 0,0.953125 0.609375,1.453125 1.71875,1.453125 1.015625,0 1.609375,-0.5 1.609375,-1.3125 0,-0.296875 -0.07813,-0.53125 -0.234375,-0.734375 -0.1875,-0.1875 -0.453125,-0.328125 -1.09375,-0.515625 -0.84375,-0.234375 -0.984375,-0.328125 -0.984375,-0.640625 0,-0.296875 0.28125,-0.515625 0.6875,-0.515625 0.453125,0 0.6875,0.203125 0.75,0.65625 z m 0,0 m -7.778255,-1.21875 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V 0 h 0.859375 v -2.21875 c 0,-0.40625 0.04687,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.07813,0.171875 0.109375,0.359375 0.109375,0.859375 V 0 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.01563,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -2.80353,-0.125 c -1.125,0 -1.953125,0.921875 -1.953125,2.171875 0,1.328125 0.796875,2.234375 1.953125,2.234375 1.140625,0 1.9375,-0.90625 1.9375,-2.1875 0,-1.296875 -0.796875,-2.21875 -1.9375,-2.21875 z m 0,0.703125 c 0.625,0 1.0625,0.625 1.0625,1.515625 0,0.875 -0.4375,1.484375 -1.0625,1.484375 -0.640625,0 -1.0625,-0.59375 -1.0625,-1.515625 0,-0.875 0.4375,-1.484375 1.0625,-1.484375 z m 0,0 M -38.91339,-4.171875 V 0 h 0.875 v -4.171875 z m 0.453125,-1.796875 c -0.328125,0 -0.5625,0.234375 -0.5625,0.5625 0,0.3125 0.21875,0.53125 0.546875,0.53125 0.328125,0 0.546875,-0.21875 0.546875,-0.53125 0,-0.328125 -0.21875,-0.5625 -0.53125,-0.5625 z m 0,0 m -2.30939,1.796875 0.01563,-1.203125 h -0.828125 l -0.03125,1.203125 h -0.65625 L -42.28528,-3.5 h 0.640625 l -0.04687,1.859375 c -0.01563,0.421875 -0.01563,0.421875 -0.01563,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 l 0.01563,-0.734375 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -40.78528,-3.5 h 0.921875 v -0.671875 z m 0,0 m -5.676575,5.90625 h 0.859375 v -2.25 c 0.328125,0.4375 0.65625,0.609375 1.15625,0.609375 0.984375,0 1.671875,-0.90625 1.671875,-2.203125 0,-1.296875 -0.6875,-2.171875 -1.703125,-2.171875 -0.53125,0 -0.890625,0.203125 -1.171875,0.640625 0,-0.1875 -0.03125,-0.40625 -0.07813,-0.53125 h -0.8125 c 0.0625,0.28125 0.07813,0.546875 0.07813,1.28125 z m 1.84375,-5.28125 c 0.59375,0 0.953125,0.5625 0.953125,1.453125 0,0.921875 -0.359375,1.453125 -0.953125,1.453125 -0.609375,0 -1,-0.578125 -1,-1.4375 0,-0.890625 0.390625,-1.46875 1,-1.46875 z m 0,0 m -5.37048,-2.421875 c -1.484375,0 -2.53125,1.21875 -2.53125,3 0,1.859375 1,3.078125 2.53125,3.078125 1.515625,0 2.53125,-1.234375 2.53125,-3.046875 0,-1.8125 -1.015625,-3.03125 -2.53125,-3.03125 z m 0,0.78125 c 0.96875,0 1.578125,0.875 1.578125,2.25 0,1.390625 -0.609375,2.265625 -1.578125,2.265625 -0.984375,0 -1.578125,-0.875 -1.578125,-2.296875 0,-1.34375 0.609375,-2.21875 1.578125,-2.21875 z m 0,0 m 43.28912,-7.90375 v 0.640625 h 2.34375 v -0.640625 z m 0,0 M -7.915035,-14.731875 -7.89941,-15.935 h -0.828125 l -0.03125,1.203125 h -0.65625 L -9.43066,-14.06 h 0.640625 l -0.046875,1.859375 c -0.015625,0.421875 -0.015625,0.421875 -0.015625,0.515625 0,0.40625 0.03125,0.59375 0.140625,0.765625 0.1875,0.28125 0.515625,0.453125 0.953125,0.453125 0.296875,0 0.546875,-0.0625 0.84375,-0.171875 L -6.89941,-11.3725 c -0.21875,0.09375 -0.421875,0.140625 -0.625,0.140625 -0.34375,0 -0.4375,-0.140625 -0.4375,-0.625 0,-0.0625 0,-0.0625 0,-0.34375 L -7.93066,-14.06 h 0.921875 v -0.671875 z m 0,0 m -5.787055,0 v 2.484375 c 0,0.5625 0.0625,0.90625 0.21875,1.15625 0.25,0.390625 0.703125,0.625 1.25,0.625 0.53125,0 0.859375,-0.1875 1.140625,-0.609375 0.01563,0.203125 0.04687,0.390625 0.09375,0.515625 h 0.828125 c -0.109375,-0.34375 -0.109375,-0.34375 -0.109375,-1.28125 v -2.890625 H -11.13959 V -12.435 c 0,0.359375 -0.04687,0.59375 -0.140625,0.78125 -0.171875,0.28125 -0.4375,0.421875 -0.765625,0.421875 -0.28125,0 -0.515625,-0.109375 -0.65625,-0.28125 -0.09375,-0.140625 -0.140625,-0.390625 -0.140625,-0.765625 v -2.453125 z m 0,0 m -2.881645,-0.125 c -1.125,0 -1.953125,0.921875 -1.953125,2.171875 0,1.328125 0.796875,2.234375 1.953125,2.234375 1.140625,0 1.9375,-0.90625 1.9375,-2.1875 0,-1.296875 -0.796875,-2.21875 -1.9375,-2.21875 z m 0,0.703125 c 0.625,0 1.0625,0.625 1.0625,1.515625 0,0.875 -0.4375,1.484375 -1.0625,1.484375 -0.640625,0 -1.0625,-0.59375 -1.0625,-1.515625 0,-0.875 0.4375,-1.484375 1.0625,-1.484375 z m 0,0 m -4.646485,1.0625 v 0.640625 h 2.34375 v -0.640625 z m 0,0 m -1.127385,-1.640625 -1.640625,1.921875 1.65625,2.25 h 1.15625 l -1.78125,-2.265625 1.65625,-1.90625 z M -24.87323,-16.46625 V -10.56 h 0.859375 v -5.90625 z m 0,0 m -0.94757,3.109375 c -0.125,-0.96875 -0.6875,-1.5 -1.625,-1.5 -1.15625,0 -1.90625,0.875 -1.90625,2.21875 0,1.3125 0.75,2.1875 1.90625,2.1875 0.953125,0 1.578125,-0.59375 1.640625,-1.5625 h -0.84375 c -0.0625,0.59375 -0.3125,0.859375 -0.796875,0.859375 -0.640625,0 -1.015625,-0.546875 -1.015625,-1.484375 0,-0.921875 0.390625,-1.515625 1,-1.515625 0.453125,0 0.6875,0.234375 0.78125,0.796875 z m 0,0 m -6.162965,-1.5 c -1.125,0 -1.953125,0.921875 -1.953125,2.171875 0,1.328125 0.796875,2.234375 1.953125,2.234375 1.140625,0 1.9375,-0.90625 1.9375,-2.1875 0,-1.296875 -0.796875,-2.21875 -1.9375,-2.21875 z m 0,0.703125 c 0.625,0 1.0625,0.625 1.0625,1.515625 0,0.875 -0.4375,1.484375 -1.0625,1.484375 -0.640625,0 -1.0625,-0.59375 -1.0625,-1.515625 0,-0.875 0.4375,-1.484375 1.0625,-1.484375 z m 0,0 m -6.41882,-0.578125 c 0.109375,0.390625 0.109375,0.4375 0.109375,1.453125 V -10.56 h 0.859375 v -2.21875 c 0,-0.40625 0.04687,-0.65625 0.15625,-0.828125 0.15625,-0.296875 0.453125,-0.46875 0.78125,-0.46875 0.3125,0 0.546875,0.140625 0.65625,0.390625 0.07813,0.171875 0.109375,0.359375 0.109375,0.859375 V -10.56 h 0.859375 v -2.40625 c 0,-0.765625 -0.03125,-0.953125 -0.171875,-1.234375 -0.203125,-0.390625 -0.640625,-0.640625 -1.1875,-0.640625 -0.546875,0 -0.96875,0.21875 -1.25,0.671875 -0.01563,-0.265625 -0.03125,-0.40625 -0.09375,-0.5625 z m 0,0 m -1.827765,-1.703125 -2.25,2.78125 2.3125,3.09375 h 1.1875 l -2.46875,-3.125 2.28125,-2.75 z m -3.171875,0 v 5.875 h 0.90625 v -5.875 z m 0,0"
                  />
                </g>
              </g>
            )}
          </g>
        </g>
        <g
          style={{
            fill: 'rgb(7.843018%,14.117432%,27.058411%)',
            fillOpacity: 1
          }}
          id="g5892"
        >
          <g id="use5876" transform="translate(36.738499,81.5168)" />
          <g id="use5878" transform="translate(44.9105,81.5168)" />
          <g id="use5880" transform="translate(51.342499,81.5168)" />
          <g id="use5882" transform="translate(58.002499,81.5168)" />
          <g id="use5884" transform="translate(64.182503,81.5168)" />
          <g id="use5886" transform="translate(67.182503,81.5168)" />
          <g id="use5888" transform="translate(73.962502,81.5168)" />
          <g id="use5890" transform="translate(77.094498,81.5168)" />
        </g>
        <g
          style={{
            fill: 'rgb(7.843018%,14.117432%,27.058411%)',
            fillOpacity: 1
          }}
          id="g5900"
        >
          <g id="use5894" transform="translate(82.998497,81.5168)" />
          <g id="use5896" transform="translate(89.658501,81.5168)" />
          <g id="use5898" transform="translate(95.838501,81.5168)" />
        </g>
        <g
          style={{
            fill: 'rgb(7.843018%,14.117432%,27.058411%)',
            fillOpacity: 1
          }}
          id="g5916"
        >
          <g id="use5902" transform="translate(100.2545,81.5168)" />
          <g id="use5904" transform="translate(106.9145,81.5168)" />
          <g id="use5906" transform="translate(113.0945,81.5168)" />
          <g id="use5908" transform="translate(116.2265,81.5168)" />
          <g id="use5910" transform="translate(120.5105,81.5168)" />
          <g id="use5912" transform="translate(126.3305,81.5168)" />
          <g id="use5914" transform="translate(132.7625,81.5168)" />
        </g>
        <g
          style={{
            fill: 'rgb(7.843018%,14.117432%,27.058411%)',
            fillOpacity: 1
          }}
          id="g5932"
        >
          <g id="use5918" transform="translate(137.17731,81.5168)" />
          <g id="use5920" transform="translate(140.3093,81.5168)" />
          <g id="use5922" transform="translate(146.4893,81.5168)" />
          <g id="use5924" transform="translate(153.06531,81.5168)" />
          <g id="use5926" transform="translate(157.3493,81.5168)" />
          <g id="use5928" transform="translate(160.48129,81.5168)" />
          <g id="use5930" transform="translate(166.6613,81.5168)" />
        </g>
        {props.lang === 'en' ? (
          <g
            style={{
              fill: 'rgb(7.843018%,14.117432%,27.058411%)',
              fillOpacity: 1
            }}
            id="g5940"
          >
            <g id="use5934" transform="translate(140.8613,81.5168)" />
            <g id="use5936" transform="translate(143.9933,81.5168)" />
            <g id="use5938" transform="translate(148.2773,71.5168)">
              <path
                id="path15448"
                style={{ stroke: 'none' }}
                d="m 0.1875,-5.703125 2.015625,5.96875 C 1.9375,0.96875 1.59375,1.140625 0.34375,1.109375 V 2.40625 c 0.234375,0 0.4375,0 0.546875,0 1.25,0 1.9375,-0.296875 2.40625,-1.0625 0.265625,-0.40625 0.28125,-0.453125 0.65625,-1.5 L 5.875,-5.703125 H 4.34375 L 3.03125,-1.359375 1.75,-5.703125 Z m 0,0 m -1.81525,0 0.015625,-1.640625 H -3.034 l -0.03125,1.640625 h -0.9375 v 1.15625 h 0.875 l -0.078125,2.21875 -0.015625,0.5625 c 0,0.625 0.0625,0.90625 0.25,1.1875 C -2.705875,-0.125 -2.205875,0.125 -1.56525,0.125 c 0.453125,0 0.84375,-0.09375 1.296875,-0.265625 V -1.375 c -0.3125,0.140625 -0.578125,0.203125 -0.84375,0.203125 -0.453125,0 -0.59375,-0.1875 -0.59375,-0.78125 0,-0.109375 0,-0.109375 0.015625,-0.40625 l 0.03125,-2.1875 h 1.1875 v -1.15625 z m 0,0 m -4.960125,0 V 0 h 1.46875 V -5.703125 Z M -5.82225,-8.15625 c -0.53125,0 -0.890625,0.34375 -0.890625,0.875 0,0.515625 0.34375,0.84375 0.875,0.84375 0.515625,0 0.84375,-0.34375 0.84375,-0.875 0,-0.5 -0.328125,-0.84375 -0.828125,-0.84375 z m 0,0 m -5.25855,2.453125 c 0.04687,0.3125 0.04687,0.4375 0.04687,0.75 0.01563,0.421875 0.01563,0.75 0.01563,1 V 0 h 1.484375 v -2.65625 c 0,-1.265625 0.359375,-1.875 1.140625,-1.875 0.3125,0 0.609375,0.109375 0.875,0.28125 v -1.5 c -0.234375,-0.0625 -0.28125,-0.0625 -0.4375,-0.0625 -0.6875,0 -1.1875,0.375 -1.640625,1.296875 C -9.5808,-4.640625 -9.5808,-4.75 -9.5808,-4.8125 c 0,-0.328125 -0.046875,-0.640625 -0.109375,-0.890625 z m 0,0 m -6.62875,0 V -2.375 c 0,0.75 0.109375,1.296875 0.328125,1.625 0.34375,0.546875 1,0.875 1.765625,0.875 0.6875,0 1.140625,-0.21875 1.59375,-0.78125 0,0.265625 0.0625,0.53125 0.109375,0.65625 h 1.390625 c -0.140625,-0.5 -0.140625,-0.5 -0.140625,-1.765625 v -3.9375 h -1.46875 v 3.046875 c 0,1 -0.375,1.484375 -1.125,1.484375 -0.34375,0 -0.625,-0.125 -0.78125,-0.34375 C -16.162675,-1.6875 -16.2408,-2 -16.2408,-2.453125 v -3.25 z m 0,0 m -1.229625,1.890625 c -0.171875,-1.328125 -1,-2.046875 -2.359375,-2.046875 -1.65625,0 -2.765625,1.203125 -2.765625,3.015625 0,1.78125 1.109375,3 2.734375,3 1.390625,0 2.359375,-0.875 2.4375,-2.1875 h -1.4375 c -0.07813,0.671875 -0.40625,1 -1,1 -0.765625,0 -1.21875,-0.671875 -1.21875,-1.8125 0,-1.109375 0.5,-1.828125 1.25,-1.828125 0.515625,0 0.828125,0.296875 0.90625,0.859375 z m 0,0 m -5.93,1.3125 v -0.28125 c 0,-1.90625 -0.984375,-3.078125 -2.59375,-3.078125 -1.671875,0 -2.78125,1.234375 -2.78125,3.078125 0,1.796875 1.09375,2.9375 2.828125,2.9375 1.25,0 2.1875,-0.671875 2.4375,-1.765625 l -1.296875,-0.0625 c -0.203125,0.4375 -0.5625,0.640625 -1.109375,0.640625 -0.828125,0 -1.328125,-0.53125 -1.375,-1.46875 z m -3.859375,-1.078125 c 0.1875,-0.765625 0.609375,-1.140625 1.25,-1.140625 0.640625,0 1,0.375 1.125,1.140625 z m 0,0 m -2.460625,-0.390625 c -0.07813,-1.203125 -0.921875,-1.90625 -2.3125,-1.90625 -1.375,0 -2.28125,0.75 -2.28125,1.859375 0,0.40625 0.140625,0.78125 0.390625,1.03125 0.234375,0.21875 0.5625,0.375 1.1875,0.578125 1.015625,0.296875 1.015625,0.296875 1.1875,0.375 0.296875,0.125 0.390625,0.25 0.390625,0.453125 0,0.375 -0.34375,0.625 -0.90625,0.625 -0.703125,0 -1.03125,-0.28125 -1.078125,-0.953125 h -1.390625 c 0,1.359375 0.859375,2.0625 2.53125,2.0625 1.46875,0 2.3125,-0.6875 2.3125,-1.84375 0,-0.375 -0.109375,-0.71875 -0.328125,-0.96875 -0.234375,-0.28125 -0.59375,-0.46875 -1.4375,-0.71875 -0.875,-0.25 -0.984375,-0.28125 -1.15625,-0.390625 -0.15625,-0.09375 -0.234375,-0.25 -0.234375,-0.40625 0,-0.34375 0.328125,-0.59375 0.78125,-0.59375 0.5625,0 0.84375,0.25 0.921875,0.796875 z m 0,0 m -14.201,-1.734375 c 0.171875,0.5625 0.1875,0.65625 0.1875,2.046875 V 0 h 1.46875 v -2.921875 c 0,-0.5625 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.359375 0.515625,-0.59375 0.9375,-0.59375 0.359375,0 0.640625,0.171875 0.78125,0.484375 0.09375,0.21875 0.140625,0.5 0.140625,1.078125 V 0 h 1.46875 v -3.28125 c 0,-1.03125 -0.04687,-1.328125 -0.265625,-1.703125 -0.296875,-0.53125 -0.921875,-0.828125 -1.625,-0.828125 -0.703125,0 -1.28125,0.28125 -1.6875,0.84375 0,-0.3125 -0.04687,-0.546875 -0.125,-0.734375 z m 0,0 m -3.853876,-0.15625 c -1.625,0 -2.828125,1.265625 -2.828125,2.96875 0,1.796875 1.15625,3.046875 2.828125,3.046875 1.625,0 2.8125,-1.265625 2.8125,-3 0,-1.75 -1.1875,-3.015625 -2.8125,-3.015625 z m 0,1.1875 c 0.765625,0 1.296875,0.75 1.296875,1.8125 0,1.078125 -0.53125,1.828125 -1.296875,1.828125 -0.796875,0 -1.3125,-0.734375 -1.3125,-1.84375 0,-1.046875 0.546875,-1.796875 1.3125,-1.796875 z m 0,0 m -6.773125,0.703125 c -0.07813,-1.203125 -0.921875,-1.90625 -2.3125,-1.90625 -1.375,0 -2.28125,0.75 -2.28125,1.859375 0,0.40625 0.140625,0.78125 0.390625,1.03125 0.234375,0.21875 0.5625,0.375 1.1875,0.578125 1.015625,0.296875 1.015625,0.296875 1.1875,0.375 0.296875,0.125 0.390625,0.25 0.390625,0.453125 0,0.375 -0.34375,0.625 -0.90625,0.625 -0.703125,0 -1.03125,-0.28125 -1.078125,-0.953125 h -1.390625 c 0,1.359375 0.859375,2.0625 2.53125,2.0625 1.46875,0 2.3125,-0.6875 2.3125,-1.84375 0,-0.375 -0.109375,-0.71875 -0.328125,-0.96875 -0.234375,-0.28125 -0.59375,-0.46875 -1.4375,-0.71875 -0.875,-0.25 -0.984375,-0.28125 -1.15625,-0.390625 -0.15625,-0.09375 -0.234375,-0.25 -0.234375,-0.40625 0,-0.34375 0.328125,-0.59375 0.78125,-0.59375 0.5625,0 0.84375,0.25 0.921875,0.796875 z m 0,0 M -67.161547,-5.703125 V -2.375 c 0,0.75 0.109375,1.296875 0.328125,1.625 0.34375,0.546875 1,0.875 1.765625,0.875 0.6875,0 1.140625,-0.21875 1.59375,-0.78125 0,0.265625 0.0625,0.53125 0.109375,0.65625 h 1.390625 c -0.140625,-0.5 -0.140625,-0.5 -0.140625,-1.765625 v -3.9375 h -1.46875 v 3.046875 c 0,1 -0.375,1.484375 -1.125,1.484375 -0.34375,0 -0.625,-0.125 -0.78125,-0.34375 -0.125,-0.171875 -0.203125,-0.484375 -0.203125,-0.9375 v -3.25 z m 0,0 m -1.229629,1.890625 c -0.171875,-1.328125 -1,-2.046875 -2.359375,-2.046875 -1.65625,0 -2.765625,1.203125 -2.765625,3.015625 0,1.78125 1.109375,3 2.734375,3 1.390625,0 2.359375,-0.875 2.4375,-2.1875 h -1.4375 c -0.07813,0.671875 -0.40625,1 -1,1 -0.765625,0 -1.21875,-0.671875 -1.21875,-1.8125 0,-1.109375 0.5,-1.828125 1.25,-1.828125 0.515625,0 0.828125,0.296875 0.90625,0.859375 z m 0,0 m -8.728875,-2.046875 c -1.625,0 -2.828125,1.265625 -2.828125,2.96875 0,1.796875 1.15625,3.046875 2.828125,3.046875 1.625,0 2.8125,-1.265625 2.8125,-3 0,-1.75 -1.1875,-3.015625 -2.8125,-3.015625 z m 0,1.1875 c 0.765625,0 1.296875,0.75 1.296875,1.8125 0,1.078125 -0.53125,1.828125 -1.296875,1.828125 -0.796875,0 -1.3125,-0.734375 -1.3125,-1.84375 0,-1.046875 0.546875,-1.796875 1.3125,-1.796875 z m 0,0 m -4.672874,-1.03125 V -5.84375 c 0,-0.90625 0.125,-1.125 0.625,-1.125 0.265625,0 0.515625,0.046875 0.96875,0.171875 v -1.1875 C -80.667925,-8.15625 -81.074175,-8.25 -81.49605,-8.25 c -0.671875,0 -1.171875,0.234375 -1.453125,0.671875 -0.234375,0.34375 -0.3125,0.75 -0.3125,1.515625 v 0.359375 H -84.0273 v 1.15625 h 0.765625 V 0 h 1.46875 v -4.546875 h 1.359375 v -1.15625 z m 0,0 m -11.25375,-2.34375 V 0 h 1.46875 v -2.921875 c 0,-0.484375 0.0625,-0.78125 0.15625,-1 0.203125,-0.375 0.578125,-0.609375 0.984375,-0.609375 0.359375,0 0.671875,0.1875 0.828125,0.515625 0.109375,0.21875 0.140625,0.484375 0.140625,1.046875 V 0 h 1.46875 v -3.28125 c 0,-1.03125 -0.0625,-1.375 -0.28125,-1.75 -0.3125,-0.484375 -0.953125,-0.78125 -1.640625,-0.78125 -0.671875,0 -1.203125,0.25 -1.65625,0.734375 v -2.96875 z m 0,0 m -1.0475,2.34375 -1.875,0.046875 c -0.46875,-0.125 -0.734375,-0.15625 -1.09375,-0.15625 -1.453125,0 -2.375,0.765625 -2.375,2 0,0.78125 0.296875,1.28125 0.96875,1.609375 -0.734375,0.296875 -1.015625,0.53125 -1.015625,0.921875 0,0.3125 0.1875,0.5 0.640625,0.6875 -0.796875,0.265625 -1.156255,0.671875 -1.156255,1.328125 0,1.03125 1.093755,1.671875 2.843755,1.671875 1.796875,0 2.84375,-0.6875 2.84375,-1.90625 0,-0.59375 -0.28125,-1.09375 -0.75,-1.34375 -0.34375,-0.1875 -0.796875,-0.28125 -1.765625,-0.375 -1.171875,-0.109375 -1.25,-0.140625 -1.25,-0.359375 0,-0.171875 0.234375,-0.3125 0.5625,-0.328125 1.234375,-0.125 1.28125,-0.125 1.671875,-0.296875 0.578125,-0.25 0.890625,-0.75 0.890625,-1.421875 0,-0.375 -0.109375,-0.734375 -0.296875,-1.015625 h 1.15625 z m -3.0625,1 c 0.5625,0 0.96875,0.34375 0.96875,0.875 0,0.5 -0.40625,0.84375 -1,0.84375 -0.59375,0 -0.984375,-0.34375 -0.984375,-0.84375 0,-0.546875 0.390625,-0.875 1.015625,-0.875 z m -0.171875,4.59375 c 1,0 1.59375,0.28125 1.59375,0.75 0,0.453125 -0.5,0.703125 -1.40625,0.703125 -1,0 -1.59375,-0.28125 -1.59375,-0.734375 0,-0.453125 0.515625,-0.71875 1.40625,-0.71875 z m 0,0 m -5.21012,-5.59375 V 0 h 1.46875 v -5.703125 z m 0.76562,-2.453125 c -0.53125,0 -0.89062,0.34375 -0.89062,0.875 0,0.515625 0.34375,0.84375 0.875,0.84375 0.51562,0 0.84375,-0.34375 0.84375,-0.875 0,-0.5 -0.32813,-0.84375 -0.82813,-0.84375 z m 0,0 m -7.26575,3.34375 V -8 h -1.54688 v 8 h 1.54688 v -3.546875 h 3.17187 V 0 h 1.54688 v -8 h -1.54688 v 3.1875 z m 0,0"
              />
            </g>
          </g>
        ) : (
          <g
            style={{
              fill: 'rgb(7.843018%,14.117432%,27.058411%)',
              fillOpacity: 1
            }}
            id="g5940"
          >
            <g id="use5934" transform="translate(171.08929,81.5168)" />
            <g id="use5936" transform="translate(177.7493,81.5168)" />
            <g id="use5938" transform="translate(184.3253,71.5168)">
              <path
                id="path15448"
                style={{ stroke: 'none' }}
                d="m 6.140625,-5.703125 -1.875,0.046875 c -0.46875,-0.125 -0.734375,-0.15625 -1.09375,-0.15625 -1.453125,0 -2.375,0.765625 -2.375,2 0,0.78125 0.296875,1.28125 0.96875,1.609375 C 1.03125,-1.90625 0.75,-1.671875 0.75,-1.28125 c 0,0.3125 0.1875,0.5 0.640625,0.6875 -0.796875,0.265625 -1.15625,0.671875 -1.15625,1.328125 0,1.03125 1.09375,1.671875 2.84375,1.671875 1.796875,0 2.84375,-0.6875 2.84375,-1.90625 0,-0.59375 -0.28125,-1.09375 -0.75,-1.34375 C 4.828125,-1.03125 4.375,-1.125 3.40625,-1.21875 c -1.171875,-0.109375 -1.25,-0.140625 -1.25,-0.359375 0,-0.171875 0.234375,-0.3125 0.5625,-0.328125 1.234375,-0.125 1.28125,-0.125 1.671875,-0.296875 0.578125,-0.25 0.890625,-0.75 0.890625,-1.421875 0,-0.375 -0.109375,-0.734375 -0.296875,-1.015625 h 1.15625 z m -3.0625,1 c 0.5625,0 0.96875,0.34375 0.96875,0.875 0,0.5 -0.40625,0.84375 -1,0.84375 -0.59375,0 -0.984375,-0.34375 -0.984375,-0.84375 0,-0.546875 0.390625,-0.875 1.015625,-0.875 z m -0.171875,4.59375 c 1,0 1.59375,0.28125 1.59375,0.75 C 4.5,1.09375 4,1.34375 3.09375,1.34375 2.09375,1.34375 1.5,1.0625 1.5,0.609375 c 0,-0.453125 0.515625,-0.71875 1.40625,-0.71875 z m 0,0 m -8.841625,-5.59375 c 0.171875,0.5625 0.1875,0.65625 0.1875,2.046875 V 0 h 1.46875 v -2.921875 c 0,-0.5625 0.046875,-0.78125 0.15625,-1.015625 0.15625,-0.359375 0.515625,-0.59375 0.9375,-0.59375 0.359375,0 0.640625,0.171875 0.78125,0.484375 0.09375,0.21875 0.140625,0.5 0.140625,1.078125 V 0 h 1.46875 v -3.28125 c 0,-1.03125 -0.046875,-1.328125 -0.265625,-1.703125 -0.296875,-0.53125 -0.921875,-0.828125 -1.625,-0.828125 -0.703125,0 -1.28125,0.28125 -1.6875,0.84375 0,-0.3125 -0.046875,-0.546875 -0.125,-0.734375 z m 0,0 m -6.519385,0 V -2.375 c 0,0.75 0.109375,1.296875 0.328125,1.625 0.34375,0.546875 1,0.875 1.765625,0.875 0.6875,0 1.140625,-0.21875 1.59375,-0.78125 0,0.265625 0.0625,0.53125 0.109375,0.65625 h 1.390625 c -0.140625,-0.5 -0.140625,-0.5 -0.140625,-1.765625 v -3.9375 h -1.46875 v 3.046875 c 0,1 -0.375,1.484375 -1.125,1.484375 -0.34375,0 -0.625,-0.125 -0.78125,-0.34375 C -10.907885,-1.6875 -10.98601,-2 -10.98601,-2.453125 v -3.25 z m 0,0 m -4.45924,0 c 0.04687,0.3125 0.04687,0.4375 0.04687,0.75 0.01563,0.421875 0.01563,0.75 0.01563,1 V 0 h 1.484375 v -2.65625 c 0,-1.265625 0.359375,-1.875 1.140625,-1.875 0.3125,0 0.609375,0.109375 0.875,0.28125 v -1.5 c -0.234375,-0.0625 -0.28125,-0.0625 -0.4375,-0.0625 -0.6875,0 -1.1875,0.375 -1.640625,1.296875 0.01563,-0.125 0.01563,-0.234375 0.01563,-0.296875 0,-0.328125 -0.04687,-0.640625 -0.109375,-0.890625 z m 0,0 M -18.078385,-2.5 v -0.28125 c 0,-1.90625 -0.984375,-3.078125 -2.59375,-3.078125 -1.671875,0 -2.78125,1.234375 -2.78125,3.078125 0,1.796875 1.09375,2.9375 2.828125,2.9375 1.25,0 2.1875,-0.671875 2.4375,-1.765625 l -1.296875,-0.0625 c -0.203125,0.4375 -0.5625,0.640625 -1.109375,0.640625 -0.828125,0 -1.328125,-0.53125 -1.375,-1.46875 z m -3.859375,-1.078125 c 0.1875,-0.765625 0.609375,-1.140625 1.25,-1.140625 0.640625,0 1,0.375 1.125,1.140625 z m 0,0 m -4.210115,-2.125 V 0 h 1.46875 v -5.703125 z m 0.765625,-2.453125 c -0.53125,0 -0.890625,0.34375 -0.890625,0.875 0,0.515625 0.34375,0.84375 0.875,0.84375 0.515625,0 0.84375,-0.34375 0.84375,-0.875 0,-0.5 -0.328125,-0.84375 -0.828125,-0.84375 z m 0,0 m -3.22149,2.453125 0.01563,-1.640625 h -1.421875 l -0.03125,1.640625 h -0.9375 v 1.15625 h 0.875 l -0.07813,2.21875 -0.01563,0.5625 c 0,0.625 0.0625,0.90625 0.25,1.1875 0.265625,0.453125 0.765625,0.703125 1.40625,0.703125 0.453125,0 0.84375,-0.09375 1.296875,-0.265625 V -1.375 c -0.3125,0.140625 -0.578125,0.203125 -0.84375,0.203125 -0.453125,0 -0.59375,-0.1875 -0.59375,-0.78125 0,-0.109375 0,-0.109375 0.01563,-0.40625 l 0.03125,-2.1875 h 1.1875 v -1.15625 z m 0,0 m -8.591635,0 c 0.171875,0.5625 0.1875,0.65625 0.1875,2.046875 V 0 h 1.46875 v -2.921875 c 0,-0.5625 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.359375 0.515625,-0.59375 0.9375,-0.59375 0.359375,0 0.640625,0.171875 0.78125,0.484375 0.09375,0.21875 0.140625,0.5 0.140625,1.078125 V 0 h 1.46875 v -3.28125 c 0,-1.03125 -0.04687,-1.328125 -0.265625,-1.703125 -0.296875,-0.53125 -0.921875,-0.828125 -1.625,-0.828125 -0.703125,0 -1.28125,0.28125 -1.6875,0.84375 0,-0.3125 -0.04687,-0.546875 -0.125,-0.734375 z m 0,0 m -1.055,3.203125 v -0.28125 c 0,-1.90625 -0.984375,-3.078125 -2.59375,-3.078125 -1.671875,0 -2.78125,1.234375 -2.78125,3.078125 0,1.796875 1.09375,2.9375 2.828125,2.9375 1.25,0 2.1875,-0.671875 2.4375,-1.765625 l -1.296875,-0.0625 c -0.203125,0.4375 -0.5625,0.640625 -1.109375,0.640625 -0.828125,0 -1.328125,-0.53125 -1.375,-1.46875 z m -3.859375,-1.078125 c 0.1875,-0.765625 0.609375,-1.140625 1.25,-1.140625 0.640625,0 1,0.375 1.125,1.140625 z m 0,0 m -4.210115,-2.125 V 0 h 1.46875 v -5.703125 z m 0.765625,-2.453125 c -0.53125,0 -0.890625,0.34375 -0.890625,0.875 0,0.515625 0.34375,0.84375 0.875,0.84375 0.515625,0 0.84375,-0.34375 0.84375,-0.875 0,-0.5 -0.328125,-0.84375 -0.828125,-0.84375 z m 0,0 m -5.25856,2.453125 c 0.04687,0.3125 0.04687,0.4375 0.04687,0.75 0.01563,0.421875 0.01563,0.75 0.01563,1 V 0 h 1.484375 v -2.65625 c 0,-1.265625 0.359375,-1.875 1.140625,-1.875 0.3125,0 0.609375,0.109375 0.875,0.28125 v -1.5 c -0.234375,-0.0625 -0.28125,-0.0625 -0.4375,-0.0625 -0.6875,0 -1.1875,0.375 -1.640625,1.296875 0.01563,-0.125 0.01563,-0.234375 0.01563,-0.296875 0,-0.328125 -0.04687,-0.640625 -0.109375,-0.890625 z m 0,0 m -3.96325,-0.15625 c -1.625,0 -2.828125,1.265625 -2.828125,2.96875 0,1.796875 1.15625,3.046875 2.828125,3.046875 1.625,0 2.8125,-1.265625 2.8125,-3 0,-1.75 -1.1875,-3.015625 -2.8125,-3.015625 z m 0,1.1875 c 0.765625,0 1.296875,0.75 1.296875,1.8125 0,1.078125 -0.53125,1.828125 -1.296875,1.828125 -0.796875,0 -1.3125,-0.734375 -1.3125,-1.84375 0,-1.046875 0.546875,-1.796875 1.3125,-1.796875 z m 0,0 m -3.773125,0.703125 c -0.07813,-1.203125 -0.921875,-1.90625 -2.3125,-1.90625 -1.375,0 -2.28125,0.75 -2.28125,1.859375 0,0.40625 0.140625,0.78125 0.390625,1.03125 0.234375,0.21875 0.5625,0.375 1.1875,0.578125 1.015625,0.296875 1.015625,0.296875 1.1875,0.375 0.296875,0.125 0.390625,0.25 0.390625,0.453125 0,0.375 -0.34375,0.625 -0.90625,0.625 -0.703125,0 -1.03125,-0.28125 -1.078125,-0.953125 h -1.390625 c 0,1.359375 0.859375,2.0625 2.53125,2.0625 1.46875,0 2.3125,-0.6875 2.3125,-1.84375 0,-0.375 -0.109375,-0.71875 -0.328125,-0.96875 -0.234375,-0.28125 -0.59375,-0.46875 -1.4375,-0.71875 -0.875,-0.25 -0.984375,-0.28125 -1.15625,-0.390625 -0.15625,-0.09375 -0.234375,-0.25 -0.234375,-0.40625 0,-0.34375 0.328125,-0.59375 0.78125,-0.59375 0.5625,0 0.84375,0.25 0.921875,0.796875 z m 0,0 m -6.893375,-1.734375 0.01563,-1.640625 H -66.8488 l -0.03125,1.640625 h -0.9375 v 1.15625 h 0.875 l -0.07813,2.21875 -0.01563,0.5625 c 0,0.625 0.0625,0.90625 0.25,1.1875 0.265625,0.453125 0.765625,0.703125 1.40625,0.703125 0.453125,0 0.84375,-0.09375 1.296875,-0.265625 V -1.375 c -0.3125,0.140625 -0.578125,0.203125 -0.84375,0.203125 -0.453125,0 -0.59375,-0.1875 -0.59375,-0.78125 0,-0.109375 0,-0.109375 0.01563,-0.40625 l 0.03125,-2.1875 h 1.1875 v -1.15625 z m 0,0 m -4.960125,0 V 0 h 1.46875 v -5.703125 z m 0.765625,-2.453125 c -0.53125,0 -0.890625,0.34375 -0.890625,0.875 0,0.515625 0.34375,0.84375 0.875,0.84375 0.515625,0 0.84375,-0.34375 0.84375,-0.875 0,-0.5 -0.328125,-0.84375 -0.828125,-0.84375 z m 0,0 M -71.645175,-2.5 v -0.28125 c 0,-1.90625 -0.984375,-3.078125 -2.59375,-3.078125 -1.671875,0 -2.78125,1.234375 -2.78125,3.078125 0,1.796875 1.09375,2.9375 2.828125,2.9375 1.25,0 2.1875,-0.671875 2.4375,-1.765625 l -1.296875,-0.0625 c -0.203125,0.4375 -0.5625,0.640625 -1.109375,0.640625 -0.828125,0 -1.328125,-0.53125 -1.375,-1.46875 z m -3.859375,-1.078125 c 0.1875,-0.765625 0.609375,-1.140625 1.25,-1.140625 0.640625,0 1,0.375 1.125,1.140625 z m 0,0 m -7.738125,-4.46875 V 0 h 1.46875 v -2.921875 c 0,-0.484375 0.0625,-0.78125 0.15625,-1 0.203125,-0.375 0.578125,-0.609375 0.984375,-0.609375 0.359375,0 0.671875,0.1875 0.828125,0.515625 0.109375,0.21875 0.140625,0.484375 0.140625,1.046875 V 0 h 1.46875 v -3.28125 c 0,-1.03125 -0.0625,-1.375 -0.28125,-1.75 -0.3125,-0.484375 -0.953125,-0.78125 -1.640625,-0.78125 -0.671875,0 -1.203125,0.25 -1.65625,0.734375 v -2.96875 z m 0,0 m -4.494124,2.34375 c 0.04687,0.3125 0.04687,0.4375 0.04687,0.75 0.01563,0.421875 0.01563,0.75 0.01563,1 V 0 h 1.484375 v -2.65625 c 0,-1.265625 0.359375,-1.875 1.140625,-1.875 0.3125,0 0.609375,0.109375 0.875,0.28125 v -1.5 c -0.234375,-0.0625 -0.28125,-0.0625 -0.4375,-0.0625 -0.6875,0 -1.1875,0.375 -1.640625,1.296875 0.01563,-0.125 0.01563,-0.234375 0.01563,-0.296875 0,-0.328125 -0.04687,-0.640625 -0.109375,-0.890625 z m 0,0 M -88.901174,-2.5 v -0.28125 c 0,-1.90625 -0.984375,-3.078125 -2.59375,-3.078125 -1.671875,0 -2.78125,1.234375 -2.78125,3.078125 0,1.796875 1.09375,2.9375 2.828125,2.9375 1.25,0 2.1875,-0.671875 2.4375,-1.765625 l -1.296875,-0.0625 c -0.203125,0.4375 -0.5625,0.640625 -1.109375,0.640625 -0.828125,0 -1.328125,-0.53125 -1.375,-1.46875 z m -3.859375,-1.078125 c 0.1875,-0.765625 0.609375,-1.140625 1.25,-1.140625 0.640625,0 1,0.375 1.125,1.140625 z m 0,0 m -7.738131,-4.46875 V 0 h 1.468752 v -2.921875 c 0,-0.484375 0.0625,-0.78125 0.15625,-1 0.203125,-0.375 0.578125,-0.609375 0.984375,-0.609375 0.359375,0 0.671875,0.1875 0.828125,0.515625 0.109375,0.21875 0.140625,0.484375 0.140625,1.046875 V 0 h 1.46875 v -3.28125 c 0,-1.03125 -0.0625,-1.375 -0.28125,-1.75 -0.3125,-0.484375 -0.953125,-0.78125 -1.640625,-0.78125 -0.671875,0 -1.203125,0.25 -1.65625,0.734375 v -2.96875 z m 0,0 m -1.2165,4.234375 c -0.17187,-1.328125 -1,-2.046875 -2.35937,-2.046875 -1.65625,0 -2.76563,1.203125 -2.76563,3.015625 0,1.78125 1.10938,3 2.73438,3 1.39062,0 2.35937,-0.875 2.4375,-2.1875 h -1.4375 c -0.0781,0.671875 -0.40625,1 -1,1 -0.76563,0 -1.21875,-0.671875 -1.21875,-1.8125 0,-1.109375 0.5,-1.828125 1.25,-1.828125 0.51562,0 0.82812,0.296875 0.90625,0.859375 z m 0,0 m -7.81949,-1.890625 V 0 h 1.46875 v -5.703125 z m 0.76562,-2.453125 c -0.53125,0 -0.89062,0.34375 -0.89062,0.875 0,0.515625 0.34375,0.84375 0.875,0.84375 0.51562,0 0.84375,-0.34375 0.84375,-0.875 0,-0.5 -0.32813,-0.84375 -0.82813,-0.84375 z m 0,0 m -2.24875,2.5 c -0.0312,-0.65625 -0.15625,-1.046875 -0.42187,-1.4375 -0.48438,-0.6875 -1.32813,-1.0625 -2.3125,-1.0625 -1.60938,0 -2.75,0.96875 -2.75,2.34375 0,0.5625 0.20312,1.078125 0.57812,1.453125 0.28125,0.3125 0.73438,0.578125 1.64063,0.96875 1.15625,0.46875 1.15625,0.46875 1.375,0.59375 0.375,0.203125 0.54687,0.453125 0.54687,0.765625 0,0.5 -0.51562,0.859375 -1.26562,0.859375 -1,0 -1.54688,-0.515625 -1.64063,-1.546875 h -1.48437 c 0.0625,1.875 1.14062,2.875 3.10937,2.875 1.75,0 2.85938,-0.953125 2.85938,-2.46875 0,-0.609375 -0.1875,-1.125 -0.54688,-1.484375 -0.34375,-0.34375 -0.51562,-0.4375 -1.90625,-1 -1.09375,-0.4375 -1.09375,-0.4375 -1.3125,-0.5625 -0.26562,-0.140625 -0.40625,-0.359375 -0.40625,-0.609375 0,-0.484375 0.5,-0.859375 1.15625,-0.859375 0.76563,0 1.25,0.4375 1.3125,1.171875 z m 0,0 M -120.55718,-2.5 v -0.28125 c 0,-1.90625 -0.98437,-3.078125 -2.59375,-3.078125 -1.67187,0 -2.78125,1.234375 -2.78125,3.078125 0,1.796875 1.09375,2.9375 2.82813,2.9375 1.25,0 2.1875,-0.671875 2.4375,-1.765625 l -1.29688,-0.0625 c -0.20312,0.4375 -0.5625,0.640625 -1.10937,0.640625 -0.82813,0 -1.32813,-0.53125 -1.375,-1.46875 z m -3.85937,-1.078125 c 0.1875,-0.765625 0.60937,-1.140625 1.25,-1.140625 0.64062,0 1,0.375 1.125,1.140625 z m 0,0 m -7.73813,-4.46875 V 0 h 1.46875 v -2.921875 c 0,-0.484375 0.0625,-0.78125 0.15625,-1 0.20313,-0.375 0.57813,-0.609375 0.98438,-0.609375 0.35937,0 0.67187,0.1875 0.82812,0.515625 0.10938,0.21875 0.14063,0.484375 0.14063,1.046875 V 0 h 1.46875 v -3.28125 c 0,-1.03125 -0.0625,-1.375 -0.28125,-1.75 -0.3125,-0.484375 -0.95313,-0.78125 -1.64063,-0.78125 -0.67187,0 -1.20312,0.25 -1.65625,0.734375 v -2.96875 z m 0,0 m -4.04137,2.1875 c -1.625,0 -2.82813,1.265625 -2.82813,2.96875 0,1.796875 1.15625,3.046875 2.82813,3.046875 1.625,0 2.8125,-1.265625 2.8125,-3 0,-1.75 -1.1875,-3.015625 -2.8125,-3.015625 z m 0,1.1875 c 0.76562,0 1.29687,0.75 1.29687,1.8125 0,1.078125 -0.53125,1.828125 -1.29687,1.828125 -0.79688,0 -1.3125,-0.734375 -1.3125,-1.84375 0,-1.046875 0.54687,-1.796875 1.3125,-1.796875 z m 0,0 M -145.0868,-4.8125 V -8 h -1.54688 v 8 h 1.54688 v -3.546875 h 3.17187 V 0 h 1.54688 v -8 h -1.54688 v 3.1875 z m 0,0"
              />
            </g>
          </g>
        )}
        <g
          style={{
            fill: 'rgb(32.156372%,47.058105%,63.922119%)',
            fillOpacity: 1
          }}
          id="g5952"
        >
          <g id="use5942" transform="translate(66.652,271.3251)" />
          <g id="use5944" transform="translate(75.681999,271.3251)" />
          <g id="use5946" transform="translate(83.902,271.3251)" />
          <g id="use5948" transform="translate(87.817001,271.3251)" />
          <g id="use5950" transform="translate(95.497002,271.3251)" />
        </g>
        <g
          style={{
            fill: 'rgb(32.156372%,47.058105%,63.922119%)',
            fillOpacity: 1
          }}
          id="g5960"
        >
          <g id="use5954" transform="translate(103.282,271.3251)" />
          <g id="use5956" transform="translate(111.007,271.3251)" />
          <g id="use5958" transform="translate(119.227,271.3251)" />
        </g>
        <g
          style={{
            fill: 'rgb(32.156372%,47.058105%,63.922119%)',
            fillOpacity: 1
          }}
          id="g5972"
        >
          <g id="use5962" transform="translate(124.852,271.3251)" />
          <g id="use5964" transform="translate(132.892,271.3251)" />
          <g id="use5966" transform="translate(141.112,271.3251)" />
          <g id="use5968" transform="translate(149.437,271.3251)" />
          <g id="use5970" transform="translate(157.47701,271.3251)" />
        </g>
        <g
          style={{
            fill: 'rgb(32.156372%,47.058105%,63.922119%)',
            fillOpacity: 1
          }}
          id="g5986"
        >
          <g id="use5974" transform="translate(162.75549,271.3251)" />
          <g id="use5976" transform="translate(170.4805,271.3251)" />
          <g id="use5978" transform="translate(174.2305,271.3251)" />
          <g id="use5980" transform="translate(186.75549,271.3251)" />
          <g id="use5982" transform="translate(190.6705,271.3251)" />
          <g id="use5984" transform="translate(196.0255,271.3251)" />
        </g>
        <g
          style={{
            fill: 'rgb(32.156372%,47.058105%,63.922119%)',
            fillOpacity: 1
          }}
          id="g5990"
        >
          <use x="199.7755" y="271.3251" id="use5988" />
        </g>
        <g
          style={{
            fill: 'rgb(32.156372%,47.058105%,63.922119%)',
            fillOpacity: 1
          }}
          id="g6006"
        >
          <g id="use5992" transform="translate(65.586998,289.3251)" />
          <g id="use5994" transform="translate(74.137001,289.3251)" />
          <g id="use5996" transform="translate(82.686996,289.3251)" />
          <g id="use5998" transform="translate(91.237,289.3251)" />
          <g id="use6000" transform="translate(93.741997,289.3251)" />
          <g id="use6002" transform="translate(104.437,289.3251)" />
          <g id="use6004" transform="translate(108.187,289.3251)" />
        </g>
        <g
          style={{
            fill: 'rgb(32.156372%,47.058105%,63.922119%)',
            fillOpacity: 1
          }}
          id="g6016"
        >
          <g id="use6008" transform="translate(117.3055,289.3251)" />
          <g id="use6010" transform="translate(124.9855,289.3251)" />
          <g id="use6012" transform="translate(133.20551,289.3251)" />
          <g id="use6014" transform="translate(137.1205,289.3251)" />
        </g>
        <g
          style={{
            fill: 'rgb(32.156372%,47.058105%,63.922119%)',
            fillOpacity: 1
          }}
          id="g6026"
        >
          <g id="use6018" transform="translate(142.49049,289.3251)" />
          <g id="use6020" transform="translate(150.1705,289.3251)" />
          <g id="use6022" transform="translate(154.08549,289.3251)" />
          <g id="use6024" transform="translate(161.3605,289.3251)" />
        </g>
        {props.lang === 'en' ? (
          <g
            style={{
              fill: 'rgb(32.156372%,47.058105%,63.922119%)',
              fillOpacity: 1
            }}
            id="g6038"
          >
            <g id="use6028" transform="translate(179.00861,289.3251)" />
            <g id="use6030" transform="translate(186.46359,289.3251)" />
            <g id="use6032" transform="translate(191.8186,289.3251)" />
            <g id="use6034" transform="translate(195.7336,289.3251)" />
            <g id="use6036" transform="translate(203.77361,289.3251)">
              <path
                id="path14993"
                style={{ stroke: 'none' }}
                d="m 0.8125,-7.125 c 0.203125,0.6875 0.21875,0.828125 0.21875,2.546875 V 0 H 2.875 v -3.640625 c 0,-0.703125 0.046875,-1 0.1875,-1.28125 C 3.265625,-5.375 3.71875,-5.65625 4.234375,-5.65625 c 0.453125,0 0.8125,0.21875 0.984375,0.59375 0.125,0.28125 0.171875,0.640625 0.171875,1.359375 V 0 h 1.84375 v -4.109375 c 0,-1.296875 -0.0625,-1.65625 -0.328125,-2.125 C 6.53125,-6.890625 5.75,-7.28125 4.859375,-7.28125 c -0.875,0 -1.59375,0.359375 -2.109375,1.078125 C 2.75,-6.59375 2.703125,-6.90625 2.59375,-7.125 Z m 0,0 m -4.836885,-0.1875 c -2.015625,0 -3.515625,1.5625 -3.515625,3.703125 0,2.25 1.4375,3.796875 3.515625,3.796875 2.046875,0 3.515625,-1.5625 3.515625,-3.75 0,-2.1875 -1.46875,-3.75 -3.515625,-3.75 z m 0,1.484375 c 0.96875,0 1.625,0.921875 1.625,2.265625 0,1.34375 -0.65625,2.265625 -1.625,2.265625 -0.984375,0 -1.625,-0.90625 -1.625,-2.28125 0,-1.328125 0.671875,-2.25 1.625,-2.25 z m 0,0 M -10.92376,-7.125 V 0 h 1.84375 v -7.125 z m 0.96875,-3.078125 c -0.671875,0 -1.109375,0.4375 -1.109375,1.09375 0,0.65625 0.421875,1.046875 1.078125,1.046875 0.640625,0 1.0625,-0.40625 1.0625,-1.078125 0,-0.625 -0.421875,-1.0625 -1.03125,-1.0625 z m 0,0 m -4.04251,3.078125 0.03125,-2.0625 h -1.78125 l -0.04687,2.0625 h -1.171875 v 1.4375 h 1.109375 l -0.109375,2.78125 -0.01563,0.703125 c 0,0.78125 0.07813,1.125 0.3125,1.484375 0.34375,0.5625 0.953125,0.875 1.75,0.875 0.5625,0 1.0625,-0.109375 1.640625,-0.34375 v -1.515625 c -0.40625,0.15625 -0.71875,0.234375 -1.078125,0.234375 -0.546875,0 -0.734375,-0.21875 -0.734375,-0.96875 0,-0.140625 0,-0.140625 0.01563,-0.5 l 0.04687,-2.75 h 1.484375 V -7.125 Z m 0,0 m -3.86123,2.359375 c -0.234375,-1.65625 -1.265625,-2.546875 -2.96875,-2.546875 -2.0625,0 -3.4375,1.5 -3.4375,3.75 0,2.25 1.375,3.75 3.421875,3.75 1.71875,0 2.9375,-1.09375 3.015625,-2.71875 h -1.78125 c -0.09375,0.84375 -0.5,1.234375 -1.234375,1.234375 -0.96875,0 -1.53125,-0.828125 -1.53125,-2.265625 0,-1.375 0.609375,-2.265625 1.546875,-2.265625 0.65625,0 1.046875,0.359375 1.140625,1.0625 z m 0,0 M -25.27126,-3.125 v -0.359375 c 0,-2.359375 -1.25,-3.828125 -3.265625,-3.828125 -2.078125,0 -3.453125,1.515625 -3.453125,3.828125 0,2.25 1.359375,3.671875 3.515625,3.671875 1.578125,0 2.75,-0.828125 3.0625,-2.203125 l -1.640625,-0.0625 c -0.234375,0.53125 -0.703125,0.78125 -1.375,0.78125 -1.03125,0 -1.65625,-0.65625 -1.71875,-1.828125 z m -4.828125,-1.34375 c 0.234375,-0.96875 0.75,-1.421875 1.546875,-1.421875 0.8125,0 1.265625,0.453125 1.421875,1.421875 z m 0,0 m -4.358125,-2.65625 0.03125,-2.0625 h -1.78125 l -0.04687,2.0625 h -1.171875 v 1.4375 h 1.109375 l -0.109375,2.78125 -0.01563,0.703125 c 0,0.78125 0.07813,1.125 0.3125,1.484375 0.34375,0.5625 0.953125,0.875 1.75,0.875 0.5625,0 1.0625,-0.109375 1.640625,-0.34375 v -1.515625 c -0.40625,0.15625 -0.71875,0.234375 -1.078125,0.234375 -0.546875,0 -0.734375,-0.21875 -0.734375,-0.96875 0,-0.140625 0,-0.140625 0.01563,-0.5 l 0.04687,-2.75 h 1.484375 V -7.125 Z m 0,0 m -7.171875,-0.1875 c -2.015625,0 -3.515625,1.5625 -3.515625,3.703125 0,2.25 1.4375,3.796875 3.515625,3.796875 2.046875,0 3.515625,-1.5625 3.515625,-3.75 0,-2.1875 -1.46875,-3.75 -3.515625,-3.75 z m 0,1.484375 c 0.96875,0 1.625,0.921875 1.625,2.265625 0,1.34375 -0.65625,2.265625 -1.625,2.265625 -0.984375,0 -1.625,-0.90625 -1.625,-2.28125 0,-1.328125 0.671875,-2.25 1.625,-2.25 z m 0,0 M -50.33251,-7.125 c 0.04687,0.390625 0.0625,0.546875 0.0625,0.9375 0.01563,0.515625 0.01563,0.9375 0.01563,1.25 V 0 h 1.84375 v -3.3125 c 0,-1.59375 0.453125,-2.34375 1.4375,-2.34375 0.390625,0 0.765625,0.125 1.109375,0.34375 v -1.875 c -0.3125,-0.078125 -0.359375,-0.09375 -0.5625,-0.09375 -0.875,0 -1.484375,0.484375 -2.046875,1.640625 0.01563,-0.171875 0.01563,-0.296875 0.01563,-0.375 0,-0.40625 -0.04687,-0.796875 -0.125,-1.109375 z m 0,0 M -58.541895,-10 V 0 h 1.921875 v -3.734375 h 0.59375 c 1.34375,0 2,-0.0625 2.5625,-0.203125 1.1875,-0.359375 1.953125,-1.46875 1.953125,-2.890625 0,-1.390625 -0.703125,-2.5 -1.859375,-2.875 C -54.041895,-9.9375 -54.729395,-10 -56.198145,-10 Z m 1.921875,4.625 v -3 h 0.703125 c 0.984375,0 1.390625,0.0625 1.765625,0.25 0.421875,0.21875 0.671875,0.6875 0.671875,1.28125 0,0.640625 -0.296875,1.125 -0.796875,1.3125 -0.375,0.125 -0.625,0.15625 -1.734375,0.15625 z m 0,0 m -9.75874,-4.6875 V 0 h 1.84375 v -10.0625 z m 0,0 M -72.480645,-5 c 0.109375,-0.546875 0.515625,-0.8125 1.21875,-0.8125 0.78125,0 1.078125,0.296875 1.078125,1.078125 V -4.625 c -1.9375,0.34375 -2.046875,0.359375 -2.6875,0.625 -1.046875,0.390625 -1.625,1.140625 -1.625,2.125 0,1.28125 0.96875,2.03125 2.59375,2.03125 0.953125,0 1.578125,-0.328125 1.96875,-0.96875 0,0.359375 0.01563,0.53125 0.09375,0.8125 h 1.6875 c -0.1875,-0.375 -0.25,-0.734375 -0.25,-1.59375 v -2.859375 c 0,-0.90625 -0.07813,-1.34375 -0.28125,-1.75 -0.328125,-0.6875 -1.21875,-1.078125 -2.453125,-1.078125 -0.9375,0 -1.78125,0.25 -2.3125,0.6875 -0.46875,0.375 -0.703125,0.8125 -0.78125,1.59375 z m 2.296875,2.015625 c 0,0.546875 -0.04687,0.84375 -0.140625,1.0625 -0.1875,0.40625 -0.640625,0.65625 -1.203125,0.65625 -0.625,0 -1.078125,-0.359375 -1.078125,-0.84375 0,-0.3125 0.171875,-0.609375 0.4375,-0.796875 0.3125,-0.234375 0.78125,-0.328125 1.984375,-0.484375 z m 0,0 M 4.62974,-28.0625 V -18 h 1.84375 v -3.640625 c 0,-0.625 0.0625,-0.984375 0.203125,-1.265625 0.234375,-0.46875 0.703125,-0.75 1.21875,-0.75 0.453125,0 0.828125,0.21875 1.03125,0.625 0.125,0.28125 0.171875,0.625 0.171875,1.328125 V -18 h 1.84375 v -4.109375 c 0,-1.296875 -0.0625,-1.703125 -0.359375,-2.171875 -0.390625,-0.609375 -1.171875,-1 -2.046875,-1 -0.828125,0 -1.5,0.328125 -2.0625,0.9375 v -3.71875 z m 0,0 m -3.08725,2.9375 0.03125,-2.0625 h -1.78125 l -0.046875,2.0625 H -1.42626 v 1.4375 h 1.109375 l -0.109375,2.78125 -0.015625,0.703125 c 0,0.78125 0.078125,1.125 0.3125,1.484375 0.34375,0.5625 0.953125,0.875 1.75,0.875 0.5625,0 1.0625,-0.109375 1.640625,-0.34375 v -1.515625 c -0.40625,0.15625 -0.71875,0.234375 -1.078125,0.234375 -0.546875,0 -0.734375,-0.21875 -0.734375,-0.96875 0,-0.140625 0,-0.140625 0.015625,-0.5 l 0.046875,-2.75 h 1.484375 v -1.4375 z m 0,0 m -6.19626,0 V -18 h 1.84375 v -7.125 z m 0.96875,-3.078125 c -0.671875,0 -1.109375,0.4375 -1.109375,1.09375 0,0.65625 0.421875,1.046875 1.078125,1.046875 0.640625,0 1.0625,-0.40625 1.0625,-1.078125 0,-0.625 -0.421875,-1.0625 -1.03125,-1.0625 z m 0,0 m -13.04748,3.078125 2.09375,7.171875 h 1.984375 l 1.296875,-4.28125 1.34375,4.28125 H -8.045 L -5.904375,-25.125 h -1.84375 l -1.359375,5.03125 -1.46875,-5.03125 h -1.484375 l -1.484375,5.03125 -1.3125,-5.03125 z m 0,0 m -4.634385,2.15625 c -0.09375,-1.5 -1.140625,-2.359375 -2.890625,-2.359375 -1.703125,0 -2.84375,0.921875 -2.84375,2.296875 0,0.515625 0.171875,0.984375 0.484375,1.296875 0.296875,0.28125 0.703125,0.484375 1.484375,0.71875 1.265625,0.375 1.265625,0.375 1.5,0.484375 0.359375,0.140625 0.46875,0.296875 0.46875,0.5625 0,0.46875 -0.421875,0.765625 -1.125,0.765625 -0.875,0 -1.28125,-0.34375 -1.34375,-1.1875 h -1.75 c 0,1.703125 1.09375,2.578125 3.171875,2.578125 1.828125,0 2.890625,-0.84375 2.890625,-2.28125 0,-0.484375 -0.140625,-0.921875 -0.421875,-1.234375 -0.296875,-0.34375 -0.75,-0.578125 -1.796875,-0.890625 -1.078125,-0.3125 -1.21875,-0.359375 -1.4375,-0.484375 -0.1875,-0.109375 -0.296875,-0.3125 -0.296875,-0.515625 0,-0.421875 0.421875,-0.734375 0.984375,-0.734375 0.6875,0 1.046875,0.3125 1.140625,0.984375 z m 0,0 m -8.620625,-2.15625 0.03125,-2.0625 h -1.78125 l -0.04687,2.0625 h -1.171875 v 1.4375 h 1.109375 l -0.109375,2.78125 -0.01563,0.703125 c 0,0.78125 0.07813,1.125 0.3125,1.484375 0.34375,0.5625 0.953125,0.875 1.75,0.875 0.5625,0 1.0625,-0.109375 1.640625,-0.34375 v -1.515625 c -0.40625,0.15625 -0.71875,0.234375 -1.078125,0.234375 -0.546875,0 -0.734375,-0.21875 -0.734375,-0.96875 0,-0.140625 0,-0.140625 0.01563,-0.5 l 0.04687,-2.75 h 1.484375 v -1.4375 z m 0,0 m -3.86125,2.359375 c -0.234375,-1.65625 -1.265625,-2.546875 -2.96875,-2.546875 -2.0625,0 -3.4375,1.5 -3.4375,3.75 0,2.25 1.375,3.75 3.421875,3.75 1.71875,0 2.9375,-1.09375 3.015625,-2.71875 h -1.78125 c -0.09375,0.84375 -0.5,1.234375 -1.234375,1.234375 -0.96875,0 -1.53125,-0.828125 -1.53125,-2.265625 0,-1.375 0.609375,-2.265625 1.546875,-2.265625 0.65625,0 1.046875,0.359375 1.140625,1.0625 z m 0,0 M -48.11126,-25.125 v 4.15625 c 0,0.921875 0.140625,1.625 0.40625,2.03125 0.4375,0.6875 1.265625,1.09375 2.203125,1.09375 0.875,0 1.453125,-0.28125 2,-0.984375 0.01563,0.328125 0.07813,0.65625 0.15625,0.828125 h 1.734375 c -0.171875,-0.625 -0.171875,-0.625 -0.171875,-2.203125 V -25.125 h -1.859375 v 3.8125 c 0,1.25 -0.453125,1.84375 -1.40625,1.84375 -0.421875,0 -0.765625,-0.15625 -0.953125,-0.421875 -0.171875,-0.21875 -0.265625,-0.609375 -0.265625,-1.1875 V -25.125 Z m 0,0 m -2.00125,-2.9375 h -1.84375 v 3.71875 c -0.53125,-0.671875 -1.03125,-0.9375 -1.84375,-0.9375 -1.75,0 -3,1.578125 -3,3.78125 0,2.1875 1.21875,3.65625 3.03125,3.65625 0.953125,0 1.546875,-0.34375 2.015625,-1.140625 -0.01563,0.171875 -0.01563,0.265625 -0.01563,0.359375 0,0.171875 0.01563,0.328125 0.0625,0.625 h 1.71875 c -0.09375,-0.5 -0.125,-1.046875 -0.125,-2.25 z m -3.265625,4.328125 c 0.90625,0 1.453125,0.8125 1.453125,2.171875 0,1.328125 -0.59375,2.171875 -1.53125,2.171875 -0.921875,0 -1.46875,-0.796875 -1.46875,-2.109375 0,-1.40625 0.5625,-2.234375 1.546875,-2.234375 z m 0,0 m -7.94626,-1.578125 c -2.015625,0 -3.515625,1.5625 -3.515625,3.703125 0,2.25 1.4375,3.796875 3.515625,3.796875 2.046875,0 3.515625,-1.5625 3.515625,-3.75 0,-2.1875 -1.46875,-3.75 -3.515625,-3.75 z m 0,1.484375 c 0.96875,0 1.625,0.921875 1.625,2.265625 0,1.34375 -0.65625,2.265625 -1.625,2.265625 -0.984375,0 -1.625,-0.90625 -1.625,-2.28125 0,-1.328125 0.671875,-2.25 1.625,-2.25 z m 0,0 M -70.02601,-25.125 c 0.04687,0.390625 0.0625,0.546875 0.0625,0.9375 0.01563,0.515625 0.01563,0.9375 0.01563,1.25 V -18 h 1.84375 v -3.3125 c 0,-1.59375 0.453125,-2.34375 1.4375,-2.34375 0.390625,0 0.765625,0.125 1.109375,0.34375 v -1.875 c -0.3125,-0.07813 -0.359375,-0.09375 -0.5625,-0.09375 -0.875,0 -1.484375,0.484375 -2.046875,1.640625 0.01563,-0.171875 0.01563,-0.296875 0.01563,-0.375 0,-0.40625 -0.04687,-0.796875 -0.125,-1.109375 z m 0,0 M -78.235385,-28 v 10 h 1.921875 v -3.734375 h 0.59375 c 1.34375,0 2,-0.0625 2.5625,-0.203125 1.1875,-0.359375 1.953125,-1.46875 1.953125,-2.890625 0,-1.390625 -0.703125,-2.5 -1.859375,-2.875 C -73.735385,-27.9375 -74.422885,-28 -75.891635,-28 Z m 1.921875,4.625 v -3 h 0.703125 c 0.984375,0 1.390625,0.0625 1.765625,0.25 0.421875,0.21875 0.671875,0.6875 0.671875,1.28125 0,0.640625 -0.296875,1.125 -0.796875,1.3125 -0.375,0.125 -0.625,0.15625 -1.734375,0.15625 z m 0,0 m -8.9175,-1.75 0.03125,-2.0625 h -1.78125 l -0.04687,2.0625 h -1.171875 v 1.4375 h 1.109375 l -0.109375,2.78125 -0.01563,0.703125 c 0,0.78125 0.07813,1.125 0.3125,1.484375 0.34375,0.5625 0.953125,0.875 1.75,0.875 0.5625,0 1.0625,-0.109375 1.640625,-0.34375 v -1.515625 c -0.40625,0.15625 -0.71875,0.234375 -1.078125,0.234375 -0.546875,0 -0.734375,-0.21875 -0.734375,-0.96875 0,-0.140625 0,-0.140625 0.01563,-0.5 l 0.04687,-2.75 h 1.484375 v -1.4375 z m 0,0 m -10.72,0 c 0.203125,0.6875 0.21875,0.828125 0.21875,2.546875 V -18 h 1.84375 v -3.640625 c 0,-0.703125 0.04687,-1 0.1875,-1.28125 0.203125,-0.453125 0.65625,-0.734375 1.171875,-0.734375 0.453125,0 0.8125,0.21875 0.984375,0.59375 0.125,0.28125 0.171875,0.640625 0.171875,1.359375 V -18 h 1.84375 v -4.109375 c 0,-1.296875 -0.0625,-1.65625 -0.328125,-2.125 -0.375,-0.65625 -1.15625,-1.046875 -2.046875,-1.046875 -0.875,0 -1.59375,0.359375 -2.109375,1.078125 0,-0.390625 -0.04687,-0.703125 -0.15625,-0.921875 z m 0,0 m -1.318747,4 v -0.359375 c 0,-2.359375 -1.25,-3.828125 -3.265623,-3.828125 -2.07813,0 -3.45313,1.515625 -3.45313,3.828125 0,2.25 1.35938,3.671875 3.51563,3.671875 1.578123,0 2.749998,-0.828125 3.062498,-2.203125 l -1.640625,-0.0625 c -0.234375,0.53125 -0.703125,0.78125 -1.375003,0.78125 -1.03125,0 -1.65625,-0.65625 -1.71875,-1.828125 z m -4.828123,-1.34375 c 0.23437,-0.96875 0.75,-1.421875 1.54687,-1.421875 0.812503,0 1.265628,0.453125 1.421878,1.421875 z m 0,0 m -14.07188,-2.65625 c 0.15625,0.4375 0.1875,0.671875 0.1875,1.6875 V -18 h 1.84375 v -3.953125 c 0,-0.515625 0.0156,-0.703125 0.10938,-0.921875 0.1875,-0.5 0.625,-0.78125 1.25,-0.78125 0.45312,0 0.82812,0.1875 0.98437,0.484375 0.125,0.203125 0.15625,0.484375 0.15625,1.21875 V -18 h 1.84375 v -4.03125 c 0,-1.09375 0.4375,-1.625 1.32813,-1.625 0.45312,0 0.79687,0.15625 0.98437,0.4375 0.125,0.203125 0.17188,0.5 0.17188,1.109375 V -18 h 1.84375 v -4.15625 c 0,-1.40625 -0.0156,-1.59375 -0.23438,-2.046875 -0.3125,-0.703125 -1.01562,-1.078125 -2,-1.078125 -0.98437,0 -1.67187,0.34375 -2.3125,1.15625 -0.4375,-0.796875 -1.07812,-1.15625 -2.04687,-1.15625 -0.95313,0 -1.625,0.34375 -2.17188,1.09375 v -0.125 c 0,-0.3125 -0.0469,-0.5625 -0.15625,-0.8125 z m 0,0 m -2.88625,0 0.0312,-2.0625 h -1.78125 l -0.0469,2.0625 h -1.17187 v 1.4375 h 1.10937 l -0.10937,2.78125 -0.0156,0.703125 c 0,0.78125 0.0781,1.125 0.3125,1.484375 0.34375,0.5625 0.95313,0.875 1.75,0.875 0.5625,0 1.0625,-0.109375 1.64063,-0.34375 v -1.515625 c -0.40625,0.15625 -0.71875,0.234375 -1.07813,0.234375 -0.54687,0 -0.73437,-0.21875 -0.73437,-0.96875 0,-0.140625 0,-0.140625 0.0156,-0.5 l 0.0469,-2.75 h 1.48437 v -1.4375 z m 0,0 m -3.94937,2.15625 c -0.0937,-1.5 -1.14063,-2.359375 -2.89063,-2.359375 -1.70312,0 -2.84375,0.921875 -2.84375,2.296875 0,0.515625 0.17188,0.984375 0.48438,1.296875 0.29687,0.28125 0.70312,0.484375 1.48437,0.71875 1.26563,0.375 1.26563,0.375 1.5,0.484375 0.35938,0.140625 0.46875,0.296875 0.46875,0.5625 0,0.46875 -0.42187,0.765625 -1.125,0.765625 -0.875,0 -1.28125,-0.34375 -1.34375,-1.1875 h -1.75 c 0,1.703125 1.09375,2.578125 3.17188,2.578125 1.82812,0 2.89062,-0.84375 2.89062,-2.28125 0,-0.484375 -0.14062,-0.921875 -0.42187,-1.234375 -0.29688,-0.34375 -0.75,-0.578125 -1.79688,-0.890625 -1.07812,-0.3125 -1.21875,-0.359375 -1.4375,-0.484375 -0.1875,-0.109375 -0.29687,-0.3125 -0.29687,-0.515625 0,-0.421875 0.42187,-0.734375 0.98437,-0.734375 0.6875,0 1.04688,0.3125 1.14063,0.984375 z m 0,0 m -7.08438,1.84375 v -0.359375 c 0,-2.359375 -1.25,-3.828125 -3.26562,-3.828125 -2.07813,0 -3.45313,1.515625 -3.45313,3.828125 0,2.25 1.35938,3.671875 3.51563,3.671875 1.57812,0 2.75,-0.828125 3.0625,-2.203125 l -1.64063,-0.0625 c -0.23437,0.53125 -0.70312,0.78125 -1.375,0.78125 -1.03125,0 -1.65625,-0.65625 -1.71875,-1.828125 z m -4.82812,-1.34375 c 0.23437,-0.96875 0.75,-1.421875 1.54687,-1.421875 0.8125,0 1.26563,0.453125 1.42188,1.421875 z m 0,0 m -9.44875,-2.65625 2.53125,7.171875 h 2.04687 l 2.57813,-7.171875 h -1.90625 l -1.65625,5.109375 -1.65625,-5.109375 z m 0,0 m -7.29438,0 c 0.20312,0.6875 0.21875,0.828125 0.21875,2.546875 V -18 h 1.84375 v -3.640625 c 0,-0.703125 0.0469,-1 0.1875,-1.28125 0.20312,-0.453125 0.65625,-0.734375 1.17187,-0.734375 0.45313,0 0.8125,0.21875 0.98438,0.59375 0.125,0.28125 0.17187,0.640625 0.17187,1.359375 V -18 h 1.84375 v -4.109375 c 0,-1.296875 -0.0625,-1.65625 -0.32812,-2.125 -0.375,-0.65625 -1.15625,-1.046875 -2.04688,-1.046875 -0.875,0 -1.59375,0.359375 -2.10937,1.078125 0,-0.390625 -0.0469,-0.703125 -0.15625,-0.921875 z m 0,0 m -2.0075,7.125 v -10 h -1.92188 v 10 z m 0,0 m 76.5225,10.875 0.03125,-2.0625 h -1.78125 l -0.04687,2.0625 h -1.171875 v 1.4375 h 1.109375 l -0.109375,2.78125 -0.01563,0.703125 c 0,0.78125 0.07813,1.125 0.3125,1.484375 0.34375,0.5625 0.953125,0.875 1.75,0.875 0.5625,0 1.0625,-0.109375 1.640625,-0.34375 v -1.515625 c -0.40625,0.15625 -0.71875,0.234375 -1.078125,0.234375 -0.546875,0 -0.734375,-0.21875 -0.734375,-0.96875 0,-0.140625 0,-0.140625 0.01563,-0.5 l 0.04687,-2.75 h 1.484375 V -7.125 Z m 0,0 m -6.19625,0 V 0 h 1.84375 v -7.125 z m 0.96875,-3.078125 c -0.671875,0 -1.109375,0.4375 -1.109375,1.09375 0,0.65625 0.421875,1.046875 1.078125,1.046875 0.640625,0 1.0625,-0.40625 1.0625,-1.078125 0,-0.625 -0.421875,-1.0625 -1.03125,-1.0625 z m 0,0 m -9.18875,13.15625 h 1.84375 v -3.71875 c 0.5625,0.640625 1.09375,0.921875 1.890625,0.921875 1.734375,0 2.953125,-1.578125 2.953125,-3.765625 0,-2.1875 -1.203125,-3.671875 -3.015625,-3.671875 -0.859375,0 -1.453125,0.3125 -1.953125,1 -0.01563,-0.390625 -0.0625,-0.671875 -0.125,-0.84375 h -1.71875 c 0.09375,0.5 0.125,1.046875 0.125,2.265625 z m 3.34375,-8.6875 c 0.921875,0 1.46875,0.8125 1.46875,2.15625 0,1.375 -0.546875,2.1875 -1.46875,2.1875 -0.921875,0 -1.53125,-0.828125 -1.53125,-2.140625 0,-1.359375 0.59375,-2.203125 1.53125,-2.203125 z m 0,0 M -97.664135,-5 c 0.109375,-0.546875 0.515625,-0.8125 1.21875,-0.8125 0.78125,0 1.078125,0.296875 1.078125,1.078125 V -4.625 c -1.9375,0.34375 -2.046875,0.359375 -2.6875,0.625 -1.046875,0.390625 -1.625,1.140625 -1.625,2.125 0,1.28125 0.96875,2.03125 2.59375,2.03125 0.953125,0 1.578125,-0.328125 1.96875,-0.96875 0,0.359375 0.01563,0.53125 0.09375,0.8125 h 1.6875 c -0.1875,-0.375 -0.25,-0.734375 -0.25,-1.59375 v -2.859375 c 0,-0.90625 -0.07813,-1.34375 -0.28125,-1.75 -0.328125,-0.6875 -1.21875,-1.078125 -2.453125,-1.078125 -0.9375,0 -1.78125,0.25 -2.3125,0.6875 -0.46875,0.375 -0.703125,0.8125 -0.78125,1.59375 z m 2.296875,2.015625 c 0,0.546875 -0.04687,0.84375 -0.140625,1.0625 -0.1875,0.40625 -0.640625,0.65625 -1.203125,0.65625 -0.625,0 -1.078125,-0.359375 -1.078125,-0.84375 0,-0.3125 0.171875,-0.609375 0.4375,-0.796875 0.3125,-0.234375 0.78125,-0.328125 1.984375,-0.484375 z m 0,0 M -100.78976,-6.75 c -0.125,-2.21875 -1.39063,-3.453125 -3.51563,-3.453125 -1.07812,0 -2.0625,0.359375 -2.82812,1.03125 -1.03125,0.953125 -1.57813,2.375 -1.57813,4.203125 0,1.75 0.48438,3.09375 1.46875,4.03125 0.79688,0.734375 1.84375,1.125 3.03125,1.125 2.23438,0 3.42188,-1.3125 3.54688,-3.890625 h -1.70313 c -0.125,1.515625 -0.75,2.25 -1.92187,2.25 -1.5,0 -2.4375,-1.34375 -2.4375,-3.53125 0,-2.1875 0.9375,-3.546875 2.42187,-3.546875 1.01563,0 1.67188,0.625 1.85938,1.78125 z m 0,0 m -15.41375,-3.25 -5.8125,10 h 1.48437 l 5.79688,-10 z m 0.57812,5.25 c -1.15625,0 -2.09375,1.0625 -2.09375,2.40625 0,1.34375 0.9375,2.421875 2.07813,2.421875 1.20312,0 2.14062,-1.046875 2.14062,-2.421875 0,-1.34375 -0.9375,-2.40625 -2.125,-2.40625 z m 0.0156,1.015625 c 0.5625,0 0.9375,0.5625 0.9375,1.390625 0,0.84375 -0.375,1.40625 -0.9375,1.40625 -0.5625,0 -0.9375,-0.5625 -0.9375,-1.40625 0,-0.84375 0.375,-1.390625 0.9375,-1.390625 z m -5.5,-6.34375 c -1.1875,0 -2.10938,1.0625 -2.10938,2.40625 0,1.34375 0.92188,2.421875 2.09375,2.421875 1.20313,0 2.125,-1.046875 2.125,-2.421875 0,-1.34375 -0.92187,-2.40625 -2.10937,-2.40625 z m 0.0156,1.015625 c 0.5625,0 0.9375,0.578125 0.9375,1.390625 0,0.84375 -0.375,1.40625 -0.95312,1.40625 -0.5625,0 -0.9375,-0.5625 -0.9375,-1.40625 0,-0.828125 0.375,-1.390625 0.95312,-1.390625 z m 0,0 m -10.61249,-0.921875 c -2.23438,0 -3.57813,1.90625 -3.57813,4.984375 0,3.265625 1.3125,5.15625 3.57813,5.15625 2.21875,0 3.54687,-1.90625 3.54687,-5.078125 0,-3.171875 -1.32812,-5.0625 -3.54687,-5.0625 z m 0,1.546875 c 0.42187,0 0.79687,0.203125 1.04687,0.59375 0.40625,0.609375 0.625,1.671875 0.625,2.921875 0,1.25 -0.21875,2.28125 -0.625,2.9375 -0.25,0.375 -0.60937,0.59375 -1.04687,0.59375 -1.10938,0 -1.70313,-1.296875 -1.70313,-3.578125 0,-1.203125 0.21875,-2.25 0.625,-2.875 0.25,-0.390625 0.60938,-0.59375 1.07813,-0.59375 z m 0,0 m -8.55,-1.546875 c -2.23438,0 -3.57813,1.90625 -3.57813,4.984375 0,3.265625 1.3125,5.15625 3.57813,5.15625 2.21875,0 3.54687,-1.90625 3.54687,-5.078125 0,-3.171875 -1.32812,-5.0625 -3.54687,-5.0625 z m 0,1.546875 c 0.42187,0 0.79687,0.203125 1.04687,0.59375 0.40625,0.609375 0.625,1.671875 0.625,2.921875 0,1.25 -0.21875,2.28125 -0.625,2.9375 -0.25,0.375 -0.60937,0.59375 -1.04687,0.59375 -1.10938,0 -1.70313,-1.296875 -1.70313,-3.578125 0,-1.203125 0.21875,-2.25 0.625,-2.875 0.25,-0.390625 0.60938,-0.59375 1.07813,-0.59375 z m 0,0 M -150.63476,-7 h 1.71875 v 7 h 1.875 v -9.796875 h -1.28125 c -0.23437,1.1875 -0.96875,1.734375 -2.3125,1.765625 z m 0,0"
              />
            </g>
          </g>
        ) : (
          <g
            style={{
              fill: 'rgb(32.156372%,47.058105%,63.922119%)',
              fillOpacity: 1
            }}
            id="g6038"
          >
            <g id="use6028" transform="translate(168.74049,289.3251)" />
            <g id="use6030" transform="translate(177.06551,289.3251)" />
            <g id="use6032" transform="translate(185.3905,289.3251)" />
            <g id="use6034" transform="translate(190.7455,289.3251)" />
            <g id="use6036" transform="translate(197.1055,289.3251)">
              <path
                id="path14993"
                style={{ stroke: 'none' }}
                d="m -5.64125,-7.125 v 1.53125 h 3 l -3.375,4.171875 V 0 H -0.36 V -1.53125 H -3.844375 L -0.4225,-5.734375 V -7.125 Z m 0,0 m -2.76125,0 0.03125,-2.0625 h -1.78125 l -0.04687,2.0625 h -1.171875 v 1.4375 h 1.109375 l -0.109375,2.78125 -0.01563,0.703125 c 0,0.78125 0.07813,1.125 0.3125,1.484375 0.34375,0.5625 0.953125,0.875 1.75,0.875 0.5625,0 1.0625,-0.109375 1.640625,-0.34375 v -1.515625 c -0.40625,0.15625 -0.71875,0.234375 -1.078125,0.234375 -0.546875,0 -0.734375,-0.21875 -0.734375,-0.96875 0,-0.140625 0,-0.140625 0.015625,-0.5 l 0.046875,-2.75 h 1.484375 V -7.125 Z m 0,0 m -10.66874,0 v 4.15625 c 0,0.921875 0.140625,1.625 0.40625,2.03125 0.4375,0.6875 1.265625,1.09375 2.203125,1.09375 0.875,0 1.453125,-0.28125 2,-0.984375 0.01563,0.328125 0.07813,0.65625 0.15625,0.828125 h 1.734375 c -0.171875,-0.625 -0.171875,-0.625 -0.171875,-2.203125 V -7.125 h -1.859375 v 3.8125 c 0,1.25 -0.453125,1.84375 -1.40625,1.84375 -0.421875,0 -0.765625,-0.15625 -0.953125,-0.421875 C -17.13374,-2.109375 -17.22749,-2.5 -17.22749,-3.078125 V -7.125 Z m 0,0 m -8.26252,-2.9375 V 0 h 1.84375 v -3.640625 c 0,-0.625 0.0625,-0.984375 0.203125,-1.265625 0.234375,-0.46875 0.703125,-0.75 1.21875,-0.75 0.453125,0 0.828125,0.21875 1.03125,0.625 0.125,0.28125 0.171875,0.625 0.171875,1.328125 V 0 h 1.84375 v -4.109375 c 0,-1.296875 -0.0625,-1.703125 -0.359375,-2.171875 -0.390625,-0.609375 -1.171875,-1 -2.046875,-1 -0.828125,0 -1.5,0.328125 -2.0625,0.9375 v -3.71875 z m 0,0 m -1.50499,5.296875 c -0.234375,-1.65625 -1.265625,-2.546875 -2.96875,-2.546875 -2.0625,0 -3.4375,1.5 -3.4375,3.75 0,2.25 1.375,3.75 3.421875,3.75 1.71875,0 2.9375,-1.09375 3.015625,-2.71875 h -1.78125 c -0.09375,0.84375 -0.5,1.234375 -1.234375,1.234375 -0.96875,0 -1.53125,-0.828125 -1.53125,-2.265625 0,-1.375 0.609375,-2.265625 1.546875,-2.265625 0.65625,0 1.046875,0.359375 1.140625,1.0625 z m 0,0 m -7.603135,-0.203125 c -0.09375,-1.5 -1.140625,-2.359375 -2.890625,-2.359375 -1.703125,0 -2.84375,0.921875 -2.84375,2.296875 0,0.515625 0.171875,0.984375 0.484375,1.296875 0.296875,0.28125 0.703125,0.484375 1.484375,0.71875 1.265625,0.375 1.265625,0.375 1.5,0.484375 0.359375,0.140625 0.46875,0.296875 0.46875,0.5625 0,0.46875 -0.421875,0.765625 -1.125,0.765625 -0.875,0 -1.28125,-0.34375 -1.34375,-1.1875 h -1.75 c 0,1.703125 1.09375,2.578125 3.171875,2.578125 1.828125,0 2.890625,-0.84375 2.890625,-2.28125 0,-0.484375 -0.140625,-0.921875 -0.421875,-1.234375 -0.296875,-0.34375 -0.75,-0.578125 -1.796875,-0.890625 -1.078125,-0.3125 -1.21875,-0.359375 -1.4375,-0.484375 -0.1875,-0.109375 -0.296875,-0.3125 -0.296875,-0.515625 0,-0.421875 0.421875,-0.734375 0.984375,-0.734375 0.6875,0 1.046875,0.3125 1.140625,0.984375 z m 0,0 M -45.90375,-10.0625 V 0 H -44.06 v -10.0625 z m 0,0 M -52.005635,-5 c 0.109375,-0.546875 0.515625,-0.8125 1.21875,-0.8125 0.78125,0 1.078125,0.296875 1.078125,1.078125 V -4.625 c -1.9375,0.34375 -2.046875,0.359375 -2.6875,0.625 -1.046875,0.390625 -1.625,1.140625 -1.625,2.125 0,1.28125 0.96875,2.03125 2.59375,2.03125 0.953125,0 1.578125,-0.328125 1.96875,-0.96875 0,0.359375 0.01563,0.53125 0.09375,0.8125 h 1.6875 c -0.1875,-0.375 -0.25,-0.734375 -0.25,-1.59375 v -2.859375 c 0,-0.90625 -0.07813,-1.34375 -0.28125,-1.75 -0.328125,-0.6875 -1.21875,-1.078125 -2.453125,-1.078125 -0.9375,0 -1.78125,0.25 -2.3125,0.6875 -0.46875,0.375 -0.703125,0.8125 -0.78125,1.59375 z m 2.296875,2.015625 c 0,0.546875 -0.04687,0.84375 -0.140625,1.0625 -0.1875,0.40625 -0.640625,0.65625 -1.203125,0.65625 -0.625,0 -1.078125,-0.359375 -1.078125,-0.84375 0,-0.3125 0.171875,-0.609375 0.4375,-0.796875 0.3125,-0.234375 0.78125,-0.328125 1.984375,-0.484375 z m 0,0 M -56.6725,-7.125 l 0.03125,-2.0625 h -1.78125 l -0.04687,2.0625 h -1.171875 v 1.4375 h 1.109375 l -0.109375,2.78125 -0.01563,0.703125 c 0,0.78125 0.07813,1.125 0.3125,1.484375 0.34375,0.5625 0.953125,0.875 1.75,0.875 0.5625,0 1.0625,-0.109375 1.640625,-0.34375 v -1.515625 c -0.40625,0.15625 -0.71875,0.234375 -1.078125,0.234375 -0.546875,0 -0.734375,-0.21875 -0.734375,-0.96875 0,-0.140625 0,-0.140625 0.01563,-0.5 l 0.04687,-2.75 h 1.484375 V -7.125 Z m 0,0 m -6.19624,0 V 0 h 1.84375 v -7.125 z m 0.96875,-3.078125 c -0.671875,0 -1.109375,0.4375 -1.109375,1.09375 0,0.65625 0.421875,1.046875 1.078125,1.046875 0.640625,0 1.0625,-0.40625 1.0625,-1.078125 0,-0.625 -0.421875,-1.0625 -1.03125,-1.0625 z m 0,0 m -9.18876,13.15625 h 1.84375 v -3.71875 c 0.5625,0.640625 1.09375,0.921875 1.890625,0.921875 1.734375,0 2.953125,-1.578125 2.953125,-3.765625 0,-2.1875 -1.203125,-3.671875 -3.015625,-3.671875 -0.859375,0 -1.453125,0.3125 -1.953125,1 -0.01563,-0.390625 -0.0625,-0.671875 -0.125,-0.84375 h -1.71875 c 0.09375,0.5 0.125,1.046875 0.125,2.265625 z m 3.34375,-8.6875 c 0.921875,0 1.46875,0.8125 1.46875,2.15625 0,1.375 -0.546875,2.1875 -1.46875,2.1875 -0.921875,0 -1.53125,-0.828125 -1.53125,-2.140625 0,-1.359375 0.59375,-2.203125 1.53125,-2.203125 z m 0,0 M -77.190625,-5 c 0.109375,-0.546875 0.515625,-0.8125 1.21875,-0.8125 0.78125,0 1.078125,0.296875 1.078125,1.078125 V -4.625 c -1.9375,0.34375 -2.046875,0.359375 -2.6875,0.625 -1.046875,0.390625 -1.625,1.140625 -1.625,2.125 0,1.28125 0.96875,2.03125 2.59375,2.03125 0.953125,0 1.578125,-0.328125 1.96875,-0.96875 0,0.359375 0.01563,0.53125 0.09375,0.8125 h 1.6875 c -0.1875,-0.375 -0.25,-0.734375 -0.25,-1.59375 v -2.859375 c 0,-0.90625 -0.07813,-1.34375 -0.28125,-1.75 -0.328125,-0.6875 -1.21875,-1.078125 -2.453125,-1.078125 -0.9375,0 -1.78125,0.25 -2.3125,0.6875 -0.46875,0.375 -0.703125,0.8125 -0.78125,1.59375 z m 2.296875,2.015625 c 0,0.546875 -0.04687,0.84375 -0.140625,1.0625 -0.1875,0.40625 -0.640625,0.65625 -1.203125,0.65625 -0.625,0 -1.078125,-0.359375 -1.078125,-0.84375 0,-0.3125 0.171875,-0.609375 0.4375,-0.796875 0.3125,-0.234375 0.78125,-0.328125 1.984375,-0.484375 z m 0,0 M -82.106,-10 -85.76225,-5.3125 -82.090375,0 h 2.4375 l -3.96875,-5.375 3.734375,-4.625 z m -5.609375,0 V 0 h 1.921875 v -10 z m 0,0 m -8.148128,0 -5.812497,10 h 1.48437 l 5.796877,-10 z m 0.578125,5.25 c -1.15625,0 -2.09375,1.0625 -2.09375,2.40625 0,1.34375 0.9375,2.421875 2.078125,2.421875 1.203125,0 2.140625,-1.046875 2.140625,-2.421875 0,-1.34375 -0.9375,-2.40625 -2.125,-2.40625 z m 0.01563,1.015625 c 0.5625,0 0.9375,0.5625 0.9375,1.390625 0,0.84375 -0.375,1.40625 -0.9375,1.40625 -0.5625,0 -0.9375,-0.5625 -0.9375,-1.40625 0,-0.84375 0.375,-1.390625 0.9375,-1.390625 z m -5.499992,-6.34375 c -1.1875,0 -2.10938,1.0625 -2.10938,2.40625 0,1.34375 0.92188,2.421875 2.09375,2.421875 1.203122,0 2.124997,-1.046875 2.124997,-2.421875 0,-1.34375 -0.921875,-2.40625 -2.109367,-2.40625 z m 0.0156,1.015625 c 0.5625,0 0.937497,0.578125 0.937497,1.390625 0,0.84375 -0.374997,1.40625 -0.953117,1.40625 -0.5625,0 -0.9375,-0.5625 -0.9375,-1.40625 0,-0.828125 0.375,-1.390625 0.95312,-1.390625 z m 0,0 m -9.3675,-0.921875 c -2.23437,0 -3.57812,1.90625 -3.57812,4.984375 0,3.265625 1.3125,5.15625 3.57812,5.15625 2.21875,0 3.54688,-1.90625 3.54688,-5.078125 0,-3.171875 -1.32813,-5.0625 -3.54688,-5.0625 z m 0,1.546875 c 0.42188,0 0.79688,0.203125 1.04688,0.59375 0.40625,0.609375 0.625,1.671875 0.625,2.921875 0,1.25 -0.21875,2.28125 -0.625,2.9375 -0.25,0.375 -0.60938,0.59375 -1.04688,0.59375 -1.10937,0 -1.70312,-1.296875 -1.70312,-3.578125 0,-1.203125 0.21875,-2.25 0.625,-2.875 0.25,-0.390625 0.60937,-0.59375 1.07812,-0.59375 z m 0,0 m -8.54999,-1.546875 c -2.23438,0 -3.57813,1.90625 -3.57813,4.984375 0,3.265625 1.3125,5.15625 3.57813,5.15625 2.21875,0 3.54687,-1.90625 3.54687,-5.078125 0,-3.171875 -1.32812,-5.0625 -3.54687,-5.0625 z m 0,1.546875 c 0.42187,0 0.79687,0.203125 1.04687,0.59375 0.40625,0.609375 0.625,1.671875 0.625,2.921875 0,1.25 -0.21875,2.28125 -0.625,2.9375 -0.25,0.375 -0.60937,0.59375 -1.04687,0.59375 -1.10938,0 -1.70313,-1.296875 -1.70313,-3.578125 0,-1.203125 0.21875,-2.25 0.625,-2.875 0.25,-0.390625 0.60938,-0.59375 1.07813,-0.59375 z m 0,0 M -129.04975,-7 h 1.71875 v 7 h 1.875 v -9.796875 h -1.28125 c -0.23438,1.1875 -0.96875,1.734375 -2.3125,1.765625 z m 0,0 M -76.941,-25.125 c 0.04687,0.390625 0.0625,0.546875 0.0625,0.9375 0.01563,0.515625 0.01563,0.9375 0.01563,1.25 V -18 h 1.84375 v -3.3125 c 0,-1.59375 0.453125,-2.34375 1.4375,-2.34375 0.390625,0 0.765625,0.125 1.109375,0.34375 v -1.875 c -0.3125,-0.07813 -0.359375,-0.09375 -0.5625,-0.09375 -0.875,0 -1.484375,0.484375 -2.046875,1.640625 0.01563,-0.171875 0.01563,-0.296875 0.01563,-0.375 0,-0.40625 -0.04687,-0.796875 -0.125,-1.109375 z m 0,0 m -8.12625,10.078125 h 1.84375 v -3.71875 c 0.5625,0.640625 1.09375,0.921875 1.890625,0.921875 1.734375,0 2.953125,-1.578125 2.953125,-3.765625 0,-2.1875 -1.203125,-3.671875 -3.015625,-3.671875 -0.859375,0 -1.453125,0.3125 -1.953125,1 -0.01563,-0.390625 -0.0625,-0.671875 -0.125,-0.84375 h -1.71875 c 0.09375,0.5 0.125,1.046875 0.125,2.265625 z m 3.34375,-8.6875 c 0.921875,0 1.46875,0.8125 1.46875,2.15625 0,1.375 -0.546875,2.1875 -1.46875,2.1875 -0.921875,0 -1.53125,-0.828125 -1.53125,-2.140625 0,-1.359375 0.59375,-2.203125 1.53125,-2.203125 z m 0,0 m -4.88125,2.609375 v -0.359375 c 0,-2.359375 -1.25,-3.828125 -3.265625,-3.828125 -2.078125,0 -3.453125,1.515625 -3.453125,3.828125 0,2.25 1.359375,3.671875 3.515625,3.671875 1.578125,0 2.75,-0.828125 3.0625,-2.203125 l -1.640625,-0.0625 c -0.234375,0.53125 -0.703125,0.78125 -1.375,0.78125 -1.03125,0 -1.65625,-0.65625 -1.71875,-1.828125 z m -4.828125,-1.34375 c 0.234375,-0.96875 0.75,-1.421875 1.546875,-1.421875 0.8125,0 1.265625,0.453125 1.421875,1.421875 z m 0,0 M -3.1225,-25.125 -3.09125,-27.1875 H -4.8725 l -0.046875,2.0625 H -6.09125 v 1.4375 h 1.109375 l -0.109375,2.78125 -0.015625,0.703125 c 0,0.78125 0.078125,1.125 0.3125,1.484375 0.34375,0.5625 0.953125,0.875 1.75,0.875 0.5625,0 1.0625,-0.109375 1.640625,-0.34375 v -1.515625 c -0.40625,0.15625 -0.71875,0.234375 -1.078125,0.234375 -0.546875,0 -0.734375,-0.21875 -0.734375,-0.96875 0,-0.140625 0,-0.140625 0.015625,-0.5 l 0.046875,-2.75 h 1.484375 v -1.4375 z m 0,0 m -6.19626,0 V -18 h 1.84375 v -7.125 z m 0.96875,-3.078125 c -0.671875,0 -1.109375,0.4375 -1.109375,1.09375 0,0.65625 0.421875,1.046875 1.078125,1.046875 0.640625,0 1.0625,-0.40625 1.0625,-1.078125 0,-0.625 -0.421875,-1.0625 -1.03125,-1.0625 z m 0,0 M -22.03125,-25.125 c 0.15625,0.4375 0.1875,0.671875 0.1875,1.6875 V -18 H -20 v -3.953125 c 0,-0.515625 0.01563,-0.703125 0.109375,-0.921875 0.1875,-0.5 0.625,-0.78125 1.25,-0.78125 0.453125,0 0.828125,0.1875 0.984375,0.484375 0.125,0.203125 0.15625,0.484375 0.15625,1.21875 V -18 h 1.84375 v -4.03125 c 0,-1.09375 0.4375,-1.625 1.328125,-1.625 0.453125,0 0.796875,0.15625 0.984375,0.4375 0.125,0.203125 0.171875,0.5 0.171875,1.109375 V -18 h 1.84375 v -4.15625 c 0,-1.40625 -0.01563,-1.59375 -0.234375,-2.046875 -0.3125,-0.703125 -1.015625,-1.078125 -2,-1.078125 -0.984375,0 -1.671875,0.34375 -2.3125,1.15625 -0.4375,-0.796875 -1.078125,-1.15625 -2.046875,-1.15625 -0.953125,0 -1.625,0.34375 -2.171875,1.09375 v -0.125 c 0,-0.3125 -0.04687,-0.5625 -0.15625,-0.8125 z m 0,0 m -5.10001,4 v -0.359375 c 0,-2.359375 -1.25,-3.828125 -3.265625,-3.828125 -2.078125,0 -3.453125,1.515625 -3.453125,3.828125 0,2.25 1.359375,3.671875 3.515625,3.671875 1.578125,0 2.75,-0.828125 3.0625,-2.203125 l -1.640625,-0.0625 c -0.234375,0.53125 -0.703125,0.78125 -1.375,0.78125 -1.03125,0 -1.65625,-0.65625 -1.71875,-1.828125 z m -4.828125,-1.34375 c 0.234375,-0.96875 0.75,-1.421875 1.546875,-1.421875 0.8125,0 1.265625,0.453125 1.421875,1.421875 z m 0,0 m -4.356605,-2.65625 0.03125,-2.0625 h -1.78125 l -0.04687,2.0625 h -1.171875 v 1.4375 h 1.109375 l -0.109375,2.78125 -0.01563,0.703125 c 0,0.78125 0.07813,1.125 0.3125,1.484375 0.34375,0.5625 0.953125,0.875 1.75,0.875 0.5625,0 1.0625,-0.109375 1.640625,-0.34375 v -1.515625 c -0.40625,0.15625 -0.71875,0.234375 -1.078125,0.234375 -0.546875,0 -0.734375,-0.21875 -0.734375,-0.96875 0,-0.140625 0,-0.140625 0.01563,-0.5 l 0.04687,-2.75 h 1.484375 v -1.4375 z m 0,0 m -5.836885,0 -2.609375,3.328125 L -42.1685,-18 h 2.484375 L -42.606,-21.828125 -39.934125,-25.125 Z m -4.484375,-2.9375 V -18 h 1.84375 v -10.0625 z m 0,0 m -8.3875,2.9375 v 4.15625 c 0,0.921875 0.140625,1.625 0.40625,2.03125 0.4375,0.6875 1.265625,1.09375 2.203125,1.09375 0.875,0 1.453125,-0.28125 2,-0.984375 0.01563,0.328125 0.07813,0.65625 0.15625,0.828125 h 1.734375 c -0.171875,-0.625 -0.171875,-0.625 -0.171875,-2.203125 V -25.125 H -50.556 v 3.8125 c 0,1.25 -0.453125,1.84375 -1.40625,1.84375 -0.421875,0 -0.765625,-0.15625 -0.953125,-0.421875 C -53.08725,-20.109375 -53.181,-20.5 -53.181,-21.078125 V -25.125 Z m 0,0 m -2.00125,-2.9375 h -1.84375 v 3.71875 c -0.53125,-0.671875 -1.03125,-0.9375 -1.84375,-0.9375 -1.75,0 -3,1.578125 -3,3.78125 0,2.1875 1.21875,3.65625 3.03125,3.65625 0.953125,0 1.546875,-0.34375 2.015625,-1.140625 -0.01563,0.171875 -0.01563,0.265625 -0.01563,0.359375 0,0.171875 0.01563,0.328125 0.0625,0.625 h 1.71875 c -0.09375,-0.5 -0.125,-1.046875 -0.125,-2.25 z m -3.265625,4.328125 c 0.90625,0 1.453125,0.8125 1.453125,2.171875 0,1.328125 -0.59375,2.171875 -1.53125,2.171875 -0.921875,0 -1.46875,-0.796875 -1.46875,-2.109375 0,-1.40625 0.5625,-2.234375 1.546875,-2.234375 z m 0,0 m -7.94625,-1.578125 c -2.015625,0 -3.515625,1.5625 -3.515625,3.703125 0,2.25 1.4375,3.796875 3.515625,3.796875 2.046875,0 3.515625,-1.5625 3.515625,-3.75 0,-2.1875 -1.46875,-3.75 -3.515625,-3.75 z m 0,1.484375 c 0.96875,0 1.625,0.921875 1.625,2.265625 0,1.34375 -0.65625,2.265625 -1.625,2.265625 -0.984375,0 -1.625,-0.90625 -1.625,-2.28125 0,-1.328125 0.671875,-2.25 1.625,-2.25 z m 0,0 m -25.683123,-1.296875 -2.359375,0.04687 c -0.59375,-0.15625 -0.921875,-0.203125 -1.375,-0.203125 -1.8125,0 -2.968747,0.984375 -2.968747,2.515625 0,0.96875 0.375,1.59375 1.218747,2.015625 -0.906247,0.359375 -1.265627,0.671875 -1.265627,1.140625 0,0.390625 0.23438,0.640625 0.796877,0.859375 -0.999997,0.34375 -1.437497,0.859375 -1.437497,1.671875 0,1.28125 1.374997,2.09375 3.562497,2.09375 2.234375,0 3.53125,-0.875 3.53125,-2.390625 0,-0.75 -0.34375,-1.375 -0.921875,-1.671875 -0.4375,-0.25 -1,-0.359375 -2.203125,-0.46875 -1.46875,-0.15625 -1.5625,-0.171875 -1.5625,-0.453125 0,-0.21875 0.28125,-0.390625 0.703125,-0.421875 1.546875,-0.140625 1.59375,-0.140625 2.078125,-0.359375 0.71875,-0.3125 1.109375,-0.9375 1.109375,-1.78125 0,-0.46875 -0.125,-0.90625 -0.375,-1.28125 h 1.46875 z m -3.84375,1.25 c 0.71875,0 1.21875,0.4375 1.21875,1.09375 0,0.625 -0.5,1.046875 -1.25,1.046875 -0.75,0 -1.234375,-0.421875 -1.234375,-1.046875 0,-0.671875 0.5,-1.09375 1.265625,-1.09375 z m -0.21875,5.734375 c 1.25,0 2,0.34375 2,0.9375 0,0.5625 -0.625,0.890625 -1.75,0.890625 -1.265625,0 -2,-0.359375 -2,-0.921875 0,-0.578125 0.640625,-0.90625 1.75,-0.90625 z m 0,0 M -106.67912,-23 c 0.10937,-0.546875 0.51562,-0.8125 1.21875,-0.8125 0.78125,0 1.07812,0.296875 1.07812,1.078125 V -22.625 c -1.9375,0.34375 -2.04687,0.359375 -2.6875,0.625 -1.04687,0.390625 -1.625,1.140625 -1.625,2.125 0,1.28125 0.96875,2.03125 2.59375,2.03125 0.95313,0 1.57813,-0.328125 1.96875,-0.96875 0,0.359375 0.0156,0.53125 0.0937,0.8125 h 1.6875 c -0.1875,-0.375 -0.25,-0.734375 -0.25,-1.59375 v -2.859375 c 0,-0.90625 -0.0781,-1.34375 -0.28125,-1.75 -0.32812,-0.6875 -1.21875,-1.078125 -2.45312,-1.078125 -0.9375,0 -1.78125,0.25 -2.3125,0.6875 -0.46875,0.375 -0.70313,0.8125 -0.78125,1.59375 z m 2.29687,2.015625 c 0,0.546875 -0.0469,0.84375 -0.14062,1.0625 -0.1875,0.40625 -0.64063,0.65625 -1.20313,0.65625 -0.625,0 -1.07812,-0.359375 -1.07812,-0.84375 0,-0.3125 0.17187,-0.609375 0.4375,-0.796875 0.3125,-0.234375 0.78125,-0.328125 1.98437,-0.484375 z m 0,0 m -7.79,-7.078125 V -18 h 1.84375 v -10.0625 z m 0,0 m -8.43875,2.9375 c 0.20312,0.6875 0.21875,0.828125 0.21875,2.546875 V -18 h 1.84375 v -3.640625 c 0,-0.703125 0.0469,-1 0.1875,-1.28125 0.20312,-0.453125 0.65625,-0.734375 1.17187,-0.734375 0.45313,0 0.8125,0.21875 0.98438,0.59375 0.125,0.28125 0.17187,0.640625 0.17187,1.359375 V -18 h 1.84375 v -4.109375 c 0,-1.296875 -0.0625,-1.65625 -0.32812,-2.125 -0.375,-0.65625 -1.15625,-1.046875 -2.04688,-1.046875 -0.875,0 -1.59375,0.359375 -2.10937,1.078125 0,-0.390625 -0.0469,-0.703125 -0.15625,-0.921875 z m 0,0 m -6.31125,-2.875 -3.375,10 h 1.95312 l 0.64063,-2.078125 h 3.51562 l 0.625,2.078125 h 1.98438 l -3.40625,-10 z m 2.26562,6.28125 h -2.57812 l 1.28125,-4.078125 z m 0,0"
              />
            </g>
          </g>
        )}
        <g
          style={{ fill: 'rgb(0%,52.941895%,49.01886%)', fillOpacity: 1 }}
          id="g6050"
        >
          <g id="use6040" transform="translate(368.96201,271.3251)" />
          <g id="use6042" transform="translate(377.992,271.3251)" />
          <g id="use6044" transform="translate(386.21201,271.3251)" />
          <g id="use6046" transform="translate(390.12701,271.3251)" />
          <g id="use6048" transform="translate(397.80701,271.3251)" />
        </g>
        <g
          style={{ fill: 'rgb(0%,52.941895%,49.01886%)', fillOpacity: 1 }}
          id="g6058"
        >
          <g id="use6052" transform="translate(405.59201,271.3251)" />
          <g id="use6054" transform="translate(413.31699,271.3251)" />
          <g id="use6056" transform="translate(421.53699,271.3251)" />
        </g>
        <g
          style={{ fill: 'rgb(0%,52.941895%,49.01886%)', fillOpacity: 1 }}
          id="g6070"
        >
          <g id="use6060" transform="translate(427.16199,271.3251)" />
          <g id="use6062" transform="translate(435.202,271.3251)" />
          <g id="use6064" transform="translate(443.422,271.3251)" />
          <g id="use6066" transform="translate(451.74701,271.3251)" />
          <g id="use6068" transform="translate(459.78699,271.3251)" />
        </g>
        <g
          style={{ fill: 'rgb(0%,52.941895%,49.01886%)', fillOpacity: 1 }}
          id="g6076"
        >
          <g id="use6072" transform="translate(465.06549,271.3251)" />
          <g id="use6074" transform="translate(472.7905,271.3251)" />
        </g>
        <g
          style={{ fill: 'rgb(0%,52.941895%,49.01886%)', fillOpacity: 1 }}
          id="g6080"
        >
          <use x="476.5405" y="271.3251" id="use6078" />
        </g>
        <g
          style={{ fill: 'rgb(0%,52.941895%,49.01886%)', fillOpacity: 1 }}
          id="g6094"
        >
          <g id="use6082" transform="translate(358.38699,289.3251)" />
          <g id="use6084" transform="translate(366.427,289.3251)" />
          <g id="use6086" transform="translate(374.75201,289.3251)" />
          <g id="use6088" transform="translate(382.97198,289.3251)" />
          <g id="use6090" transform="translate(390.69699,289.3251)" />
          <g id="use6092" transform="translate(394.44699,289.3251)" />
        </g>
        <g
          style={{ fill: 'rgb(0%,52.941895%,49.01886%)', fillOpacity: 1 }}
          id="g6104"
        >
          <g id="use6096" transform="translate(403.56699,289.3251)" />
          <g id="use6098" transform="translate(411.24701,289.3251)" />
          <g id="use6100" transform="translate(419.46701,289.3251)" />
          <g id="use6102" transform="translate(423.38199,289.3251)" />
        </g>
        <g
          style={{ fill: 'rgb(0%,52.941895%,49.01886%)', fillOpacity: 1 }}
          id="g6114"
        >
          <g id="use6106" transform="translate(428.75049,289.3251)" />
          <g id="use6108" transform="translate(436.43051,289.3251)" />
          <g id="use6110" transform="translate(440.34549,289.3251)" />
          <g id="use6112" transform="translate(447.62051,289.3251)" />
        </g>
        {props.lang === 'en' ? (
          <g
            style={{ fill: 'rgb(0%,52.941895%,49.01886%)', fillOpacity: 1 }}
            id="g6124"
          >
            <g id="use6116" transform="translate(481.22861,289.3251)" />
            <g id="use6118" transform="translate(486.58359,289.3251)" />
            <g id="use6120" transform="translate(490.4986,289.3251)" />
            <g id="use6122" transform="translate(498.5386,289.3251)">
              <path
                id="path15104"
                style={{ stroke: 'none' }}
                d="m 0.8125,-7.125 c 0.203125,0.6875 0.21875,0.828125 0.21875,2.546875 V 0 H 2.875 v -3.640625 c 0,-0.703125 0.046875,-1 0.1875,-1.28125 C 3.265625,-5.375 3.71875,-5.65625 4.234375,-5.65625 c 0.453125,0 0.8125,0.21875 0.984375,0.59375 0.125,0.28125 0.171875,0.640625 0.171875,1.359375 V 0 h 1.84375 v -4.109375 c 0,-1.296875 -0.0625,-1.65625 -0.328125,-2.125 C 6.53125,-6.890625 5.75,-7.28125 4.859375,-7.28125 c -0.875,0 -1.59375,0.359375 -2.109375,1.078125 C 2.75,-6.59375 2.703125,-6.90625 2.59375,-7.125 Z m 0,0 M -4.024375,-7.3125 C -6.04,-7.3125 -7.54,-5.75 -7.54,-3.609375 c 0,2.25 1.4375,3.796875 3.515625,3.796875 2.046875,0 3.515625,-1.5625 3.515625,-3.75 0,-2.1875 -1.46875,-3.75 -3.515625,-3.75 z m 0,1.484375 c 0.96875,0 1.625,0.921875 1.625,2.265625 0,1.34375 -0.65625,2.265625 -1.625,2.265625 -0.984375,0 -1.625,-0.90625 -1.625,-2.28125 0,-1.328125 0.671875,-2.25 1.625,-2.25 z m 0,0 M -10.92376,-7.125 V 0 h 1.84375 v -7.125 z m 0.96875,-3.078125 c -0.671875,0 -1.109375,0.4375 -1.109375,1.09375 0,0.65625 0.421875,1.046875 1.078125,1.046875 0.640625,0 1.0625,-0.40625 1.0625,-1.078125 0,-0.625 -0.421875,-1.0625 -1.03125,-1.0625 z m 0,0 m -4.04248,3.078125 0.03125,-2.0625 h -1.78125 l -0.04687,2.0625 h -1.171875 v 1.4375 h 1.109375 l -0.109375,2.78125 -0.01563,0.703125 c 0,0.78125 0.07813,1.125 0.3125,1.484375 0.34375,0.5625 0.953125,0.875 1.75,0.875 0.5625,0 1.0625,-0.109375 1.640625,-0.34375 v -1.515625 c -0.40625,0.15625 -0.71875,0.234375 -1.078125,0.234375 -0.546875,0 -0.734375,-0.21875 -0.734375,-0.96875 0,-0.140625 0,-0.140625 0.01563,-0.5 l 0.04687,-2.75 h 1.484375 V -7.125 Z m 0,0 m -3.86127,2.359375 c -0.234375,-1.65625 -1.265625,-2.546875 -2.96875,-2.546875 -2.0625,0 -3.4375,1.5 -3.4375,3.75 0,2.25 1.375,3.75 3.421875,3.75 1.71875,0 2.9375,-1.09375 3.015625,-2.71875 h -1.78125 c -0.09375,0.84375 -0.5,1.234375 -1.234375,1.234375 -0.96875,0 -1.53125,-0.828125 -1.53125,-2.265625 0,-1.375 0.609375,-2.265625 1.546875,-2.265625 0.65625,0 1.046875,0.359375 1.140625,1.0625 z m 0,0 M -25.27124,-3.125 v -0.359375 c 0,-2.359375 -1.25,-3.828125 -3.265625,-3.828125 -2.078125,0 -3.453125,1.515625 -3.453125,3.828125 0,2.25 1.359375,3.671875 3.515625,3.671875 1.578125,0 2.75,-0.828125 3.0625,-2.203125 l -1.640625,-0.0625 c -0.234375,0.53125 -0.703125,0.78125 -1.375,0.78125 -1.03125,0 -1.65625,-0.65625 -1.71875,-1.828125 z m -4.828125,-1.34375 c 0.234375,-0.96875 0.75,-1.421875 1.546875,-1.421875 0.8125,0 1.265625,0.453125 1.421875,1.421875 z m 0,0 m -4.358145,-2.65625 0.03125,-2.0625 h -1.78125 l -0.04687,2.0625 h -1.171875 v 1.4375 h 1.109375 l -0.109375,2.78125 -0.01563,0.703125 c 0,0.78125 0.07813,1.125 0.3125,1.484375 0.34375,0.5625 0.953125,0.875 1.75,0.875 0.5625,0 1.0625,-0.109375 1.640625,-0.34375 v -1.515625 c -0.40625,0.15625 -0.71875,0.234375 -1.078125,0.234375 -0.546875,0 -0.734375,-0.21875 -0.734375,-0.96875 0,-0.140625 0,-0.140625 0.01563,-0.5 l 0.04687,-2.75 h 1.484375 V -7.125 Z m 0,0 m -7.171875,-0.1875 c -2.015625,0 -3.515625,1.5625 -3.515625,3.703125 0,2.25 1.4375,3.796875 3.515625,3.796875 2.046875,0 3.515625,-1.5625 3.515625,-3.75 0,-2.1875 -1.46875,-3.75 -3.515625,-3.75 z m 0,1.484375 c 0.96875,0 1.625,0.921875 1.625,2.265625 0,1.34375 -0.65625,2.265625 -1.625,2.265625 -0.984375,0 -1.625,-0.90625 -1.625,-2.28125 0,-1.328125 0.671875,-2.25 1.625,-2.25 z m 0,0 M -50.33251,-7.125 c 0.04687,0.390625 0.0625,0.546875 0.0625,0.9375 0.01563,0.515625 0.01563,0.9375 0.01563,1.25 V 0 h 1.84375 v -3.3125 c 0,-1.59375 0.453125,-2.34375 1.4375,-2.34375 0.390625,0 0.765625,0.125 1.109375,0.34375 v -1.875 c -0.3125,-0.078125 -0.359375,-0.09375 -0.5625,-0.09375 -0.875,0 -1.484375,0.484375 -2.046875,1.640625 0.01563,-0.171875 0.01563,-0.296875 0.01563,-0.375 0,-0.40625 -0.04687,-0.796875 -0.125,-1.109375 z m 0,0 M -58.541865,-10 V 0 h 1.921875 v -3.734375 h 0.59375 c 1.34375,0 2,-0.0625 2.5625,-0.203125 1.1875,-0.359375 1.953125,-1.46875 1.953125,-2.890625 0,-1.390625 -0.703125,-2.5 -1.859375,-2.875 C -54.041865,-9.9375 -54.729365,-10 -56.198115,-10 Z m 1.921875,4.625 v -3 h 0.703125 c 0.984375,0 1.390625,0.0625 1.765625,0.25 0.421875,0.21875 0.671875,0.6875 0.671875,1.28125 0,0.640625 -0.296875,1.125 -0.796875,1.3125 -0.375,0.125 -0.625,0.15625 -1.734375,0.15625 z m 0,0 m -9.75876,-4.6875 V 0 h 1.84375 v -10.0625 z m 0,0 M -72.480615,-5 c 0.109375,-0.546875 0.515625,-0.8125 1.21875,-0.8125 0.78125,0 1.078125,0.296875 1.078125,1.078125 V -4.625 c -1.9375,0.34375 -2.046875,0.359375 -2.6875,0.625 -1.046875,0.390625 -1.625,1.140625 -1.625,2.125 0,1.28125 0.96875,2.03125 2.59375,2.03125 0.953125,0 1.578125,-0.328125 1.96875,-0.96875 0,0.359375 0.01563,0.53125 0.09375,0.8125 h 1.6875 c -0.1875,-0.375 -0.25,-0.734375 -0.25,-1.59375 v -2.859375 c 0,-0.90625 -0.07813,-1.34375 -0.28125,-1.75 -0.328125,-0.6875 -1.21875,-1.078125 -2.453125,-1.078125 -0.9375,0 -1.78125,0.25 -2.3125,0.6875 -0.46875,0.375 -0.703125,0.8125 -0.78125,1.59375 z m 2.296875,2.015625 c 0,0.546875 -0.04687,0.84375 -0.140625,1.0625 -0.1875,0.40625 -0.640625,0.65625 -1.203125,0.65625 -0.625,0 -1.078125,-0.359375 -1.078125,-0.84375 0,-0.3125 0.171875,-0.609375 0.4375,-0.796875 0.3125,-0.234375 0.78125,-0.328125 1.984375,-0.484375 z m 0,0 m -6.96225,-4.140625 0.03125,-2.0625 h -1.78125 l -0.04687,2.0625 h -1.171875 v 1.4375 h 1.109375 l -0.109375,2.78125 -0.01563,0.703125 c 0,0.78125 0.07813,1.125 0.3125,1.484375 0.34375,0.5625 0.953125,0.875 1.75,0.875 0.5625,0 1.0625,-0.109375 1.640625,-0.34375 v -1.515625 c -0.40625,0.15625 -0.71875,0.234375 -1.078125,0.234375 -0.546875,0 -0.734375,-0.21875 -0.734375,-0.96875 0,-0.140625 0,-0.140625 0.01563,-0.5 l 0.04687,-2.75 h 1.484375 V -7.125 Z m 0,0 m -6.19626,0 V 0 h 1.84375 v -7.125 z m 0.96875,-3.078125 c -0.671875,0 -1.109375,0.4375 -1.109375,1.09375 0,0.65625 0.421875,1.046875 1.078125,1.046875 0.640625,0 1.0625,-0.40625 1.0625,-1.078125 0,-0.625 -0.421875,-1.0625 -1.03125,-1.0625 z m 0,0 m -9.18875,13.15625 h 1.84375 v -3.71875 c 0.5625,0.640625 1.09375,0.921875 1.890625,0.921875 1.734375,0 2.953125,-1.578125 2.953125,-3.765625 0,-2.1875 -1.203125,-3.671875 -3.015625,-3.671875 -0.859375,0 -1.453125,0.3125 -1.953125,1 -0.01563,-0.390625 -0.0625,-0.671875 -0.125,-0.84375 h -1.71875 c 0.09375,0.5 0.125,1.046875 0.125,2.265625 z m 3.34375,-8.6875 c 0.921875,0 1.46875,0.8125 1.46875,2.15625 0,1.375 -0.546875,2.1875 -1.46875,2.1875 -0.921875,0 -1.53125,-0.828125 -1.53125,-2.140625 0,-1.359375 0.59375,-2.203125 1.53125,-2.203125 z m 0,0 M -97.664115,-5 c 0.109375,-0.546875 0.515625,-0.8125 1.21875,-0.8125 0.78125,0 1.078125,0.296875 1.078125,1.078125 V -4.625 c -1.9375,0.34375 -2.046875,0.359375 -2.6875,0.625 -1.046875,0.390625 -1.625,1.140625 -1.625,2.125 0,1.28125 0.96875,2.03125 2.59375,2.03125 0.953125,0 1.578125,-0.328125 1.96875,-0.96875 0,0.359375 0.01563,0.53125 0.09375,0.8125 h 1.6875 c -0.1875,-0.375 -0.25,-0.734375 -0.25,-1.59375 v -2.859375 c 0,-0.90625 -0.07813,-1.34375 -0.28125,-1.75 -0.328125,-0.6875 -1.21875,-1.078125 -2.453125,-1.078125 -0.9375,0 -1.78125,0.25 -2.3125,0.6875 -0.46875,0.375 -0.703125,0.8125 -0.78125,1.59375 z m 2.296875,2.015625 c 0,0.546875 -0.04687,0.84375 -0.140625,1.0625 -0.1875,0.40625 -0.640625,0.65625 -1.203125,0.65625 -0.625,0 -1.078125,-0.359375 -1.078125,-0.84375 0,-0.3125 0.171875,-0.609375 0.4375,-0.796875 0.3125,-0.234375 0.78125,-0.328125 1.984375,-0.484375 z m 0,0 M -100.78976,-6.75 c -0.125,-2.21875 -1.39063,-3.453125 -3.51563,-3.453125 -1.07812,0 -2.0625,0.359375 -2.82812,1.03125 -1.03125,0.953125 -1.57813,2.375 -1.57813,4.203125 0,1.75 0.48438,3.09375 1.46875,4.03125 0.79688,0.734375 1.84375,1.125 3.03125,1.125 2.23438,0 3.42188,-1.3125 3.54688,-3.890625 h -1.70313 c -0.125,1.515625 -0.75,2.25 -1.92187,2.25 -1.5,0 -2.4375,-1.34375 -2.4375,-3.53125 0,-2.1875 0.9375,-3.546875 2.42187,-3.546875 1.01563,0 1.67188,0.625 1.85938,1.78125 z m 0,0 m -14.26123,-0.375 0.0312,-2.0625 h -1.78125 l -0.0469,2.0625 h -1.17188 v 1.4375 h 1.10938 l -0.10938,2.78125 -0.0156,0.703125 c 0,0.78125 0.0781,1.125 0.3125,1.484375 0.34375,0.5625 0.95312,0.875 1.75,0.875 0.5625,0 1.0625,-0.109375 1.64062,-0.34375 v -1.515625 c -0.40625,0.15625 -0.71875,0.234375 -1.07812,0.234375 -0.54688,0 -0.73438,-0.21875 -0.73438,-0.96875 0,-0.140625 0,-0.140625 0.0156,-0.5 l 0.0469,-2.75 h 1.48438 V -7.125 Z m 0,0 m -10.66876,0 v 4.15625 c 0,0.921875 0.14063,1.625 0.40625,2.03125 0.4375,0.6875 1.26563,1.09375 2.20313,1.09375 0.875,0 1.45312,-0.28125 2,-0.984375 0.0156,0.328125 0.0781,0.65625 0.15625,0.828125 h 1.73437 c -0.17187,-0.625 -0.17187,-0.625 -0.17187,-2.203125 V -7.125 h -1.85938 v 3.8125 c 0,1.25 -0.45312,1.84375 -1.40625,1.84375 -0.42187,0 -0.76562,-0.15625 -0.95312,-0.421875 -0.17188,-0.21875 -0.26563,-0.609375 -0.26563,-1.1875 V -7.125 Z m 0,0 m -4.99313,-0.1875 c -2.01563,0 -3.51563,1.5625 -3.51563,3.703125 0,2.25 1.4375,3.796875 3.51563,3.796875 2.04687,0 3.51562,-1.5625 3.51562,-3.75 0,-2.1875 -1.46875,-3.75 -3.51562,-3.75 z m 0,1.484375 c 0.96875,0 1.625,0.921875 1.625,2.265625 0,1.34375 -0.65625,2.265625 -1.625,2.265625 -0.98438,0 -1.625,-0.90625 -1.625,-2.28125 0,-1.328125 0.67187,-2.25 1.625,-2.25 z m 0,0 M -142.02224,-10.0625 V 0 h 1.84375 v -3.640625 c 0,-0.625 0.0625,-0.984375 0.20313,-1.265625 0.23437,-0.46875 0.70312,-0.75 1.21875,-0.75 0.45312,0 0.82812,0.21875 1.03125,0.625 0.125,0.28125 0.17187,0.625 0.17187,1.328125 V 0 h 1.84375 v -4.109375 c 0,-1.296875 -0.0625,-1.703125 -0.35937,-2.171875 -0.39063,-0.609375 -1.17188,-1 -2.04688,-1 -0.82812,0 -1.5,0.328125 -2.0625,0.9375 v -3.71875 z m 0,0 m -3.08875,2.9375 0.0312,-2.0625 h -1.78125 l -0.0469,2.0625 h -1.17188 v 1.4375 h 1.10938 l -0.10938,2.78125 -0.0156,0.703125 c 0,0.78125 0.0781,1.125 0.3125,1.484375 0.34375,0.5625 0.95312,0.875 1.75,0.875 0.5625,0 1.0625,-0.109375 1.64062,-0.34375 v -1.515625 c -0.40625,0.15625 -0.71875,0.234375 -1.07812,0.234375 -0.54688,0 -0.73438,-0.21875 -0.73438,-0.96875 0,-0.140625 0,-0.140625 0.0156,-0.5 l 0.0469,-2.75 h 1.48438 V -7.125 Z m 0,0 m -6.19626,0 V 0 h 1.84375 v -7.125 z m 0.96875,-3.078125 c -0.67187,0 -1.10937,0.4375 -1.10937,1.09375 0,0.65625 0.42187,1.046875 1.07812,1.046875 0.64063,0 1.0625,-0.40625 1.0625,-1.078125 0,-0.625 -0.42187,-1.0625 -1.03125,-1.0625 z m 0,0 m -13.04751,3.078125 2.09375,7.171875 h 1.98438 l 1.29687,-4.28125 1.34375,4.28125 h 1.96875 l 2.14063,-7.171875 h -1.84375 l -1.35938,5.03125 -1.46875,-5.03125 h -1.48437 l -1.48438,5.03125 -1.3125,-5.03125 z m 0,0 m 51.43564,-15.84375 c -0.0937,-1.5 -1.14063,-2.359375 -2.89063,-2.359375 -1.70312,0 -2.84375,0.921875 -2.84375,2.296875 0,0.515625 0.17188,0.984375 0.48438,1.296875 0.29687,0.28125 0.70312,0.484375 1.48437,0.71875 1.26563,0.375 1.26563,0.375 1.5,0.484375 0.35938,0.140625 0.46875,0.296875 0.46875,0.5625 0,0.46875 -0.42187,0.765625 -1.125,0.765625 -0.875,0 -1.28125,-0.34375 -1.34375,-1.1875 h -1.75 c 0,1.703125 1.09375,2.578125 3.17188,2.578125 1.82812,0 2.89062,-0.84375 2.89062,-2.28125 0,-0.484375 -0.14062,-0.921875 -0.42187,-1.234375 -0.29688,-0.34375 -0.75,-0.578125 -1.79688,-0.890625 -1.07812,-0.3125 -1.21875,-0.359375 -1.4375,-0.484375 -0.1875,-0.109375 -0.29687,-0.3125 -0.29687,-0.515625 0,-0.421875 0.42187,-0.734375 0.98437,-0.734375 0.6875,0 1.04688,0.3125 1.14063,0.984375 z m 0,0 m -7.08438,1.84375 v -0.359375 c 0,-2.359375 -1.25,-3.828125 -3.26562,-3.828125 -2.07813,0 -3.45313,1.515625 -3.45313,3.828125 0,2.25 1.35938,3.671875 3.51563,3.671875 1.57812,0 2.75,-0.828125 3.0625,-2.203125 l -1.64063,-0.0625 c -0.23437,0.53125 -0.70312,0.78125 -1.375,0.78125 -1.03125,0 -1.65625,-0.65625 -1.71875,-1.828125 z m -4.82812,-1.34375 c 0.23437,-0.96875 0.75,-1.421875 1.54687,-1.421875 0.8125,0 1.26563,0.453125 1.42188,1.421875 z m 0,0 m -9.44874,-2.65625 2.53125,7.171875 h 2.04687 l 2.57813,-7.171875 h -1.90625 l -1.65625,5.109375 -1.65625,-5.109375 z m 0,0 m 122.999725,2.15625 c -0.09375,-1.5 -1.140625,-2.359375 -2.890625,-2.359375 -1.703125,0 -2.84375,0.921875 -2.84375,2.296875 0,0.515625 0.171875,0.984375 0.484375,1.296875 0.296875,0.28125 0.703125,0.484375 1.484375,0.71875 1.265625,0.375 1.265625,0.375 1.5,0.484375 0.359375,0.140625 0.46875,0.296875 0.46875,0.5625 0,0.46875 -0.421875,0.765625 -1.125,0.765625 -0.875,0 -1.28125,-0.34375 -1.34375,-1.1875 h -1.75 c 0,1.703125 1.09375,2.578125 3.171875,2.578125 1.828125,0 2.890625,-0.84375 2.890625,-2.28125 0,-0.484375 -0.140625,-0.921875 -0.421875,-1.234375 -0.296875,-0.34375 -0.75,-0.578125 -1.796875,-0.890625 -1.078125,-0.3125 -1.21875,-0.359375 -1.4375,-0.484375 -0.1875,-0.109375 -0.296875,-0.3125 -0.296875,-0.515625 0,-0.421875 0.421875,-0.734375 0.984375,-0.734375 0.6875,0 1.046875,0.3125 1.140625,0.984375 z m 0,0 m -8.620605,-2.15625 0.03125,-2.0625 h -1.78125 l -0.04687,2.0625 h -1.171875 v 1.4375 h 1.109375 l -0.109375,2.78125 -0.01563,0.703125 c 0,0.78125 0.07813,1.125 0.3125,1.484375 0.34375,0.5625 0.953125,0.875 1.75,0.875 0.5625,0 1.0625,-0.109375 1.640625,-0.34375 v -1.515625 c -0.40625,0.15625 -0.71875,0.234375 -1.078125,0.234375 -0.546875,0 -0.734375,-0.21875 -0.734375,-0.96875 0,-0.140625 0,-0.140625 0.01563,-0.5 l 0.04687,-2.75 h 1.484375 v -1.4375 z m 0,0 m -3.86127,2.359375 c -0.234375,-1.65625 -1.265625,-2.546875 -2.96875,-2.546875 -2.0625,0 -3.4375,1.5 -3.4375,3.75 0,2.25 1.375,3.75 3.421875,3.75 1.71875,0 2.9375,-1.09375 3.015625,-2.71875 h -1.78125 c -0.09375,0.84375 -0.5,1.234375 -1.234375,1.234375 -0.96875,0 -1.53125,-0.828125 -1.53125,-2.265625 0,-1.375 0.609375,-2.265625 1.546875,-2.265625 0.65625,0 1.046875,0.359375 1.140625,1.0625 z m 0,0 M -37.05624,-25.125 v 4.15625 c 0,0.921875 0.140625,1.625 0.40625,2.03125 0.4375,0.6875 1.265625,1.09375 2.203125,1.09375 0.875,0 1.453125,-0.28125 2,-0.984375 0.01563,0.328125 0.07813,0.65625 0.15625,0.828125 h 1.734375 c -0.171875,-0.625 -0.171875,-0.625 -0.171875,-2.203125 V -25.125 h -1.859375 v 3.8125 c 0,1.25 -0.453125,1.84375 -1.40625,1.84375 -0.421875,0 -0.765625,-0.15625 -0.953125,-0.421875 -0.171875,-0.21875 -0.265625,-0.609375 -0.265625,-1.1875 V -25.125 Z m 0,0 m -2.00125,-2.9375 h -1.84375 v 3.71875 c -0.53125,-0.671875 -1.03125,-0.9375 -1.84375,-0.9375 -1.75,0 -3,1.578125 -3,3.78125 0,2.1875 1.21875,3.65625 3.03125,3.65625 0.953125,0 1.546875,-0.34375 2.015625,-1.140625 -0.01563,0.171875 -0.01563,0.265625 -0.01563,0.359375 0,0.171875 0.01563,0.328125 0.0625,0.625 h 1.71875 c -0.09375,-0.5 -0.125,-1.046875 -0.125,-2.25 z m -3.265625,4.328125 c 0.90625,0 1.453125,0.8125 1.453125,2.171875 0,1.328125 -0.59375,2.171875 -1.53125,2.171875 -0.921875,0 -1.46875,-0.796875 -1.46875,-2.109375 0,-1.40625 0.5625,-2.234375 1.546875,-2.234375 z m 0,0 m -7.94626,-1.578125 c -2.015625,0 -3.515625,1.5625 -3.515625,3.703125 0,2.25 1.4375,3.796875 3.515625,3.796875 2.046875,0 3.515625,-1.5625 3.515625,-3.75 0,-2.1875 -1.46875,-3.75 -3.515625,-3.75 z m 0,1.484375 c 0.96875,0 1.625,0.921875 1.625,2.265625 0,1.34375 -0.65625,2.265625 -1.625,2.265625 -0.984375,0 -1.625,-0.90625 -1.625,-2.28125 0,-1.328125 0.671875,-2.25 1.625,-2.25 z m 0,0 M -58.971,-25.125 c 0.04687,0.390625 0.0625,0.546875 0.0625,0.9375 0.01563,0.515625 0.01563,0.9375 0.01563,1.25 V -18 h 1.84375 v -3.3125 c 0,-1.59375 0.453125,-2.34375 1.4375,-2.34375 0.390625,0 0.765625,0.125 1.109375,0.34375 v -1.875 c -0.3125,-0.07813 -0.359375,-0.09375 -0.5625,-0.09375 -0.875,0 -1.484375,0.484375 -2.046875,1.640625 0.01563,-0.171875 0.01563,-0.296875 0.01563,-0.375 0,-0.40625 -0.04687,-0.796875 -0.125,-1.109375 z m 0,0 M -67.180385,-28 v 10 h 1.921875 v -3.734375 h 0.59375 c 1.34375,0 2,-0.0625 2.5625,-0.203125 1.1875,-0.359375 1.953125,-1.46875 1.953125,-2.890625 0,-1.390625 -0.703125,-2.5 -1.859375,-2.875 C -62.680385,-27.9375 -63.367885,-28 -64.836635,-28 Z m 1.921875,4.625 v -3 h 0.703125 c 0.984375,0 1.390625,0.0625 1.765625,0.25 0.421875,0.21875 0.671875,0.6875 0.671875,1.28125 0,0.640625 -0.296875,1.125 -0.796875,1.3125 -0.375,0.125 -0.625,0.15625 -1.734375,0.15625 z m 0,0 m -8.91748,-1.75 0.03125,-2.0625 h -1.78125 l -0.04687,2.0625 h -1.171875 v 1.4375 h 1.109375 l -0.109375,2.78125 -0.01563,0.703125 c 0,0.78125 0.07813,1.125 0.3125,1.484375 0.34375,0.5625 0.953125,0.875 1.75,0.875 0.5625,0 1.0625,-0.109375 1.640625,-0.34375 v -1.515625 c -0.40625,0.15625 -0.71875,0.234375 -1.078125,0.234375 -0.546875,0 -0.734375,-0.21875 -0.734375,-0.96875 0,-0.140625 0,-0.140625 0.01563,-0.5 l 0.04687,-2.75 h 1.484375 v -1.4375 z m 0,0 m -10.72,0 c 0.203125,0.6875 0.21875,0.828125 0.21875,2.546875 V -18 h 1.84375 v -3.640625 c 0,-0.703125 0.04687,-1 0.1875,-1.28125 0.203125,-0.453125 0.65625,-0.734375 1.171875,-0.734375 0.453125,0 0.8125,0.21875 0.984375,0.59375 0.125,0.28125 0.171875,0.640625 0.171875,1.359375 V -18 h 1.84375 v -4.109375 c 0,-1.296875 -0.0625,-1.65625 -0.328125,-2.125 -0.375,-0.65625 -1.15625,-1.046875 -2.046875,-1.046875 -0.875,0 -1.59375,0.359375 -2.109375,1.078125 0,-0.390625 -0.04687,-0.703125 -0.15625,-0.921875 z m 0,0 m -1.31876,4 v -0.359375 c 0,-2.359375 -1.25,-3.828125 -3.265625,-3.828125 -2.078125,0 -3.453125,1.515625 -3.453125,3.828125 0,2.25 1.359375,3.671875 3.515625,3.671875 1.578125,0 2.75,-0.828125 3.0625,-2.203125 l -1.640625,-0.0625 c -0.234375,0.53125 -0.703125,0.78125 -1.375,0.78125 -1.03125,0 -1.65625,-0.65625 -1.71875,-1.828125 z m -4.828125,-1.34375 c 0.234375,-0.96875 0.75,-1.421875 1.546875,-1.421875 0.8125,0 1.265625,0.453125 1.421875,1.421875 z m 0,0 M -105.11474,-25.125 c 0.15625,0.4375 0.1875,0.671875 0.1875,1.6875 V -18 h 1.84375 v -3.953125 c 0,-0.515625 0.0156,-0.703125 0.10938,-0.921875 0.1875,-0.5 0.625,-0.78125 1.25,-0.78125 0.45312,0 0.82812,0.1875 0.98437,0.484375 0.125,0.203125 0.15625,0.484375 0.15625,1.21875 V -18 h 1.84375 v -4.03125 c 0,-1.09375 0.4375,-1.625 1.328125,-1.625 0.453125,0 0.796875,0.15625 0.984375,0.4375 0.125,0.203125 0.171875,0.5 0.171875,1.109375 V -18 h 1.84375 v -4.15625 c 0,-1.40625 -0.01563,-1.59375 -0.234375,-2.046875 -0.3125,-0.703125 -1.015625,-1.078125 -2,-1.078125 -0.984375,0 -1.671875,0.34375 -2.3125,1.15625 -0.4375,-0.796875 -1.07812,-1.15625 -2.04687,-1.15625 -0.95313,0 -1.625,0.34375 -2.17188,1.09375 v -0.125 c 0,-0.3125 -0.0469,-0.5625 -0.15625,-0.8125 z m 0,0 m -2.88626,0 0.0312,-2.0625 h -1.78125 l -0.0469,2.0625 h -1.17188 v 1.4375 h 1.10938 l -0.10938,2.78125 -0.0156,0.703125 c 0,0.78125 0.0781,1.125 0.3125,1.484375 0.34375,0.5625 0.95312,0.875 1.75,0.875 0.5625,0 1.0625,-0.109375 1.64062,-0.34375 v -1.515625 c -0.40625,0.15625 -0.71875,0.234375 -1.07812,0.234375 -0.54688,0 -0.73438,-0.21875 -0.73438,-0.96875 0,-0.140625 0,-0.140625 0.0156,-0.5 l 0.0469,-2.75 h 1.48438 v -1.4375 z m 0,0 m -32.60501,0 c 0.20313,0.6875 0.21875,0.828125 0.21875,2.546875 V -18 h 1.84375 v -3.640625 c 0,-0.703125 0.0469,-1 0.1875,-1.28125 0.20313,-0.453125 0.65625,-0.734375 1.17188,-0.734375 0.45312,0 0.8125,0.21875 0.98437,0.59375 0.125,0.28125 0.17188,0.640625 0.17188,1.359375 V -18 h 1.84375 v -4.109375 c 0,-1.296875 -0.0625,-1.65625 -0.32813,-2.125 -0.375,-0.65625 -1.15625,-1.046875 -2.04687,-1.046875 -0.875,0 -1.59375,0.359375 -2.10938,1.078125 0,-0.390625 -0.0469,-0.703125 -0.15625,-0.921875 z m 0,0 m -2.00748,7.125 v -10 h -1.92187 v 10 z m 0,0"
              />
            </g>
          </g>
        ) : (
          <g
            style={{ fill: 'rgb(0%,52.941895%,49.01886%)', fillOpacity: 1 }}
            id="g6124"
          >
            <g id="use6116" transform="translate(455.00049,289.3251)" />
            <g id="use6118" transform="translate(463.3255,289.3251)" />
            <g id="use6120" transform="translate(471.65051,289.3251)" />
            <g id="use6122" transform="translate(477.00549,289.3251)">
              <path
                id="path15104"
                style={{ stroke: 'none' }}
                d="m 0.71875,-7.125 v 1.53125 h 3 l -3.375,4.171875 V 0 H 6 V -1.53125 H 2.515625 L 5.9375,-5.734375 V -7.125 Z m 0,0 m -2.76123,0 0.03125,-2.0625 H -3.79248 L -3.839355,-7.125 H -5.01123 v 1.4375 h 1.109375 l -0.109375,2.78125 -0.015625,0.703125 c 0,0.78125 0.078125,1.125 0.3125,1.484375 0.34375,0.5625 0.953125,0.875 1.75,0.875 0.5625,0 1.0625,-0.109375 1.640625,-0.34375 v -1.515625 c -0.40625,0.15625 -0.71875,0.234375 -1.078125,0.234375 -0.546875,0 -0.734375,-0.21875 -0.734375,-0.96875 0,-0.140625 0,-0.140625 0.015625,-0.5 l 0.046875,-2.75 h 1.484375 V -7.125 Z m 0,0 m -10.66876,0 v 4.15625 c 0,0.921875 0.140625,1.625 0.40625,2.03125 0.4375,0.6875 1.265625,1.09375 2.203125,1.09375 0.875,0 1.453125,-0.28125 2,-0.984375 C -8.08624,-0.5 -8.02374,-0.171875 -7.945615,0 H -6.21124 C -6.383115,-0.625 -6.383115,-0.625 -6.383115,-2.203125 V -7.125 H -8.24249 v 3.8125 c 0,1.25 -0.453125,1.84375 -1.40625,1.84375 -0.421875,0 -0.765625,-0.15625 -0.953125,-0.421875 C -10.77374,-2.109375 -10.86749,-2.5 -10.86749,-3.078125 V -7.125 Z m 0,0 m -8.26251,-2.9375 V 0 H -19.13 v -3.640625 c 0,-0.625 0.0625,-0.984375 0.203125,-1.265625 0.234375,-0.46875 0.703125,-0.75 1.21875,-0.75 0.453125,0 0.828125,0.21875 1.03125,0.625 0.125,0.28125 0.171875,0.625 0.171875,1.328125 V 0 h 1.84375 v -4.109375 c 0,-1.296875 -0.0625,-1.703125 -0.359375,-2.171875 -0.390625,-0.609375 -1.171875,-1 -2.046875,-1 -0.828125,0 -1.5,0.328125 -2.0625,0.9375 v -3.71875 z m 0,0 m -1.50498,5.296875 c -0.234375,-1.65625 -1.265625,-2.546875 -2.96875,-2.546875 -2.0625,0 -3.4375,1.5 -3.4375,3.75 0,2.25 1.375,3.75 3.421875,3.75 1.71875,0 2.9375,-1.09375 3.015625,-2.71875 h -1.78125 c -0.09375,0.84375 -0.5,1.234375 -1.234375,1.234375 -0.96875,0 -1.53125,-0.828125 -1.53125,-2.265625 0,-1.375 0.609375,-2.265625 1.546875,-2.265625 0.65625,0 1.046875,0.359375 1.140625,1.0625 z m 0,0 m -7.603145,-0.203125 c -0.09375,-1.5 -1.140625,-2.359375 -2.890625,-2.359375 -1.703125,0 -2.84375,0.921875 -2.84375,2.296875 0,0.515625 0.171875,0.984375 0.484375,1.296875 0.296875,0.28125 0.703125,0.484375 1.484375,0.71875 1.265625,0.375 1.265625,0.375 1.5,0.484375 0.359375,0.140625 0.46875,0.296875 0.46875,0.5625 0,0.46875 -0.421875,0.765625 -1.125,0.765625 -0.875,0 -1.28125,-0.34375 -1.34375,-1.1875 h -1.75 c 0,1.703125 1.09375,2.578125 3.171875,2.578125 1.828125,0 2.890625,-0.84375 2.890625,-2.28125 0,-0.484375 -0.140625,-0.921875 -0.421875,-1.234375 -0.296875,-0.34375 -0.75,-0.578125 -1.796875,-0.890625 -1.078125,-0.3125 -1.21875,-0.359375 -1.4375,-0.484375 -0.1875,-0.109375 -0.296875,-0.3125 -0.296875,-0.515625 0,-0.421875 0.421875,-0.734375 0.984375,-0.734375 0.6875,0 1.046875,0.3125 1.140625,0.984375 z m 0,0 M -39.54373,-10.0625 V 0 h 1.84375 v -10.0625 z m 0,0 M -45.645625,-5 c 0.109375,-0.546875 0.515625,-0.8125 1.21875,-0.8125 0.78125,0 1.078125,0.296875 1.078125,1.078125 V -4.625 c -1.9375,0.34375 -2.046875,0.359375 -2.6875,0.625 -1.046875,0.390625 -1.625,1.140625 -1.625,2.125 0,1.28125 0.96875,2.03125 2.59375,2.03125 0.953125,0 1.578125,-0.328125 1.96875,-0.96875 0,0.359375 0.01563,0.53125 0.09375,0.8125 h 1.6875 c -0.1875,-0.375 -0.25,-0.734375 -0.25,-1.59375 v -2.859375 c 0,-0.90625 -0.07813,-1.34375 -0.28125,-1.75 -0.328125,-0.6875 -1.21875,-1.078125 -2.453125,-1.078125 -0.9375,0 -1.78125,0.25 -2.3125,0.6875 -0.46875,0.375 -0.703125,0.8125 -0.78125,1.59375 z m 2.296875,2.015625 c 0,0.546875 -0.04687,0.84375 -0.140625,1.0625 -0.1875,0.40625 -0.640625,0.65625 -1.203125,0.65625 -0.625,0 -1.078125,-0.359375 -1.078125,-0.84375 0,-0.3125 0.171875,-0.609375 0.4375,-0.796875 0.3125,-0.234375 0.78125,-0.328125 1.984375,-0.484375 z m 0,0 M -50.311,-7.125 -50.27975,-9.1875 H -52.061 l -0.04687,2.0625 h -1.171875 v 1.4375 h 1.109375 l -0.109375,2.78125 -0.01563,0.703125 c 0,0.78125 0.07813,1.125 0.3125,1.484375 0.34375,0.5625 0.953125,0.875 1.75,0.875 0.5625,0 1.0625,-0.109375 1.640625,-0.34375 v -1.515625 c -0.40625,0.15625 -0.71875,0.234375 -1.078125,0.234375 -0.546875,0 -0.734375,-0.21875 -0.734375,-0.96875 0,-0.140625 0,-0.140625 0.01563,-0.5 l 0.04687,-2.75 h 1.484375 V -7.125 Z m 0,0 m -6.19623,0 V 0 h 1.84375 v -7.125 z m 0.96875,-3.078125 c -0.671875,0 -1.109375,0.4375 -1.109375,1.09375 0,0.65625 0.421875,1.046875 1.078125,1.046875 0.640625,0 1.0625,-0.40625 1.0625,-1.078125 0,-0.625 -0.421875,-1.0625 -1.03125,-1.0625 z m 0,0 m -9.18875,13.15625 h 1.84375 v -3.71875 c 0.5625,0.640625 1.09375,0.921875 1.890625,0.921875 1.734375,0 2.953125,-1.578125 2.953125,-3.765625 0,-2.1875 -1.203125,-3.671875 -3.015625,-3.671875 -0.859375,0 -1.453125,0.3125 -1.953125,1 -0.01563,-0.390625 -0.0625,-0.671875 -0.125,-0.84375 h -1.71875 c 0.09375,0.5 0.125,1.046875 0.125,2.265625 z m 3.34375,-8.6875 c 0.921875,0 1.46875,0.8125 1.46875,2.15625 0,1.375 -0.546875,2.1875 -1.46875,2.1875 -0.921875,0 -1.53125,-0.828125 -1.53125,-2.140625 0,-1.359375 0.59375,-2.203125 1.53125,-2.203125 z m 0,0 M -70.829125,-5 c 0.109375,-0.546875 0.515625,-0.8125 1.21875,-0.8125 0.78125,0 1.078125,0.296875 1.078125,1.078125 V -4.625 c -1.9375,0.34375 -2.046875,0.359375 -2.6875,0.625 -1.046875,0.390625 -1.625,1.140625 -1.625,2.125 0,1.28125 0.96875,2.03125 2.59375,2.03125 0.953125,0 1.578125,-0.328125 1.96875,-0.96875 0,0.359375 0.01563,0.53125 0.09375,0.8125 h 1.6875 c -0.1875,-0.375 -0.25,-0.734375 -0.25,-1.59375 v -2.859375 c 0,-0.90625 -0.07813,-1.34375 -0.28125,-1.75 -0.328125,-0.6875 -1.21875,-1.078125 -2.453125,-1.078125 -0.9375,0 -1.78125,0.25 -2.3125,0.6875 -0.46875,0.375 -0.703125,0.8125 -0.78125,1.59375 z m 2.296875,2.015625 c 0,0.546875 -0.04687,0.84375 -0.140625,1.0625 -0.1875,0.40625 -0.640625,0.65625 -1.203125,0.65625 -0.625,0 -1.078125,-0.359375 -1.078125,-0.84375 0,-0.3125 0.171875,-0.609375 0.4375,-0.796875 0.3125,-0.234375 0.78125,-0.328125 1.984375,-0.484375 z m 0,0 M -75.746,-10 -79.40225,-5.3125 -75.730375,0 h 2.4375 l -3.96875,-5.375 3.734375,-4.625 z m -5.609375,0 V 0 h 1.921875 v -10 z m 0,0 m -5.459385,6.875 v -0.359375 c 0,-2.359375 -1.25,-3.828125 -3.265625,-3.828125 -2.078125,0 -3.453125,1.515625 -3.453125,3.828125 0,2.25 1.359375,3.671875 3.515625,3.671875 1.578125,0 2.75,-0.828125 3.0625,-2.203125 l -1.640625,-0.0625 c -0.234375,0.53125 -0.703125,0.78125 -1.375,0.78125 -1.03125,0 -1.65625,-0.65625 -1.71875,-1.828125 z m -4.828125,-1.34375 c 0.234375,-0.96875 0.75,-1.421875 1.546875,-1.421875 0.8125,0 1.265625,0.453125 1.421875,1.421875 z m 0,0 M -101.44098,-7.125 c 0.20312,0.6875 0.21875,0.828125 0.21875,2.546875 V 0 h 1.84375 v -3.640625 c 0,-0.703125 0.04687,-1 0.1875,-1.28125 0.203125,-0.453125 0.65625,-0.734375 1.171875,-0.734375 0.453125,0 0.8125,0.21875 0.984375,0.59375 0.125,0.28125 0.171875,0.640625 0.171875,1.359375 V 0 h 1.84375 v -4.109375 c 0,-1.296875 -0.0625,-1.65625 -0.328125,-2.125 -0.375,-0.65625 -1.15625,-1.046875 -2.046875,-1.046875 -0.875,0 -1.59375,0.359375 -2.109375,1.078125 0,-0.390625 -0.04687,-0.703125 -0.15625,-0.921875 z m 0,0 m -8.10626,-2.9375 V 0 h 1.84375 v -3.640625 c 0,-0.625 0.0625,-0.984375 0.20313,-1.265625 0.23437,-0.46875 0.70312,-0.75 1.21875,-0.75 0.45312,0 0.82812,0.21875 1.03125,0.625 0.125,0.28125 0.17187,0.625 0.17187,1.328125 V 0 h 1.84375 v -4.109375 c 0,-1.296875 -0.0625,-1.703125 -0.35937,-2.171875 -0.39063,-0.609375 -1.17188,-1 -2.04688,-1 -0.82812,0 -1.5,0.328125 -2.0625,0.9375 v -3.71875 z m 0,0 m -5.05563,2.75 c -2.01563,0 -3.51563,1.5625 -3.51563,3.703125 0,2.25 1.4375,3.796875 3.51563,3.796875 2.04687,0 3.51562,-1.5625 3.51562,-3.75 0,-2.1875 -1.46875,-3.75 -3.51562,-3.75 z m 0,1.484375 c 0.96875,0 1.625,0.921875 1.625,2.265625 0,1.34375 -0.65625,2.265625 -1.625,2.265625 -0.98438,0 -1.625,-0.90625 -1.625,-2.28125 0,-1.328125 0.67187,-2.25 1.625,-2.25 z m 0,0 M -4.72125,-21.125 v -0.359375 c 0,-2.359375 -1.25,-3.828125 -3.265625,-3.828125 -2.078125,0 -3.453125,1.515625 -3.453125,3.828125 0,2.25 1.359375,3.671875 3.515625,3.671875 1.578125,0 2.75,-0.828125 3.0625,-2.203125 l -1.640625,-0.0625 c -0.234375,0.53125 -0.703125,0.78125 -1.375,0.78125 -1.03125,0 -1.65625,-0.65625 -1.71875,-1.828125 z m -4.828125,-1.34375 c 0.234375,-0.96875 0.75,-1.421875 1.546875,-1.421875 0.8125,0 1.265625,0.453125 1.421875,1.421875 z m 0,0 M -54.531,-25.125 c 0.04687,0.390625 0.0625,0.546875 0.0625,0.9375 0.01563,0.515625 0.01563,0.9375 0.01563,1.25 V -18 h 1.84375 v -3.3125 c 0,-1.59375 0.453125,-2.34375 1.4375,-2.34375 0.390625,0 0.765625,0.125 1.109375,0.34375 v -1.875 c -0.3125,-0.07813 -0.359375,-0.09375 -0.5625,-0.09375 -0.875,0 -1.484375,0.484375 -2.046875,1.640625 0.01563,-0.171875 0.01563,-0.296875 0.01563,-0.375 0,-0.40625 -0.04687,-0.796875 -0.125,-1.109375 z m 0,0 m -8.12625,10.078125 h 1.84375 v -3.71875 c 0.5625,0.640625 1.09375,0.921875 1.890625,0.921875 1.734375,0 2.953125,-1.578125 2.953125,-3.765625 0,-2.1875 -1.203125,-3.671875 -3.015625,-3.671875 -0.859375,0 -1.453125,0.3125 -1.953125,1 -0.01563,-0.390625 -0.0625,-0.671875 -0.125,-0.84375 h -1.71875 c 0.09375,0.5 0.125,1.046875 0.125,2.265625 z m 3.34375,-8.6875 c 0.921875,0 1.46875,0.8125 1.46875,2.15625 0,1.375 -0.546875,2.1875 -1.46875,2.1875 -0.921875,0 -1.53125,-0.828125 -1.53125,-2.140625 0,-1.359375 0.59375,-2.203125 1.53125,-2.203125 z m 0,0 m -4.88123,2.609375 v -0.359375 c 0,-2.359375 -1.25,-3.828125 -3.265625,-3.828125 -2.078125,0 -3.453125,1.515625 -3.453125,3.828125 0,2.25 1.359375,3.671875 3.515625,3.671875 1.578125,0 2.75,-0.828125 3.0625,-2.203125 l -1.640625,-0.0625 c -0.234375,0.53125 -0.703125,0.78125 -1.375,0.78125 -1.03125,0 -1.65625,-0.65625 -1.71875,-1.828125 z m -4.828125,-1.34375 c 0.234375,-0.96875 0.75,-1.421875 1.546875,-1.421875 0.8125,0 1.265625,0.453125 1.421875,1.421875 z m 0,0 M -13.906,-25.125 l 0.03125,-2.0625 H -15.656 l -0.04687,2.0625 h -1.171875 v 1.4375 h 1.109375 l -0.109375,2.78125 -0.01563,0.703125 c 0,0.78125 0.07813,1.125 0.3125,1.484375 0.34375,0.5625 0.953125,0.875 1.75,0.875 0.5625,0 1.0625,-0.109375 1.640625,-0.34375 v -1.515625 c -0.40625,0.15625 -0.71875,0.234375 -1.078125,0.234375 -0.546875,0 -0.734375,-0.21875 -0.734375,-0.96875 0,-0.140625 0,-0.140625 0.01563,-0.5 l 0.04687,-2.75 h 1.484375 v -1.4375 z m 0,0 m -5.836855,0 -2.609375,3.328125 L -19.75848,-18 h 2.484375 l -2.921875,-3.828125 2.671875,-3.296875 z m -4.484375,-2.9375 V -18 h 1.84375 v -10.0625 z m 0,0 m -8.38751,2.9375 v 4.15625 c 0,0.921875 0.140625,1.625 0.40625,2.03125 0.4375,0.6875 1.265625,1.09375 2.203125,1.09375 0.875,0 1.453125,-0.28125 2,-0.984375 0.01563,0.328125 0.07813,0.65625 0.15625,0.828125 h 1.734375 c -0.171875,-0.625 -0.171875,-0.625 -0.171875,-2.203125 V -25.125 h -1.859375 v 3.8125 c 0,1.25 -0.453125,1.84375 -1.40625,1.84375 -0.421875,0 -0.765625,-0.15625 -0.953125,-0.421875 -0.171875,-0.21875 -0.265625,-0.609375 -0.265625,-1.1875 V -25.125 Z m 0,0 m -2.00125,-2.9375 h -1.84375 v 3.71875 c -0.53125,-0.671875 -1.03125,-0.9375 -1.84375,-0.9375 -1.75,0 -3,1.578125 -3,3.78125 0,2.1875 1.21875,3.65625 3.03125,3.65625 0.953125,0 1.546875,-0.34375 2.015625,-1.140625 -0.01563,0.171875 -0.01563,0.265625 -0.01563,0.359375 0,0.171875 0.01563,0.328125 0.0625,0.625 h 1.71875 c -0.09375,-0.5 -0.125,-1.046875 -0.125,-2.25 z m -3.265625,4.328125 c 0.90625,0 1.453125,0.8125 1.453125,2.171875 0,1.328125 -0.59375,2.171875 -1.53125,2.171875 -0.921875,0 -1.46875,-0.796875 -1.46875,-2.109375 0,-1.40625 0.5625,-2.234375 1.546875,-2.234375 z m 0,0 m -7.94626,-1.578125 c -2.015625,0 -3.515625,1.5625 -3.515625,3.703125 0,2.25 1.4375,3.796875 3.515625,3.796875 2.046875,0 3.515625,-1.5625 3.515625,-3.75 0,-2.1875 -1.46875,-3.75 -3.515625,-3.75 z m 0,1.484375 c 0.96875,0 1.625,0.921875 1.625,2.265625 0,1.34375 -0.65625,2.265625 -1.625,2.265625 -0.984375,0 -1.625,-0.90625 -1.625,-2.28125 0,-1.328125 0.671875,-2.25 1.625,-2.25 z m 0,0 M -71.51098,-25.125 l -2.359375,0.04687 c -0.59375,-0.15625 -0.921875,-0.203125 -1.375,-0.203125 -1.8125,0 -2.96875,0.984375 -2.96875,2.515625 0,0.96875 0.375,1.59375 1.21875,2.015625 -0.90625,0.359375 -1.265625,0.671875 -1.265625,1.140625 0,0.390625 0.234375,0.640625 0.796875,0.859375 -1,0.34375 -1.4375,0.859375 -1.4375,1.671875 0,1.28125 1.375,2.09375 3.5625,2.09375 2.234375,0 3.53125,-0.875 3.53125,-2.390625 0,-0.75 -0.34375,-1.375 -0.921875,-1.671875 -0.4375,-0.25 -1,-0.359375 -2.203125,-0.46875 -1.46875,-0.15625 -1.5625,-0.171875 -1.5625,-0.453125 0,-0.21875 0.28125,-0.390625 0.703125,-0.421875 1.546875,-0.140625 1.59375,-0.140625 2.078125,-0.359375 0.71875,-0.3125 1.109375,-0.9375 1.109375,-1.78125 0,-0.46875 -0.125,-0.90625 -0.375,-1.28125 h 1.46875 z m -3.84375,1.25 c 0.71875,0 1.21875,0.4375 1.21875,1.09375 0,0.625 -0.5,1.046875 -1.25,1.046875 -0.75,0 -1.234375,-0.421875 -1.234375,-1.046875 0,-0.671875 0.5,-1.09375 1.265625,-1.09375 z m -0.21875,5.734375 c 1.25,0 2,0.34375 2,0.9375 0,0.5625 -0.625,0.890625 -1.75,0.890625 -1.265625,0 -2,-0.359375 -2,-0.921875 0,-0.578125 0.640625,-0.90625 1.75,-0.90625 z m 0,0 M -84.269105,-23 c 0.109375,-0.546875 0.515625,-0.8125 1.21875,-0.8125 0.78125,0 1.078125,0.296875 1.078125,1.078125 V -22.625 c -1.9375,0.34375 -2.046875,0.359375 -2.6875,0.625 -1.046875,0.390625 -1.625,1.140625 -1.625,2.125 0,1.28125 0.96875,2.03125 2.59375,2.03125 0.953125,0 1.578125,-0.328125 1.96875,-0.96875 0,0.359375 0.01563,0.53125 0.09375,0.8125 h 1.6875 c -0.1875,-0.375 -0.25,-0.734375 -0.25,-1.59375 v -2.859375 c 0,-0.90625 -0.07813,-1.34375 -0.28125,-1.75 -0.328125,-0.6875 -1.21875,-1.078125 -2.453125,-1.078125 -0.9375,0 -1.78125,0.25 -2.3125,0.6875 -0.46875,0.375 -0.703125,0.8125 -0.78125,1.59375 z m 2.296875,2.015625 c 0,0.546875 -0.04687,0.84375 -0.140625,1.0625 -0.1875,0.40625 -0.640625,0.65625 -1.203125,0.65625 -0.625,0 -1.078125,-0.359375 -1.078125,-0.84375 0,-0.3125 0.171875,-0.609375 0.4375,-0.796875 0.3125,-0.234375 0.78125,-0.328125 1.984375,-0.484375 z m 0,0 m -7.79,-7.078125 V -18 h 1.84375 v -10.0625 z m 0,0 m -8.43876,2.9375 c 0.203125,0.6875 0.21875,0.828125 0.21875,2.546875 V -18 h 1.84375 v -3.640625 c 0,-0.703125 0.04687,-1 0.1875,-1.28125 0.203125,-0.453125 0.65625,-0.734375 1.171875,-0.734375 0.453125,0 0.8125,0.21875 0.984375,0.59375 0.125,0.28125 0.171875,0.640625 0.171875,1.359375 V -18 h 1.84375 v -4.109375 c 0,-1.296875 -0.0625,-1.65625 -0.328125,-2.125 -0.375,-0.65625 -1.15625,-1.046875 -2.046875,-1.046875 -0.875,0 -1.59375,0.359375 -2.109375,1.078125 0,-0.390625 -0.04687,-0.703125 -0.15625,-0.921875 z m 0,0 m -6.31124,-2.875 -3.375,10 h 1.95313 l 0.64062,-2.078125 h 3.51563 l 0.625,2.078125 h 1.98437 l -3.40625,-10 z m 2.26563,6.28125 h -2.57813 l 1.28125,-4.078125 z m 0,0"
              />
            </g>
          </g>
        )}
        <g
          style={{
            fill: 'rgb(41.175842%,25.097656%,39.99939%)',
            fillOpacity: 1
          }}
          id="g6140"
        >
          <g id="use6126" transform="translate(662.047,271.3251)" />
          <g id="use6128" transform="translate(672.26202,271.3251)" />
          <g id="use6130" transform="translate(679.987,271.3251)" />
          <g id="use6132" transform="translate(688.22198,271.3251)" />
          <g id="use6134" transform="translate(695.94702,271.3251)" />
          <g id="use6136" transform="translate(699.862,271.3251)" />
          <g id="use6138" transform="translate(708.08197,271.3251)" />
        </g>
        <g
          style={{
            fill: 'rgb(41.175842%,25.097656%,39.99939%)',
            fillOpacity: 1
          }}
          id="g6152"
        >
          <g id="use6142" transform="translate(713.70697,271.3251)" />
          <g id="use6144" transform="translate(721.74701,271.3251)" />
          <g id="use6146" transform="translate(729.96698,271.3251)" />
          <g id="use6148" transform="translate(738.29199,271.3251)" />
          <g id="use6150" transform="translate(746.33197,271.3251)" />
        </g>
        {props.lang === 'en' ? (
          <g
            style={{
              fill: 'rgb(41.175842%,25.097656%,39.99939%)',
              fillOpacity: 1
            }}
            id="g6156"
          >
            <g id="use6154" transform="translate(764.11511,271.3251)">
              <path
                id="path15175"
                style={{ stroke: 'none' }}
                d="m 6.578125,-4.96875 c -0.09375,-1.5 -1.140625,-2.359375 -2.890625,-2.359375 -1.703125,0 -2.84375,0.921875 -2.84375,2.296875 0,0.515625 0.171875,0.984375 0.484375,1.296875 C 1.625,-3.453125 2.03125,-3.25 2.8125,-3.015625 c 1.265625,0.375 1.265625,0.375 1.5,0.484375 0.359375,0.140625 0.46875,0.296875 0.46875,0.5625 0,0.46875 -0.421875,0.765625 -1.125,0.765625 -0.875,0 -1.28125,-0.34375 -1.34375,-1.1875 h -1.75 C 0.5625,-0.6875 1.65625,0.1875 3.734375,0.1875 5.5625,0.1875 6.625,-0.65625 6.625,-2.09375 6.625,-2.578125 6.484375,-3.015625 6.203125,-3.328125 5.90625,-3.671875 5.453125,-3.90625 4.40625,-4.21875 3.328125,-4.53125 3.1875,-4.578125 2.96875,-4.703125 2.78125,-4.8125 2.671875,-5.015625 2.671875,-5.21875 c 0,-0.421875 0.421875,-0.734375 0.984375,-0.734375 0.6875,0 1.046875,0.3125 1.140625,0.984375 z m 0,0 M -2.04254,-7.125 -2.01129,-9.1875 H -3.79254 L -3.839415,-7.125 H -5.01129 v 1.4375 h 1.109375 l -0.109375,2.78125 -0.015625,0.703125 c 0,0.78125 0.078125,1.125 0.3125,1.484375 0.34375,0.5625 0.953125,0.875 1.75,0.875 0.5625,0 1.0625,-0.109375 1.640625,-0.34375 v -1.515625 c -0.40625,0.15625 -0.71875,0.234375 -1.078125,0.234375 -0.546875,0 -0.734375,-0.21875 -0.734375,-0.96875 0,-0.140625 0,-0.140625 0.015625,-0.5 l 0.046875,-2.75 h 1.484375 V -7.125 Z m 0,0 m -3.86121,2.359375 C -6.138125,-6.421875 -7.169375,-7.3125 -8.8725,-7.3125 c -2.0625,0 -3.4375,1.5 -3.4375,3.75 0,2.25 1.375,3.75 3.421875,3.75 1.71875,0 2.9375,-1.09375 3.015625,-2.71875 h -1.78125 c -0.09375,0.84375 -0.5,1.234375 -1.234375,1.234375 -0.96875,0 -1.53125,-0.828125 -1.53125,-2.265625 0,-1.375 0.609375,-2.265625 1.546875,-2.265625 0.65625,0 1.046875,0.359375 1.140625,1.0625 z m 0,0 M -20.16626,-7.125 v 4.15625 c 0,0.921875 0.140625,1.625 0.40625,2.03125 0.4375,0.6875 1.265625,1.09375 2.203125,1.09375 0.875,0 1.453125,-0.28125 2,-0.984375 0.01563,0.328125 0.07813,0.65625 0.15625,0.828125 h 1.734375 c -0.171875,-0.625 -0.171875,-0.625 -0.171875,-2.203125 V -7.125 h -1.859375 v 3.8125 c 0,1.25 -0.453125,1.84375 -1.40625,1.84375 -0.421875,0 -0.765625,-0.15625 -0.953125,-0.421875 C -18.22876,-2.109375 -18.32251,-2.5 -18.32251,-3.078125 V -7.125 Z m 0,0 m -2.00128,-2.9375 h -1.84375 v 3.71875 c -0.53125,-0.671875 -1.03125,-0.9375 -1.84375,-0.9375 -1.75,0 -3,1.578125 -3,3.78125 0,2.1875 1.21875,3.65625 3.03125,3.65625 0.953125,0 1.546875,-0.34375 2.015625,-1.140625 -0.01563,0.171875 -0.01563,0.265625 -0.01563,0.359375 0,0.171875 0.01563,0.328125 0.0625,0.625 h 1.71875 c -0.09375,-0.5 -0.125,-1.046875 -0.125,-2.25 z m -3.265625,4.328125 c 0.90625,0 1.453125,0.8125 1.453125,2.171875 0,1.328125 -0.59375,2.171875 -1.53125,2.171875 -0.921875,0 -1.46875,-0.796875 -1.46875,-2.109375 0,-1.40625 0.5625,-2.234375 1.546875,-2.234375 z m 0,0 m -7.94623,-1.578125 c -2.015625,0 -3.515625,1.5625 -3.515625,3.703125 0,2.25 1.4375,3.796875 3.515625,3.796875 2.046875,0 3.515625,-1.5625 3.515625,-3.75 0,-2.1875 -1.46875,-3.75 -3.515625,-3.75 z m 0,1.484375 c 0.96875,0 1.625,0.921875 1.625,2.265625 0,1.34375 -0.65625,2.265625 -1.625,2.265625 -0.984375,0 -1.625,-0.90625 -1.625,-2.28125 0,-1.328125 0.671875,-2.25 1.625,-2.25 z m 0,0 M -42.08252,-7.125 c 0.04687,0.390625 0.0625,0.546875 0.0625,0.9375 0.01563,0.515625 0.01563,0.9375 0.01563,1.25 V 0 h 1.84375 v -3.3125 c 0,-1.59375 0.453125,-2.34375 1.4375,-2.34375 0.390625,0 0.765625,0.125 1.109375,0.34375 v -1.875 c -0.3125,-0.078125 -0.359375,-0.09375 -0.5625,-0.09375 -0.875,0 -1.484375,0.484375 -2.046875,1.640625 0.01563,-0.171875 0.01563,-0.296875 0.01563,-0.375 0,-0.40625 -0.04687,-0.796875 -0.125,-1.109375 z m 0,0 M -50.291865,-10 V 0 h 1.921875 v -3.734375 h 0.59375 c 1.34375,0 2,-0.0625 2.5625,-0.203125 1.1875,-0.359375 1.953125,-1.46875 1.953125,-2.890625 0,-1.390625 -0.703125,-2.5 -1.859375,-2.875 C -45.791865,-9.9375 -46.479365,-10 -47.948115,-10 Z m 1.921875,4.625 v -3 h 0.703125 c 0.984375,0 1.390625,0.0625 1.765625,0.25 0.421875,0.21875 0.671875,0.6875 0.671875,1.28125 0,0.640625 -0.296875,1.125 -0.796875,1.3125 -0.375,0.125 -0.625,0.15625 -1.734375,0.15625 z m 0,0 m -7.38129,2.25 v -0.359375 c 0,-2.359375 -1.25,-3.828125 -3.265625,-3.828125 -2.078125,0 -3.453125,1.515625 -3.453125,3.828125 0,2.25 1.359375,3.671875 3.515625,3.671875 1.578125,0 2.75,-0.828125 3.0625,-2.203125 l -1.640625,-0.0625 c -0.234375,0.53125 -0.703125,0.78125 -1.375,0.78125 -1.03125,0 -1.65625,-0.65625 -1.71875,-1.828125 z m -4.828125,-1.34375 c 0.234375,-0.96875 0.75,-1.421875 1.546875,-1.421875 0.8125,0 1.265625,0.453125 1.421875,1.421875 z m 0,0 M -63.0675,-7.125 l -2.359375,0.046875 c -0.59375,-0.15625 -0.921875,-0.203125 -1.375,-0.203125 -1.8125,0 -2.96875,0.984375 -2.96875,2.515625 0,0.96875 0.375,1.59375 1.21875,2.015625 -0.90625,0.359375 -1.265625,0.671875 -1.265625,1.140625 0,0.390625 0.234375,0.640625 0.796875,0.859375 -1,0.34375 -1.4375,0.859375 -1.4375,1.671875 0,1.28125 1.375,2.09375 3.5625,2.09375 2.234375,0 3.53125,-0.875 3.53125,-2.390625 0,-0.75 -0.34375,-1.375 -0.921875,-1.671875 -0.4375,-0.25 -1,-0.359375 -2.203125,-0.46875 -1.46875,-0.15625 -1.5625,-0.171875 -1.5625,-0.453125 0,-0.21875 0.28125,-0.390625 0.703125,-0.421875 1.546875,-0.140625 1.59375,-0.140625 2.078125,-0.359375 0.71875,-0.3125 1.109375,-0.9375 1.109375,-1.78125 0,-0.46875 -0.125,-0.90625 -0.375,-1.28125 h 1.46875 z m -3.84375,1.25 c 0.71875,0 1.21875,0.4375 1.21875,1.09375 0,0.625 -0.5,1.046875 -1.25,1.046875 -0.75,0 -1.234375,-0.421875 -1.234375,-1.046875 0,-0.671875 0.5,-1.09375 1.265625,-1.09375 z M -67.13,-0.140625 c 1.25,0 2,0.34375 2,0.9375 0,0.5625 -0.625,0.890625 -1.75,0.890625 -1.265625,0 -2,-0.359375 -2,-0.921875 0,-0.578125 0.640625,-0.90625 1.75,-0.90625 z m 0,0 M -75.825625,-5 c 0.109375,-0.546875 0.515625,-0.8125 1.21875,-0.8125 0.78125,0 1.078125,0.296875 1.078125,1.078125 V -4.625 c -1.9375,0.34375 -2.046875,0.359375 -2.6875,0.625 -1.046875,0.390625 -1.625,1.140625 -1.625,2.125 0,1.28125 0.96875,2.03125 2.59375,2.03125 0.953125,0 1.578125,-0.328125 1.96875,-0.96875 0,0.359375 0.01563,0.53125 0.09375,0.8125 h 1.6875 c -0.1875,-0.375 -0.25,-0.734375 -0.25,-1.59375 v -2.859375 c 0,-0.90625 -0.07813,-1.34375 -0.28125,-1.75 -0.328125,-0.6875 -1.21875,-1.078125 -2.453125,-1.078125 -0.9375,0 -1.78125,0.25 -2.3125,0.6875 -0.46875,0.375 -0.703125,0.8125 -0.78125,1.59375 z m 2.296875,2.015625 c 0,0.546875 -0.04687,0.84375 -0.140625,1.0625 -0.1875,0.40625 -0.640625,0.65625 -1.203125,0.65625 -0.625,0 -1.078125,-0.359375 -1.078125,-0.84375 0,-0.3125 0.171875,-0.609375 0.4375,-0.796875 0.3125,-0.234375 0.78125,-0.328125 1.984375,-0.484375 z m 0,0 M -83.09253,-7.125 c 0.04687,0.390625 0.0625,0.546875 0.0625,0.9375 0.01563,0.515625 0.01563,0.9375 0.01563,1.25 V 0 h 1.84375 v -3.3125 c 0,-1.59375 0.453125,-2.34375 1.4375,-2.34375 0.390625,0 0.765625,0.125 1.109375,0.34375 v -1.875 c -0.3125,-0.078125 -0.359375,-0.09375 -0.5625,-0.09375 -0.875,0 -1.484375,0.484375 -2.046875,1.640625 0.01563,-0.171875 0.01563,-0.296875 0.01563,-0.375 0,-0.40625 -0.04687,-0.796875 -0.125,-1.109375 z m 0,0 m -1.44372,4 v -0.359375 c 0,-2.359375 -1.25,-3.828125 -3.265625,-3.828125 -2.078125,0 -3.453125,1.515625 -3.453125,3.828125 0,2.25 1.359375,3.671875 3.515625,3.671875 1.578125,0 2.75,-0.828125 3.0625,-2.203125 l -1.640625,-0.0625 c -0.234375,0.53125 -0.703125,0.78125 -1.375,0.78125 -1.03125,0 -1.65625,-0.65625 -1.71875,-1.828125 z m -4.828125,-1.34375 c 0.234375,-0.96875 0.75,-1.421875 1.546875,-1.421875 0.8125,0 1.265625,0.453125 1.421875,1.421875 z m 0,0 m -9.44873,-2.65625 2.53125,7.171875 h 2.046875 L -91.656855,-7.125 h -1.90625 l -1.65625,5.109375 -1.65625,-5.109375 z m 0,0 m -0.408145,4 v -0.359375 c 0,-2.359375 -1.25,-3.828125 -3.26562,-3.828125 -2.07813,0 -3.45313,1.515625 -3.45313,3.828125 0,2.25 1.35938,3.671875 3.51563,3.671875 1.57812,0 2.749995,-0.828125 3.062495,-2.203125 l -1.640625,-0.0625 c -0.23437,0.53125 -0.70312,0.78125 -1.375,0.78125 -1.03125,0 -1.65625,-0.65625 -1.71875,-1.828125 z m -4.82812,-1.34375 c 0.23437,-0.96875 0.75,-1.421875 1.54687,-1.421875 0.8125,0 1.26563,0.453125 1.42188,1.421875 z m 0,0 M -112.96191,-10 V 0 h 6.29687 v -1.640625 h -4.32812 V -10 Z m 0,0"
              />
            </g>
          </g>
        ) : (
          <g
            style={{
              fill: 'rgb(41.175842%,25.097656%,39.99939%)',
              fillOpacity: 1
            }}
            id="g6156"
          >
            <g id="use6154" transform="translate(751.612,271.3251)">
              <path
                id="path15175"
                style={{ stroke: 'none' }}
                d="M 7.21875,-3.125 V -3.484375 C 7.21875,-5.84375 5.96875,-7.3125 3.953125,-7.3125 1.875,-7.3125 0.5,-5.796875 0.5,-3.484375 c 0,2.25 1.359375,3.671875 3.515625,3.671875 1.578125,0 2.75,-0.828125 3.0625,-2.203125 L 5.4375,-2.078125 c -0.234375,0.53125 -0.703125,0.78125 -1.375,0.78125 -1.03125,0 -1.65625,-0.65625 -1.71875,-1.828125 z M 2.390625,-4.46875 c 0.234375,-0.96875 0.75,-1.421875 1.546875,-1.421875 0.8125,0 1.265625,0.453125 1.421875,1.421875 z m 0,0 M -1.96753,-7.125 -1.93628,-9.1875 H -3.71753 L -3.764405,-7.125 H -4.93628 v 1.4375 h 1.109375 l -0.109375,2.78125 -0.015625,0.703125 c 0,0.78125 0.078125,1.125 0.3125,1.484375 0.34375,0.5625 0.953125,0.875 1.75,0.875 0.5625,0 1.0625,-0.109375 1.640625,-0.34375 v -1.515625 c -0.40625,0.15625 -0.71875,0.234375 -1.078125,0.234375 -0.546875,0 -0.734375,-0.21875 -0.734375,-0.96875 0,-0.140625 0,-0.140625 0.015625,-0.5 l 0.046875,-2.75 h 1.484375 V -7.125 Z m 0,0 m -5.836855,0 -2.609375,3.328125 L -7.82001,0 h 2.484375 L -8.25751,-3.828125 -5.585635,-7.125 Z m -4.484375,-2.9375 V 0 h 1.84375 v -10.0625 z m 0,0 m -8.38751,2.9375 v 4.15625 c 0,0.921875 0.140625,1.625 0.40625,2.03125 0.4375,0.6875 1.265625,1.09375 2.203125,1.09375 0.875,0 1.453125,-0.28125 2,-0.984375 0.01563,0.328125 0.07812,0.65625 0.15625,0.828125 h 1.734375 c -0.171875,-0.625 -0.171875,-0.625 -0.171875,-2.203125 V -7.125 h -1.859375 v 3.8125 c 0,1.25 -0.453125,1.84375 -1.40625,1.84375 -0.421875,0 -0.765625,-0.15625 -0.953125,-0.421875 C -18.73877,-2.109375 -18.83252,-2.5 -18.83252,-3.078125 V -7.125 Z m 0,0 m -2.00122,-2.9375 h -1.84375 v 3.71875 c -0.53125,-0.671875 -1.03125,-0.9375 -1.84375,-0.9375 -1.75,0 -3,1.578125 -3,3.78125 0,2.1875 1.21875,3.65625 3.03125,3.65625 0.953125,0 1.546875,-0.34375 2.015625,-1.140625 -0.01563,0.171875 -0.01563,0.265625 -0.01563,0.359375 0,0.171875 0.01563,0.328125 0.0625,0.625 h 1.71875 c -0.09375,-0.5 -0.125,-1.046875 -0.125,-2.25 z m -3.265625,4.328125 c 0.90625,0 1.453125,0.8125 1.453125,2.171875 0,1.328125 -0.59375,2.171875 -1.53125,2.171875 -0.921875,0 -1.46875,-0.796875 -1.46875,-2.109375 0,-1.40625 0.5625,-2.234375 1.546875,-2.234375 z m 0,0 m -7.94629,-1.578125 c -2.015625,0 -3.515625,1.5625 -3.515625,3.703125 0,2.25 1.4375,3.796875 3.515625,3.796875 2.046875,0 3.515625,-1.5625 3.515625,-3.75 0,-2.1875 -1.46875,-3.75 -3.515625,-3.75 z m 0,1.484375 c 0.96875,0 1.625,0.921875 1.625,2.265625 0,1.34375 -0.65625,2.265625 -1.625,2.265625 -0.984375,0 -1.625,-0.90625 -1.625,-2.28125 0,-1.328125 0.671875,-2.25 1.625,-2.25 z m 0,0 M -42.59253,-7.125 c 0.04687,0.390625 0.0625,0.546875 0.0625,0.9375 0.01563,0.515625 0.01563,0.9375 0.01563,1.25 V 0 h 1.84375 v -3.3125 c 0,-1.59375 0.453125,-2.34375 1.4375,-2.34375 0.390625,0 0.765625,0.125 1.109375,0.34375 v -1.875 c -0.3125,-0.078125 -0.359375,-0.09375 -0.5625,-0.09375 -0.875,0 -1.484375,0.484375 -2.046875,1.640625 0.01563,-0.171875 0.01563,-0.296875 0.01563,-0.375 0,-0.40625 -0.04687,-0.796875 -0.125,-1.109375 z m 0,0 m -8.12622,10.078125 h 1.84375 v -3.71875 c 0.5625,0.640625 1.09375,0.921875 1.890625,0.921875 1.734375,0 2.953125,-1.578125 2.953125,-3.765625 0,-2.1875 -1.203125,-3.671875 -3.015625,-3.671875 -0.859375,0 -1.453125,0.3125 -1.953125,1 -0.01563,-0.390625 -0.0625,-0.671875 -0.125,-0.84375 h -1.71875 c 0.09375,0.5 0.125,1.046875 0.125,2.265625 z m 3.34375,-8.6875 c 0.921875,0 1.46875,0.8125 1.46875,2.15625 0,1.375 -0.546875,2.1875 -1.46875,2.1875 -0.921875,0 -1.53125,-0.828125 -1.53125,-2.140625 0,-1.359375 0.59375,-2.203125 1.53125,-2.203125 z m 0,0 M -54.63373,-10.0625 V 0 h 1.84375 v -10.0625 z m 0,0 m -1.53754,6.9375 v -0.359375 c 0,-2.359375 -1.25,-3.828125 -3.265625,-3.828125 -2.078125,0 -3.453125,1.515625 -3.453125,3.828125 0,2.25 1.359375,3.671875 3.515625,3.671875 1.578125,0 2.75,-0.828125 3.0625,-2.203125 l -1.640625,-0.0625 c -0.234375,0.53125 -0.703125,0.78125 -1.375,0.78125 -1.03125,0 -1.65625,-0.65625 -1.71875,-1.828125 z m -4.828125,-1.34375 c 0.234375,-0.96875 0.75,-1.421875 1.546875,-1.421875 0.8125,0 1.265625,0.453125 1.421875,1.421875 z m 0,0 m -9.60998,-5.59375 v 8.1875 c 0,1.203125 0,1.40625 -0.04687,1.875 h 1.59375 c 0.07813,-0.296875 0.109375,-0.484375 0.140625,-0.953125 0.390625,0.75 1.015625,1.109375 1.90625,1.109375 1.8125,0 3.09375,-1.546875 3.09375,-3.71875 0,-2.15625 -1.203125,-3.71875 -2.890625,-3.71875 -0.8125,0 -1.375,0.3125 -1.953125,1.0625 V -10.0625 Z M -67.25,-5.734375 c 0.890625,0 1.4375,0.8125 1.4375,2.140625 0,1.34375 -0.578125,2.203125 -1.5,2.203125 -0.890625,0 -1.453125,-0.828125 -1.453125,-2.15625 0,-1.375 0.578125,-2.1875 1.515625,-2.1875 z m 0,0 M -72.13123,-3.125 v -0.359375 c 0,-2.359375 -1.25,-3.828125 -3.265625,-3.828125 -2.078125,0 -3.453125,1.515625 -3.453125,3.828125 0,2.25 1.359375,3.671875 3.515625,3.671875 1.578125,0 2.75,-0.828125 3.0625,-2.203125 l -1.640625,-0.0625 c -0.234375,0.53125 -0.703125,0.78125 -1.375,0.78125 -1.03125,0 -1.65625,-0.65625 -1.71875,-1.828125 z m -4.828125,-1.34375 c 0.234375,-0.96875 0.75,-1.421875 1.546875,-1.421875 0.8125,0 1.265625,0.453125 1.421875,1.421875 z m 0,0 M -86.44,-6.015625 V -10 h -1.921875 V 0 H -86.44 v -4.421875 h 3.96875 V 0 h 1.921875 v -10 h -1.921875 v 3.984375 z m 0,0"
              />
            </g>
          </g>
        )}
        <g
          style={{
            fill: 'rgb(7.843018%,14.117432%,27.058411%)',
            fillOpacity: 1
          }}
          id="g6178"
        >
          <g id="use6158" transform="translate(656.40698,551.05182)" />
          <g id="use6160" transform="translate(664.57898,551.05182)" />
          <g id="use6162" transform="translate(671.01099,551.05182)" />
          <g id="use6164" transform="translate(677.67102,551.05182)" />
          <g id="use6166" transform="translate(683.85101,551.05182)" />
          <g id="use6168" transform="translate(686.85101,551.05182)" />
          <g id="use6170" transform="translate(693.93103,551.05182)" />
          <g id="use6172" transform="translate(697.06299,551.05182)" />
          <g id="use6174" transform="translate(702.883,551.05182)" />
          <g id="use6176" transform="translate(706.01501,551.05182)" />
        </g>
        <g
          style={{
            fill: 'rgb(7.843018%,14.117432%,27.058411%)',
            fillOpacity: 1
          }}
          id="g6188"
        >
          <g id="use6180" transform="translate(712.14581,551.05182)" />
          <g id="use6182" transform="translate(718.57782,551.05182)" />
          <g id="use6184" transform="translate(725.16577,551.05182)" />
          <g id="use6186" transform="translate(731.34583,551.05182)" />
        </g>
        <g
          style={{
            fill: 'rgb(7.843018%,14.117432%,27.058411%)',
            fillOpacity: 1
          }}
          id="g6200"
        >
          <g id="use6190" transform="translate(735.84583,551.05182)" />
          <g id="use6192" transform="translate(742.02582,551.05182)" />
          <g id="use6194" transform="translate(745.15778,551.05182)" />
          <g id="use6196" transform="translate(749.44177,551.05182)" />
          <g id="use6198" transform="translate(755.26178,551.05182)" />
        </g>
        <g
          style={{
            fill: 'rgb(7.843018%,14.117432%,27.058411%)',
            fillOpacity: 1
          }}
          id="g6208"
        >
          <g id="use6202" transform="translate(761.16577,551.05182)" />
          <g id="use6204" transform="translate(767.82581,551.05182)" />
          <g id="use6206" transform="translate(773.96979,551.05182)" />
        </g>
        <g
          style={{
            fill: 'rgb(7.843018%,14.117432%,27.058411%)',
            fillOpacity: 1
          }}
          id="g6222"
        >
          <g id="use6210" transform="translate(778.08582,551.05182)" />
          <g id="use6212" transform="translate(782.36981,551.05182)" />
          <g id="use6214" transform="translate(785.36981,551.05182)" />
          <g id="use6216" transform="translate(792.02979,551.05182)" />
          <g id="use6218" transform="translate(798.60577,551.05182)" />
          <g id="use6220" transform="translate(805.18182,551.05182)" />
        </g>
        <g
          style={{
            fill: 'rgb(7.843018%,14.117432%,27.058411%)',
            fillOpacity: 1
          }}
          id="g6226"
        >
          <g id="use6224" transform="translate(710.89899,565.45178)" />
        </g>
        <g
          style={{
            fill: 'rgb(7.843018%,14.117432%,27.058411%)',
            fillOpacity: 1
          }}
          id="g6238"
        >
          <g id="use6228" transform="translate(717.91901,565.45178)" />
          <g id="use6230" transform="translate(724.099,565.45178)" />
          <g id="use6232" transform="translate(730.67499,565.45178)" />
          <g id="use6234" transform="translate(737.25098,565.45178)" />
          <g id="use6236" transform="translate(740.383,565.45178)" />
        </g>
        <g
          style={{
            fill: 'rgb(7.843018%,14.117432%,27.058411%)',
            fillOpacity: 1
          }}
          id="g6246"
        >
          <g id="use6240" transform="translate(744.60699,565.45178)" />
          <g id="use6242" transform="translate(750.78699,565.45178)" />
          <g id="use6244" transform="translate(756.96698,565.45178)" />
        </g>
        <g
          style={{
            fill: 'rgb(7.843018%,14.117432%,27.058411%)',
            fillOpacity: 1
          }}
          id="g6250"
        >
          <g id="use6248" transform="translate(761.70697,565.45178)" />
        </g>
        <g
          style={{
            fill: 'rgb(7.843018%,14.117432%,27.058411%)',
            fillOpacity: 1
          }}
          id="g6256"
        >
          <g id="use6252" transform="translate(770.46698,565.45178)" />
          <g id="use6254" transform="translate(776.61102,565.45178)" />
        </g>
        {props.lang === 'en' ? (
          <g
            style={{
              fill: 'rgb(7.843018%,14.117432%,27.058411%)',
              fillOpacity: 1
            }}
            id="g6266"
          >
            <g id="use6258" transform="translate(783.22241,565.4519)" />
            <g id="use6260" transform="translate(786.35437,565.4519)" />
            <g id="use6262" transform="translate(792.78638,565.4519)" />
            <g id="use6264" transform="translate(799.36243,575.4519)">
              <path
                id="path15762"
                style={{ stroke: 'none' }}
                d="M 5.265625,-3.96875 C 5.1875,-5.171875 4.34375,-5.875 2.953125,-5.875 c -1.375,0 -2.28125,0.75 -2.28125,1.859375 0,0.40625 0.140625,0.78125 0.390625,1.03125 0.234375,0.21875 0.5625,0.375 1.1875,0.578125 1.015625,0.296875 1.015625,0.296875 1.1875,0.375 0.296875,0.125 0.390625,0.25 0.390625,0.453125 0,0.375 -0.34375,0.625 -0.90625,0.625 -0.703125,0 -1.03125,-0.28125 -1.078125,-0.953125 H 0.453125 c 0,1.359375 0.859375,2.0625 2.53125,2.0625 1.46875,0 2.3125,-0.6875 2.3125,-1.84375 0,-0.375 -0.109375,-0.71875 -0.328125,-0.96875 C 4.734375,-2.9375 4.375,-3.125 3.53125,-3.375 2.65625,-3.625 2.546875,-3.65625 2.375,-3.765625 c -0.15625,-0.09375 -0.234375,-0.25 -0.234375,-0.40625 0,-0.34375 0.328125,-0.59375 0.78125,-0.59375 0.5625,0 0.84375,0.25 0.921875,0.796875 z m 0,0 m -11.20105,-1.734375 c 0.171875,0.5625 0.1875,0.65625 0.1875,2.046875 V 0 h 1.46875 v -2.921875 c 0,-0.5625 0.046875,-0.78125 0.15625,-1.015625 0.15625,-0.359375 0.515625,-0.59375 0.9375,-0.59375 0.359375,0 0.640625,0.171875 0.78125,0.484375 0.09375,0.21875 0.140625,0.5 0.140625,1.078125 V 0 h 1.46875 v -3.28125 c 0,-1.03125 -0.046875,-1.328125 -0.265625,-1.703125 -0.296875,-0.53125 -0.921875,-0.828125 -1.625,-0.828125 -0.703125,0 -1.28125,0.28125 -1.6875,0.84375 0,-0.3125 -0.046875,-0.546875 -0.125,-0.734375 z m 0,0 m -3.853885,-0.15625 c -1.625,0 -2.828125,1.265625 -2.828125,2.96875 0,1.796875 1.15625,3.046875 2.828125,3.046875 1.625,0 2.8125,-1.265625 2.8125,-3 0,-1.75 -1.1875,-3.015625 -2.8125,-3.015625 z m 0,1.1875 c 0.765625,0 1.296875,0.75 1.296875,1.8125 0,1.078125 -0.53125,1.828125 -1.296875,1.828125 -0.796875,0 -1.3125,-0.734375 -1.3125,-1.84375 0,-1.046875 0.546875,-1.796875 1.3125,-1.796875 z m 0,0 m -5.522585,-1.03125 V 0 h 1.46875 v -5.703125 z m 0.765625,-2.453125 c -0.53125,0 -0.890625,0.34375 -0.890625,0.875 0,0.515625 0.34375,0.84375 0.875,0.84375 0.515625,0 0.84375,-0.34375 0.84375,-0.875 0,-0.5 -0.328125,-0.84375 -0.828125,-0.84375 z m 0,0 m -3.22149,2.453125 0.01563,-1.640625 h -1.421875 l -0.03125,1.640625 h -0.9375 v 1.15625 h 0.875 l -0.07813,2.21875 -0.01563,0.5625 c 0,0.625 0.0625,0.90625 0.25,1.1875 0.265625,0.453125 0.765625,0.703125 1.40625,0.703125 0.453125,0 0.84375,-0.09375 1.296875,-0.265625 V -1.375 c -0.3125,0.140625 -0.578125,0.203125 -0.84375,0.203125 -0.453125,0 -0.59375,-0.1875 -0.59375,-0.78125 0,-0.109375 0,-0.109375 0.01563,-0.40625 l 0.03125,-2.1875 h 1.1875 v -1.15625 z m 0,0 M -24.47431,-4 c 0.07813,-0.4375 0.40625,-0.65625 0.96875,-0.65625 0.625,0 0.859375,0.234375 0.859375,0.859375 v 0.09375 c -1.546875,0.28125 -1.625,0.296875 -2.140625,0.5 -0.84375,0.3125 -1.296875,0.90625 -1.296875,1.703125 0,1.015625 0.765625,1.625 2.078125,1.625 0.75,0 1.25,-0.25 1.5625,-0.765625 0,0.28125 0.01563,0.40625 0.07813,0.640625 h 1.34375 c -0.140625,-0.296875 -0.1875,-0.59375 -0.1875,-1.265625 V -3.5625 c 0,-0.71875 -0.0625,-1.0625 -0.234375,-1.40625 -0.265625,-0.546875 -0.96875,-0.84375 -1.953125,-0.84375 -0.765625,0 -1.4375,0.1875 -1.859375,0.53125 -0.375,0.296875 -0.5625,0.65625 -0.625,1.28125 z m 1.828125,1.609375 c 0,0.453125 -0.03125,0.671875 -0.109375,0.859375 -0.15625,0.3125 -0.515625,0.515625 -0.953125,0.515625 -0.5,0 -0.875,-0.28125 -0.875,-0.671875 0,-0.25 0.140625,-0.484375 0.359375,-0.640625 0.25,-0.1875 0.625,-0.265625 1.578125,-0.390625 z m 0,0 m -5.561585,-3.3125 0.01563,-1.640625 h -1.421875 l -0.03125,1.640625 h -0.9375 v 1.15625 h 0.875 l -0.07813,2.21875 -0.01563,0.5625 c 0,0.625 0.0625,0.90625 0.25,1.1875 C -29.2859,-0.125 -28.7859,0.125 -28.145275,0.125 c 0.453125,0 0.84375,-0.09375 1.296875,-0.265625 V -1.375 c -0.3125,0.140625 -0.578125,0.203125 -0.84375,0.203125 -0.453125,0 -0.59375,-0.1875 -0.59375,-0.78125 0,-0.109375 0,-0.109375 0.01563,-0.40625 l 0.03125,-2.1875 h 1.1875 v -1.15625 z m 0,0 m -3.104615,1.890625 c -0.171875,-1.328125 -1,-2.046875 -2.359375,-2.046875 -1.65625,0 -2.765625,1.203125 -2.765625,3.015625 0,1.78125 1.109375,3 2.734375,3 1.390625,0 2.359375,-0.875 2.4375,-2.1875 h -1.4375 c -0.07813,0.671875 -0.40625,1 -1,1 -0.765625,0 -1.21875,-0.671875 -1.21875,-1.8125 0,-1.109375 0.5,-1.828125 1.25,-1.828125 0.515625,0 0.828125,0.296875 0.90625,0.859375 z m 0,0 m -5.93005,1.3125 v -0.28125 c 0,-1.90625 -0.984375,-3.078125 -2.59375,-3.078125 -1.671875,0 -2.78125,1.234375 -2.78125,3.078125 0,1.796875 1.09375,2.9375 2.828125,2.9375 1.25,0 2.1875,-0.671875 2.4375,-1.765625 l -1.296875,-0.0625 c -0.203125,0.4375 -0.5625,0.640625 -1.109375,0.640625 -0.828125,0 -1.328125,-0.53125 -1.375,-1.46875 z m -3.859375,-1.078125 c 0.1875,-0.765625 0.609375,-1.140625 1.25,-1.140625 0.640625,0 1,0.375 1.125,1.140625 z m 0,0 m -7.654115,5.9375 h 1.46875 v -2.96875 C -46.83405,-0.09375 -46.39655,0.125 -45.77155,0.125 c 1.390625,0 2.375,-1.265625 2.375,-3.015625 0,-1.734375 -0.984375,-2.921875 -2.421875,-2.921875 -0.6875,0 -1.15625,0.234375 -1.5625,0.78125 -0.01563,-0.3125 -0.0625,-0.53125 -0.109375,-0.671875 h -1.375 c 0.07813,0.40625 0.109375,0.84375 0.109375,1.8125 z m 2.671875,-6.9375 c 0.734375,0 1.1875,0.640625 1.1875,1.703125 0,1.109375 -0.453125,1.765625 -1.1875,1.765625 -0.734375,0 -1.21875,-0.671875 -1.21875,-1.703125 0,-1.09375 0.46875,-1.765625 1.21875,-1.765625 z m 0,0 m -9.215085,-1.125 1.8125,2.671875 L -55.580385,0 h 1.78125 L -52.59601,-1.890625 -51.392885,0 h 1.796875 l -2.09375,-3.03125 1.8125,-2.671875 h -1.75 l -0.96875,1.59375 -0.9375,-1.59375 z m 0,0 M -55.806395,-2.5 v -0.28125 c 0,-1.90625 -0.984375,-3.078125 -2.59375,-3.078125 -1.671875,0 -2.78125,1.234375 -2.78125,3.078125 0,1.796875 1.09375,2.9375 2.828125,2.9375 1.25,0 2.1875,-0.671875 2.4375,-1.765625 l -1.296875,-0.0625 c -0.203125,0.4375 -0.5625,0.640625 -1.109375,0.640625 -0.828125,0 -1.328125,-0.53125 -1.375,-1.46875 z m -3.859375,-1.078125 c 0.1875,-0.765625 0.609375,-1.140625 1.25,-1.140625 0.640625,0 1,0.375 1.125,1.140625 z m 0,0 m -10.841615,-2.125 c 0.171875,0.5625 0.1875,0.65625 0.1875,2.046875 V 0 h 1.46875 v -2.921875 c 0,-0.5625 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.359375 0.515625,-0.59375 0.9375,-0.59375 0.359375,0 0.640625,0.171875 0.78125,0.484375 0.09375,0.21875 0.140625,0.5 0.140625,1.078125 V 0 h 1.46875 v -3.28125 c 0,-1.03125 -0.04687,-1.328125 -0.265625,-1.703125 -0.296875,-0.53125 -0.921875,-0.828125 -1.625,-0.828125 -0.703125,0 -1.28125,0.28125 -1.6875,0.84375 0,-0.3125 -0.04687,-0.546875 -0.125,-0.734375 z m 0,0 m -4.390625,0 c 0.04687,0.3125 0.04687,0.4375 0.04687,0.75 0.01563,0.421875 0.01563,0.75 0.01563,1 V 0 h 1.484375 v -2.65625 c 0,-1.265625 0.359375,-1.875 1.140625,-1.875 0.3125,0 0.609375,0.109375 0.875,0.28125 v -1.5 c -0.234375,-0.0625 -0.28125,-0.0625 -0.4375,-0.0625 -0.6875,0 -1.1875,0.375 -1.640625,1.296875 0.01563,-0.125 0.01563,-0.234375 0.01563,-0.296875 0,-0.328125 -0.04687,-0.640625 -0.109375,-0.890625 z m 0,0 m -6.62879,0 V -2.375 c 0,0.75 0.109375,1.296875 0.328125,1.625 0.34375,0.546875 1,0.875 1.765625,0.875 0.6875,0 1.140625,-0.21875 1.59375,-0.78125 0,0.265625 0.0625,0.53125 0.109375,0.65625 h 1.390625 c -0.140625,-0.5 -0.140625,-0.5 -0.140625,-1.765625 v -3.9375 h -1.46875 v 3.046875 c 0,1 -0.375,1.484375 -1.125,1.484375 -0.34375,0 -0.625,-0.125 -0.78125,-0.34375 C -79.979925,-1.6875 -80.05805,-2 -80.05805,-2.453125 v -3.25 z m 0,0 m -2.40899,0 0.01563,-1.640625 h -1.421875 l -0.03125,1.640625 h -0.9375 v 1.15625 h 0.875 l -0.07813,2.21875 -0.01563,0.5625 c 0,0.625 0.0625,0.90625 0.25,1.1875 0.265625,0.453125 0.765625,0.703125 1.40625,0.703125 0.453125,0 0.84375,-0.09375 1.296875,-0.265625 V -1.375 c -0.3125,0.140625 -0.578125,0.203125 -0.84375,0.203125 -0.453125,0 -0.59375,-0.1875 -0.59375,-0.78125 0,-0.109375 0,-0.109375 0.01563,-0.40625 l 0.03125,-2.1875 h 1.1875 v -1.15625 z m 0,0 M -86.898375,-2.5 v -0.28125 c 0,-1.90625 -0.984375,-3.078125 -2.59375,-3.078125 -1.671875,0 -2.78125,1.234375 -2.78125,3.078125 0,1.796875 1.09375,2.9375 2.828125,2.9375 1.25,0 2.1875,-0.671875 2.4375,-1.765625 l -1.296875,-0.0625 c -0.203125,0.4375 -0.5625,0.640625 -1.109375,0.640625 -0.828125,0 -1.328125,-0.53125 -1.375,-1.46875 z m -3.859375,-1.078125 c 0.1875,-0.765625 0.609375,-1.140625 1.25,-1.140625 0.640625,0 1,0.375 1.125,1.140625 z m 0,0 m -5.65625,-2.125 c 0.04687,0.3125 0.04687,0.4375 0.04687,0.75 0.01563,0.421875 0.01563,0.75 0.01563,1 V 0 h 1.484375 v -2.65625 c 0,-1.265625 0.359375,-1.875 1.140625,-1.875 0.3125,0 0.609375,0.109375 0.875,0.28125 v -1.5 c -0.234375,-0.0625 -0.28125,-0.0625 -0.4375,-0.0625 -0.6875,0 -1.1875,0.375 -1.640625,1.296875 0.01563,-0.125 0.01563,-0.234375 0.01563,-0.296875 0,-0.328125 -0.04687,-0.640625 -0.109375,-0.890625 z m 0,0 M 4.99279,-22.446895 H 3.508415 v 2.96875 c -0.40625,-0.53125 -0.8125,-0.734375 -1.46875,-0.734375 -1.390625,0 -2.40625,1.25 -2.40625,3.015625 0,1.734375 0.984375,2.921875 2.421875,2.921875 0.78125,0 1.25,-0.265625 1.625,-0.921875 -0.015625,0.15625 -0.015625,0.21875 -0.015625,0.296875 0,0.140625 0.015625,0.265625 0.046875,0.5 H 5.102165 C 5.008415,-14.790645 4.99279,-15.24377 4.99279,-16.196895 Z m -2.625,3.46875 c 0.734375,0 1.171875,0.640625 1.171875,1.71875 0,1.078125 -0.46875,1.75 -1.21875,1.75 -0.734375,0 -1.1875,-0.640625 -1.1875,-1.6875 0,-1.125 0.46875,-1.78125 1.234375,-1.78125 z m 0,0 m -9.060425,-1.125 c 0.171875,0.5625 0.1875,0.65625 0.1875,2.046875 v 3.65625 h 1.46875 v -2.921875 c 0,-0.5625 0.046875,-0.78125 0.15625,-1.015625 0.15625,-0.359375 0.515625,-0.59375 0.9375,-0.59375 0.359375,0 0.640625,0.171875 0.78125,0.484375 0.09375,0.21875 0.140625,0.5 0.140625,1.078125 v 2.96875 h 1.46875 v -3.28125 c 0,-1.03125 -0.046875,-1.328125 -0.265625,-1.703125 -0.296875,-0.53125 -0.921875,-0.828125 -1.625,-0.828125 -0.703125,0 -1.28125,0.28125 -1.6875,0.84375 0,-0.3125 -0.046875,-0.546875 -0.125,-0.734375 z m 0,0 m -4.690855,1.703125 c 0.07813,-0.4375 0.40625,-0.65625 0.96875,-0.65625 0.625,0 0.859375,0.234375 0.859375,0.859375 v 0.09375 c -1.546875,0.28125 -1.625,0.296875 -2.140625,0.5 -0.84375,0.3125 -1.296875,0.90625 -1.296875,1.703125 0,1.015625 0.765625,1.625 2.078125,1.625 0.75,0 1.25,-0.25 1.5625,-0.765625 0,0.28125 0.015625,0.40625 0.078125,0.640625 h 1.34375 c -0.140625,-0.296875 -0.1875,-0.59375 -0.1875,-1.265625 v -2.296875 c 0,-0.71875 -0.0625,-1.0625 -0.234375,-1.40625 -0.265625,-0.546875 -0.96875,-0.84375 -1.953125,-0.84375 -0.765625,0 -1.4375,0.1875 -1.859375,0.53125 -0.375,0.296875 -0.5625,0.65625 -0.625,1.28125 z m 1.828125,1.609375 c 0,0.453125 -0.03125,0.671875 -0.109375,0.859375 -0.15625,0.3125 -0.515625,0.515625 -0.953125,0.515625 -0.5,0 -0.875,-0.28125 -0.875,-0.671875 0,-0.25 0.140625,-0.484375 0.359375,-0.640625 0.25,-0.1875 0.625,-0.265625 1.578125,-0.390625 z m 0,0 m -7.33624,-0.109375 v -0.28125 c 0,-1.90625 -0.984375,-3.078125 -2.59375,-3.078125 -1.671875,0 -2.78125,1.234375 -2.78125,3.078125 0,1.796875 1.09375,2.9375 2.828125,2.9375 1.25,0 2.1875,-0.671875 2.4375,-1.765625 l -1.296875,-0.0625 c -0.203125,0.4375 -0.5625,0.640625 -1.109375,0.640625 -0.828125,0 -1.328125,-0.53125 -1.375,-1.46875 z m -3.859375,-1.078125 c 0.1875,-0.765625 0.609375,-1.140625 1.25,-1.140625 0.640625,0 1,0.375 1.125,1.140625 z m 0,0 m -3.474,-2.125 0.01563,-1.640625 h -1.421875 l -0.03125,1.640625 h -0.9375 v 1.15625 h 0.875 l -0.07813,2.21875 -0.01563,0.5625 c 0,0.625 0.0625,0.90625 0.25,1.1875 0.265625,0.453125 0.765625,0.703125 1.40625,0.703125 0.453125,0 0.84375,-0.09375 1.296875,-0.265625 v -1.234375 c -0.3125,0.140625 -0.578125,0.203125 -0.84375,0.203125 -0.453125,0 -0.59375,-0.1875 -0.59375,-0.78125 0,-0.109375 0,-0.109375 0.01563,-0.40625 l 0.03125,-2.1875 h 1.1875 v -1.15625 z m 0,0 m -4.960145,0 v 5.703125 h 1.46875 v -5.703125 z m 0.765625,-2.453125 c -0.53125,0 -0.890625,0.34375 -0.890625,0.875 0,0.515625 0.34375,0.84375 0.875,0.84375 0.515625,0 0.84375,-0.34375 0.84375,-0.875 0,-0.5 -0.328125,-0.84375 -0.828125,-0.84375 z m 0,0 m -3.22149,2.453125 0.01563,-1.640625 h -1.421875 l -0.03125,1.640625 h -0.9375 v 1.15625 h 0.875 l -0.07813,2.21875 -0.01563,0.5625 c 0,0.625 0.0625,0.90625 0.25,1.1875 0.265625,0.453125 0.765625,0.703125 1.40625,0.703125 0.453125,0 0.84375,-0.09375 1.296875,-0.265625 v -1.234375 c -0.3125,0.140625 -0.578125,0.203125 -0.84375,0.203125 -0.453125,0 -0.59375,-0.1875 -0.59375,-0.78125 0,-0.109375 0,-0.109375 0.01563,-0.40625 l 0.03125,-2.1875 h 1.1875 v -1.15625 z m 0,0 m -2.961435,3.203125 v -0.28125 c 0,-1.90625 -0.984375,-3.078125 -2.59375,-3.078125 -1.671875,0 -2.78125,1.234375 -2.78125,3.078125 0,1.796875 1.09375,2.9375 2.828125,2.9375 1.25,0 2.1875,-0.671875 2.4375,-1.765625 l -1.296875,-0.0625 c -0.203125,0.4375 -0.5625,0.640625 -1.109375,0.640625 -0.828125,0 -1.328125,-0.53125 -1.375,-1.46875 z m -3.859375,-1.078125 c 0.1875,-0.765625 0.609375,-1.140625 1.25,-1.140625 0.640625,0 1,0.375 1.125,1.140625 z m 0,0 m -7.654105,5.9375 h 1.46875 v -2.96875 c 0.453125,0.515625 0.890625,0.734375 1.515625,0.734375 1.390625,0 2.375,-1.265625 2.375,-3.015625 0,-1.734375 -0.984375,-2.921875 -2.421875,-2.921875 -0.6875,0 -1.15625,0.234375 -1.5625,0.78125 -0.01563,-0.3125 -0.0625,-0.53125 -0.109375,-0.671875 h -1.375 c 0.07813,0.40625 0.109375,0.84375 0.109375,1.8125 z m 2.671875,-6.9375 c 0.734375,0 1.1875,0.640625 1.1875,1.703125 0,1.109375 -0.453125,1.765625 -1.1875,1.765625 -0.734375,0 -1.21875,-0.671875 -1.21875,-1.703125 0,-1.09375 0.46875,-1.765625 1.21875,-1.765625 z m 0,0 m -9.247865,6.9375 h 1.46875 v -2.96875 c 0.453125,0.515625 0.890625,0.734375 1.515625,0.734375 1.390625,0 2.375,-1.265625 2.375,-3.015625 0,-1.734375 -0.984375,-2.921875 -2.421875,-2.921875 -0.6875,0 -1.15625,0.234375 -1.5625,0.78125 -0.01563,-0.3125 -0.0625,-0.53125 -0.109375,-0.671875 h -1.375 c 0.07813,0.40625 0.109375,0.84375 0.109375,1.8125 z m 2.671875,-6.9375 c 0.734375,0 1.1875,0.640625 1.1875,1.703125 0,1.109375 -0.453125,1.765625 -1.1875,1.765625 -0.734375,0 -1.21875,-0.671875 -1.21875,-1.703125 0,-1.09375 0.46875,-1.765625 1.21875,-1.765625 z m 0,0 m -7.55023,0.578125 c 0.07813,-0.4375 0.40625,-0.65625 0.96875,-0.65625 0.625,0 0.859375,0.234375 0.859375,0.859375 v 0.09375 c -1.546875,0.28125 -1.625,0.296875 -2.140625,0.5 -0.84375,0.3125 -1.296875,0.90625 -1.296875,1.703125 0,1.015625 0.765625,1.625 2.078125,1.625 0.75,0 1.25,-0.25 1.5625,-0.765625 0,0.28125 0.01563,0.40625 0.07813,0.640625 h 1.34375 c -0.140625,-0.296875 -0.1875,-0.59375 -0.1875,-1.265625 v -2.296875 c 0,-0.71875 -0.0625,-1.0625 -0.234375,-1.40625 -0.265625,-0.546875 -0.96875,-0.84375 -1.953125,-0.84375 -0.765625,0 -1.4375,0.1875 -1.859375,0.53125 -0.375,0.296875 -0.5625,0.65625 -0.625,1.28125 z m 1.828125,1.609375 c 0,0.453125 -0.03125,0.671875 -0.109375,0.859375 -0.15625,0.3125 -0.515625,0.515625 -0.953125,0.515625 -0.5,0 -0.875,-0.28125 -0.875,-0.671875 0,-0.25 0.140625,-0.484375 0.359375,-0.640625 0.25,-0.1875 0.625,-0.265625 1.578125,-0.390625 z m 0,0 m -8.93201,-3.3125 -2.09375,2.671875 2.078125,3.03125 h 1.984375 l -2.328125,-3.0625 2.125,-2.640625 z m -3.59375,-2.34375 v 8.046875 h 1.46875 v -8.046875 z m 0,0 m -1.38251,4.078125 c -0.07813,-1.203125 -0.921875,-1.90625 -2.3125,-1.90625 -1.375,0 -2.28125,0.75 -2.28125,1.859375 0,0.40625 0.140625,0.78125 0.390625,1.03125 0.234375,0.21875 0.5625,0.375 1.1875,0.578125 1.015625,0.296875 1.015625,0.296875 1.1875,0.375 0.296875,0.125 0.390625,0.25 0.390625,0.453125 0,0.375 -0.34375,0.625 -0.90625,0.625 -0.703125,0 -1.03125,-0.28125 -1.078125,-0.953125 h -1.390625 c 0,1.359375 0.859375,2.0625 2.53125,2.0625 1.46875,0 2.3125,-0.6875 2.3125,-1.84375 0,-0.375 -0.109375,-0.71875 -0.328125,-0.96875 -0.234375,-0.28125 -0.59375,-0.46875 -1.4375,-0.71875 -0.875,-0.25 -0.984375,-0.28125 -1.15625,-0.390625 -0.15625,-0.09375 -0.234375,-0.25 -0.234375,-0.40625 0,-0.34375 0.328125,-0.59375 0.78125,-0.59375 0.5625,0 0.84375,0.25 0.921875,0.796875 z m 0,0 m -7.56952,-1.734375 v 5.703125 h 1.46875 v -5.703125 z m 0.765625,-2.453125 c -0.53125,0 -0.890625,0.34375 -0.890625,0.875 0,0.515625 0.34375,0.84375 0.875,0.84375 0.515625,0 0.84375,-0.34375 0.84375,-0.875 0,-0.5 -0.328125,-0.84375 -0.828125,-0.84375 z m 0,0 m -5.25976,2.453125 c 0.04687,0.3125 0.04687,0.4375 0.04687,0.75 0.01563,0.421875 0.01563,0.75 0.01563,1 v 3.953125 h 1.484375 v -2.65625 c 0,-1.265625 0.359375,-1.875 1.140625,-1.875 0.3125,0 0.609375,0.109375 0.875,0.28125 v -1.5 c -0.234375,-0.0625 -0.28125,-0.0625 -0.4375,-0.0625 -0.6875,0 -1.1875,0.375 -1.640625,1.296875 0.01563,-0.125 0.01563,-0.234375 0.01563,-0.296875 0,-0.328125 -0.04687,-0.640625 -0.109375,-0.890625 z m 0,0 m -9.581855,-2.34375 v 8.046875 h 1.46875 v -2.921875 c 0,-0.484375 0.0625,-0.78125 0.15625,-1 0.203125,-0.375 0.578125,-0.609375 0.984375,-0.609375 0.359375,0 0.671875,0.1875 0.828125,0.515625 0.109375,0.21875 0.140625,0.484375 0.140625,1.046875 v 2.96875 h 1.46875 v -3.28125 c 0,-1.03125 -0.0625,-1.375 -0.28125,-1.75 -0.3125,-0.484375 -0.953125,-0.78125 -1.640625,-0.78125 -0.671875,0 -1.203125,0.25 -1.65625,0.734375 v -2.96875 z m 0,0 m -1.04748,2.34375 -1.875,0.04687 c -0.46875,-0.125 -0.734375,-0.15625 -1.09375,-0.15625 -1.453125,0 -2.375,0.765625 -2.375,2 0,0.78125 0.296875,1.28125 0.96875,1.609375 -0.734375,0.296875 -1.015625,0.53125 -1.015625,0.921875 0,0.3125 0.1875,0.5 0.640625,0.6875 -0.796875,0.265625 -1.15625,0.671875 -1.15625,1.328125 0,1.03125 1.09375,1.671875 2.84375,1.671875 1.796875,0 2.84375,-0.6875 2.84375,-1.90625 0,-0.59375 -0.28125,-1.09375 -0.75,-1.34375 -0.34375,-0.1875 -0.796875,-0.28125 -1.765625,-0.375 -1.171875,-0.109375 -1.25,-0.140625 -1.25,-0.359375 0,-0.171875 0.234375,-0.3125 0.5625,-0.328125 1.234375,-0.125 1.28125,-0.125 1.671875,-0.296875 0.578125,-0.25 0.890625,-0.75 0.890625,-1.421875 0,-0.375 -0.109375,-0.734375 -0.296875,-1.015625 h 1.15625 z m -3.0625,1 c 0.5625,0 0.96875,0.34375 0.96875,0.875 0,0.5 -0.40625,0.84375 -1,0.84375 -0.59375,0 -0.984375,-0.34375 -0.984375,-0.84375 0,-0.546875 0.390625,-0.875 1.015625,-0.875 z m -0.171875,4.59375 c 1,0 1.59375,0.28125 1.59375,0.75 0,0.453125 -0.5,0.703125 -1.40625,0.703125 -1,0 -1.59375,-0.28125 -1.59375,-0.734375 0,-0.453125 0.515625,-0.71875 1.40625,-0.71875 z m 0,0 m -5.21015,-5.59375 v 5.703125 h 1.468755 v -5.703125 z m 0.76563,-2.453125 c -0.53125,0 -0.89063,0.34375 -0.89063,0.875 0,0.515625 0.34375,0.84375 0.875,0.84375 0.51563,0 0.843755,-0.34375 0.843755,-0.875 0,-0.5 -0.328125,-0.84375 -0.828125,-0.84375 z m 0,0 m -7.26575,3.34375 v -3.1875 h -1.54688 v 8 h 1.54688 v -3.546875 h 3.17187 v 3.546875 h 1.54688 v -8 h -1.54688 v 3.1875 z m 0,0"
              />
            </g>
          </g>
        ) : (
          <g
            style={{
              fill: 'rgb(7.843018%,14.117432%,27.058411%)',
              fillOpacity: 1
            }}
            id="g6266"
          >
            <g id="use6258" transform="translate(781.30298,565.45178)" />
            <g id="use6260" transform="translate(785.58698,565.45178)" />
            <g id="use6262" transform="translate(792.24701,565.45178)" />
            <g id="use6264" transform="translate(798.823,575.45178)">
              <path
                id="path15762"
                style={{ stroke: 'none' }}
                d="m 6.140625,-5.703125 -1.875,0.046875 c -0.46875,-0.125 -0.734375,-0.15625 -1.09375,-0.15625 -1.453125,0 -2.375,0.765625 -2.375,2 0,0.78125 0.296875,1.28125 0.96875,1.609375 C 1.03125,-1.90625 0.75,-1.671875 0.75,-1.28125 c 0,0.3125 0.1875,0.5 0.640625,0.6875 -0.796875,0.265625 -1.15625,0.671875 -1.15625,1.328125 0,1.03125 1.09375,1.671875 2.84375,1.671875 1.796875,0 2.84375,-0.6875 2.84375,-1.90625 0,-0.59375 -0.28125,-1.09375 -0.75,-1.34375 C 4.828125,-1.03125 4.375,-1.125 3.40625,-1.21875 c -1.171875,-0.109375 -1.25,-0.140625 -1.25,-0.359375 0,-0.171875 0.234375,-0.3125 0.5625,-0.328125 1.234375,-0.125 1.28125,-0.125 1.671875,-0.296875 0.578125,-0.25 0.890625,-0.75 0.890625,-1.421875 0,-0.375 -0.109375,-0.734375 -0.296875,-1.015625 h 1.15625 z m -3.0625,1 c 0.5625,0 0.96875,0.34375 0.96875,0.875 0,0.5 -0.40625,0.84375 -1,0.84375 -0.59375,0 -0.984375,-0.34375 -0.984375,-0.84375 0,-0.546875 0.390625,-0.875 1.015625,-0.875 z m -0.171875,4.59375 c 1,0 1.59375,0.28125 1.59375,0.75 C 4.5,1.09375 4,1.34375 3.09375,1.34375 2.09375,1.34375 1.5,1.0625 1.5,0.609375 c 0,-0.453125 0.515625,-0.71875 1.40625,-0.71875 z m 0,0 m -8.841615,-5.59375 c 0.171875,0.5625 0.1875,0.65625 0.1875,2.046875 V 0 h 1.46875 v -2.921875 c 0,-0.5625 0.046875,-0.78125 0.15625,-1.015625 0.15625,-0.359375 0.515625,-0.59375 0.9375,-0.59375 0.359375,0 0.640625,0.171875 0.78125,0.484375 0.09375,0.21875 0.140625,0.5 0.140625,1.078125 V 0 h 1.46875 v -3.28125 c 0,-1.03125 -0.046875,-1.328125 -0.265625,-1.703125 -0.296875,-0.53125 -0.921875,-0.828125 -1.625,-0.828125 -0.703125,0 -1.28125,0.28125 -1.6875,0.84375 0,-0.3125 -0.046875,-0.546875 -0.125,-0.734375 z m 0,0 m -6.519405,0 V -2.375 c 0,0.75 0.109375,1.296875 0.328125,1.625 0.34375,0.546875 1,0.875 1.765625,0.875 0.6875,0 1.140625,-0.21875 1.59375,-0.78125 0,0.265625 0.0625,0.53125 0.109375,0.65625 h 1.390625 c -0.140625,-0.5 -0.140625,-0.5 -0.140625,-1.765625 v -3.9375 h -1.46875 v 3.046875 c 0,1 -0.375,1.484375 -1.125,1.484375 -0.34375,0 -0.625,-0.125 -0.78125,-0.34375 C -10.907895,-1.6875 -10.98602,-2 -10.98602,-2.453125 v -3.25 z m 0,0 m -2.409,0 0.01563,-1.640625 h -1.421875 l -0.03125,1.640625 h -0.9375 v 1.15625 h 0.875 l -0.07813,2.21875 -0.01563,0.5625 c 0,0.625 0.0625,0.90625 0.25,1.1875 0.265625,0.453125 0.765625,0.703125 1.40625,0.703125 0.453125,0 0.84375,-0.09375 1.296875,-0.265625 V -1.375 c -0.3125,0.140625 -0.578125,0.203125 -0.84375,0.203125 -0.453125,0 -0.59375,-0.1875 -0.59375,-0.78125 0,-0.109375 0,-0.109375 0.01563,-0.40625 l 0.03125,-2.1875 h 1.1875 v -1.15625 z m 0,0 m -6.59821,0 c 0.04687,0.3125 0.04687,0.4375 0.04687,0.75 0.01563,0.421875 0.01563,0.75 0.01563,1 V 0 h 1.484375 v -2.65625 c 0,-1.265625 0.359375,-1.875 1.140625,-1.875 0.3125,0 0.609375,0.109375 0.875,0.28125 v -1.5 c -0.234375,-0.0625 -0.28125,-0.0625 -0.4375,-0.0625 -0.6875,0 -1.1875,0.375 -1.640625,1.296875 0.01563,-0.125 0.01563,-0.234375 0.01563,-0.296875 0,-0.328125 -0.04687,-0.640625 -0.109375,-0.890625 z m 0,0 M -26.26227,-4 c 0.07813,-0.4375 0.40625,-0.65625 0.96875,-0.65625 0.625,0 0.859375,0.234375 0.859375,0.859375 v 0.09375 c -1.546875,0.28125 -1.625,0.296875 -2.140625,0.5 -0.84375,0.3125 -1.296875,0.90625 -1.296875,1.703125 0,1.015625 0.765625,1.625 2.078125,1.625 0.75,0 1.25,-0.25 1.5625,-0.765625 0,0.28125 0.01563,0.40625 0.07813,0.640625 h 1.34375 c -0.140625,-0.296875 -0.1875,-0.59375 -0.1875,-1.265625 V -3.5625 c 0,-0.71875 -0.0625,-1.0625 -0.234375,-1.40625 -0.265625,-0.546875 -0.96875,-0.84375 -1.953125,-0.84375 -0.765625,0 -1.4375,0.1875 -1.859375,0.53125 -0.375,0.296875 -0.5625,0.65625 -0.625,1.28125 z m 1.828125,1.609375 c 0,0.453125 -0.03125,0.671875 -0.109375,0.859375 -0.15625,0.3125 -0.515625,0.515625 -0.953125,0.515625 -0.5,0 -0.875,-0.28125 -0.875,-0.671875 0,-0.25 0.140625,-0.484375 0.359375,-0.640625 0.25,-0.1875 0.625,-0.265625 1.578125,-0.390625 z m 0,0 m -12.525635,-3.3125 1.671875,5.734375 h 1.578125 l 1.046875,-3.421875 1.0625,3.421875 h 1.59375 l 1.703125,-5.734375 h -1.484375 l -1.078125,4.015625 -1.171875,-4.015625 h -1.1875 l -1.1875,4.015625 -1.0625,-4.015625 z m 0,0 m -4.14624,0 c 0.04687,0.3125 0.04687,0.4375 0.04687,0.75 0.01563,0.421875 0.01563,0.75 0.01563,1 V 0 h 1.484375 v -2.65625 c 0,-1.265625 0.359375,-1.875 1.140625,-1.875 0.3125,0 0.609375,0.109375 0.875,0.28125 v -1.5 c -0.234375,-0.0625 -0.28125,-0.0625 -0.4375,-0.0625 -0.6875,0 -1.1875,0.375 -1.640625,1.296875 0.01563,-0.125 0.01563,-0.234375 0.01563,-0.296875 0,-0.328125 -0.04687,-0.640625 -0.109375,-0.890625 z m 0,0 M -42.270385,-2.5 v -0.28125 c 0,-1.90625 -0.984375,-3.078125 -2.59375,-3.078125 -1.671875,0 -2.78125,1.234375 -2.78125,3.078125 0,1.796875 1.09375,2.9375 2.828125,2.9375 1.25,0 2.1875,-0.671875 2.4375,-1.765625 l -1.296875,-0.0625 c -0.203125,0.4375 -0.5625,0.640625 -1.109375,0.640625 -0.828125,0 -1.328125,-0.53125 -1.375,-1.46875 z m -3.859375,-1.078125 c 0.1875,-0.765625 0.609375,-1.140625 1.25,-1.140625 0.640625,0 1,0.375 1.125,1.140625 z m 0,0 M -48.450385,-2.5 v -0.28125 c 0,-1.90625 -0.984375,-3.078125 -2.59375,-3.078125 -1.671875,0 -2.78125,1.234375 -2.78125,3.078125 0,1.796875 1.09375,2.9375 2.828125,2.9375 1.25,0 2.1875,-0.671875 2.4375,-1.765625 l -1.296875,-0.0625 c -0.203125,0.4375 -0.5625,0.640625 -1.109375,0.640625 -0.828125,0 -1.328125,-0.53125 -1.375,-1.46875 z m -3.859375,-1.078125 c 0.1875,-0.765625 0.609375,-1.140625 1.25,-1.140625 0.640625,0 1,0.375 1.125,1.140625 z m 0,0 m -3.47399,-2.125 0.01563,-1.640625 H -57.19 l -0.03125,1.640625 h -0.9375 v 1.15625 h 0.875 l -0.07813,2.21875 -0.01563,0.5625 c 0,0.625 0.0625,0.90625 0.25,1.1875 0.265625,0.453125 0.765625,0.703125 1.40625,0.703125 0.453125,0 0.84375,-0.09375 1.296875,-0.265625 V -1.375 c -0.3125,0.140625 -0.578125,0.203125 -0.84375,0.203125 -0.453125,0 -0.59375,-0.1875 -0.59375,-0.78125 0,-0.109375 0,-0.109375 0.01563,-0.40625 l 0.03125,-2.1875 h 1.1875 v -1.15625 z m 0,0 m -4.960145,0 V 0 h 1.46875 v -5.703125 z m 0.765625,-2.453125 c -0.53125,0 -0.890625,0.34375 -0.890625,0.875 0,0.515625 0.34375,0.84375 0.875,0.84375 0.515625,0 0.84375,-0.34375 0.84375,-0.875 0,-0.5 -0.328125,-0.84375 -0.828125,-0.84375 z m 0,0 m -2.41974,0.109375 h -1.484375 v 2.96875 c -0.40625,-0.53125 -0.8125,-0.734375 -1.46875,-0.734375 -1.390625,0 -2.40625,1.25 -2.40625,3.015625 0,1.734375 0.984375,2.921875 2.421875,2.921875 0.78125,0 1.25,-0.265625 1.625,-0.921875 -0.01563,0.15625 -0.01563,0.21875 -0.01563,0.296875 0,0.140625 0.01563,0.265625 0.04687,0.5 h 1.390625 c -0.09375,-0.390625 -0.109375,-0.84375 -0.109375,-1.796875 z m -2.625,3.46875 c 0.734375,0 1.171875,0.640625 1.171875,1.71875 0,1.078125 -0.46875,1.75 -1.21875,1.75 -0.734375,0 -1.1875,-0.640625 -1.1875,-1.6875 0,-1.125 0.46875,-1.78125 1.234375,-1.78125 z m 0,0 m -9.060365,-1.125 c 0.171875,0.5625 0.1875,0.65625 0.1875,2.046875 V 0 h 1.46875 v -2.921875 c 0,-0.5625 0.04687,-0.78125 0.15625,-1.015625 0.15625,-0.359375 0.515625,-0.59375 0.9375,-0.59375 0.359375,0 0.640625,0.171875 0.78125,0.484375 0.09375,0.21875 0.140625,0.5 0.140625,1.078125 V 0 h 1.46875 v -3.28125 c 0,-1.03125 -0.04687,-1.328125 -0.265625,-1.703125 -0.296875,-0.53125 -0.921875,-0.828125 -1.625,-0.828125 -0.703125,0 -1.28125,0.28125 -1.6875,0.84375 0,-0.3125 -0.04687,-0.546875 -0.125,-0.734375 z m 0,0 M -75.138365,-2.5 v -0.28125 c 0,-1.90625 -0.984375,-3.078125 -2.59375,-3.078125 -1.671875,0 -2.78125,1.234375 -2.78125,3.078125 0,1.796875 1.09375,2.9375 2.828125,2.9375 1.25,0 2.1875,-0.671875 2.4375,-1.765625 l -1.296875,-0.0625 c -0.203125,0.4375 -0.5625,0.640625 -1.109375,0.640625 -0.828125,0 -1.328125,-0.53125 -1.375,-1.46875 z m -3.859375,-1.078125 c 0.1875,-0.765625 0.609375,-1.140625 1.25,-1.140625 0.640625,0 1,0.375 1.125,1.140625 z m 0,0 M -86.970885,-8 v 8 h 1.546875 v -3.0625 h 1.09375 L -82.689635,0 h 1.78125 l -1.828125,-3.328125 c 0.9375,-0.421875 1.40625,-1.171875 1.40625,-2.21875 0,-0.921875 -0.40625,-1.6875 -1.140625,-2.078125 -0.546875,-0.296875 -1.078125,-0.375 -2.5,-0.375 z m 1.546875,3.625 v -2.328125 h 0.4375 c 1.046875,0 1.265625,0.03125 1.578125,0.21875 0.328125,0.1875 0.515625,0.515625 0.515625,0.921875 0,0.515625 -0.25,0.90625 -0.671875,1.0625 -0.296875,0.109375 -0.5625,0.125 -1.3125,0.125 z m 0,0 M 5.53277,-22.446835 H 4.048395 v 2.96875 c -0.40625,-0.53125 -0.8125,-0.734375 -1.46875,-0.734375 -1.390625,0 -2.40625,1.25 -2.40625,3.015625 0,1.734375 0.984375,2.921875 2.421875,2.921875 0.78125,0 1.25,-0.265625 1.625,-0.921875 -0.015625,0.15625 -0.015625,0.21875 -0.015625,0.296875 0,0.140625 0.015625,0.265625 0.046875,0.5 H 5.642145 C 5.548395,-14.790585 5.53277,-15.24371 5.53277,-16.196835 Z m -2.625,3.46875 c 0.734375,0 1.171875,0.640625 1.171875,1.71875 0,1.078125 -0.46875,1.75 -1.21875,1.75 -0.734375,0 -1.1875,-0.640625 -1.1875,-1.6875 0,-1.125 0.46875,-1.78125 1.234375,-1.78125 z m 0,0 m -9.060355,-1.125 c 0.171875,0.5625 0.1875,0.65625 0.1875,2.046875 v 3.65625 h 1.46875 v -2.921875 c 0,-0.5625 0.046875,-0.78125 0.15625,-1.015625 0.15625,-0.359375 0.515625,-0.59375 0.9375,-0.59375 0.359375,0 0.640625,0.171875 0.78125,0.484375 0.09375,0.21875 0.140625,0.5 0.140625,1.078125 v 2.96875 h 1.46875 v -3.28125 c 0,-1.03125 -0.046875,-1.328125 -0.265625,-1.703125 -0.296875,-0.53125 -0.921875,-0.828125 -1.625,-0.828125 -0.703125,0 -1.28125,0.28125 -1.6875,0.84375 0,-0.3125 -0.046875,-0.546875 -0.125,-0.734375 z m 0,0 m -6.519355,0 v 3.328125 c 0,0.75 0.109375,1.296875 0.328125,1.625 0.34375,0.546875 1,0.875 1.765625,0.875 0.6875,0 1.140625,-0.21875 1.59375,-0.78125 0,0.265625 0.0625,0.53125 0.109375,0.65625 h 1.390625 c -0.140625,-0.5 -0.140625,-0.5 -0.140625,-1.765625 v -3.9375 h -1.46875 v 3.046875 c 0,1 -0.375,1.484375 -1.125,1.484375 -0.34375,0 -0.625,-0.125 -0.78125,-0.34375 -0.125,-0.171875 -0.203125,-0.484375 -0.203125,-0.9375 v -3.25 z m 0,0 m -5.40899,0 0.01563,-1.640625 h -1.421875 l -0.03125,1.640625 h -0.9375 v 1.15625 h 0.875 l -0.07813,2.21875 -0.01563,0.5625 c 0,0.625 0.0625,0.90625 0.25,1.1875 0.265625,0.453125 0.765625,0.703125 1.40625,0.703125 0.453125,0 0.84375,-0.09375 1.296875,-0.265625 v -1.234375 c -0.3125,0.140625 -0.578125,0.203125 -0.84375,0.203125 -0.453125,0 -0.59375,-0.1875 -0.59375,-0.78125 0,-0.109375 0,-0.109375 0.01563,-0.40625 l 0.03125,-2.1875 h 1.1875 v -1.15625 z m 0,0 m -4.350405,0 v -0.140625 c 0,-0.90625 0.125,-1.125 0.625,-1.125 0.265625,0 0.515625,0.04687 0.96875,0.171875 v -1.1875 c -0.46875,-0.171875 -0.875,-0.265625 -1.296875,-0.265625 -0.671875,0 -1.171875,0.234375 -1.453125,0.671875 -0.234375,0.34375 -0.3125,0.75 -0.3125,1.515625 v 0.359375 h -0.765625 v 1.15625 h 0.765625 v 4.546875 h 1.46875 v -4.546875 h 1.359375 v -1.15625 z m 0,0 m -6.472105,1.703125 c 0.07813,-0.4375 0.40625,-0.65625 0.96875,-0.65625 0.625,0 0.859375,0.234375 0.859375,0.859375 v 0.09375 c -1.546875,0.28125 -1.625,0.296875 -2.140625,0.5 -0.84375,0.3125 -1.296875,0.90625 -1.296875,1.703125 0,1.015625 0.765625,1.625 2.078125,1.625 0.75,0 1.25,-0.25 1.5625,-0.765625 0,0.28125 0.01563,0.40625 0.07813,0.640625 h 1.34375 c -0.140625,-0.296875 -0.1875,-0.59375 -0.1875,-1.265625 v -2.296875 c 0,-0.71875 -0.0625,-1.0625 -0.234375,-1.40625 -0.265625,-0.546875 -0.96875,-0.84375 -1.953125,-0.84375 -0.765625,0 -1.4375,0.1875 -1.859375,0.53125 -0.375,0.296875 -0.5625,0.65625 -0.625,1.28125 z m 1.828125,1.609375 c 0,0.453125 -0.03125,0.671875 -0.109375,0.859375 -0.15625,0.3125 -0.515625,0.515625 -0.953125,0.515625 -0.5,0 -0.875,-0.28125 -0.875,-0.671875 0,-0.25 0.140625,-0.484375 0.359375,-0.640625 0.25,-0.1875 0.625,-0.265625 1.578125,-0.390625 z m 0,0 m -9.75379,-5.65625 v 8.046875 h 1.46875 v -2.921875 c 0,-0.484375 0.0625,-0.78125 0.15625,-1 0.203125,-0.375 0.578125,-0.609375 0.984375,-0.609375 0.359375,0 0.671875,0.1875 0.828125,0.515625 0.109375,0.21875 0.140625,0.484375 0.140625,1.046875 v 2.96875 h 1.46875 v -3.28125 c 0,-1.03125 -0.0625,-1.375 -0.28125,-1.75 -0.3125,-0.484375 -0.953125,-0.78125 -1.640625,-0.78125 -0.671875,0 -1.203125,0.25 -1.65625,0.734375 v -2.96875 z m 0,0 m -1.21649,4.234375 c -0.171875,-1.328125 -1,-2.046875 -2.359375,-2.046875 -1.65625,0 -2.765625,1.203125 -2.765625,3.015625 0,1.78125 1.109375,3 2.734375,3 1.390625,0 2.359375,-0.875 2.4375,-2.1875 h -1.4375 c -0.07813,0.671875 -0.40625,1 -1,1 -0.765625,0 -1.21875,-0.671875 -1.21875,-1.8125 0,-1.109375 0.5,-1.828125 1.25,-1.828125 0.515625,0 0.828125,0.296875 0.90625,0.859375 z m 0,0 m -6.07001,-0.15625 c -0.07813,-1.203125 -0.921875,-1.90625 -2.3125,-1.90625 -1.375,0 -2.28125,0.75 -2.28125,1.859375 0,0.40625 0.140625,0.78125 0.390625,1.03125 0.234375,0.21875 0.5625,0.375 1.1875,0.578125 1.015625,0.296875 1.015625,0.296875 1.1875,0.375 0.296875,0.125 0.390625,0.25 0.390625,0.453125 0,0.375 -0.34375,0.625 -0.90625,0.625 -0.703125,0 -1.03125,-0.28125 -1.078125,-0.953125 h -1.390625 c 0,1.359375 0.859375,2.0625 2.53125,2.0625 1.46875,0 2.3125,-0.6875 2.3125,-1.84375 0,-0.375 -0.109375,-0.71875 -0.328125,-0.96875 -0.234375,-0.28125 -0.59375,-0.46875 -1.4375,-0.71875 -0.875,-0.25 -0.984375,-0.28125 -1.15625,-0.390625 -0.15625,-0.09375 -0.234375,-0.25 -0.234375,-0.40625 0,-0.34375 0.328125,-0.59375 0.78125,-0.59375 0.5625,0 0.84375,0.25 0.921875,0.796875 z m 0,0 m -6.893365,-1.734375 0.01563,-1.640625 h -1.421875 l -0.03125,1.640625 h -0.9375 v 1.15625 h 0.875 l -0.07813,2.21875 -0.01563,0.5625 c 0,0.625 0.0625,0.90625 0.25,1.1875 0.265625,0.453125 0.765625,0.703125 1.40625,0.703125 0.453125,0 0.84375,-0.09375 1.296875,-0.265625 v -1.234375 c -0.3125,0.140625 -0.578125,0.203125 -0.84375,0.203125 -0.453125,0 -0.59375,-0.1875 -0.59375,-0.78125 0,-0.109375 0,-0.109375 0.01563,-0.40625 l 0.03125,-2.1875 h 1.1875 v -1.15625 z m 0,0 m -4.960085,0 v 5.703125 h 1.46875 v -5.703125 z m 0.765625,-2.453125 c -0.53125,0 -0.890625,0.34375 -0.890625,0.875 0,0.515625 0.34375,0.84375 0.875,0.84375 0.515625,0 0.84375,-0.34375 0.84375,-0.875 0,-0.5 -0.328125,-0.84375 -0.828125,-0.84375 z m 0,0 m -2.008115,5.65625 v -0.28125 c 0,-1.90625 -0.984375,-3.078125 -2.59375,-3.078125 -1.671875,0 -2.78125,1.234375 -2.78125,3.078125 0,1.796875 1.09375,2.9375 2.828125,2.9375 1.25,0 2.1875,-0.671875 2.4375,-1.765625 l -1.296875,-0.0625 c -0.203125,0.4375 -0.5625,0.640625 -1.109375,0.640625 -0.828125,0 -1.328125,-0.53125 -1.375,-1.46875 z m -3.859375,-1.078125 c 0.1875,-0.765625 0.609375,-1.140625 1.25,-1.140625 0.640625,0 1,0.375 1.125,1.140625 z m 0,0 m -5.65625,-2.125 c 0.04687,0.3125 0.04687,0.4375 0.04687,0.75 0.01563,0.421875 0.01563,0.75 0.01563,1 v 3.953125 h 1.484375 v -2.65625 c 0,-1.265625 0.359375,-1.875 1.140625,-1.875 0.3125,0 0.609375,0.109375 0.875,0.28125 v -1.5 c -0.234375,-0.0625 -0.28125,-0.0625 -0.4375,-0.0625 -0.6875,0 -1.1875,0.375 -1.640625,1.296875 0.01563,-0.125 0.01563,-0.234375 0.01563,-0.296875 0,-0.328125 -0.04687,-0.640625 -0.109375,-0.890625 z m 0,0 m -1.164435,3.203125 v -0.28125 c 0,-1.90625 -0.984375,-3.078125 -2.59375,-3.078125 -1.671875,0 -2.78125,1.234375 -2.78125,3.078125 0,1.796875 1.09375,2.9375 2.828125,2.9375 1.25,0 2.1875,-0.671875 2.4375,-1.765625 l -1.296875,-0.0625 c -0.203125,0.4375 -0.5625,0.640625 -1.109375,0.640625 -0.828125,0 -1.328125,-0.53125 -1.375,-1.46875 z m -3.859375,-1.078125 c 0.1875,-0.765625 0.609375,-1.140625 1.25,-1.140625 0.640625,0 1,0.375 1.125,1.140625 z m 0,0 m -7.6817,-4.46875 v 6.546875 c 0,0.953125 0,1.125 -0.03125,1.5 h 1.265625 c 0.0625,-0.234375 0.09375,-0.390625 0.109375,-0.765625 0.3125,0.59375 0.8125,0.890625 1.53125,0.890625 1.453125,0 2.484375,-1.234375 2.484375,-2.984375 0,-1.71875 -0.96875,-2.953125 -2.3125,-2.953125 -0.65625,0 -1.109375,0.234375 -1.5625,0.828125 v -3.0625 z m 2.6875,3.46875 c 0.71875,0 1.15625,0.640625 1.15625,1.703125 0,1.078125 -0.46875,1.765625 -1.203125,1.765625 -0.71875,0 -1.15625,-0.671875 -1.15625,-1.71875 0,-1.109375 0.453125,-1.75 1.203125,-1.75 z m 0,0 m -6.71326,-1.28125 c -1.625,0 -2.828125,1.265625 -2.828125,2.96875 0,1.796875 1.15625,3.046875 2.828125,3.046875 1.625,0 2.8125,-1.265625 2.8125,-3 0,-1.75 -1.1875,-3.015625 -2.8125,-3.015625 z m 0,1.1875 c 0.765625,0 1.296875,0.75 1.296875,1.8125 0,1.078125 -0.53125,1.828125 -1.296875,1.828125 -0.796875,0 -1.3125,-0.734375 -1.3125,-1.84375 0,-1.046875 0.546875,-1.796875 1.3125,-1.796875 z m 0,0 m -4.927675,-1.03125 -2.09375,2.671875 2.078125,3.03125 h 1.984375 l -2.328125,-3.0625 2.125,-2.640625 z m -3.59375,-2.34375 v 8.046875 h 1.46875 v -8.046875 z m 0,0 m -3.13201,2.34375 v 5.703125 h 1.46875 v -5.703125 z m 0.765625,-2.453125 c -0.53125,0 -0.890625,0.34375 -0.890625,0.875 0,0.515625 0.34375,0.84375 0.875,0.84375 0.515625,0 0.84375,-0.34375 0.84375,-0.875 0,-0.5 -0.328125,-0.84375 -0.828125,-0.84375 z m 0,0 m -2.148135,4.1875 c -0.07813,-1.203125 -0.921875,-1.90625 -2.3125,-1.90625 -1.374995,0 -2.281245,0.75 -2.281245,1.859375 0,0.40625 0.14062,0.78125 0.39062,1.03125 0.23438,0.21875 0.5625,0.375 1.1875,0.578125 1.015625,0.296875 1.015625,0.296875 1.1875,0.375 0.296875,0.125 0.390625,0.25 0.390625,0.453125 0,0.375 -0.34375,0.625 -0.90625,0.625 -0.703125,0 -1.03125,-0.28125 -1.078125,-0.953125 h -1.39062 c 0,1.359375 0.85937,2.0625 2.531245,2.0625 1.46875,0 2.3125,-0.6875 2.3125,-1.84375 0,-0.375 -0.109375,-0.71875 -0.328125,-0.96875 -0.234375,-0.28125 -0.59375,-0.46875 -1.4375,-0.71875 -0.875,-0.25 -0.984375,-0.28125 -1.15625,-0.390625 -0.15625,-0.09375 -0.234375,-0.25 -0.234375,-0.40625 0,-0.34375 0.328125,-0.59375 0.78125,-0.59375 0.5625,0 0.84375,0.25 0.921875,0.796875 z m 0,0 m -7.569465,-1.734375 v 5.703125 h 1.46875 v -5.703125 z m 0.76563,-2.453125 c -0.53125,0 -0.89063,0.34375 -0.89063,0.875 0,0.515625 0.34375,0.84375 0.875,0.84375 0.51563,0 0.84375,-0.34375 0.84375,-0.875 0,-0.5 -0.32812,-0.84375 -0.82812,-0.84375 z m 0,0 m -7.72065,0.15625 v 8 h 1.54688 v -3.0625 h 1.09375 l 1.64062,3.0625 h 1.78125 l -1.82812,-3.328125 c 0.9375,-0.421875 1.40625,-1.171875 1.40625,-2.21875 0,-0.921875 -0.40625,-1.6875 -1.14063,-2.078125 -0.54687,-0.296875 -1.07812,-0.375 -2.5,-0.375 z m 1.54688,3.625 v -2.328125 h 0.4375 c 1.04687,0 1.26562,0.03125 1.57812,0.21875 0.32813,0.1875 0.51563,0.515625 0.51563,0.921875 0,0.515625 -0.25,0.90625 -0.67188,1.0625 -0.29687,0.109375 -0.5625,0.125 -1.3125,0.125 z m 0,0 m -5.91436,1.875 v -0.28125 c 0,-1.90625 -0.98438,-3.078125 -2.59375,-3.078125 -1.67188,0 -2.78125,1.234375 -2.78125,3.078125 0,1.796875 1.09375,2.9375 2.82812,2.9375 1.25,0 2.1875,-0.671875 2.4375,-1.765625 l -1.29687,-0.0625 c -0.20313,0.4375 -0.5625,0.640625 -1.10938,0.640625 -0.82812,0 -1.32812,-0.53125 -1.375,-1.46875 z m -3.85938,-1.078125 c 0.1875,-0.765625 0.60938,-1.140625 1.25,-1.140625 0.64063,0 1,0.375 1.125,1.140625 z m 0,0 m -7.73815,-4.46875 v 8.046875 h 1.46875 v -2.921875 c 0,-0.484375 0.0625,-0.78125 0.15625,-1 0.20312,-0.375 0.57812,-0.609375 0.98437,-0.609375 0.35938,0 0.67188,0.1875 0.82813,0.515625 0.10937,0.21875 0.14062,0.484375 0.14062,1.046875 v 2.96875 h 1.46875 v -3.28125 c 0,-1.03125 -0.0625,-1.375 -0.28125,-1.75 -0.3125,-0.484375 -0.95312,-0.78125 -1.64062,-0.78125 -0.67188,0 -1.20313,0.25 -1.65625,0.734375 v -2.96875 z m 0,0 m -4.04139,2.1875 c -1.625,0 -2.82812,1.265625 -2.82812,2.96875 0,1.796875 1.15625,3.046875 2.82812,3.046875 1.625,0 2.8125,-1.265625 2.8125,-3 0,-1.75 -1.1875,-3.015625 -2.8125,-3.015625 z m 0,1.1875 c 0.76563,0 1.29688,0.75 1.29688,1.8125 0,1.078125 -0.53125,1.828125 -1.29688,1.828125 -0.79687,0 -1.3125,-0.734375 -1.3125,-1.84375 0,-1.046875 0.54688,-1.796875 1.3125,-1.796875 z m 0,0 m -8.89075,-0.140625 v -3.1875 h -1.54687 v 8 h 1.54687 v -3.546875 h 3.17188 v 3.546875 h 1.54687 v -8 h -1.54687 v 3.1875 z m 0,0"
              />
            </g>
          </g>
        )}
        <g
          className="bar-top"
          clipPath="url(#clip3)"
          clipRule="nonzero"
          id="bar-top-66"
        >
          <g clipPath="url(#clip4)" clipRule="nonzero" id="g6276">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00096875 -0.000625 L 0.475594 -483.762344 L 0.143563 -483.762344 L -0.333 -0.000625 Z M -0.00096875 -0.000625 "
              transform="matrix(1,0,0,-1,638.1455,-81.36)"
              id="path6274"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00096875 -0.000625 L 0.475594 -483.762344 L 0.143563 -483.762344 L -0.333 -0.000625 Z M -0.00096875 -0.000625 "
              transform="matrix(1,0,0,-1,638.1455,-81.36)"
              id="path6274"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip7)"
          clipRule="nonzero"
          id="bar-top-67"
        >
          <g clipPath="url(#clip8)" clipRule="nonzero" id="g6288">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00048125 -0.000625 L 0.477044 -483.762344 L 0.141106 -483.762344 L -0.335456 -0.000625 Z M 0.00048125 -0.000625 "
              transform="matrix(1,0,0,-1,647.3628,-81.36)"
              id="path6286"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00048125 -0.000625 L 0.477044 -483.762344 L 0.141106 -483.762344 L -0.335456 -0.000625 Z M 0.00048125 -0.000625 "
              transform="matrix(1,0,0,-1,647.3628,-81.36)"
              id="path6286"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip11)"
          clipRule="nonzero"
          id="bar-top-68"
        >
          <g clipPath="url(#clip12)" clipRule="nonzero" id="g6300">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.001475 -0.000625 L 0.475087 -483.762344 L 0.143056 -483.762344 L -0.333506 -0.000625 Z M -0.001475 -0.000625 "
              transform="matrix(1,0,0,-1,656.5796,-81.36)"
              id="path6298"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.001475 -0.000625 L 0.475087 -483.762344 L 0.143056 -483.762344 L -0.333506 -0.000625 Z M -0.001475 -0.000625 "
              transform="matrix(1,0,0,-1,656.5796,-81.36)"
              id="path6298"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip15)"
          clipRule="nonzero"
          id="bar-top-69"
        >
          <g clipPath="url(#clip16)" clipRule="nonzero" id="g6312">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.000475 -0.000625 L 0.477037 -483.762344 L 0.1411 -483.762344 L -0.331556 -0.000625 Z M 0.000475 -0.000625 "
              transform="matrix(1,0,0,-1,665.7964,-81.36)"
              id="path6310"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.000475 -0.000625 L 0.477037 -483.762344 L 0.1411 -483.762344 L -0.331556 -0.000625 Z M 0.000475 -0.000625 "
              transform="matrix(1,0,0,-1,665.7964,-81.36)"
              id="path6310"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip19)"
          clipRule="nonzero"
          id="bar-top-70"
        >
          <g clipPath="url(#clip20)" clipRule="nonzero" id="g6324">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.001925 -0.000625 L 0.474581 -483.762344 L 0.14255 -483.762344 L -0.334013 -0.000625 Z M 0.001925 -0.000625 "
              transform="matrix(1,0,0,-1,675.0137,-81.36)"
              id="path6322"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.001925 -0.000625 L 0.474581 -483.762344 L 0.14255 -483.762344 L -0.334013 -0.000625 Z M 0.001925 -0.000625 "
              transform="matrix(1,0,0,-1,675.0137,-81.36)"
              id="path6322"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip23)"
          clipRule="nonzero"
          id="bar-top-71"
        >
          <g clipPath="url(#clip24)" clipRule="nonzero" id="g6336">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00003125 -0.000625 L 0.476531 -483.762344 L 0.1445 -483.762344 L -0.332063 -0.000625 Z M -0.00003125 -0.000625 "
              transform="matrix(1,0,0,-1,684.2305,-81.36)"
              id="path6334"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00003125 -0.000625 L 0.476531 -483.762344 L 0.1445 -483.762344 L -0.332063 -0.000625 Z M -0.00003125 -0.000625 "
              transform="matrix(1,0,0,-1,684.2305,-81.36)"
              id="path6334"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip27)"
          clipRule="nonzero"
          id="bar-top-72"
        >
          <g clipPath="url(#clip28)" clipRule="nonzero" id="g6348">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00141875 -0.000625 L 0.474075 -483.762344 L 0.142044 -483.762344 L -0.334519 -0.000625 Z M 0.00141875 -0.000625 "
              transform="matrix(1,0,0,-1,693.4478,-81.36)"
              id="path6346"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00141875 -0.000625 L 0.474075 -483.762344 L 0.142044 -483.762344 L -0.334519 -0.000625 Z M 0.00141875 -0.000625 "
              transform="matrix(1,0,0,-1,693.4478,-81.36)"
              id="path6346"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip31)"
          clipRule="nonzero"
          id="bar-top-73"
        >
          <g clipPath="url(#clip32)" clipRule="nonzero" id="g6360">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0005375 -0.000625 L 0.476025 -483.762344 L 0.143994 -483.762344 L -0.332569 -0.000625 Z M -0.0005375 -0.000625 "
              transform="matrix(1,0,0,-1,702.6646,-81.36)"
              id="path6358"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0005375 -0.000625 L 0.476025 -483.762344 L 0.143994 -483.762344 L -0.332569 -0.000625 Z M -0.0005375 -0.000625 "
              transform="matrix(1,0,0,-1,702.6646,-81.36)"
              id="path6358"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip35)"
          clipRule="nonzero"
          id="bar-top-74"
        >
          <g clipPath="url(#clip36)" clipRule="nonzero" id="g6372">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0015125 -0.000625 L 0.474169 -483.762344 L 0.142137 -483.762344 L -0.334425 -0.000625 Z M 0.0015125 -0.000625 "
              transform="matrix(1,0,0,-1,711.8813,-81.36)"
              id="path6370"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0015125 -0.000625 L 0.474169 -483.762344 L 0.142137 -483.762344 L -0.334425 -0.000625 Z M 0.0015125 -0.000625 "
              transform="matrix(1,0,0,-1,711.8813,-81.36)"
              id="path6370"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip39)"
          clipRule="nonzero"
          id="bar-top-75"
        >
          <g clipPath="url(#clip40)" clipRule="nonzero" id="g6384">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00094375 -0.000625 L 0.475619 -483.762344 L 0.143587 -483.762344 L -0.332975 -0.000625 Z M -0.00094375 -0.000625 "
              transform="matrix(1,0,0,-1,721.0986,-81.36)"
              id="path6382"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00094375 -0.000625 L 0.475619 -483.762344 L 0.143587 -483.762344 L -0.332975 -0.000625 Z M -0.00094375 -0.000625 "
              transform="matrix(1,0,0,-1,721.0986,-81.36)"
              id="path6382"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip43)"
          clipRule="nonzero"
          id="bar-top-76"
        >
          <g clipPath="url(#clip44)" clipRule="nonzero" id="g6396">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00050625 -0.000625 L 0.477069 -483.762344 L 0.141131 -483.762344 L -0.335431 -0.000625 Z M 0.00050625 -0.000625 "
              transform="matrix(1,0,0,-1,730.3159,-81.36)"
              id="path6394"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00050625 -0.000625 L 0.477069 -483.762344 L 0.141131 -483.762344 L -0.335431 -0.000625 Z M 0.00050625 -0.000625 "
              transform="matrix(1,0,0,-1,730.3159,-81.36)"
              id="path6394"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip47)"
          clipRule="nonzero"
          id="bar-top-77"
        >
          <g clipPath="url(#clip48)" clipRule="nonzero" id="g6408">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00095 -0.000625 L 0.475613 -483.762344 L 0.143581 -483.762344 L -0.332981 -0.000625 Z M -0.00095 -0.000625 "
              transform="matrix(1,0,0,-1,739.5322,-81.36)"
              id="path6406"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00095 -0.000625 L 0.475613 -483.762344 L 0.143581 -483.762344 L -0.332981 -0.000625 Z M -0.00095 -0.000625 "
              transform="matrix(1,0,0,-1,739.5322,-81.36)"
              id="path6406"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip51)"
          clipRule="nonzero"
          id="bar-top-78"
        >
          <g clipPath="url(#clip52)" clipRule="nonzero" id="g6420">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0005 -0.000625 L 0.477062 -483.762344 L 0.141125 -483.762344 L -0.331531 -0.000625 Z M 0.0005 -0.000625 "
              transform="matrix(1,0,0,-1,748.7495,-81.36)"
              id="path6418"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0005 -0.000625 L 0.477062 -483.762344 L 0.141125 -483.762344 L -0.331531 -0.000625 Z M 0.0005 -0.000625 "
              transform="matrix(1,0,0,-1,748.7495,-81.36)"
              id="path6418"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip55)"
          clipRule="nonzero"
          id="bar-top-79"
        >
          <g clipPath="url(#clip56)" clipRule="nonzero" id="g6432">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00195 -0.000625 L 0.474606 -483.762344 L 0.142575 -483.762344 L -0.333987 -0.000625 Z M 0.00195 -0.000625 "
              transform="matrix(1,0,0,-1,757.9668,-81.36)"
              id="path6430"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00195 -0.000625 L 0.474606 -483.762344 L 0.142575 -483.762344 L -0.333987 -0.000625 Z M 0.00195 -0.000625 "
              transform="matrix(1,0,0,-1,757.9668,-81.36)"
              id="path6430"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip59)"
          clipRule="nonzero"
          id="bar-top-80"
        >
          <g clipPath="url(#clip60)" clipRule="nonzero" id="g6444">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00000625 -0.000625 L 0.476556 -483.762344 L 0.140619 -483.762344 L -0.332038 -0.000625 Z M -0.00000625 -0.000625 "
              transform="matrix(1,0,0,-1,767.1836,-81.36)"
              id="path6442"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00000625 -0.000625 L 0.476556 -483.762344 L 0.140619 -483.762344 L -0.332038 -0.000625 Z M -0.00000625 -0.000625 "
              transform="matrix(1,0,0,-1,767.1836,-81.36)"
              id="path6442"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip63)"
          clipRule="nonzero"
          id="bar-top-81"
        >
          <g clipPath="url(#clip64)" clipRule="nonzero" id="g6456">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00194375 -0.000625 L 0.4746 -483.762344 L 0.142569 -483.762344 L -0.333994 -0.000625 Z M 0.00194375 -0.000625 "
              transform="matrix(1,0,0,-1,776.4004,-81.36)"
              id="path6454"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00194375 -0.000625 L 0.4746 -483.762344 L 0.142569 -483.762344 L -0.333994 -0.000625 Z M 0.00194375 -0.000625 "
              transform="matrix(1,0,0,-1,776.4004,-81.36)"
              id="path6454"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip67)"
          clipRule="nonzero"
          id="bar-top-82"
        >
          <g clipPath="url(#clip68)" clipRule="nonzero" id="g6468">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0000125 -0.000625 L 0.47655 -483.762344 L 0.144519 -483.762344 L -0.332044 -0.000625 Z M -0.0000125 -0.000625 "
              transform="matrix(1,0,0,-1,785.6172,-81.36)"
              id="path6466"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0000125 -0.000625 L 0.47655 -483.762344 L 0.144519 -483.762344 L -0.332044 -0.000625 Z M -0.0000125 -0.000625 "
              transform="matrix(1,0,0,-1,785.6172,-81.36)"
              id="path6466"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip71)"
          clipRule="nonzero"
          id="bar-top-83"
        >
          <g clipPath="url(#clip72)" clipRule="nonzero" id="g6480">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0014375 -0.000625 L 0.474094 -483.762344 L 0.142063 -483.762344 L -0.3345 -0.000625 Z M 0.0014375 -0.000625 "
              transform="matrix(1,0,0,-1,794.8345,-81.36)"
              id="path6478"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0014375 -0.000625 L 0.474094 -483.762344 L 0.142063 -483.762344 L -0.3345 -0.000625 Z M 0.0014375 -0.000625 "
              transform="matrix(1,0,0,-1,794.8345,-81.36)"
              id="path6478"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip75)"
          clipRule="nonzero"
          id="bar-top-84"
        >
          <g clipPath="url(#clip76)" clipRule="nonzero" id="g6492">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00101875 -0.000625 L 0.475544 -483.762344 L 0.143513 -483.762344 L -0.33305 -0.000625 Z M -0.00101875 -0.000625 "
              transform="matrix(1,0,0,-1,804.0518,-81.36)"
              id="path6490"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00101875 -0.000625 L 0.475544 -483.762344 L 0.143513 -483.762344 L -0.33305 -0.000625 Z M -0.00101875 -0.000625 "
              transform="matrix(1,0,0,-1,804.0518,-81.36)"
              id="path6490"
            />
          </g>
        </g>
        <g clipPath="url(#clip77)" clipRule="nonzero" id="g6500">
          <g clipPath="url(#clip78)" clipRule="nonzero" id="g6498">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00093125 -0.000625 L 0.477494 -483.762344 L 0.141556 -483.762344 L -0.3311 -0.000625 Z M 0.00093125 -0.000625 "
              transform="matrix(1,0,0,-1,813.2686,-81.36)"
              id="path6496"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip81)"
          clipRule="nonzero"
          id="bar-top-43"
        >
          <g clipPath="url(#clip82)" clipRule="nonzero" id="g6510">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00194375 -0.000625 L 0.478525 -483.762344 L 0.142588 -483.762344 L -0.333975 -0.000625 Z M -0.00194375 -0.000625 "
              transform="matrix(1,0,0,-1,425.7871,-81.36)"
              id="path6508"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00194375 -0.000625 L 0.478525 -483.762344 L 0.142588 -483.762344 L -0.333975 -0.000625 Z M -0.00194375 -0.000625 "
              transform="matrix(1,0,0,-1,425.7871,-81.36)"
              id="path6508"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip85)"
          clipRule="nonzero"
          id="bar-top-44"
        >
          <g clipPath="url(#clip86)" clipRule="nonzero" id="g6522">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00049375 -0.000625 L 0.476069 -483.762344 L 0.144037 -483.762344 L -0.332525 -0.000625 Z M -0.00049375 -0.000625 "
              transform="matrix(1,0,0,-1,435.0044,-81.36)"
              id="path6520"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00049375 -0.000625 L 0.476069 -483.762344 L 0.144037 -483.762344 L -0.332525 -0.000625 Z M -0.00049375 -0.000625 "
              transform="matrix(1,0,0,-1,435.0044,-81.36)"
              id="path6520"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip89)"
          clipRule="nonzero"
          id="bar-top-45"
        >
          <g clipPath="url(#clip90)" clipRule="nonzero" id="g6534">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00095625 -0.000625 L 0.477519 -483.762344 L 0.141581 -483.762344 L -0.331075 -0.000625 Z M 0.00095625 -0.000625 "
              transform="matrix(1,0,0,-1,444.2217,-81.36)"
              id="path6532"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00095625 -0.000625 L 0.477519 -483.762344 L 0.141581 -483.762344 L -0.331075 -0.000625 Z M 0.00095625 -0.000625 "
              transform="matrix(1,0,0,-1,444.2217,-81.36)"
              id="path6532"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip93)"
          clipRule="nonzero"
          id="bar-top-46"
        >
          <g clipPath="url(#clip94)" clipRule="nonzero" id="g6546">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.001 -0.000625 L 0.475563 -483.762344 L 0.143531 -483.762344 L -0.333031 -0.000625 Z M -0.001 -0.000625 "
              transform="matrix(1,0,0,-1,453.4385,-81.36)"
              id="path6544"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.001 -0.000625 L 0.475563 -483.762344 L 0.143531 -483.762344 L -0.333031 -0.000625 Z M -0.001 -0.000625 "
              transform="matrix(1,0,0,-1,453.4385,-81.36)"
              id="path6544"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip97)"
          clipRule="nonzero"
          id="bar-top-47"
        >
          <g clipPath="url(#clip98)" clipRule="nonzero" id="g6558">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00095 -0.000625 L 0.477512 -483.762344 L 0.141575 -483.762344 L -0.331081 -0.000625 Z M 0.00095 -0.000625 "
              transform="matrix(1,0,0,-1,462.6553,-81.36)"
              id="path6556"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00095 -0.000625 L 0.477512 -483.762344 L 0.141575 -483.762344 L -0.331081 -0.000625 Z M 0.00095 -0.000625 "
              transform="matrix(1,0,0,-1,462.6553,-81.36)"
              id="path6556"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip101)"
          clipRule="nonzero"
          id="bar-top-48"
        >
          <g clipPath="url(#clip102)" clipRule="nonzero" id="g6570">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00150625 -0.000625 L 0.475056 -483.762344 L 0.143025 -483.762344 L -0.333538 -0.000625 Z M -0.00150625 -0.000625 "
              transform="matrix(1,0,0,-1,471.8726,-81.36)"
              id="path6568"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00150625 -0.000625 L 0.475056 -483.762344 L 0.143025 -483.762344 L -0.333538 -0.000625 Z M -0.00150625 -0.000625 "
              transform="matrix(1,0,0,-1,471.8726,-81.36)"
              id="path6568"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip105)"
          clipRule="nonzero"
          id="bar-top-49"
        >
          <g clipPath="url(#clip106)" clipRule="nonzero" id="g6582">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00044375 -0.000625 L 0.477006 -483.762344 L 0.141069 -483.762344 L -0.331588 -0.000625 Z M 0.00044375 -0.000625 "
              transform="matrix(1,0,0,-1,481.0894,-81.36)"
              id="path6580"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00044375 -0.000625 L 0.477006 -483.762344 L 0.141069 -483.762344 L -0.331588 -0.000625 Z M 0.00044375 -0.000625 "
              transform="matrix(1,0,0,-1,481.0894,-81.36)"
              id="path6580"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip109)"
          clipRule="nonzero"
          id="bar-top-50"
        >
          <g clipPath="url(#clip110)" clipRule="nonzero" id="g6594">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0019125 -0.000625 L 0.47465 -483.762344 L 0.142619 -483.762344 L -0.333944 -0.000625 Z M -0.0019125 -0.000625 "
              transform="matrix(1,0,0,-1,490.3066,-81.36)"
              id="path6592"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0019125 -0.000625 L 0.47465 -483.762344 L 0.142619 -483.762344 L -0.333944 -0.000625 Z M -0.0019125 -0.000625 "
              transform="matrix(1,0,0,-1,490.3066,-81.36)"
              id="path6592"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip113)"
          clipRule="nonzero"
          id="bar-top-51"
        >
          <g clipPath="url(#clip114)" clipRule="nonzero" id="g6606">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0000375 -0.000625 L 0.4766 -483.762344 L 0.144569 -483.762344 L -0.331994 -0.000625 Z M 0.0000375 -0.000625 "
              transform="matrix(1,0,0,-1,499.5234,-81.36)"
              id="path6604"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0000375 -0.000625 L 0.4766 -483.762344 L 0.144569 -483.762344 L -0.331994 -0.000625 Z M 0.0000375 -0.000625 "
              transform="matrix(1,0,0,-1,499.5234,-81.36)"
              id="path6604"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip117)"
          clipRule="nonzero"
          id="bar-top-52"
        >
          <g clipPath="url(#clip118)" clipRule="nonzero" id="g6618">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00191875 -0.000625 L 0.474644 -483.762344 L 0.142612 -483.762344 L -0.33395 -0.000625 Z M -0.00191875 -0.000625 "
              transform="matrix(1,0,0,-1,508.7402,-81.36)"
              id="path6616"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00191875 -0.000625 L 0.474644 -483.762344 L 0.142612 -483.762344 L -0.33395 -0.000625 Z M -0.00191875 -0.000625 "
              transform="matrix(1,0,0,-1,508.7402,-81.36)"
              id="path6616"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip121)"
          clipRule="nonzero"
          id="bar-top-53"
        >
          <g clipPath="url(#clip122)" clipRule="nonzero" id="g6630">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00046875 -0.000625 L 0.476094 -483.762344 L 0.144063 -483.762344 L -0.3325 -0.000625 Z M -0.00046875 -0.000625 "
              transform="matrix(1,0,0,-1,517.9575,-81.36)"
              id="path6628"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00046875 -0.000625 L 0.476094 -483.762344 L 0.144063 -483.762344 L -0.3325 -0.000625 Z M -0.00046875 -0.000625 "
              transform="matrix(1,0,0,-1,517.9575,-81.36)"
              id="path6628"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip125)"
          clipRule="nonzero"
          id="bar-top-54"
        >
          <g clipPath="url(#clip126)" clipRule="nonzero" id="g6642">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00148125 -0.000625 L 0.474137 -483.762344 L 0.142106 -483.762344 L -0.334456 -0.000625 Z M 0.00148125 -0.000625 "
              transform="matrix(1,0,0,-1,527.1743,-81.36)"
              id="path6640"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00148125 -0.000625 L 0.474137 -483.762344 L 0.142106 -483.762344 L -0.334456 -0.000625 Z M 0.00148125 -0.000625 "
              transform="matrix(1,0,0,-1,527.1743,-81.36)"
              id="path6640"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip129)"
          clipRule="nonzero"
          id="bar-top-55"
        >
          <g clipPath="url(#clip130)" clipRule="nonzero" id="g6654">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.000975 -0.000625 L 0.475588 -483.762344 L 0.143556 -483.762344 L -0.333006 -0.000625 Z M -0.000975 -0.000625 "
              transform="matrix(1,0,0,-1,536.3916,-81.36)"
              id="path6652"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.000975 -0.000625 L 0.475588 -483.762344 L 0.143556 -483.762344 L -0.333006 -0.000625 Z M -0.000975 -0.000625 "
              transform="matrix(1,0,0,-1,536.3916,-81.36)"
              id="path6652"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip133)"
          clipRule="nonzero"
          id="bar-top-56"
        >
          <g clipPath="url(#clip134)" clipRule="nonzero" id="g6666">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.000975 -0.000625 L 0.477537 -483.762344 L 0.1416 -483.762344 L -0.331056 -0.000625 Z M 0.000975 -0.000625 "
              transform="matrix(1,0,0,-1,545.6084,-81.36)"
              id="path6664"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.000975 -0.000625 L 0.477537 -483.762344 L 0.1416 -483.762344 L -0.331056 -0.000625 Z M 0.000975 -0.000625 "
              transform="matrix(1,0,0,-1,545.6084,-81.36)"
              id="path6664"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip137)"
          clipRule="nonzero"
          id="bar-top-57"
        >
          <g clipPath="url(#clip138)" clipRule="nonzero" id="g6678">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00148125 -0.000625 L 0.475081 -483.762344 L 0.14305 -483.762344 L -0.333512 -0.000625 Z M -0.00148125 -0.000625 "
              transform="matrix(1,0,0,-1,554.8257,-81.36)"
              id="path6676"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00148125 -0.000625 L 0.475081 -483.762344 L 0.14305 -483.762344 L -0.333512 -0.000625 Z M -0.00148125 -0.000625 "
              transform="matrix(1,0,0,-1,554.8257,-81.36)"
              id="path6676"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip141)"
          clipRule="nonzero"
          id="bar-top-58"
        >
          <g clipPath="url(#clip142)" clipRule="nonzero" id="g6690">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00046875 -0.000625 L 0.477031 -483.762344 L 0.141094 -483.762344 L -0.331562 -0.000625 Z M 0.00046875 -0.000625 "
              transform="matrix(1,0,0,-1,564.0425,-81.36)"
              id="path6688"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00046875 -0.000625 L 0.477031 -483.762344 L 0.141094 -483.762344 L -0.331562 -0.000625 Z M 0.00046875 -0.000625 "
              transform="matrix(1,0,0,-1,564.0425,-81.36)"
              id="path6688"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip145)"
          clipRule="nonzero"
          id="bar-top-59"
        >
          <g clipPath="url(#clip146)" clipRule="nonzero" id="g6702">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00191875 -0.000625 L 0.474575 -483.762344 L 0.142544 -483.762344 L -0.334019 -0.000625 Z M 0.00191875 -0.000625 "
              transform="matrix(1,0,0,-1,573.2598,-81.36)"
              id="path6700"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00191875 -0.000625 L 0.474575 -483.762344 L 0.142544 -483.762344 L -0.334019 -0.000625 Z M 0.00191875 -0.000625 "
              transform="matrix(1,0,0,-1,573.2598,-81.36)"
              id="path6700"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip149)"
          clipRule="nonzero"
          id="bar-top-60"
        >
          <g clipPath="url(#clip150)" clipRule="nonzero" id="g6714">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0000375 -0.000625 L 0.476525 -483.762344 L 0.144494 -483.762344 L -0.332069 -0.000625 Z M -0.0000375 -0.000625 "
              transform="matrix(1,0,0,-1,582.4766,-81.36)"
              id="path6712"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0000375 -0.000625 L 0.476525 -483.762344 L 0.144494 -483.762344 L -0.332069 -0.000625 Z M -0.0000375 -0.000625 "
              transform="matrix(1,0,0,-1,582.4766,-81.36)"
              id="path6712"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip153)"
          clipRule="nonzero"
          id="bar-top-61"
        >
          <g clipPath="url(#clip154)" clipRule="nonzero" id="g6726">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0019125 -0.000625 L 0.474569 -483.762344 L 0.142537 -483.762344 L -0.334025 -0.000625 Z M 0.0019125 -0.000625 "
              transform="matrix(1,0,0,-1,591.6934,-81.36)"
              id="path6724"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0019125 -0.000625 L 0.474569 -483.762344 L 0.142537 -483.762344 L -0.334025 -0.000625 Z M 0.0019125 -0.000625 "
              transform="matrix(1,0,0,-1,591.6934,-81.36)"
              id="path6724"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip157)"
          clipRule="nonzero"
          id="bar-top-62"
        >
          <g clipPath="url(#clip158)" clipRule="nonzero" id="g6738">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00044375 -0.000625 L 0.476119 -483.762344 L 0.144088 -483.762344 L -0.332475 -0.000625 Z M -0.00044375 -0.000625 "
              transform="matrix(1,0,0,-1,600.9106,-81.36)"
              id="path6736"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00044375 -0.000625 L 0.476119 -483.762344 L 0.144088 -483.762344 L -0.332475 -0.000625 Z M -0.00044375 -0.000625 "
              transform="matrix(1,0,0,-1,600.9106,-81.36)"
              id="path6736"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip161)"
          clipRule="nonzero"
          id="bar-top-63"
        >
          <g clipPath="url(#clip162)" clipRule="nonzero" id="g6750">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00150625 -0.000625 L 0.474163 -483.762344 L 0.142131 -483.762344 L -0.334431 -0.000625 Z M 0.00150625 -0.000625 "
              transform="matrix(1,0,0,-1,610.1274,-81.36)"
              id="path6748"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00150625 -0.000625 L 0.474163 -483.762344 L 0.142131 -483.762344 L -0.334431 -0.000625 Z M 0.00150625 -0.000625 "
              transform="matrix(1,0,0,-1,610.1274,-81.36)"
              id="path6748"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip165)"
          clipRule="nonzero"
          id="bar-top-64"
        >
          <g clipPath="url(#clip166)" clipRule="nonzero" id="g6762">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00045 -0.000625 L 0.476113 -483.762344 L 0.144081 -483.762344 L -0.332481 -0.000625 Z M -0.00045 -0.000625 "
              transform="matrix(1,0,0,-1,619.3442,-81.36)"
              id="path6760"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00045 -0.000625 L 0.476113 -483.762344 L 0.144081 -483.762344 L -0.332481 -0.000625 Z M -0.00045 -0.000625 "
              transform="matrix(1,0,0,-1,619.3442,-81.36)"
              id="path6760"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip169)"
          clipRule="nonzero"
          id="bar-top-65"
        >
          <g clipPath="url(#clip170)" clipRule="nonzero" id="g6774">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.001 -0.000625 L 0.477563 -483.762344 L 0.141625 -483.762344 L -0.334937 -0.000625 Z M 0.001 -0.000625 "
              transform="matrix(1,0,0,-1,628.5615,-81.36)"
              id="path6772"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.001 -0.000625 L 0.477563 -483.762344 L 0.141625 -483.762344 L -0.334937 -0.000625 Z M 0.001 -0.000625 "
              transform="matrix(1,0,0,-1,628.5615,-81.36)"
              id="path6772"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip173)"
          clipRule="nonzero"
          id="bar-top-20"
        >
          <g clipPath="url(#clip174)" clipRule="nonzero" id="g6786">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0000125 -0.000625 L 0.47655 -483.762344 L 0.140613 -483.762344 L -0.332044 -0.000625 Z M -0.0000125 -0.000625 "
              transform="matrix(1,0,0,-1,213.4297,-81.36)"
              id="path6784"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0000125 -0.000625 L 0.47655 -483.762344 L 0.140613 -483.762344 L -0.332044 -0.000625 Z M -0.0000125 -0.000625 "
              transform="matrix(1,0,0,-1,213.4297,-81.36)"
              id="path6784"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip177)"
          clipRule="nonzero"
          id="bar-top-21"
        >
          <g clipPath="url(#clip178)" clipRule="nonzero" id="g6798">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0019375 -0.000625 L 0.474594 -483.762344 L 0.142563 -483.762344 L -0.334 -0.000625 Z M 0.0019375 -0.000625 "
              transform="matrix(1,0,0,-1,222.6465,-81.36)"
              id="path6796"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0019375 -0.000625 L 0.474594 -483.762344 L 0.142563 -483.762344 L -0.334 -0.000625 Z M 0.0019375 -0.000625 "
              transform="matrix(1,0,0,-1,222.6465,-81.36)"
              id="path6796"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip181)"
          clipRule="nonzero"
          id="bar-top-22"
        >
          <g clipPath="url(#clip182)" clipRule="nonzero" id="g6810">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00051875 -0.000625 L 0.476044 -483.762344 L 0.144013 -483.762344 L -0.33255 -0.000625 Z M -0.00051875 -0.000625 "
              transform="matrix(1,0,0,-1,231.8638,-81.36)"
              id="path6808"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00051875 -0.000625 L 0.476044 -483.762344 L 0.144013 -483.762344 L -0.33255 -0.000625 Z M -0.00051875 -0.000625 "
              transform="matrix(1,0,0,-1,231.8638,-81.36)"
              id="path6808"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip185)"
          clipRule="nonzero"
          id="bar-top-23"
        >
          <g clipPath="url(#clip186)" clipRule="nonzero" id="g6822">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00143125 -0.000625 L 0.474087 -483.762344 L 0.142056 -483.762344 L -0.334506 -0.000625 Z M 0.00143125 -0.000625 "
              transform="matrix(1,0,0,-1,241.0806,-81.36)"
              id="path6820"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00143125 -0.000625 L 0.474087 -483.762344 L 0.142056 -483.762344 L -0.334506 -0.000625 Z M 0.00143125 -0.000625 "
              transform="matrix(1,0,0,-1,241.0806,-81.36)"
              id="path6820"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip189)"
          clipRule="nonzero"
          id="bar-top-24"
        >
          <g clipPath="url(#clip190)" clipRule="nonzero" id="g6834">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.001025 -0.000625 L 0.475538 -483.762344 L 0.143506 -483.762344 L -0.333056 -0.000625 Z M -0.001025 -0.000625 "
              transform="matrix(1,0,0,-1,250.2979,-81.36)"
              id="path6832"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.001025 -0.000625 L 0.475538 -483.762344 L 0.143506 -483.762344 L -0.333056 -0.000625 Z M -0.001025 -0.000625 "
              transform="matrix(1,0,0,-1,250.2979,-81.36)"
              id="path6832"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip193)"
          clipRule="nonzero"
          id="bar-top-25"
        >
          <g clipPath="url(#clip194)" clipRule="nonzero" id="g6846">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.001025 -0.000625 L 0.477587 -483.762344 L 0.14165 -483.762344 L -0.334913 -0.000625 Z M 0.001025 -0.000625 "
              transform="matrix(1,0,0,-1,259.5146,-81.36)"
              id="path6844"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.001025 -0.000625 L 0.477587 -483.762344 L 0.14165 -483.762344 L -0.334913 -0.000625 Z M 0.001025 -0.000625 "
              transform="matrix(1,0,0,-1,259.5146,-81.36)"
              id="path6844"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip197)"
          clipRule="nonzero"
          id="bar-top-26"
        >
          <g clipPath="url(#clip198)" clipRule="nonzero" id="g6858">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00093125 -0.000625 L 0.475631 -483.762344 L 0.1436 -483.762344 L -0.332962 -0.000625 Z M -0.00093125 -0.000625 "
              transform="matrix(1,0,0,-1,268.7314,-81.36)"
              id="path6856"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00093125 -0.000625 L 0.475631 -483.762344 L 0.1436 -483.762344 L -0.332962 -0.000625 Z M -0.00093125 -0.000625 "
              transform="matrix(1,0,0,-1,268.7314,-81.36)"
              id="path6856"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip201)"
          clipRule="nonzero"
          id="bar-top-27"
        >
          <g clipPath="url(#clip202)" clipRule="nonzero" id="g6870">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00051875 -0.000625 L 0.477081 -483.762344 L 0.141144 -483.762344 L -0.331512 -0.000625 Z M 0.00051875 -0.000625 "
              transform="matrix(1,0,0,-1,277.9487,-81.36)"
              id="path6868"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00051875 -0.000625 L 0.477081 -483.762344 L 0.141144 -483.762344 L -0.331512 -0.000625 Z M 0.00051875 -0.000625 "
              transform="matrix(1,0,0,-1,277.9487,-81.36)"
              id="path6868"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip205)"
          clipRule="nonzero"
          id="bar-top-28"
        >
          <g clipPath="url(#clip206)" clipRule="nonzero" id="g6882">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0019375 -0.000625 L 0.474625 -483.762344 L 0.142594 -483.762344 L -0.333969 -0.000625 Z M -0.0019375 -0.000625 "
              transform="matrix(1,0,0,-1,287.166,-81.36)"
              id="path6880"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0019375 -0.000625 L 0.474625 -483.762344 L 0.142594 -483.762344 L -0.333969 -0.000625 Z M -0.0019375 -0.000625 "
              transform="matrix(1,0,0,-1,287.166,-81.36)"
              id="path6880"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip209)"
          clipRule="nonzero"
          id="bar-top-29"
        >
          <g clipPath="url(#clip210)" clipRule="nonzero" id="g6894">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0000125 -0.000625 L 0.476575 -483.762344 L 0.140637 -483.762344 L -0.332019 -0.000625 Z M 0.0000125 -0.000625 "
              transform="matrix(1,0,0,-1,296.3828,-81.36)"
              id="path6892"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0000125 -0.000625 L 0.476575 -483.762344 L 0.140637 -483.762344 L -0.332019 -0.000625 Z M 0.0000125 -0.000625 "
              transform="matrix(1,0,0,-1,296.3828,-81.36)"
              id="path6892"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip213)"
          clipRule="nonzero"
          id="bar-top-30"
        >
          <g clipPath="url(#clip214)" clipRule="nonzero" id="g6906">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00194375 -0.000625 L 0.474619 -483.762344 L 0.142587 -483.762344 L -0.333975 -0.000625 Z M -0.00194375 -0.000625 "
              transform="matrix(1,0,0,-1,305.5996,-81.36)"
              id="path6904"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00194375 -0.000625 L 0.474619 -483.762344 L 0.142587 -483.762344 L -0.333975 -0.000625 Z M -0.00194375 -0.000625 "
              transform="matrix(1,0,0,-1,305.5996,-81.36)"
              id="path6904"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip217)"
          clipRule="nonzero"
          id="bar-top-31"
        >
          <g clipPath="url(#clip218)" clipRule="nonzero" id="g6918">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00000625 -0.000625 L 0.476569 -483.762344 L 0.144538 -483.762344 L -0.332025 -0.000625 Z M 0.00000625 -0.000625 "
              transform="matrix(1,0,0,-1,314.8164,-81.36)"
              id="path6916"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00000625 -0.000625 L 0.476569 -483.762344 L 0.144538 -483.762344 L -0.332025 -0.000625 Z M 0.00000625 -0.000625 "
              transform="matrix(1,0,0,-1,314.8164,-81.36)"
              id="path6916"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip221)"
          clipRule="nonzero"
          id="bar-top-32"
        >
          <g clipPath="url(#clip222)" clipRule="nonzero" id="g6930">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00145625 -0.000625 L 0.474113 -483.762344 L 0.142081 -483.762344 L -0.334481 -0.000625 Z M 0.00145625 -0.000625 "
              transform="matrix(1,0,0,-1,324.0337,-81.36)"
              id="path6928"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00145625 -0.000625 L 0.474113 -483.762344 L 0.142081 -483.762344 L -0.334481 -0.000625 Z M 0.00145625 -0.000625 "
              transform="matrix(1,0,0,-1,324.0337,-81.36)"
              id="path6928"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip225)"
          clipRule="nonzero"
          id="bar-top-33"
        >
          <g clipPath="url(#clip226)" clipRule="nonzero" id="g6942">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.001 -0.000625 L 0.475563 -483.762344 L 0.143531 -483.762344 L -0.333031 -0.000625 Z M -0.001 -0.000625 "
              transform="matrix(1,0,0,-1,333.251,-81.36)"
              id="path6940"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.001 -0.000625 L 0.475563 -483.762344 L 0.143531 -483.762344 L -0.333031 -0.000625 Z M -0.001 -0.000625 "
              transform="matrix(1,0,0,-1,333.251,-81.36)"
              id="path6940"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip229)"
          clipRule="nonzero"
          id="bar-top-34"
        >
          <g clipPath="url(#clip230)" clipRule="nonzero" id="g6954">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00095 -0.000625 L 0.477512 -483.762344 L 0.141575 -483.762344 L -0.331081 -0.000625 Z M 0.00095 -0.000625 "
              transform="matrix(1,0,0,-1,342.4678,-81.36)"
              id="path6952"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00095 -0.000625 L 0.477512 -483.762344 L 0.141575 -483.762344 L -0.331081 -0.000625 Z M 0.00095 -0.000625 "
              transform="matrix(1,0,0,-1,342.4678,-81.36)"
              id="path6952"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip233)"
          clipRule="nonzero"
          id="bar-top-35"
        >
          <g clipPath="url(#clip234)" clipRule="nonzero" id="g6966">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00100625 -0.000625 L 0.475556 -483.762344 L 0.143525 -483.762344 L -0.333038 -0.000625 Z M -0.00100625 -0.000625 "
              transform="matrix(1,0,0,-1,351.6846,-81.36)"
              id="path6964"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00100625 -0.000625 L 0.475556 -483.762344 L 0.143525 -483.762344 L -0.333038 -0.000625 Z M -0.00100625 -0.000625 "
              transform="matrix(1,0,0,-1,351.6846,-81.36)"
              id="path6964"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip237)"
          clipRule="nonzero"
          id="bar-top-36"
        >
          <g clipPath="url(#clip238)" clipRule="nonzero" id="g6978">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00044375 -0.000625 L 0.477006 -483.762344 L 0.141069 -483.762344 L -0.331587 -0.000625 Z M 0.00044375 -0.000625 "
              transform="matrix(1,0,0,-1,360.9019,-81.36)"
              id="path6976"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00044375 -0.000625 L 0.477006 -483.762344 L 0.141069 -483.762344 L -0.331587 -0.000625 Z M 0.00044375 -0.000625 "
              transform="matrix(1,0,0,-1,360.9019,-81.36)"
              id="path6976"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip241)"
          clipRule="nonzero"
          id="bar-top-37"
        >
          <g clipPath="url(#clip242)" clipRule="nonzero" id="g6990">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0015125 -0.000625 L 0.47505 -483.762344 L 0.143019 -483.762344 L -0.333544 -0.000625 Z M -0.0015125 -0.000625 "
              transform="matrix(1,0,0,-1,370.1187,-81.36)"
              id="path6988"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0015125 -0.000625 L 0.47505 -483.762344 L 0.143019 -483.762344 L -0.333544 -0.000625 Z M -0.0015125 -0.000625 "
              transform="matrix(1,0,0,-1,370.1187,-81.36)"
              id="path6988"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip245)"
          clipRule="nonzero"
          id="bar-top-38"
        >
          <g clipPath="url(#clip246)" clipRule="nonzero" id="g7002">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0005375 -0.000625 L 0.4771 -483.762344 L 0.141163 -483.762344 L -0.331494 -0.000625 Z M 0.0005375 -0.000625 "
              transform="matrix(1,0,0,-1,379.3354,-81.36)"
              id="path7000"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0005375 -0.000625 L 0.4771 -483.762344 L 0.141163 -483.762344 L -0.331494 -0.000625 Z M 0.0005375 -0.000625 "
              transform="matrix(1,0,0,-1,379.3354,-81.36)"
              id="path7000"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip249)"
          clipRule="nonzero"
          id="bar-top-39"
        >
          <g clipPath="url(#clip250)" clipRule="nonzero" id="g7014">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00191875 -0.000625 L 0.474644 -483.762344 L 0.142612 -483.762344 L -0.33395 -0.000625 Z M -0.00191875 -0.000625 "
              transform="matrix(1,0,0,-1,388.5527,-81.36)"
              id="path7012"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00191875 -0.000625 L 0.474644 -483.762344 L 0.142612 -483.762344 L -0.33395 -0.000625 Z M -0.00191875 -0.000625 "
              transform="matrix(1,0,0,-1,388.5527,-81.36)"
              id="path7012"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip253)"
          clipRule="nonzero"
          id="bar-top-40"
        >
          <g clipPath="url(#clip254)" clipRule="nonzero" id="g7026">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00003125 -0.000625 L 0.476594 -483.762344 L 0.144563 -483.762344 L -0.332 -0.000625 Z M 0.00003125 -0.000625 "
              transform="matrix(1,0,0,-1,397.7695,-81.36)"
              id="path7024"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00003125 -0.000625 L 0.476594 -483.762344 L 0.144563 -483.762344 L -0.332 -0.000625 Z M 0.00003125 -0.000625 "
              transform="matrix(1,0,0,-1,397.7695,-81.36)"
              id="path7024"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip257)"
          clipRule="nonzero"
          id="bar-top-41"
        >
          <g clipPath="url(#clip258)" clipRule="nonzero" id="g7038">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00148125 -0.000625 L 0.474138 -483.762344 L 0.142106 -483.762344 L -0.334456 -0.000625 Z M 0.00148125 -0.000625 "
              transform="matrix(1,0,0,-1,406.9868,-81.36)"
              id="path7036"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00148125 -0.000625 L 0.474138 -483.762344 L 0.142106 -483.762344 L -0.334456 -0.000625 Z M 0.00148125 -0.000625 "
              transform="matrix(1,0,0,-1,406.9868,-81.36)"
              id="path7036"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip261)"
          clipRule="nonzero"
          id="bar-top-42"
        >
          <g clipPath="url(#clip262)" clipRule="nonzero" id="g7050">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.000475 -0.000625 L 0.476088 -483.762344 L 0.14015 -483.762344 L -0.332506 -0.000625 Z M -0.000475 -0.000625 "
              transform="matrix(1,0,0,-1,416.2036,-81.36)"
              id="path7048"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.000475 -0.000625 L 0.476088 -483.762344 L 0.14015 -483.762344 L -0.332506 -0.000625 Z M -0.000475 -0.000625 "
              transform="matrix(1,0,0,-1,416.2036,-81.36)"
              id="path7048"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip267)"
          clipRule="nonzero"
          id="bar-top-1"
        >
          <g clipPath="url(#clip268)" clipRule="nonzero" id="g7068">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00150625 -0.000625 L 0.474162 -483.762344 L 0.142131 -483.762344 L -0.334431 -0.000625 Z M 0.00150625 -0.000625 "
              transform="matrix(1,0,0,-1,37.9399,-81.36)"
              id="path7066"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00150625 -0.000625 L 0.474162 -483.762344 L 0.142131 -483.762344 L -0.334431 -0.000625 Z M 0.00150625 -0.000625 "
              transform="matrix(1,0,0,-1,37.9399,-81.36)"
              id="path7066"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip271)"
          clipRule="nonzero"
          id="bar-top-2"
        >
          <g clipPath="url(#clip272)" clipRule="nonzero" id="g7080">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00045 -0.000625 L 0.476112 -483.762344 L 0.140175 -483.762344 L -0.332481 -0.000625 Z M -0.00045 -0.000625 "
              transform="matrix(1,0,0,-1,47.1567,-81.36)"
              id="path7078"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00045 -0.000625 L 0.476112 -483.762344 L 0.140175 -483.762344 L -0.332481 -0.000625 Z M -0.00045 -0.000625 "
              transform="matrix(1,0,0,-1,47.1567,-81.36)"
              id="path7078"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip275)"
          clipRule="nonzero"
          id="bar-top-3"
        >
          <g clipPath="url(#clip276)" clipRule="nonzero" id="g7092">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0015 -0.000625 L 0.474156 -483.762344 L 0.142125 -483.762344 L -0.334437 -0.000625 Z M 0.0015 -0.000625 "
              transform="matrix(1,0,0,-1,56.3735,-81.36)"
              id="path7090"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0015 -0.000625 L 0.474156 -483.762344 L 0.142125 -483.762344 L -0.334437 -0.000625 Z M 0.0015 -0.000625 "
              transform="matrix(1,0,0,-1,56.3735,-81.36)"
              id="path7090"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip279)"
          clipRule="nonzero"
          id="bar-top-4"
        >
          <g clipPath="url(#clip280)" clipRule="nonzero" id="g7104">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00095625 -0.000625 L 0.475606 -483.762344 L 0.143575 -483.762344 L -0.332988 -0.000625 Z M -0.00095625 -0.000625 "
              transform="matrix(1,0,0,-1,65.5908,-81.36)"
              id="path7102"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00095625 -0.000625 L 0.475606 -483.762344 L 0.143575 -483.762344 L -0.332988 -0.000625 Z M -0.00095625 -0.000625 "
              transform="matrix(1,0,0,-1,65.5908,-81.36)"
              id="path7102"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip283)"
          clipRule="nonzero"
          id="bar-top-5"
        >
          <g clipPath="url(#clip284)" clipRule="nonzero" id="g7116">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00049375 -0.000625 L 0.477056 -483.762344 L 0.141119 -483.762344 L -0.335444 -0.000625 Z M 0.00049375 -0.000625 "
              transform="matrix(1,0,0,-1,74.8081,-81.36)"
              id="path7114"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00049375 -0.000625 L 0.477056 -483.762344 L 0.141119 -483.762344 L -0.335444 -0.000625 Z M 0.00049375 -0.000625 "
              transform="matrix(1,0,0,-1,74.8081,-81.36)"
              id="path7114"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip287)"
          clipRule="nonzero"
          id="bar-top-6"
        >
          <g clipPath="url(#clip288)" clipRule="nonzero" id="g7128">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0014625 -0.000625 L 0.4751 -483.762344 L 0.143069 -483.762344 L -0.333494 -0.000625 Z M -0.0014625 -0.000625 "
              transform="matrix(1,0,0,-1,84.0249,-81.36)"
              id="path7126"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0014625 -0.000625 L 0.4751 -483.762344 L 0.143069 -483.762344 L -0.333494 -0.000625 Z M -0.0014625 -0.000625 "
              transform="matrix(1,0,0,-1,84.0249,-81.36)"
              id="path7126"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip291)"
          clipRule="nonzero"
          id="bar-top-7"
        >
          <g clipPath="url(#clip292)" clipRule="nonzero" id="g7140">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0004875 -0.000625 L 0.47705 -483.762344 L 0.141112 -483.762344 L -0.331544 -0.000625 Z M 0.0004875 -0.000625 "
              transform="matrix(1,0,0,-1,93.2417,-81.36)"
              id="path7138"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0004875 -0.000625 L 0.47705 -483.762344 L 0.141112 -483.762344 L -0.331544 -0.000625 Z M 0.0004875 -0.000625 "
              transform="matrix(1,0,0,-1,93.2417,-81.36)"
              id="path7138"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip295)"
          clipRule="nonzero"
          id="bar-top-8"
        >
          <g clipPath="url(#clip296)" clipRule="nonzero" id="g7152">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00146875 -0.000625 L 0.475094 -483.762344 L 0.143062 -483.762344 L -0.3335 -0.000625 Z M -0.00146875 -0.000625 "
              transform="matrix(1,0,0,-1,102.4585,-81.36)"
              id="path7150"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00146875 -0.000625 L 0.475094 -483.762344 L 0.143062 -483.762344 L -0.3335 -0.000625 Z M -0.00146875 -0.000625 "
              transform="matrix(1,0,0,-1,102.4585,-81.36)"
              id="path7150"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip299)"
          clipRule="nonzero"
          id="bar-top-9"
        >
          <g clipPath="url(#clip300)" clipRule="nonzero" id="g7164">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00001875 -0.000625 L 0.476544 -483.762344 L 0.144513 -483.762344 L -0.33205 -0.000625 Z M -0.00001875 -0.000625 "
              transform="matrix(1,0,0,-1,111.6758,-81.36)"
              id="path7162"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00001875 -0.000625 L 0.476544 -483.762344 L 0.144513 -483.762344 L -0.33205 -0.000625 Z M -0.00001875 -0.000625 "
              transform="matrix(1,0,0,-1,111.6758,-81.36)"
              id="path7162"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip303)"
          clipRule="nonzero"
          id="bar-top-10"
        >
          <g clipPath="url(#clip304)" clipRule="nonzero" id="g7176">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00143125 -0.000625 L 0.474087 -483.762344 L 0.142056 -483.762344 L -0.334506 -0.000625 Z M 0.00143125 -0.000625 "
              transform="matrix(1,0,0,-1,120.8931,-81.36)"
              id="path7174"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00143125 -0.000625 L 0.474087 -483.762344 L 0.142056 -483.762344 L -0.334506 -0.000625 Z M 0.00143125 -0.000625 "
              transform="matrix(1,0,0,-1,120.8931,-81.36)"
              id="path7174"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip307)"
          clipRule="nonzero"
          id="bar-top-11"
        >
          <g clipPath="url(#clip308)" clipRule="nonzero" id="g7188">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.000525 -0.000625 L 0.476038 -483.762344 L 0.1401 -483.762344 L -0.332556 -0.000625 Z M -0.000525 -0.000625 "
              transform="matrix(1,0,0,-1,130.1099,-81.36)"
              id="path7186"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.000525 -0.000625 L 0.476038 -483.762344 L 0.1401 -483.762344 L -0.332556 -0.000625 Z M -0.000525 -0.000625 "
              transform="matrix(1,0,0,-1,130.1099,-81.36)"
              id="path7186"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip311)"
          clipRule="nonzero"
          id="bar-top-12"
        >
          <g clipPath="url(#clip312)" clipRule="nonzero" id="g7200">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.001425 -0.000625 L 0.474081 -483.762344 L 0.14205 -483.762344 L -0.334513 -0.000625 Z M 0.001425 -0.000625 "
              transform="matrix(1,0,0,-1,139.3267,-81.36)"
              id="path7198"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.001425 -0.000625 L 0.474081 -483.762344 L 0.14205 -483.762344 L -0.334513 -0.000625 Z M 0.001425 -0.000625 "
              transform="matrix(1,0,0,-1,139.3267,-81.36)"
              id="path7198"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip315)"
          clipRule="nonzero"
          id="bar-top-13"
        >
          <g clipPath="url(#clip316)" clipRule="nonzero" id="g7212">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00053125 -0.000625 L 0.476031 -483.762344 L 0.144 -483.762344 L -0.332562 -0.000625 Z M -0.00053125 -0.000625 "
              transform="matrix(1,0,0,-1,148.5435,-81.36)"
              id="path7210"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00053125 -0.000625 L 0.476031 -483.762344 L 0.144 -483.762344 L -0.332562 -0.000625 Z M -0.00053125 -0.000625 "
              transform="matrix(1,0,0,-1,148.5435,-81.36)"
              id="path7210"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip319)"
          clipRule="nonzero"
          id="bar-top-14"
        >
          <g clipPath="url(#clip320)" clipRule="nonzero" id="g7224">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00101875 -0.000625 L 0.477581 -483.762344 L 0.141644 -483.762344 L -0.334919 -0.000625 Z M 0.00101875 -0.000625 "
              transform="matrix(1,0,0,-1,157.7607,-81.36)"
              id="path7222"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00101875 -0.000625 L 0.477581 -483.762344 L 0.141644 -483.762344 L -0.334919 -0.000625 Z M 0.00101875 -0.000625 "
              transform="matrix(1,0,0,-1,157.7607,-81.36)"
              id="path7222"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip323)"
          clipRule="nonzero"
          id="bar-top-15"
        >
          <g clipPath="url(#clip324)" clipRule="nonzero" id="g7236">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0014375 -0.000625 L 0.475125 -483.762344 L 0.143094 -483.762344 L -0.333469 -0.000625 Z M -0.0014375 -0.000625 "
              transform="matrix(1,0,0,-1,166.978,-81.36)"
              id="path7234"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0014375 -0.000625 L 0.475125 -483.762344 L 0.143094 -483.762344 L -0.333469 -0.000625 Z M -0.0014375 -0.000625 "
              transform="matrix(1,0,0,-1,166.978,-81.36)"
              id="path7234"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip327)"
          clipRule="nonzero"
          id="bar-top-16"
        >
          <g clipPath="url(#clip328)" clipRule="nonzero" id="g7248">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0005125 -0.000625 L 0.477075 -483.762344 L 0.141138 -483.762344 L -0.331519 -0.000625 Z M 0.0005125 -0.000625 "
              transform="matrix(1,0,0,-1,176.1948,-81.36)"
              id="path7246"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0005125 -0.000625 L 0.477075 -483.762344 L 0.141138 -483.762344 L -0.331519 -0.000625 Z M 0.0005125 -0.000625 "
              transform="matrix(1,0,0,-1,176.1948,-81.36)"
              id="path7246"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip331)"
          clipRule="nonzero"
          id="bar-top-17"
        >
          <g clipPath="url(#clip332)" clipRule="nonzero" id="g7260">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00144375 -0.000625 L 0.475119 -483.762344 L 0.143088 -483.762344 L -0.333475 -0.000625 Z M -0.00144375 -0.000625 "
              transform="matrix(1,0,0,-1,185.4116,-81.36)"
              id="path7258"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00144375 -0.000625 L 0.475119 -483.762344 L 0.143088 -483.762344 L -0.333475 -0.000625 Z M -0.00144375 -0.000625 "
              transform="matrix(1,0,0,-1,185.4116,-81.36)"
              id="path7258"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip335)"
          clipRule="nonzero"
          id="bar-top-18"
        >
          <g clipPath="url(#clip336)" clipRule="nonzero" id="g7272">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00050625 -0.000625 L 0.477069 -483.762344 L 0.141131 -483.762344 L -0.331525 -0.000625 Z M 0.00050625 -0.000625 "
              transform="matrix(1,0,0,-1,194.6284,-81.36)"
              id="path7270"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00050625 -0.000625 L 0.477069 -483.762344 L 0.141131 -483.762344 L -0.331525 -0.000625 Z M 0.00050625 -0.000625 "
              transform="matrix(1,0,0,-1,194.6284,-81.36)"
              id="path7270"
            />
          </g>
        </g>
        <g
          className="bar-top"
          clipPath="url(#clip339)"
          clipRule="nonzero"
          id="bar-top-19"
        >
          <g clipPath="url(#clip340)" clipRule="nonzero" id="g7284">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00195 -0.000625 L 0.474613 -483.762344 L 0.142581 -483.762344 L -0.333981 -0.000625 Z M -0.00195 -0.000625 "
              transform="matrix(1,0,0,-1,203.8457,-81.36)"
              id="path7282"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00195 -0.000625 L 0.474613 -483.762344 L 0.142581 -483.762344 L -0.333981 -0.000625 Z M -0.00195 -0.000625 "
              transform="matrix(1,0,0,-1,203.8457,-81.36)"
              id="path7282"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip343)"
          clipRule="nonzero"
          id="bar-bottom-19"
        >
          <g clipPath="url(#clip344)" clipRule="nonzero" id="g7296">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00193125 0.00144375 L -0.474588 483.763163 L -0.142556 483.763163 L 0.334006 0.00144375 Z M -0.00193125 0.00144375 "
              transform="matrix(1,0,0,-1,204.4824,704.9116)"
              id="path7294"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00193125 0.00144375 L -0.474588 483.763163 L -0.142556 483.763163 L 0.334006 0.00144375 Z M -0.00193125 0.00144375 "
              transform="matrix(1,0,0,-1,204.4824,704.9116)"
              id="path7294"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip347)"
          clipRule="nonzero"
          id="bar-bottom-18"
        >
          <g clipPath="url(#clip348)" clipRule="nonzero" id="g7308">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.000525 0.00144375 L -0.476037 483.763163 L -0.1401 483.763163 L 0.332556 0.00144375 Z M 0.000525 0.00144375 "
              transform="matrix(1,0,0,-1,195.2651,704.9116)"
              id="path7306"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.000525 0.00144375 L -0.476037 483.763163 L -0.1401 483.763163 L 0.332556 0.00144375 Z M 0.000525 0.00144375 "
              transform="matrix(1,0,0,-1,195.2651,704.9116)"
              id="path7306"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip351)"
          clipRule="nonzero"
          id="bar-bottom-17"
        >
          <g clipPath="url(#clip352)" clipRule="nonzero" id="g7320">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.001425 0.00144375 L -0.474081 483.763163 L -0.14205 483.763163 L 0.334512 0.00144375 Z M -0.001425 0.00144375 "
              transform="matrix(1,0,0,-1,186.0483,704.9116)"
              id="path7318"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.001425 0.00144375 L -0.474081 483.763163 L -0.14205 483.763163 L 0.334512 0.00144375 Z M -0.001425 0.00144375 "
              transform="matrix(1,0,0,-1,186.0483,704.9116)"
              id="path7318"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip355)"
          clipRule="nonzero"
          id="bar-bottom-16"
        >
          <g clipPath="url(#clip356)" clipRule="nonzero" id="g7332">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00053125 0.00144375 L -0.476031 483.763163 L -0.144 483.763163 L 0.332562 0.00144375 Z M 0.00053125 0.00144375 "
              transform="matrix(1,0,0,-1,176.8315,704.9116)"
              id="path7330"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00053125 0.00144375 L -0.476031 483.763163 L -0.144 483.763163 L 0.332562 0.00144375 Z M 0.00053125 0.00144375 "
              transform="matrix(1,0,0,-1,176.8315,704.9116)"
              id="path7330"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip359)"
          clipRule="nonzero"
          id="bar-bottom-15"
        >
          <g clipPath="url(#clip360)" clipRule="nonzero" id="g7344">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00101875 0.00144375 L -0.477581 483.763163 L -0.141644 483.763163 L 0.334919 0.00144375 Z M -0.00101875 0.00144375 "
              transform="matrix(1,0,0,-1,167.6143,704.9116)"
              id="path7342"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00101875 0.00144375 L -0.477581 483.763163 L -0.141644 483.763163 L 0.334919 0.00144375 Z M -0.00101875 0.00144375 "
              transform="matrix(1,0,0,-1,167.6143,704.9116)"
              id="path7342"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip363)"
          clipRule="nonzero"
          id="bar-bottom-14"
        >
          <g clipPath="url(#clip364)" clipRule="nonzero" id="g7356">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0009375 0.00144375 L -0.475625 483.763163 L -0.143594 483.763163 L 0.332969 0.00144375 Z M 0.0009375 0.00144375 "
              transform="matrix(1,0,0,-1,158.3975,704.9116)"
              id="path7354"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0009375 0.00144375 L -0.475625 483.763163 L -0.143594 483.763163 L 0.332969 0.00144375 Z M 0.0009375 0.00144375 "
              transform="matrix(1,0,0,-1,158.3975,704.9116)"
              id="path7354"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip367)"
          clipRule="nonzero"
          id="bar-bottom-13"
        >
          <g clipPath="url(#clip368)" clipRule="nonzero" id="g7368">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0005125 0.00144375 L -0.477075 483.763163 L -0.141138 483.763163 L 0.335425 0.00144375 Z M -0.0005125 0.00144375 "
              transform="matrix(1,0,0,-1,149.1802,704.9116)"
              id="path7366"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0005125 0.00144375 L -0.477075 483.763163 L -0.141138 483.763163 L 0.335425 0.00144375 Z M -0.0005125 0.00144375 "
              transform="matrix(1,0,0,-1,149.1802,704.9116)"
              id="path7366"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip371)"
          clipRule="nonzero"
          id="bar-bottom-12"
        >
          <g clipPath="url(#clip372)" clipRule="nonzero" id="g7380">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00144375 0.00144375 L -0.475119 483.763163 L -0.143088 483.763163 L 0.333475 0.00144375 Z M 0.00144375 0.00144375 "
              transform="matrix(1,0,0,-1,139.9634,704.9116)"
              id="path7378"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00144375 0.00144375 L -0.475119 483.763163 L -0.143088 483.763163 L 0.333475 0.00144375 Z M 0.00144375 0.00144375 "
              transform="matrix(1,0,0,-1,139.9634,704.9116)"
              id="path7378"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip375)"
          clipRule="nonzero"
          id="bar-bottom-11"
        >
          <g clipPath="url(#clip376)" clipRule="nonzero" id="g7392">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00050625 0.00144375 L -0.477069 483.763163 L -0.141131 483.763163 L 0.331525 0.00144375 Z M -0.00050625 0.00144375 "
              transform="matrix(1,0,0,-1,130.7466,704.9116)"
              id="path7390"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00050625 0.00144375 L -0.477069 483.763163 L -0.141131 483.763163 L 0.331525 0.00144375 Z M -0.00050625 0.00144375 "
              transform="matrix(1,0,0,-1,130.7466,704.9116)"
              id="path7390"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip379)"
          clipRule="nonzero"
          id="bar-bottom-10"
        >
          <g clipPath="url(#clip380)" clipRule="nonzero" id="g7404">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00195 0.00144375 L -0.474612 483.763163 L -0.142581 483.763163 L 0.333981 0.00144375 Z M 0.00195 0.00144375 "
              transform="matrix(1,0,0,-1,121.5293,704.9116)"
              id="path7402"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00195 0.00144375 L -0.474612 483.763163 L -0.142581 483.763163 L 0.333981 0.00144375 Z M 0.00195 0.00144375 "
              transform="matrix(1,0,0,-1,121.5293,704.9116)"
              id="path7402"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip383)"
          clipRule="nonzero"
          id="bar-bottom-9"
        >
          <g clipPath="url(#clip384)" clipRule="nonzero" id="g7416">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0005 0.00144375 L -0.476062 483.763163 L -0.140125 483.763163 L 0.332531 0.00144375 Z M 0.0005 0.00144375 "
              transform="matrix(1,0,0,-1,112.312,704.9116)"
              id="path7414"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0005 0.00144375 L -0.476062 483.763163 L -0.140125 483.763163 L 0.332531 0.00144375 Z M 0.0005 0.00144375 "
              transform="matrix(1,0,0,-1,112.312,704.9116)"
              id="path7414"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip387)"
          clipRule="nonzero"
          id="bar-bottom-8"
        >
          <g clipPath="url(#clip388)" clipRule="nonzero" id="g7428">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00195 0.00144375 L -0.474606 483.763163 L -0.142575 483.763163 L 0.333988 0.00144375 Z M -0.00195 0.00144375 "
              transform="matrix(1,0,0,-1,103.0957,704.9116)"
              id="path7426"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00195 0.00144375 L -0.474606 483.763163 L -0.142575 483.763163 L 0.333988 0.00144375 Z M -0.00195 0.00144375 "
              transform="matrix(1,0,0,-1,103.0957,704.9116)"
              id="path7426"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip391)"
          clipRule="nonzero"
          id="bar-bottom-7"
        >
          <g clipPath="url(#clip392)" clipRule="nonzero" id="g7440">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00050625 0.00144375 L -0.476056 483.763163 L -0.144025 483.763163 L 0.332538 0.00144375 Z M 0.00050625 0.00144375 "
              transform="matrix(1,0,0,-1,93.8784,704.9116)"
              id="path7438"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00050625 0.00144375 L -0.476056 483.763163 L -0.144025 483.763163 L 0.332538 0.00144375 Z M 0.00050625 0.00144375 "
              transform="matrix(1,0,0,-1,93.8784,704.9116)"
              id="path7438"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip395)"
          clipRule="nonzero"
          id="bar-bottom-6"
        >
          <g clipPath="url(#clip396)" clipRule="nonzero" id="g7452">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00094375 0.00144375 L -0.477506 483.763163 L -0.141569 483.763163 L 0.334994 0.00144375 Z M -0.00094375 0.00144375 "
              transform="matrix(1,0,0,-1,84.6611,704.9116)"
              id="path7450"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00094375 0.00144375 L -0.477506 483.763163 L -0.141569 483.763163 L 0.334994 0.00144375 Z M -0.00094375 0.00144375 "
              transform="matrix(1,0,0,-1,84.6611,704.9116)"
              id="path7450"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip399)"
          clipRule="nonzero"
          id="bar-bottom-5"
        >
          <g clipPath="url(#clip400)" clipRule="nonzero" id="g7464">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0010125 0.00144375 L -0.47555 483.763163 L -0.143519 483.763163 L 0.333044 0.00144375 Z M 0.0010125 0.00144375 "
              transform="matrix(1,0,0,-1,75.4443,704.9116)"
              id="path7462"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0010125 0.00144375 L -0.47555 483.763163 L -0.143519 483.763163 L 0.333044 0.00144375 Z M 0.0010125 0.00144375 "
              transform="matrix(1,0,0,-1,75.4443,704.9116)"
              id="path7462"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip403)"
          clipRule="nonzero"
          id="bar-bottom-4"
        >
          <g clipPath="url(#clip404)" clipRule="nonzero" id="g7476">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0009375 0.00144375 L -0.4775 483.763163 L -0.141563 483.763163 L 0.331094 0.00144375 Z M -0.0009375 0.00144375 "
              transform="matrix(1,0,0,-1,66.2275,704.9116)"
              id="path7474"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0009375 0.00144375 L -0.4775 483.763163 L -0.141563 483.763163 L 0.331094 0.00144375 Z M -0.0009375 0.00144375 "
              transform="matrix(1,0,0,-1,66.2275,704.9116)"
              id="path7474"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip407)"
          clipRule="nonzero"
          id="bar-bottom-3"
        >
          <g clipPath="url(#clip408)" clipRule="nonzero" id="g7488">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00101875 0.00144375 L -0.475544 483.763163 L -0.143512 483.763163 L 0.33305 0.00144375 Z M 0.00101875 0.00144375 "
              transform="matrix(1,0,0,-1,57.0107,704.9116)"
              id="path7486"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00101875 0.00144375 L -0.475544 483.763163 L -0.143512 483.763163 L 0.33305 0.00144375 Z M 0.00101875 0.00144375 "
              transform="matrix(1,0,0,-1,57.0107,704.9116)"
              id="path7486"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip411)"
          clipRule="nonzero"
          id="bar-bottom-2"
        >
          <g clipPath="url(#clip412)" clipRule="nonzero" id="g7500">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00053125 0.00144375 L -0.477094 483.763163 L -0.141156 483.763163 L 0.3315 0.00144375 Z M -0.00053125 0.00144375 "
              transform="matrix(1,0,0,-1,47.7935,704.9116)"
              id="path7498"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00053125 0.00144375 L -0.477094 483.763163 L -0.141156 483.763163 L 0.3315 0.00144375 Z M -0.00053125 0.00144375 "
              transform="matrix(1,0,0,-1,47.7935,704.9116)"
              id="path7498"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip415)"
          clipRule="nonzero"
          id="bar-bottom-1"
        >
          <g clipPath="url(#clip416)" clipRule="nonzero" id="g7512">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.001925 0.00144375 L -0.474638 483.763163 L -0.142606 483.763163 L 0.333956 0.00144375 Z M 0.001925 0.00144375 "
              transform="matrix(1,0,0,-1,38.5762,704.9116)"
              id="path7510"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.001925 0.00144375 L -0.474638 483.763163 L -0.142606 483.763163 L 0.333956 0.00144375 Z M 0.001925 0.00144375 "
              transform="matrix(1,0,0,-1,38.5762,704.9116)"
              id="path7510"
            />
          </g>
        </g>
        <g clipPath="url(#clip417)" clipRule="nonzero" id="g7520">
          <g clipPath="url(#clip418)" clipRule="nonzero" id="g7518">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.000025 0.00144375 L -0.476588 483.763163 L -0.14065 483.763163 L 0.332006 0.00144375 Z M -0.000025 0.00144375 "
              transform="matrix(1,0,0,-1,29.3594,704.9116)"
              id="path7516"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip421)"
          clipRule="nonzero"
          id="bar-bottom-42"
        >
          <g clipPath="url(#clip422)" clipRule="nonzero" id="g7530">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00095625 0.00144375 L -0.477519 483.763163 L -0.141581 483.763163 L 0.331075 0.00144375 Z M -0.00095625 0.00144375 "
              transform="matrix(1,0,0,-1,416.8408,704.9116)"
              id="path7528"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00095625 0.00144375 L -0.477519 483.763163 L -0.141581 483.763163 L 0.331075 0.00144375 Z M -0.00095625 0.00144375 "
              transform="matrix(1,0,0,-1,416.8408,704.9116)"
              id="path7528"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip425)"
          clipRule="nonzero"
          id="bar-bottom-41"
        >
          <g clipPath="url(#clip426)" clipRule="nonzero" id="g7542">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0015 0.00144375 L -0.475062 483.763163 L -0.143031 483.763163 L 0.333531 0.00144375 Z M 0.0015 0.00144375 "
              transform="matrix(1,0,0,-1,407.6235,704.9116)"
              id="path7540"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0015 0.00144375 L -0.475062 483.763163 L -0.143031 483.763163 L 0.333531 0.00144375 Z M 0.0015 0.00144375 "
              transform="matrix(1,0,0,-1,407.6235,704.9116)"
              id="path7540"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip429)"
          clipRule="nonzero"
          id="bar-bottom-40"
        >
          <g clipPath="url(#clip430)" clipRule="nonzero" id="g7554">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00005 0.00144375 L -0.476512 483.763163 L -0.140575 483.763163 L 0.332081 0.00144375 Z M 0.00005 0.00144375 "
              transform="matrix(1,0,0,-1,398.4062,704.9116)"
              id="path7552"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00005 0.00144375 L -0.476512 483.763163 L -0.140575 483.763163 L 0.332081 0.00144375 Z M 0.00005 0.00144375 "
              transform="matrix(1,0,0,-1,398.4062,704.9116)"
              id="path7552"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip433)"
          clipRule="nonzero"
          id="bar-bottom-39"
        >
          <g clipPath="url(#clip434)" clipRule="nonzero" id="g7566">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00190625 0.00144375 L -0.474656 483.763163 L -0.142625 483.763163 L 0.333937 0.00144375 Z M 0.00190625 0.00144375 "
              transform="matrix(1,0,0,-1,389.1895,704.9116)"
              id="path7564"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00190625 0.00144375 L -0.474656 483.763163 L -0.142625 483.763163 L 0.333937 0.00144375 Z M 0.00190625 0.00144375 "
              transform="matrix(1,0,0,-1,389.1895,704.9116)"
              id="path7564"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip437)"
          clipRule="nonzero"
          id="bar-bottom-38"
        >
          <g clipPath="url(#clip438)" clipRule="nonzero" id="g7578">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00004375 0.00144375 L -0.476606 483.763163 L -0.144575 483.763163 L 0.331988 0.00144375 Z M -0.00004375 0.00144375 "
              transform="matrix(1,0,0,-1,379.9727,704.9116)"
              id="path7576"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00004375 0.00144375 L -0.476606 483.763163 L -0.144575 483.763163 L 0.331988 0.00144375 Z M -0.00004375 0.00144375 "
              transform="matrix(1,0,0,-1,379.9727,704.9116)"
              id="path7576"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip441)"
          clipRule="nonzero"
          id="bar-bottom-37"
        >
          <g clipPath="url(#clip442)" clipRule="nonzero" id="g7590">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00149375 0.00144375 L -0.47415 483.763163 L -0.142119 483.763163 L 0.334444 0.00144375 Z M -0.00149375 0.00144375 "
              transform="matrix(1,0,0,-1,370.7554,704.9116)"
              id="path7588"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00149375 0.00144375 L -0.47415 483.763163 L -0.142119 483.763163 L 0.334444 0.00144375 Z M -0.00149375 0.00144375 "
              transform="matrix(1,0,0,-1,370.7554,704.9116)"
              id="path7588"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip445)"
          clipRule="nonzero"
          id="bar-bottom-36"
        >
          <g clipPath="url(#clip446)" clipRule="nonzero" id="g7602">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0004625 0.00144375 L -0.4761 483.763163 L -0.144069 483.763163 L 0.332494 0.00144375 Z M 0.0004625 0.00144375 "
              transform="matrix(1,0,0,-1,361.5386,704.9116)"
              id="path7600"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0004625 0.00144375 L -0.4761 483.763163 L -0.144069 483.763163 L 0.332494 0.00144375 Z M 0.0004625 0.00144375 "
              transform="matrix(1,0,0,-1,361.5386,704.9116)"
              id="path7600"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip449)"
          clipRule="nonzero"
          id="bar-bottom-35"
        >
          <g clipPath="url(#clip450)" clipRule="nonzero" id="g7614">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0009875 0.00144375 L -0.47755 483.763163 L -0.141612 483.763163 L 0.33495 0.00144375 Z M -0.0009875 0.00144375 "
              transform="matrix(1,0,0,-1,352.3213,704.9116)"
              id="path7612"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0009875 0.00144375 L -0.47755 483.763163 L -0.141612 483.763163 L 0.33495 0.00144375 Z M -0.0009875 0.00144375 "
              transform="matrix(1,0,0,-1,352.3213,704.9116)"
              id="path7612"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip453)"
          clipRule="nonzero"
          id="bar-bottom-34"
        >
          <g clipPath="url(#clip454)" clipRule="nonzero" id="g7626">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00096875 0.00144375 L -0.475594 483.763163 L -0.143563 483.763163 L 0.333 0.00144375 Z M 0.00096875 0.00144375 "
              transform="matrix(1,0,0,-1,343.1045,704.9116)"
              id="path7624"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00096875 0.00144375 L -0.475594 483.763163 L -0.143563 483.763163 L 0.333 0.00144375 Z M 0.00096875 0.00144375 "
              transform="matrix(1,0,0,-1,343.1045,704.9116)"
              id="path7624"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip457)"
          clipRule="nonzero"
          id="bar-bottom-33"
        >
          <g clipPath="url(#clip458)" clipRule="nonzero" id="g7638">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00098125 0.00144375 L -0.477544 483.763163 L -0.141606 483.763163 L 0.33105 0.00144375 Z M -0.00098125 0.00144375 "
              transform="matrix(1,0,0,-1,333.8877,704.9116)"
              id="path7636"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00098125 0.00144375 L -0.477544 483.763163 L -0.141606 483.763163 L 0.33105 0.00144375 Z M -0.00098125 0.00144375 "
              transform="matrix(1,0,0,-1,333.8877,704.9116)"
              id="path7636"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip461)"
          clipRule="nonzero"
          id="bar-bottom-32"
        >
          <g clipPath="url(#clip462)" clipRule="nonzero" id="g7650">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.001475 0.00144375 L -0.475088 483.763163 L -0.143056 483.763163 L 0.333506 0.00144375 Z M 0.001475 0.00144375 "
              transform="matrix(1,0,0,-1,324.6704,704.9116)"
              id="path7648"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.001475 0.00144375 L -0.475088 483.763163 L -0.143056 483.763163 L 0.333506 0.00144375 Z M 0.001475 0.00144375 "
              transform="matrix(1,0,0,-1,324.6704,704.9116)"
              id="path7648"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip465)"
          clipRule="nonzero"
          id="bar-bottom-31"
        >
          <g clipPath="url(#clip466)" clipRule="nonzero" id="g7662">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.000475 0.00144375 L -0.477037 483.763163 L -0.1411 483.763163 L 0.331556 0.00144375 Z M -0.000475 0.00144375 "
              transform="matrix(1,0,0,-1,315.4536,704.9116)"
              id="path7660"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.000475 0.00144375 L -0.477037 483.763163 L -0.1411 483.763163 L 0.331556 0.00144375 Z M -0.000475 0.00144375 "
              transform="matrix(1,0,0,-1,315.4536,704.9116)"
              id="path7660"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip469)"
          clipRule="nonzero"
          id="bar-bottom-30"
        >
          <g clipPath="url(#clip470)" clipRule="nonzero" id="g7674">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.001925 0.00144375 L -0.474581 483.763163 L -0.14255 483.763163 L 0.334013 0.00144375 Z M -0.001925 0.00144375 "
              transform="matrix(1,0,0,-1,306.2363,704.9116)"
              id="path7672"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.001925 0.00144375 L -0.474581 483.763163 L -0.14255 483.763163 L 0.334013 0.00144375 Z M -0.001925 0.00144375 "
              transform="matrix(1,0,0,-1,306.2363,704.9116)"
              id="path7672"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip473)"
          clipRule="nonzero"
          id="bar-bottom-29"
        >
          <g clipPath="url(#clip474)" clipRule="nonzero" id="g7686">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00003125 0.00144375 L -0.476531 483.763163 L -0.1445 483.763163 L 0.332063 0.00144375 Z M 0.00003125 0.00144375 "
              transform="matrix(1,0,0,-1,297.0195,704.9116)"
              id="path7684"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00003125 0.00144375 L -0.476531 483.763163 L -0.1445 483.763163 L 0.332063 0.00144375 Z M 0.00003125 0.00144375 "
              transform="matrix(1,0,0,-1,297.0195,704.9116)"
              id="path7684"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip477)"
          clipRule="nonzero"
          id="bar-bottom-28"
        >
          <g clipPath="url(#clip478)" clipRule="nonzero" id="g7698">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00141875 0.00144375 L -0.474075 483.763163 L -0.142044 483.763163 L 0.334519 0.00144375 Z M -0.00141875 0.00144375 "
              transform="matrix(1,0,0,-1,287.8022,704.9116)"
              id="path7696"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00141875 0.00144375 L -0.474075 483.763163 L -0.142044 483.763163 L 0.334519 0.00144375 Z M -0.00141875 0.00144375 "
              transform="matrix(1,0,0,-1,287.8022,704.9116)"
              id="path7696"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip481)"
          clipRule="nonzero"
          id="bar-bottom-27"
        >
          <g clipPath="url(#clip482)" clipRule="nonzero" id="g7710">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0005375 0.00144375 L -0.476025 483.763163 L -0.143994 483.763163 L 0.332569 0.00144375 Z M 0.0005375 0.00144375 "
              transform="matrix(1,0,0,-1,278.5854,704.9116)"
              id="path7708"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0005375 0.00144375 L -0.476025 483.763163 L -0.143994 483.763163 L 0.332569 0.00144375 Z M 0.0005375 0.00144375 "
              transform="matrix(1,0,0,-1,278.5854,704.9116)"
              id="path7708"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip485)"
          clipRule="nonzero"
          id="bar-bottom-26"
        >
          <g clipPath="url(#clip486)" clipRule="nonzero" id="g7722">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0010125 0.00144375 L -0.477575 483.763163 L -0.141638 483.763163 L 0.334925 0.00144375 Z M -0.0010125 0.00144375 "
              transform="matrix(1,0,0,-1,269.3682,704.9116)"
              id="path7720"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0010125 0.00144375 L -0.477575 483.763163 L -0.141638 483.763163 L 0.334925 0.00144375 Z M -0.0010125 0.00144375 "
              transform="matrix(1,0,0,-1,269.3682,704.9116)"
              id="path7720"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip489)"
          clipRule="nonzero"
          id="bar-bottom-25"
        >
          <g clipPath="url(#clip490)" clipRule="nonzero" id="g7734">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00094375 0.00144375 L -0.475619 483.763163 L -0.143588 483.763163 L 0.332975 0.00144375 Z M 0.00094375 0.00144375 "
              transform="matrix(1,0,0,-1,260.1514,704.9116)"
              id="path7732"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00094375 0.00144375 L -0.475619 483.763163 L -0.143588 483.763163 L 0.332975 0.00144375 Z M 0.00094375 0.00144375 "
              transform="matrix(1,0,0,-1,260.1514,704.9116)"
              id="path7732"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip493)"
          clipRule="nonzero"
          id="bar-bottom-24"
        >
          <g clipPath="url(#clip494)" clipRule="nonzero" id="g7746">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00100625 0.00144375 L -0.477569 483.763163 L -0.141631 483.763163 L 0.334931 0.00144375 Z M -0.00100625 0.00144375 "
              transform="matrix(1,0,0,-1,250.9346,704.9116)"
              id="path7744"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00100625 0.00144375 L -0.477569 483.763163 L -0.141631 483.763163 L 0.334931 0.00144375 Z M -0.00100625 0.00144375 "
              transform="matrix(1,0,0,-1,250.9346,704.9116)"
              id="path7744"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip497)"
          clipRule="nonzero"
          id="bar-bottom-23"
        >
          <g clipPath="url(#clip498)" clipRule="nonzero" id="g7758">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00145 0.00144375 L -0.475112 483.763163 L -0.143081 483.763163 L 0.333481 0.00144375 Z M 0.00145 0.00144375 "
              transform="matrix(1,0,0,-1,241.7173,704.9116)"
              id="path7756"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00145 0.00144375 L -0.475112 483.763163 L -0.143081 483.763163 L 0.333481 0.00144375 Z M 0.00145 0.00144375 "
              transform="matrix(1,0,0,-1,241.7173,704.9116)"
              id="path7756"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip501)"
          clipRule="nonzero"
          id="bar-bottom-22"
        >
          <g clipPath="url(#clip502)" clipRule="nonzero" id="g7770">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0005 0.00144375 L -0.477062 483.763163 L -0.141125 483.763163 L 0.331531 0.00144375 Z M -0.0005 0.00144375 "
              transform="matrix(1,0,0,-1,232.5005,704.9116)"
              id="path7768"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0005 0.00144375 L -0.477062 483.763163 L -0.141125 483.763163 L 0.331531 0.00144375 Z M -0.0005 0.00144375 "
              transform="matrix(1,0,0,-1,232.5005,704.9116)"
              id="path7768"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip505)"
          clipRule="nonzero"
          id="bar-bottom-21"
        >
          <g clipPath="url(#clip506)" clipRule="nonzero" id="g7782">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00145625 0.00144375 L -0.475106 483.763163 L -0.143075 483.763163 L 0.333488 0.00144375 Z M 0.00145625 0.00144375 "
              transform="matrix(1,0,0,-1,223.2837,704.9116)"
              id="path7780"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00145625 0.00144375 L -0.475106 483.763163 L -0.143075 483.763163 L 0.333488 0.00144375 Z M 0.00145625 0.00144375 "
              transform="matrix(1,0,0,-1,223.2837,704.9116)"
              id="path7780"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip509)"
          clipRule="nonzero"
          id="bar-bottom-20"
        >
          <g clipPath="url(#clip510)" clipRule="nonzero" id="g7794">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00000625 0.00144375 L -0.476556 483.763163 L -0.144525 483.763163 L 0.332037 0.00144375 Z M 0.00000625 0.00144375 "
              transform="matrix(1,0,0,-1,214.0664,704.9116)"
              id="path7792"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00000625 0.00144375 L -0.476556 483.763163 L -0.144525 483.763163 L 0.332037 0.00144375 Z M 0.00000625 0.00144375 "
              transform="matrix(1,0,0,-1,214.0664,704.9116)"
              id="path7792"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip513)"
          clipRule="nonzero"
          id="bar-bottom-65"
        >
          <g clipPath="url(#clip514)" clipRule="nonzero" id="g7806">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00101875 0.00144375 L -0.475544 483.763163 L -0.143513 483.763163 L 0.33305 0.00144375 Z M 0.00101875 0.00144375 "
              transform="matrix(1,0,0,-1,629.1982,704.9116)"
              id="path7804"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00101875 0.00144375 L -0.475544 483.763163 L -0.143513 483.763163 L 0.33305 0.00144375 Z M 0.00101875 0.00144375 "
              transform="matrix(1,0,0,-1,629.1982,704.9116)"
              id="path7804"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip517)"
          clipRule="nonzero"
          id="bar-bottom-64"
        >
          <g clipPath="url(#clip518)" clipRule="nonzero" id="g7818">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00093125 0.00144375 L -0.477494 483.763163 L -0.141556 483.763163 L 0.3311 0.00144375 Z M -0.00093125 0.00144375 "
              transform="matrix(1,0,0,-1,619.9814,704.9116)"
              id="path7816"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00093125 0.00144375 L -0.477494 483.763163 L -0.141556 483.763163 L 0.3311 0.00144375 Z M -0.00093125 0.00144375 "
              transform="matrix(1,0,0,-1,619.9814,704.9116)"
              id="path7816"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip521)"
          clipRule="nonzero"
          id="bar-bottom-63"
        >
          <g clipPath="url(#clip522)" clipRule="nonzero" id="g7830">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.001425 0.00144375 L -0.475137 483.763163 L -0.143106 483.763163 L 0.333456 0.00144375 Z M 0.001425 0.00144375 "
              transform="matrix(1,0,0,-1,610.7642,704.9116)"
              id="path7828"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.001425 0.00144375 L -0.475137 483.763163 L -0.143106 483.763163 L 0.333456 0.00144375 Z M 0.001425 0.00144375 "
              transform="matrix(1,0,0,-1,610.7642,704.9116)"
              id="path7828"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip525)"
          clipRule="nonzero"
          id="bar-bottom-62"
        >
          <g clipPath="url(#clip526)" clipRule="nonzero" id="g7842">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.000525 0.00144375 L -0.477087 483.763163 L -0.14115 483.763163 L 0.331506 0.00144375 Z M -0.000525 0.00144375 "
              transform="matrix(1,0,0,-1,601.5474,704.9116)"
              id="path7840"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.000525 0.00144375 L -0.477087 483.763163 L -0.14115 483.763163 L 0.331506 0.00144375 Z M -0.000525 0.00144375 "
              transform="matrix(1,0,0,-1,601.5474,704.9116)"
              id="path7840"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip529)"
          clipRule="nonzero"
          id="bar-bottom-61"
        >
          <g clipPath="url(#clip530)" clipRule="nonzero" id="g7854">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00193125 0.00144375 L -0.474631 483.763163 L -0.1426 483.763163 L 0.333963 0.00144375 Z M 0.00193125 0.00144375 "
              transform="matrix(1,0,0,-1,592.3301,704.9116)"
              id="path7852"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00193125 0.00144375 L -0.474631 483.763163 L -0.1426 483.763163 L 0.333963 0.00144375 Z M 0.00193125 0.00144375 "
              transform="matrix(1,0,0,-1,592.3301,704.9116)"
              id="path7852"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip533)"
          clipRule="nonzero"
          id="bar-bottom-60"
        >
          <g clipPath="url(#clip534)" clipRule="nonzero" id="g7866">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00001875 0.00144375 L -0.476581 483.763163 L -0.140644 483.763163 L 0.332012 0.00144375 Z M -0.00001875 0.00144375 "
              transform="matrix(1,0,0,-1,583.1133,704.9116)"
              id="path7864"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00001875 0.00144375 L -0.476581 483.763163 L -0.140644 483.763163 L 0.332012 0.00144375 Z M -0.00001875 0.00144375 "
              transform="matrix(1,0,0,-1,583.1133,704.9116)"
              id="path7864"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip537)"
          clipRule="nonzero"
          id="bar-bottom-59"
        >
          <g clipPath="url(#clip538)" clipRule="nonzero" id="g7878">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0019375 0.00144375 L -0.474625 483.763163 L -0.142594 483.763163 L 0.333969 0.00144375 Z M 0.0019375 0.00144375 "
              transform="matrix(1,0,0,-1,573.8965,704.9116)"
              id="path7876"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0019375 0.00144375 L -0.474625 483.763163 L -0.142594 483.763163 L 0.333969 0.00144375 Z M 0.0019375 0.00144375 "
              transform="matrix(1,0,0,-1,573.8965,704.9116)"
              id="path7876"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip541)"
          clipRule="nonzero"
          id="bar-bottom-58"
        >
          <g clipPath="url(#clip542)" clipRule="nonzero" id="g7890">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0004875 0.00144375 L -0.476075 483.763163 L -0.144044 483.763163 L 0.332519 0.00144375 Z M 0.0004875 0.00144375 "
              transform="matrix(1,0,0,-1,564.6792,704.9116)"
              id="path7888"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0004875 0.00144375 L -0.476075 483.763163 L -0.144044 483.763163 L 0.332519 0.00144375 Z M 0.0004875 0.00144375 "
              transform="matrix(1,0,0,-1,564.6792,704.9116)"
              id="path7888"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip545)"
          clipRule="nonzero"
          id="bar-bottom-57"
        >
          <g clipPath="url(#clip546)" clipRule="nonzero" id="g7902">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0009625 0.00144375 L -0.477525 483.763163 L -0.141587 483.763163 L 0.331069 0.00144375 Z M -0.0009625 0.00144375 "
              transform="matrix(1,0,0,-1,555.4619,704.9116)"
              id="path7900"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0009625 0.00144375 L -0.477525 483.763163 L -0.141587 483.763163 L 0.331069 0.00144375 Z M -0.0009625 0.00144375 "
              transform="matrix(1,0,0,-1,555.4619,704.9116)"
              id="path7900"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip549)"
          clipRule="nonzero"
          id="bar-bottom-56"
        >
          <g clipPath="url(#clip550)" clipRule="nonzero" id="g7914">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00099375 0.00144375 L -0.475569 483.763163 L -0.143537 483.763163 L 0.333025 0.00144375 Z M 0.00099375 0.00144375 "
              transform="matrix(1,0,0,-1,546.2451,704.9116)"
              id="path7912"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00099375 0.00144375 L -0.475569 483.763163 L -0.143537 483.763163 L 0.333025 0.00144375 Z M 0.00099375 0.00144375 "
              transform="matrix(1,0,0,-1,546.2451,704.9116)"
              id="path7912"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip553)"
          clipRule="nonzero"
          id="bar-bottom-55"
        >
          <g clipPath="url(#clip554)" clipRule="nonzero" id="g7926">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00095625 0.00144375 L -0.477519 483.763163 L -0.141581 483.763163 L 0.331075 0.00144375 Z M -0.00095625 0.00144375 "
              transform="matrix(1,0,0,-1,537.0283,704.9116)"
              id="path7924"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00095625 0.00144375 L -0.477519 483.763163 L -0.141581 483.763163 L 0.331075 0.00144375 Z M -0.00095625 0.00144375 "
              transform="matrix(1,0,0,-1,537.0283,704.9116)"
              id="path7924"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip557)"
          clipRule="nonzero"
          id="bar-bottom-54"
        >
          <g clipPath="url(#clip558)" clipRule="nonzero" id="g7938">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.001 0.00144375 L -0.475562 483.763163 L -0.143531 483.763163 L 0.333031 0.00144375 Z M 0.001 0.00144375 "
              transform="matrix(1,0,0,-1,527.8115,704.9116)"
              id="path7936"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.001 0.00144375 L -0.475562 483.763163 L -0.143531 483.763163 L 0.333031 0.00144375 Z M 0.001 0.00144375 "
              transform="matrix(1,0,0,-1,527.8115,704.9116)"
              id="path7936"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip561)"
          clipRule="nonzero"
          id="bar-bottom-53"
        >
          <g clipPath="url(#clip562)" clipRule="nonzero" id="g7950">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00045 0.00144375 L -0.477013 483.763163 L -0.141075 483.763163 L 0.331581 0.00144375 Z M -0.00045 0.00144375 "
              transform="matrix(1,0,0,-1,518.5942,704.9116)"
              id="path7948"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00045 0.00144375 L -0.477013 483.763163 L -0.141075 483.763163 L 0.331581 0.00144375 Z M -0.00045 0.00144375 "
              transform="matrix(1,0,0,-1,518.5942,704.9116)"
              id="path7948"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip565)"
          clipRule="nonzero"
          id="bar-bottom-52"
        >
          <g clipPath="url(#clip566)" clipRule="nonzero" id="g7962">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00190625 0.00144375 L -0.474656 483.763163 L -0.142625 483.763163 L 0.333937 0.00144375 Z M 0.00190625 0.00144375 "
              transform="matrix(1,0,0,-1,509.377,704.9116)"
              id="path7960"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00190625 0.00144375 L -0.474656 483.763163 L -0.142625 483.763163 L 0.333937 0.00144375 Z M 0.00190625 0.00144375 "
              transform="matrix(1,0,0,-1,509.377,704.9116)"
              id="path7960"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip569)"
          clipRule="nonzero"
          id="bar-bottom-51"
        >
          <g clipPath="url(#clip570)" clipRule="nonzero" id="g7974">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00004375 0.00144375 L -0.476606 483.763163 L -0.140669 483.763163 L 0.331987 0.00144375 Z M -0.00004375 0.00144375 "
              transform="matrix(1,0,0,-1,500.1602,704.9116)"
              id="path7972"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00004375 0.00144375 L -0.476606 483.763163 L -0.140669 483.763163 L 0.331987 0.00144375 Z M -0.00004375 0.00144375 "
              transform="matrix(1,0,0,-1,500.1602,704.9116)"
              id="path7972"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip573)"
          clipRule="nonzero"
          id="bar-bottom-50"
        >
          <g clipPath="url(#clip574)" clipRule="nonzero" id="g7986">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0019125 0.00144375 L -0.47465 483.763163 L -0.142619 483.763163 L 0.333944 0.00144375 Z M 0.0019125 0.00144375 "
              transform="matrix(1,0,0,-1,490.9434,704.9116)"
              id="path7984"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0019125 0.00144375 L -0.47465 483.763163 L -0.142619 483.763163 L 0.333944 0.00144375 Z M 0.0019125 0.00144375 "
              transform="matrix(1,0,0,-1,490.9434,704.9116)"
              id="path7984"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip577)"
          clipRule="nonzero"
          id="bar-bottom-49"
        >
          <g clipPath="url(#clip578)" clipRule="nonzero" id="g7998">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0004625 0.00144375 L -0.4761 483.763163 L -0.140162 483.763163 L 0.332494 0.00144375 Z M 0.0004625 0.00144375 "
              transform="matrix(1,0,0,-1,481.7261,704.9116)"
              id="path7996"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0004625 0.00144375 L -0.4761 483.763163 L -0.140162 483.763163 L 0.332494 0.00144375 Z M 0.0004625 0.00144375 "
              transform="matrix(1,0,0,-1,481.7261,704.9116)"
              id="path7996"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip581)"
          clipRule="nonzero"
          id="bar-bottom-48"
        >
          <g clipPath="url(#clip582)" clipRule="nonzero" id="g8010">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0014875 0.00144375 L -0.474144 483.763163 L -0.142112 483.763163 L 0.33445 0.00144375 Z M -0.0014875 0.00144375 "
              transform="matrix(1,0,0,-1,472.5093,704.9116)"
              id="path8008"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0014875 0.00144375 L -0.474144 483.763163 L -0.142112 483.763163 L 0.33445 0.00144375 Z M -0.0014875 0.00144375 "
              transform="matrix(1,0,0,-1,472.5093,704.9116)"
              id="path8008"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip585)"
          clipRule="nonzero"
          id="bar-bottom-47"
        >
          <g clipPath="url(#clip586)" clipRule="nonzero" id="g8022">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00046875 0.00144375 L -0.476094 483.763163 L -0.144062 483.763163 L 0.3325 0.00144375 Z M 0.00046875 0.00144375 "
              transform="matrix(1,0,0,-1,463.2925,704.9116)"
              id="path8020"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00046875 0.00144375 L -0.476094 483.763163 L -0.144062 483.763163 L 0.3325 0.00144375 Z M 0.00046875 0.00144375 "
              transform="matrix(1,0,0,-1,463.2925,704.9116)"
              id="path8020"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip589)"
          clipRule="nonzero"
          id="bar-bottom-46"
        >
          <g clipPath="url(#clip590)" clipRule="nonzero" id="g8034">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00098125 0.00144375 L -0.477544 483.763163 L -0.141606 483.763163 L 0.33105 0.00144375 Z M -0.00098125 0.00144375 "
              transform="matrix(1,0,0,-1,454.0752,704.9116)"
              id="path8032"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00098125 0.00144375 L -0.477544 483.763163 L -0.141606 483.763163 L 0.33105 0.00144375 Z M -0.00098125 0.00144375 "
              transform="matrix(1,0,0,-1,454.0752,704.9116)"
              id="path8032"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip593)"
          clipRule="nonzero"
          id="bar-bottom-45"
        >
          <g clipPath="url(#clip594)" clipRule="nonzero" id="g8046">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.000975 0.00144375 L -0.475588 483.763163 L -0.143556 483.763163 L 0.333006 0.00144375 Z M 0.000975 0.00144375 "
              transform="matrix(1,0,0,-1,444.8584,704.9116)"
              id="path8044"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.000975 0.00144375 L -0.475588 483.763163 L -0.143556 483.763163 L 0.333006 0.00144375 Z M 0.000975 0.00144375 "
              transform="matrix(1,0,0,-1,444.8584,704.9116)"
              id="path8044"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip597)"
          clipRule="nonzero"
          id="bar-bottom-44"
        >
          <g clipPath="url(#clip598)" clipRule="nonzero" id="g8058">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.000475 0.00144375 L -0.477037 483.763163 L -0.1411 483.763163 L 0.331556 0.00144375 Z M -0.000475 0.00144375 "
              transform="matrix(1,0,0,-1,435.6411,704.9116)"
              id="path8056"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.000475 0.00144375 L -0.477037 483.763163 L -0.1411 483.763163 L 0.331556 0.00144375 Z M -0.000475 0.00144375 "
              transform="matrix(1,0,0,-1,435.6411,704.9116)"
              id="path8056"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip601)"
          clipRule="nonzero"
          id="bar-bottom-43"
        >
          <g clipPath="url(#clip602)" clipRule="nonzero" id="g8070">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00148125 0.00144375 L -0.475081 483.763163 L -0.14305 483.763163 L 0.333513 0.00144375 Z M 0.00148125 0.00144375 "
              transform="matrix(1,0,0,-1,426.4243,704.9116)"
              id="path8068"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00148125 0.00144375 L -0.475081 483.763163 L -0.14305 483.763163 L 0.333513 0.00144375 Z M 0.00148125 0.00144375 "
              transform="matrix(1,0,0,-1,426.4243,704.9116)"
              id="path8068"
            />
          </g>
        </g>
        <g clipPath="url(#clip603)" clipRule="nonzero" id="g8078">
          <g clipPath="url(#clip604)" clipRule="nonzero" id="g8076">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00095 0.00144375 L -0.475613 483.763163 L -0.143581 483.763163 L 0.332981 0.00144375 Z M 0.00095 0.00144375 "
              transform="matrix(1,0,0,-1,813.9053,704.9116)"
              id="path8074"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip607)"
          clipRule="nonzero"
          id="bar-bottom-84"
        >
          <g clipPath="url(#clip608)" clipRule="nonzero" id="g8088">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0005 0.00144375 L -0.477063 483.763163 L -0.141125 483.763163 L 0.335437 0.00144375 Z M -0.0005 0.00144375 "
              transform="matrix(1,0,0,-1,804.688,704.9116)"
              id="path8086"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0005 0.00144375 L -0.477063 483.763163 L -0.141125 483.763163 L 0.335437 0.00144375 Z M -0.0005 0.00144375 "
              transform="matrix(1,0,0,-1,804.688,704.9116)"
              id="path8086"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip611)"
          clipRule="nonzero"
          id="bar-bottom-83"
        >
          <g clipPath="url(#clip612)" clipRule="nonzero" id="g8100">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00145625 0.00144375 L -0.475106 483.763163 L -0.143075 483.763163 L 0.333488 0.00144375 Z M 0.00145625 0.00144375 "
              transform="matrix(1,0,0,-1,795.4712,704.9116)"
              id="path8098"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00145625 0.00144375 L -0.475106 483.763163 L -0.143075 483.763163 L 0.333488 0.00144375 Z M 0.00145625 0.00144375 "
              transform="matrix(1,0,0,-1,795.4712,704.9116)"
              id="path8098"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip615)"
          clipRule="nonzero"
          id="bar-bottom-82"
        >
          <g clipPath="url(#clip616)" clipRule="nonzero" id="g8112">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00049375 0.00144375 L -0.477056 483.763163 L -0.141119 483.763163 L 0.331537 0.00144375 Z M -0.00049375 0.00144375 "
              transform="matrix(1,0,0,-1,786.2544,704.9116)"
              id="path8110"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00049375 0.00144375 L -0.477056 483.763163 L -0.141119 483.763163 L 0.331537 0.00144375 Z M -0.00049375 0.00144375 "
              transform="matrix(1,0,0,-1,786.2544,704.9116)"
              id="path8110"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip619)"
          clipRule="nonzero"
          id="bar-bottom-81"
        >
          <g clipPath="url(#clip620)" clipRule="nonzero" id="g8124">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00194375 0.00144375 L -0.4746 483.763163 L -0.142569 483.763163 L 0.333994 0.00144375 Z M -0.00194375 0.00144375 "
              transform="matrix(1,0,0,-1,777.0371,704.9116)"
              id="path8122"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00194375 0.00144375 L -0.4746 483.763163 L -0.142569 483.763163 L 0.333994 0.00144375 Z M -0.00194375 0.00144375 "
              transform="matrix(1,0,0,-1,777.0371,704.9116)"
              id="path8122"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip623)"
          clipRule="nonzero"
          id="bar-bottom-80"
        >
          <g clipPath="url(#clip624)" clipRule="nonzero" id="g8136">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0005125 0.00144375 L -0.47605 483.763163 L -0.140112 483.763163 L 0.332544 0.00144375 Z M 0.0005125 0.00144375 "
              transform="matrix(1,0,0,-1,767.8198,704.9116)"
              id="path8134"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0005125 0.00144375 L -0.47605 483.763163 L -0.140112 483.763163 L 0.332544 0.00144375 Z M 0.0005125 0.00144375 "
              transform="matrix(1,0,0,-1,767.8198,704.9116)"
              id="path8134"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip627)"
          clipRule="nonzero"
          id="bar-bottom-79"
        >
          <g clipPath="url(#clip628)" clipRule="nonzero" id="g8148">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0014375 0.00144375 L -0.474094 483.763163 L -0.142063 483.763163 L 0.3345 0.00144375 Z M -0.0014375 0.00144375 "
              transform="matrix(1,0,0,-1,758.603,704.9116)"
              id="path8146"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0014375 0.00144375 L -0.474094 483.763163 L -0.142063 483.763163 L 0.3345 0.00144375 Z M -0.0014375 0.00144375 "
              transform="matrix(1,0,0,-1,758.603,704.9116)"
              id="path8146"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip631)"
          clipRule="nonzero"
          id="bar-bottom-78"
        >
          <g clipPath="url(#clip632)" clipRule="nonzero" id="g8160">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00051875 0.00144375 L -0.476044 483.763163 L -0.144012 483.763163 L 0.33255 0.00144375 Z M 0.00051875 0.00144375 "
              transform="matrix(1,0,0,-1,749.3862,704.9116)"
              id="path8158"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00051875 0.00144375 L -0.476044 483.763163 L -0.144012 483.763163 L 0.33255 0.00144375 Z M 0.00051875 0.00144375 "
              transform="matrix(1,0,0,-1,749.3862,704.9116)"
              id="path8158"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip635)"
          clipRule="nonzero"
          id="bar-bottom-77"
        >
          <g clipPath="url(#clip636)" clipRule="nonzero" id="g8172">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00143125 0.00144375 L -0.474087 483.763163 L -0.142056 483.763163 L 0.334506 0.00144375 Z M -0.00143125 0.00144375 "
              transform="matrix(1,0,0,-1,740.1694,704.9116)"
              id="path8170"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00143125 0.00144375 L -0.474087 483.763163 L -0.142056 483.763163 L 0.334506 0.00144375 Z M -0.00143125 0.00144375 "
              transform="matrix(1,0,0,-1,740.1694,704.9116)"
              id="path8170"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip639)"
          clipRule="nonzero"
          id="bar-bottom-76"
        >
          <g clipPath="url(#clip640)" clipRule="nonzero" id="g8184">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.001025 0.00144375 L -0.475537 483.763163 L -0.143506 483.763163 L 0.333056 0.00144375 Z M 0.001025 0.00144375 "
              transform="matrix(1,0,0,-1,730.9521,704.9116)"
              id="path8182"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.001025 0.00144375 L -0.475537 483.763163 L -0.143506 483.763163 L 0.333056 0.00144375 Z M 0.001025 0.00144375 "
              transform="matrix(1,0,0,-1,730.9521,704.9116)"
              id="path8182"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip643)"
          clipRule="nonzero"
          id="bar-bottom-75"
        >
          <g clipPath="url(#clip644)" clipRule="nonzero" id="g8196">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.000525 0.00144375 L -0.477088 483.763163 L -0.14115 483.763163 L 0.335412 0.00144375 Z M -0.000525 0.00144375 "
              transform="matrix(1,0,0,-1,721.7349,704.9116)"
              id="path8194"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.000525 0.00144375 L -0.477088 483.763163 L -0.14115 483.763163 L 0.335412 0.00144375 Z M -0.000525 0.00144375 "
              transform="matrix(1,0,0,-1,721.7349,704.9116)"
              id="path8194"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip647)"
          clipRule="nonzero"
          id="bar-bottom-74"
        >
          <g clipPath="url(#clip648)" clipRule="nonzero" id="g8208">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00143125 0.00144375 L -0.475131 483.763163 L -0.1431 483.763163 L 0.333462 0.00144375 Z M 0.00143125 0.00144375 "
              transform="matrix(1,0,0,-1,712.5181,704.9116)"
              id="path8206"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00143125 0.00144375 L -0.475131 483.763163 L -0.1431 483.763163 L 0.333462 0.00144375 Z M 0.00143125 0.00144375 "
              transform="matrix(1,0,0,-1,712.5181,704.9116)"
              id="path8206"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip651)"
          clipRule="nonzero"
          id="bar-bottom-73"
        >
          <g clipPath="url(#clip652)" clipRule="nonzero" id="g8220">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00051875 0.00144375 L -0.477081 483.763163 L -0.141144 483.763163 L 0.331513 0.00144375 Z M -0.00051875 0.00144375 "
              transform="matrix(1,0,0,-1,703.3013,704.9116)"
              id="path8218"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00051875 0.00144375 L -0.477081 483.763163 L -0.141144 483.763163 L 0.331513 0.00144375 Z M -0.00051875 0.00144375 "
              transform="matrix(1,0,0,-1,703.3013,704.9116)"
              id="path8218"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip655)"
          clipRule="nonzero"
          id="bar-bottom-72"
        >
          <g clipPath="url(#clip656)" clipRule="nonzero" id="g8232">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0014375 0.00144375 L -0.475125 483.763163 L -0.143094 483.763163 L 0.333469 0.00144375 Z M 0.0014375 0.00144375 "
              transform="matrix(1,0,0,-1,694.0845,704.9116)"
              id="path8230"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0014375 0.00144375 L -0.475125 483.763163 L -0.143094 483.763163 L 0.333469 0.00144375 Z M 0.0014375 0.00144375 "
              transform="matrix(1,0,0,-1,694.0845,704.9116)"
              id="path8230"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip659)"
          clipRule="nonzero"
          id="bar-bottom-71"
        >
          <g clipPath="url(#clip660)" clipRule="nonzero" id="g8244">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0000125 0.00144375 L -0.476575 483.763163 L -0.144544 483.763163 L 0.332019 0.00144375 Z M -0.0000125 0.00144375 "
              transform="matrix(1,0,0,-1,684.8672,704.9116)"
              id="path8242"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0000125 0.00144375 L -0.476575 483.763163 L -0.144544 483.763163 L 0.332019 0.00144375 Z M -0.0000125 0.00144375 "
              transform="matrix(1,0,0,-1,684.8672,704.9116)"
              id="path8242"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip663)"
          clipRule="nonzero"
          id="bar-bottom-70"
        >
          <g clipPath="url(#clip664)" clipRule="nonzero" id="g8256">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0014625 0.00144375 L -0.474119 483.763163 L -0.142088 483.763163 L 0.334475 0.00144375 Z M -0.0014625 0.00144375 "
              transform="matrix(1,0,0,-1,675.6499,704.9116)"
              id="path8254"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.0014625 0.00144375 L -0.474119 483.763163 L -0.142088 483.763163 L 0.334475 0.00144375 Z M -0.0014625 0.00144375 "
              transform="matrix(1,0,0,-1,675.6499,704.9116)"
              id="path8254"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip667)"
          clipRule="nonzero"
          id="bar-bottom-69"
        >
          <g clipPath="url(#clip668)" clipRule="nonzero" id="g8268">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00049375 0.00144375 L -0.476069 483.763163 L -0.144037 483.763163 L 0.332525 0.00144375 Z M 0.00049375 0.00144375 "
              transform="matrix(1,0,0,-1,666.4331,704.9116)"
              id="path8266"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.00049375 0.00144375 L -0.476069 483.763163 L -0.144037 483.763163 L 0.332525 0.00144375 Z M 0.00049375 0.00144375 "
              transform="matrix(1,0,0,-1,666.4331,704.9116)"
              id="path8266"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip671)"
          clipRule="nonzero"
          id="bar-bottom-68"
        >
          <g clipPath="url(#clip672)" clipRule="nonzero" id="g8280">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00145625 0.00144375 L -0.474113 483.763163 L -0.142081 483.763163 L 0.334481 0.00144375 Z M -0.00145625 0.00144375 "
              transform="matrix(1,0,0,-1,657.2163,704.9116)"
              id="path8278"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00145625 0.00144375 L -0.474113 483.763163 L -0.142081 483.763163 L 0.334481 0.00144375 Z M -0.00145625 0.00144375 "
              transform="matrix(1,0,0,-1,657.2163,704.9116)"
              id="path8278"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip675)"
          clipRule="nonzero"
          id="bar-bottom-67"
        >
          <g clipPath="url(#clip676)" clipRule="nonzero" id="g8292">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0005 0.00144375 L -0.476063 483.763163 L -0.144031 483.763163 L 0.332531 0.00144375 Z M 0.0005 0.00144375 "
              transform="matrix(1,0,0,-1,647.9995,704.9116)"
              id="path8290"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M 0.0005 0.00144375 L -0.476063 483.763163 L -0.144031 483.763163 L 0.332531 0.00144375 Z M 0.0005 0.00144375 "
              transform="matrix(1,0,0,-1,647.9995,704.9116)"
              id="path8290"
            />
          </g>
        </g>
        <g
          className="bar-bottom"
          clipPath="url(#clip679)"
          clipRule="nonzero"
          id="bar-bottom-66"
        >
          <g clipPath="url(#clip680)" clipRule="nonzero" id="g8304">
            <path
              style={{
                fill: 'none',
                strokeWidth: 1,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgb(7.843018%,14.117432%,27.058411%)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00095 0.00144375 L -0.477512 483.763163 L -0.141575 483.763163 L 0.331081 0.00144375 Z M -0.00095 0.00144375 "
              transform="matrix(1,0,0,-1,638.7822,704.9116)"
              id="path8302"
            />
            <path
              style={{
                fill: 'none',
                strokeWidth: 10,
                strokeLinecap: 'butt',
                strokeLinejoin: 'miter',
                stroke: 'rgba(7.843018%,14.117432%,27.058411%,0)',
                strokeOpacity: 1,
                strokeMiterlimit: 10
              }}
              d="M -0.00095 0.00144375 L -0.477512 483.763163 L -0.141575 483.763163 L 0.331081 0.00144375 Z M -0.00095 0.00144375 "
              transform="matrix(1,0,0,-1,638.7822,704.9116)"
              id="path8302"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}
